// Auto-generated from OpenFlights database (https://github.com/jpatokal/openflights)
// Run: node scripts/gen-airports.mjs
// 6033 airports with valid IATA codes

export const AIRPORTS: Record<string, { city: string; name: string }> = {
  AAA: { city: 'Anaa', name: 'Anaa' },
  AAC: { city: 'El Arish', name: 'El Arish International' },
  AAE: { city: 'Annaba', name: 'Rabah Bitat' },
  AAF: { city: 'Apalachicola', name: 'Apalachicola Regional' },
  AAH: { city: 'Aachen', name: 'Aachen-Merzbrück' },
  AAK: { city: 'Buariki', name: 'Buariki' },
  AAL: { city: 'Aalborg', name: 'Aalborg' },
  AAM: { city: 'Malamala', name: 'Malamala' },
  AAN: { city: 'Al Ain', name: 'Al Ain International' },
  AAO: { city: 'Anaco', name: 'Anaco' },
  AAP: { city: 'Houston', name: 'Andrau Airpark' },
  AAQ: { city: 'Anapa', name: 'Anapa Vityazevo' },
  AAR: { city: 'Aarhus', name: 'Aarhus' },
  AAT: { city: 'Altay', name: 'Altay Air Base' },
  AAV: { city: 'Surallah', name: 'Allah Valley' },
  AAX: { city: 'Araxa', name: 'Romeu Zema' },
  AAY: { city: 'Al Ghaidah Intl', name: 'Al Ghaidah International' },
  AAZ: { city: 'Quezaltenango', name: 'Quezaltenango' },
  ABA: { city: 'Abakan', name: 'Abakan' },
  ABB: { city: 'Asaba', name: 'Asaba International' },
  ABC: { city: 'Albacete', name: 'Albacete-Los Llanos' },
  ABD: { city: 'Abadan', name: 'Abadan' },
  ABE: { city: 'Allentown', name: 'Lehigh Valley International' },
  ABF: { city: 'Abaiang Atoll', name: 'Abaiang' },
  ABH: { city: 'Alpha', name: 'Alpha' },
  ABI: { city: 'Abilene', name: 'Abilene Regional' },
  ABJ: { city: 'Abidjan', name: 'Port Bouet' },
  ABK: { city: 'Kabri Dehar', name: 'Kabri Dehar' },
  ABL: { city: 'Ambler', name: 'Ambler' },
  ABM: { city: 'Amberley', name: 'Northern Peninsula' },
  ABN: { city: 'Albina', name: 'Albina' },
  ABQ: { city: 'Albuquerque', name: 'Albuquerque International Sunport' },
  ABR: { city: 'Aberdeen', name: 'Aberdeen Regional' },
  ABS: { city: 'Abu Simbel', name: 'Abu Simbel' },
  ABT: { city: 'El-baha', name: 'Al Baha' },
  ABV: { city: 'Abuja', name: 'Nnamdi Azikiwe International' },
  ABX: { city: 'Albury', name: 'Albury' },
  ABY: { city: 'Albany', name: 'Southwest Georgia Regional' },
  ABZ: { city: 'Aberdeen', name: 'Aberdeen Dyce' },
  ACA: { city: 'Acapulco', name: 'General Juan N Alvarez International' },
  ACC: { city: 'Accra', name: 'Kotoka International' },
  ACD: { city: 'Acandi', name: 'Alcides Fernández' },
  ACE: { city: 'Arrecife', name: 'Lanzarote' },
  ACF: { city: 'Brisbane', name: 'Brisbane Archerfield' },
  ACH: { city: 'Altenrhein', name: 'St Gallen Altenrhein' },
  ACI: { city: 'Alderney', name: 'Alderney' },
  ACJ: { city: 'Anuradhapura', name: 'Anuradhapura Air Force Base' },
  ACK: { city: 'Nantucket', name: 'Nantucket Memorial' },
  ACN: { city: 'Ciudad Acuna', name: 'Ciudad Acuña New International' },
  ACP: { city: 'Maragheh', name: 'Sahand' },
  ACR: { city: 'Araracuara', name: 'Araracuara' },
  ACS: { city: 'Achinsk', name: 'Achinsk' },
  ACT: { city: 'Waco', name: 'Waco Regional' },
  ACV: { city: 'Arcata CA', name: 'California Redwood Coast-Humboldt County' },
  ACX: { city: 'Xingyi', name: 'Xingyi' },
  ACY: { city: 'Atlantic City', name: 'Atlantic City International' },
  ACZ: { city: 'Zabol', name: 'Zabol' },
  ADA: { city: 'Adana', name: 'Adana' },
  ADB: { city: 'Izmir', name: 'Adnan Menderes International' },
  ADD: { city: 'Addis Ababa', name: 'Addis Ababa Bole International' },
  ADE: { city: 'Aden', name: 'Aden International' },
  ADF: { city: 'Adiyaman', name: 'Adıyaman' },
  ADH: { city: 'Aldan', name: 'Aldan' },
  ADI: { city: 'Arandis', name: 'Arandis' },
  ADJ: { city: 'Amman', name: 'Amman-Marka International' },
  ADK: { city: 'Adak Island', name: 'Adak' },
  ADL: { city: 'Adelaide', name: 'Adelaide International' },
  ADM: { city: 'Ardmore', name: 'Ardmore Municipal' },
  ADP: { city: 'Galoya', name: 'Ampara' },
  ADQ: { city: 'Kodiak', name: 'Kodiak' },
  ADS: { city: 'Addison', name: 'Addison' },
  ADT: { city: 'Ada', name: 'Ada Regional' },
  ADU: { city: 'Ardabil', name: 'Ardabil' },
  ADW: { city: 'Camp Springs', name: 'Joint Base Andrews' },
  ADX: { city: 'Leuchars', name: 'RAF Leuchars' },
  ADY: { city: 'Alldays', name: 'Alldays' },
  ADZ: { city: 'San Andres Island', name: 'Gustavo Rojas Pinilla International' },
  AEA: { city: 'Abemama', name: 'Abemama Atoll' },
  AEB: { city: 'Baise', name: 'Baise Youjiang' },
  AEG: { city: 'Padang Sidempuan', name: 'Aek Godang' },
  AEH: { city: 'Abeche', name: 'Abeche' },
  AEI: { city: 'Algeciras', name: 'Algeciras Heliport' },
  AEO: { city: 'Aioun El Atrouss', name: 'Aioun el Atrouss' },
  AEP: { city: 'Buenos Aires', name: 'Jorge Newbery Airpark' },
  AER: { city: 'Sochi', name: 'Sochi International' },
  AES: { city: 'Alesund', name: 'Ålesund' },
  AET: { city: 'Allakaket', name: 'Allakaket' },
  AEU: { city: 'Abumusa I.', name: 'Abu Musa Island' },
  AEX: { city: 'Alexandria', name: 'Alexandria International' },
  AEY: { city: 'Akureyri', name: 'Akureyri' },
  AFA: { city: 'San Rafael', name: 'Suboficial Ay Santiago Germano' },
  AFL: { city: 'Alta Floresta', name: 'Piloto Osvaldo Marques Dias' },
  AFS: { city: 'Zarafshan', name: 'Sugraly' },
  AFT: { city: 'Afutara', name: 'Afutara Aerodrome' },
  AFW: { city: 'Fort Worth', name: 'Fort Worth Alliance' },
  AFY: { city: 'Afyon', name: 'Afyon' },
  AFZ: { city: 'Sabzevar', name: 'Sabzevar National' },
  AGA: { city: 'Agadir', name: 'Al Massira' },
  AGB: { city: 'Augsburg', name: 'Augsburg' },
  AGC: { city: 'Pittsburgh', name: 'Allegheny County' },
  AGE: { city: 'Wangerooge', name: 'Wangerooge' },
  AGF: { city: 'Agen', name: 'Agen-La Garenne' },
  AGH: { city: 'Ängelholm', name: 'Ängelholm-Helsingborg' },
  AGI: { city: 'Wageningen', name: 'Wageningen Airstrip' },
  AGJ: { city: 'Aguni', name: 'Aguni' },
  AGN: { city: 'Angoon', name: 'Angoon Seaplane Base' },
  AGP: { city: 'Malaga', name: 'Málaga' },
  AGQ: { city: 'Agrinion', name: 'Agrinion Air Base' },
  AGR: { city: 'Agra', name: 'Agra' },
  AGS: { city: 'Bush Field', name: 'Augusta Regional At Bush Field' },
  AGT: { city: 'Ciudad del Este', name: 'Guarani International' },
  AGU: { city: 'Aguascalientes', name: 'Jesús Terán Paredo International' },
  AGV: { city: 'Acarigua', name: 'Oswaldo Guevara Mujica' },
  AGX: { city: 'Agatti Island', name: 'Agatti' },
  AGZ: { city: 'Aggeneys', name: 'Aggeneys' },
  AHB: { city: 'Abha', name: 'Abha Regional' },
  AHE: { city: 'Ahe', name: 'Ahe' },
  AHJ: { city: 'Ngawa', name: 'Hongyuan' },
  AHN: { city: 'Athens', name: 'Athens Ben Epps' },
  AHO: { city: 'Alghero', name: 'Alghero-Fertilia' },
  AHS: { city: 'Ahuas', name: 'Ahuas' },
  AHU: { city: 'Al Hociema', name: 'Cherif Al Idrissi' },
  AIA: { city: 'Alliance', name: 'Alliance Municipal' },
  AID: { city: 'ANDERSON', name: 'Anderson Municipal Darlington Field' },
  AIK: { city: 'Aiken', name: 'Aiken Regional' },
  AIN: { city: 'Wainwright', name: 'Wainwright' },
  AIP: { city: 'Adampur', name: 'Adampur' },
  AIR: { city: 'Aripuana', name: 'Aripuanã' },
  AIS: { city: 'Arorae', name: 'Arorae Island' },
  AIT: { city: 'Aitutaki', name: 'Aitutaki' },
  AIU: { city: 'Atiu Island', name: 'Enua' },
  AIZ: { city: 'Kaiser Lake Ozark', name: 'Lee C Fine Memorial' },
  AJA: { city: 'Ajaccio', name: 'Ajaccio-Napoléon Bonaparte' },
  AJF: { city: 'Al-Jawf', name: 'Al-Jawf Domestic' },
  AJI: { city: 'Agri', name: 'Ağrı' },
  AJK: { city: 'Arak', name: 'Arak' },
  AJL: { city: 'Aizwal', name: 'Lengpui' },
  AJN: { city: 'Anjouan', name: 'Ouani' },
  AJR: { city: 'Arvidsjaur', name: 'Arvidsjaur' },
  AJU: { city: 'Aracaju', name: 'Santa Maria' },
  AJY: { city: 'Agadez', name: 'Mano Dayak International' },
  AKA: { city: 'Ankang', name: 'Ankang Wulipu' },
  AKB: { city: 'Atka', name: 'Atka' },
  AKC: { city: 'Akron', name: 'Akron Fulton International' },
  AKD: { city: 'Akola', name: 'Akola' },
  AKF: { city: 'Kufra', name: 'Kufra' },
  AKH: { city: 'Al Kharj', name: 'Prince Sultan Air Base' },
  AKI: { city: 'Akiak', name: 'Akiak' },
  AKJ: { city: 'Asahikawa', name: 'Asahikawa' },
  AKK: { city: 'Akhiok', name: 'Akhiok' },
  AKL: { city: 'Auckland', name: 'Auckland International' },
  AKN: { city: 'King Salmon', name: 'King Salmon' },
  AKO: { city: 'Akron', name: 'Colorado Plains Regional' },
  AKP: { city: 'Anaktuvuk Pass', name: 'Anaktuvuk Pass' },
  AKR: { city: 'Akure', name: 'Akure' },
  AKS: { city: 'Auki', name: 'Gwaunaruu' },
  AKT: { city: 'Akrotiri', name: 'RAF Akrotiri' },
  AKU: { city: 'Aksu', name: 'Aksu' },
  AKV: { city: 'Akulivik', name: 'Akulivik' },
  AKW: { city: 'Aghajari', name: 'Aghajari' },
  AKX: { city: 'Aktyubinsk', name: 'Aktobe' },
  AKY: { city: 'Sittwe', name: 'Sittwe' },
  ALA: { city: 'Alma-ata', name: 'Almaty' },
  ALB: { city: 'Albany', name: 'Albany International' },
  ALC: { city: 'Alicante', name: 'Alicante International' },
  ALE: { city: 'Alpine', name: 'Alpine Casparis Municipal' },
  ALF: { city: 'Alta', name: 'Alta' },
  ALG: { city: 'Algier', name: 'Houari Boumediene' },
  ALH: { city: 'Albany', name: 'Albany' },
  ALI: { city: 'Alice', name: 'Alice International' },
  ALJ: { city: 'Alexander Bay', name: 'Alexander Bay' },
  ALL: { city: 'Albenga', name: 'Villanova DAlbenga International' },
  ALM: { city: 'Alamogordo', name: 'Alamogordo White Sands Regional' },
  ALN: { city: 'Alton/St Louis', name: 'St Louis Regional' },
  ALO: { city: 'Waterloo', name: 'Waterloo Regional' },
  ALP: { city: 'Aleppo', name: 'Aleppo International' },
  ALR: { city: 'Alexandra', name: 'Alexandra' },
  ALS: { city: 'Alamosa', name: 'San Luis Valley Regional Bergman Field' },
  ALU: { city: 'Alula', name: 'Alula' },
  ALW: { city: 'Walla Walla', name: 'Walla Walla Regional' },
  ALX: { city: 'Alexander City', name: 'Thomas C Russell Field' },
  ALY: { city: 'Alexandria', name: 'El Nouzha' },
  AMA: { city: 'Amarillo', name: 'Rick Husband Amarillo International' },
  AMB: { city: 'Ambilobe', name: 'Ambilobe' },
  AMC: { city: 'Am Timan', name: 'Am Timan' },
  AMD: { city: 'Ahmedabad', name: 'Sardar Vallabhbhai Patel International' },
  AMH: { city: 'Arba Minch', name: 'Arba Minch' },
  AMI: { city: 'Mataram', name: 'Selaparang' },
  AMM: { city: 'Amman', name: 'Queen Alia International' },
  AMN: { city: 'Kamloops', name: 'Gratiot Community' },
  AMQ: { city: 'Ambon', name: 'Pattimura Airport, Ambon' },
  AMS: { city: 'Amsterdam', name: 'Amsterdam Airport Schiphol' },
  AMT: { city: 'Amata', name: 'Amata' },
  AMV: { city: 'Amderma', name: 'Amderma' },
  AMZ: { city: 'Ardmore', name: 'Ardmore' },
  ANB: { city: 'Anniston', name: 'Anniston Regional' },
  ANC: { city: 'Anchorage', name: 'Ted Stevens Anchorage International' },
  AND: { city: 'Andersen', name: 'Anderson Regional' },
  ANE: { city: 'Angers/Marcé', name: 'Angers-Loire' },
  ANF: { city: 'Antofagasta', name: 'Andrés Sabella Gálvez International' },
  ANG: { city: 'Angouleme', name: 'Angoulême-Brie-Champniers' },
  ANI: { city: 'Aniak', name: 'Aniak' },
  ANK: { city: 'Ankara', name: 'Etimesgut Air Base' },
  ANM: { city: 'Antalaha', name: 'Antsirabato' },
  ANN: { city: 'Annette Island', name: 'Annette Island' },
  ANP: { city: 'Annapolis', name: 'Lee' },
  ANQ: { city: 'Angola', name: 'Tri State Steuben County' },
  ANR: { city: 'Antwerp', name: 'Antwerp International Airport (Deurne)' },
  ANS: { city: 'Andahuaylas', name: 'Andahuaylas' },
  ANU: { city: 'Antigua', name: 'V.C. Bird International' },
  ANV: { city: 'Anvik', name: 'Anvik' },
  ANX: { city: 'Andoya', name: 'Andøya' },
  AOC: { city: 'Altenburg', name: 'Altenburg-Nobitz' },
  AOE: { city: 'Eskissehir', name: 'Anadolu' },
  AOG: { city: 'Anshan', name: 'Anshan Air Base' },
  AOH: { city: 'Lima', name: 'Lima Allen County' },
  AOI: { city: 'Ancona', name: 'Ancona Falconara' },
  AOJ: { city: 'Aomori', name: 'Aomori' },
  AOK: { city: 'Karpathos', name: 'Karpathos' },
  AOL: { city: 'Paso De Los Libres', name: 'Paso De Los Libres' },
  AOO: { city: 'Altoona', name: 'Altoona Blair County' },
  AOP: { city: 'Andoas', name: 'Alferez FAP Alfredo Vladimir Sara Bauer' },
  AOR: { city: 'Alor Setar', name: 'Sultan Abdul Halim' },
  AOT: { city: 'Aosta', name: 'Aosta' },
  AOU: { city: 'Attopeu', name: 'Attopeu' },
  APA: { city: 'Denver', name: 'Centennial' },
  APC: { city: 'Napa', name: 'Napa County' },
  APF: { city: 'Naples', name: 'Naples Municipal' },
  APG: { city: 'Aberdeen', name: 'Phillips Army Air Field' },
  API: { city: 'Apiay', name: 'Gomez Nino Apiay Air Base' },
  APK: { city: 'Apataki', name: 'Apataki' },
  APL: { city: 'Nampula', name: 'Nampula' },
  APN: { city: 'Alpena', name: 'Alpena County Regional' },
  APO: { city: 'Carepa', name: 'Antonio Roldan Betancourt' },
  APQ: { city: 'Arapiraca', name: 'Arapiraca' },
  APT: { city: 'Jasper', name: 'Marion County Brown Field' },
  APW: { city: 'Faleolo', name: 'Faleolo International' },
  APZ: { city: 'ZAPALA', name: 'Zapala' },
  AQA: { city: 'Araracuara', name: 'Araraquara' },
  AQB: { city: 'Santa Cruz des Quiche', name: 'Santa Cruz del Quiche' },
  AQG: { city: 'Anqing', name: 'Anqing Tianzhushan' },
  AQI: { city: 'Hafr Al-batin', name: 'Al Qaisumah/Hafr Al Batin' },
  AQJ: { city: 'Aqaba', name: 'Aqaba King Hussein International' },
  AQP: { city: 'Arequipa', name: 'Rodríguez Ballón International' },
  ARA: { city: 'Louisiana', name: 'Acadiana Regional' },
  ARB: { city: 'Ann Arbor', name: 'Ann Arbor Municipal' },
  ARC: { city: 'Arctic Village', name: 'Arctic Village' },
  ARD: { city: 'Alor Island', name: 'Mali' },
  ARE: { city: 'Arecibo', name: 'Antonio Nery Juarbe Pol' },
  ARH: { city: 'Arkhangelsk', name: 'Talagi' },
  ARI: { city: 'Arica', name: 'Chacalluta' },
  ARK: { city: 'Arusha', name: 'Arusha' },
  ARM: { city: 'Armidale', name: 'Armidale' },
  ARN: { city: 'Stockholm', name: 'Stockholm-Arlanda' },
  ARR: { city: 'Alto Rio Senguer', name: 'D. Casimiro Szlapelis' },
  ART: { city: 'Watertown', name: 'Watertown International' },
  ARU: { city: 'Aracatuba', name: 'Araçatuba' },
  ARV: { city: 'Minocqua - Woodruff', name: 'Lakeland-Noble F. Lee Memorial field' },
  ARW: { city: 'Arad', name: 'Arad International' },
  ASA: { city: 'Assab', name: 'Assab International' },
  ASB: { city: 'Ashkhabad', name: 'Ashgabat International' },
  ASD: { city: 'Andros Town', name: 'Andros Town' },
  ASE: { city: 'Aspen', name: 'Aspen-Pitkin Co/Sardy Field' },
  ASF: { city: 'Astrakhan', name: 'Astrakhan' },
  ASH: { city: 'Nashua', name: 'Boire Field' },
  ASI: { city: 'Wide Awake', name: 'RAF Ascension Island' },
  ASJ: { city: 'Amami', name: 'Amami' },
  ASK: { city: 'Yamoussoukro', name: 'Yamoussoukro' },
  ASM: { city: 'Asmara', name: 'Asmara International' },
  ASN: { city: 'Talladega', name: 'Talladega Municipal' },
  ASO: { city: 'Asosa', name: 'Asosa' },
  ASP: { city: 'Alice Springs', name: 'Alice Springs' },
  ASR: { city: 'Kayseri', name: 'Kayseri Erkilet' },
  ASS: { city: 'Arathusa', name: 'Arathusa Safari Lodge' },
  AST: { city: 'Astoria', name: 'Astoria Regional' },
  ASU: { city: 'Asuncion', name: 'Silvio Pettirossi International' },
  ASV: { city: 'Amboseli National Park', name: 'Amboseli' },
  ASW: { city: 'Aswan', name: 'Aswan International' },
  ATA: { city: 'Anta', name: 'Comandante FAP German Arias Graziani' },
  ATB: { city: 'Atbara', name: 'Atbara' },
  ATC: { city: 'Arthurs Town', name: 'Arthurs Town' },
  ATD: { city: 'Atoifi', name: 'Uru Harbour' },
  ATF: { city: 'Ambato', name: 'Chachoán' },
  ATG: { city: 'Kamra', name: 'Minhas Air Base' },
  ATH: { city: 'Athens', name: 'Eleftherios Venizelos International' },
  ATI: { city: 'Artigas', name: 'Artigas International' },
  ATJ: { city: 'Antsirabe', name: 'Antsirabe' },
  ATK: { city: 'Atqasuk', name: 'Atqasuk Edward Burnell Sr Memorial' },
  ATL: { city: 'Atlanta', name: 'Hartsfield Jackson Atlanta International' },
  ATM: { city: 'Altamira', name: 'Altamira' },
  ATO: { city: 'Athens', name: 'Ohio University Snyder Field' },
  ATQ: { city: 'Amritsar', name: 'Sri Guru Ram Dass Jee International' },
  ATR: { city: 'Atar', name: 'Atar International' },
  ATW: { city: 'Appleton', name: 'Appleton International' },
  ATY: { city: 'Watertown', name: 'Watertown Regional' },
  ATZ: { city: 'Asyut', name: 'Assiut International' },
  AUA: { city: 'Oranjestad', name: 'Queen Beatrix International' },
  AUC: { city: 'Arauca', name: 'Santiago Perez' },
  AUF: { city: 'Auxerre', name: 'Auxerre-Branches' },
  AUG: { city: 'Augusta', name: 'Augusta State' },
  AUH: { city: 'Abu Dhabi', name: 'Abu Dhabi International' },
  AUK: { city: 'Alakanuk', name: 'Alakanuk' },
  AUO: { city: 'Auburn', name: 'Auburn University Regional' },
  AUQ: { city: 'Hiva-oa', name: 'Hiva Oa-Atuona' },
  AUR: { city: 'Aurillac', name: 'Aurillac' },
  AUS: { city: 'Austin', name: 'Austin Bergstrom International' },
  AUU: { city: 'Aurukun', name: 'Aurukun' },
  AUW: { city: 'Wausau', name: 'Wausau Downtown' },
  AUX: { city: 'Araguaina', name: 'Araguaína' },
  AUY: { city: 'Anelghowhat', name: 'Aneityum' },
  AVA: { city: 'Anshun', name: 'Anshun Huangguoshu' },
  AVB: { city: 'Aviano', name: 'Aviano Air Base' },
  AVI: { city: 'Ciego De Avila', name: 'Maximo Gomez' },
  AVK: { city: 'Arvaikheer', name: 'Arvaikheer' },
  AVL: { city: 'Asheville', name: 'Asheville Regional' },
  AVN: { city: 'Avignon', name: 'Avignon-Caumont' },
  AVO: { city: 'Avon Park', name: 'Avon Park Executive' },
  AVP: { city: 'Scranton', name: 'Wilkes Barre Scranton International' },
  AVR: { city: 'Alverca', name: 'Alverca Air Base' },
  AVV: { city: 'Avalon', name: 'Avalon' },
  AVW: { city: 'Tucson', name: 'Marana Regional' },
  AVX: { city: 'Catalina Island', name: 'Catalina' },
  AWA: { city: 'Awasa', name: 'Awassa' },
  AWD: { city: 'Aniwa', name: 'Aniwa' },
  AWK: { city: 'Wake island', name: 'Wake Island' },
  AWZ: { city: 'Ahwaz', name: 'Ahwaz' },
  AXA: { city: 'The Valley', name: 'Clayton J Lloyd International' },
  AXD: { city: 'Alexandroupolis', name: 'Dimokritos' },
  AXF: { city: 'Alxa Left Banner', name: 'Alxa Left Banner Bayanhot' },
  AXJ: { city: 'Amakusa', name: 'Amakusa' },
  AXK: { city: 'Ataq', name: 'Ataq' },
  AXM: { city: 'Armenia', name: 'El Eden' },
  AXN: { city: 'Alexandria', name: 'Chandler Field' },
  AXP: { city: 'Spring Point', name: 'Spring Point' },
  AXR: { city: 'Arutua', name: 'Arutua' },
  AXT: { city: 'Akita', name: 'Akita' },
  AXU: { city: 'Axum', name: 'Axum' },
  AYK: { city: 'Arkalyk', name: 'Arkalyk North' },
  AYO: { city: 'Ayolas', name: 'Juan De Ayolas' },
  AYP: { city: 'Ayacucho', name: 'Coronel FAP Alfredo Mendivil Duarte' },
  AYQ: { city: 'Uluru', name: 'Ayers Rock Connellan' },
  AYS: { city: 'Waycross', name: 'Waycross Ware County' },
  AYT: { city: 'Antalya', name: 'Antalya International' },
  AYW: { city: 'Ayawasi', name: 'Ayawasi' },
  AZA: { city: 'Mesa', name: 'Phoenix-Mesa-Gateway' },
  AZD: { city: 'Yazd', name: 'Shahid Sadooghi' },
  AZI: { city: 'Abu Dhabi', name: 'Bateen' },
  AZN: { city: 'Andizhan', name: 'Andizhan' },
  AZO: { city: 'Kalamazoo', name: 'Kalamazoo Battle Creek International' },
  AZR: { city: 'Adrar', name: 'Touat Cheikh Sidi Mohamed Belkebir' },
  AZS: { city: 'Samana', name: 'Samaná El Catey International' },
  BAB: { city: 'Marysville', name: 'Beale Air Force Base' },
  BAD: { city: 'Shreveport', name: 'Barksdale Air Force Base' },
  BAF: { city: 'Westfield', name: 'Westfield-Barnes Regional' },
  BAG: { city: 'Baguio', name: 'Loakan' },
  BAH: { city: 'Bahrain', name: 'Bahrain International' },
  BAI: { city: 'Buenos Aires', name: 'Buenos Aires' },
  BAL: { city: 'Batman', name: 'Batman' },
  BAQ: { city: 'Barranquilla', name: 'Ernesto Cortissoz International' },
  BAR: { city: 'Qionghai', name: 'Qionghai Boao' },
  BAS: { city: 'Ballalae', name: 'Ballalae' },
  BAT: { city: 'Barretos', name: 'Chafei Amsei' },
  BAU: { city: 'Bauru', name: 'Bauru' },
  BAV: { city: 'Baotou', name: 'Baotou' },
  BAX: { city: 'Barnaul', name: 'Barnaul' },
  BAY: { city: 'Baia Mare', name: 'Tautii Magheraus' },
  BAZ: { city: 'Barcelos', name: 'Barcelos' },
  BBA: { city: 'Balmaceda', name: 'Balmaceda' },
  BBC: { city: 'Bay City', name: 'Bay City Municipal' },
  BBD: { city: 'Brady', name: 'Curtis Field' },
  BBG: { city: 'Butaritari', name: 'Butaritari Atoll' },
  BBH: { city: 'Barth', name: 'Barth' },
  BBI: { city: 'Bhubaneswar', name: 'Biju Patnaik' },
  BBJ: { city: 'Birburg', name: 'Bitburg' },
  BBK: { city: 'Kasane', name: 'Kasane' },
  BBL: { city: 'Ballera', name: 'Ballera' },
  BBM: { city: 'Battambang', name: 'Battambang' },
  BBN: { city: 'Bario', name: 'Bario' },
  BBO: { city: 'Berbera', name: 'Berbera' },
  BBP: { city: 'Bembridge', name: 'Bembridge' },
  BBQ: { city: 'Codrington', name: 'Codrington' },
  BBR: { city: 'Basse Terre', name: 'Baillif' },
  BBS: { city: 'Blackbushe', name: 'Blackbushe' },
  BBT: { city: 'Berberati', name: 'Berbérati' },
  BBU: { city: 'Bucharest', name: 'Băneasa International' },
  BBX: { city: 'Philadelphia', name: 'Wings Field' },
  BCA: { city: 'Baracoa Playa', name: 'Gustavo Rizo' },
  BCD: { city: 'Bacolod', name: 'Bacolod-Silay' },
  BCE: { city: 'Bryce Canyon', name: 'Bryce Canyon' },
  BCH: { city: 'Baucau', name: 'Cakung' },
  BCI: { city: 'Barcaldine', name: 'Barcaldine' },
  BCL: { city: 'Pococi', name: 'Barra del Colorado' },
  BCM: { city: 'Bacau', name: 'Bacău' },
  BCN: { city: 'Barcelona', name: 'Barcelona International' },
  BCO: { city: 'Baco', name: 'Baco' },
  BCT: { city: 'Boca Raton', name: 'Boca Raton' },
  BCU: { city: 'Bauchi', name: 'Sir Abubakar Tafawa Balewa International' },
  BDA: { city: 'Bermuda', name: 'L.F. Wade International International' },
  BDB: { city: 'Bundaberg', name: 'Bundaberg' },
  BDD: { city: 'Badu Island', name: 'Badu Island' },
  BDE: { city: 'Baudette', name: 'Baudette International' },
  BDH: { city: 'Bandar Lengeh', name: 'Bandar Lengeh' },
  BDI: { city: 'Bird Island', name: 'Bird Island' },
  BDJ: { city: 'Banjarmasin', name: 'Syamsudin Noor' },
  BDL: { city: 'Windsor Locks', name: 'Bradley International' },
  BDM: { city: 'Bandirma', name: 'Bandırma' },
  BDN: { city: 'Talhar', name: 'Talhar' },
  BDO: { city: 'Bandung', name: 'Husein Sastranegara International' },
  BDP: { city: 'Chandragarhi', name: 'Bhadrapur' },
  BDQ: { city: 'Baroda', name: 'Vadodara' },
  BDR: { city: 'Stratford', name: 'Igor I Sikorsky Memorial' },
  BDS: { city: 'Brindisi', name: 'Brindisi – Salento' },
  BDT: { city: 'Gbadolite', name: 'Gbadolite' },
  BDU: { city: 'Bardufoss', name: 'Bardufoss' },
  BEB: { city: 'Benbecula', name: 'Benbecula' },
  BEC: { city: 'Wichita', name: 'Beech Factory' },
  BED: { city: 'Bedford', name: 'Laurence G Hanscom Field' },
  BEF: { city: 'Bluefields', name: 'Bluefields' },
  BEG: { city: 'Belgrade', name: 'Belgrade Nikola Tesla' },
  BEI: { city: 'Beica', name: 'Beica' },
  BEJ: { city: 'Tanjung Redep-Borneo Island', name: 'Kalimarau' },
  BEK: { city: 'Bareilly', name: 'Bareilly Air Force Station' },
  BEL: { city: 'Belem', name: 'Val de Cans/Júlio Cezar Ribeiro International' },
  BEM: { city: 'Beni Mellal', name: 'Beni Mellal' },
  BEN: { city: 'Benghazi', name: 'Benina International' },
  BEO: { city: 'Lake Macquarie', name: 'Lake Macquarie' },
  BEP: { city: 'Bellary', name: 'Bellary' },
  BEQ: { city: 'Honington', name: 'RAF Honington' },
  BES: { city: 'Brest', name: 'Brest Bretagne' },
  BET: { city: 'Bethel', name: 'Bethel' },
  BEU: { city: 'Bedourie', name: 'Bedourie' },
  BEV: { city: 'Beer-sheba', name: 'Beersheba (Teyman)' },
  BEW: { city: 'Beira', name: 'Beira' },
  BEX: { city: 'Benson', name: 'RAF Benson' },
  BEY: { city: 'Beirut', name: 'Beirut Rafic Hariri International' },
  BEZ: { city: 'Beru Island', name: 'Beru' },
  BFD: { city: 'Bradford', name: 'Bradford Regional' },
  BFE: { city: 'Bielefeld', name: 'Bielefeld' },
  BFF: { city: 'Scottsbluff', name: 'Western Neb. Rgnl/William B. Heilig' },
  BFH: { city: 'Curitiba', name: 'Bacacheri' },
  BFI: { city: 'Seattle', name: 'Boeing Field King County International' },
  BFJ: { city: 'Bijie', name: 'Bijie Feixiong' },
  BFK: { city: 'Buckley', name: 'Buckley Air Force Base' },
  BFL: { city: 'Bakersfield', name: 'Meadows Field' },
  BFM: { city: 'Mobile', name: 'Mobile Downtown' },
  BFN: { city: 'Bloemfontein', name: 'Bram Fischer International' },
  BFO: { city: 'Chiredzi', name: 'Buffalo Range' },
  BFP: { city: 'Beaver Falls', name: 'Beaver County' },
  BFS: { city: 'Belfast', name: 'Belfast International' },
  BFT: { city: 'Beaufort', name: 'Beaufort County' },
  BFU: { city: 'Bengbu', name: 'Bengbu' },
  BFV: { city: 'Buri Ram', name: 'Buri Ram' },
  BFW: { city: 'Sidi Bel Abbes', name: 'Sidi Bel Abbes' },
  BFX: { city: 'Bafoussam', name: 'Bafoussam' },
  BGA: { city: 'Bucaramanga', name: 'Palonegro' },
  BGC: { city: 'Braganca', name: 'Bragança' },
  BGD: { city: 'Borger', name: 'Hutchinson County' },
  BGE: { city: 'Bainbridge', name: 'Decatur County Industrial Air Park' },
  BGF: { city: 'Bangui', name: 'Bangui MPoko International' },
  BGG: { city: 'Bingol', name: 'Bingöl Çeltiksuyu' },
  BGI: { city: 'Bridgetown', name: 'Sir Grantley Adams International' },
  BGL: { city: 'Baglung', name: 'Baglung' },
  BGM: { city: 'Binghamton', name: 'Greater Binghamton/Edwin A Link field' },
  BGO: { city: 'Bergen', name: 'Bergen Airport Flesland' },
  BGR: { city: 'Bangor', name: 'Bangor International' },
  BGW: { city: 'Baghdad', name: 'Baghdad International' },
  BGX: { city: 'Bage', name: 'Comandante Gustavo Kraemer' },
  BGY: { city: 'Bergamo', name: 'Il Caravaggio International' },
  BGZ: { city: 'Braga', name: 'Braga Municipal Aerodrome' },
  BHB: { city: 'Bar Harbor', name: 'Hancock County-Bar Harbor' },
  BHD: { city: 'Belfast', name: 'George Best Belfast City' },
  BHE: { city: 'Woodbourne', name: 'Woodbourne' },
  BHG: { city: 'Brus Laguna', name: 'Brus Laguna' },
  BHH: { city: 'Bisha', name: 'Bisha' },
  BHI: { city: 'Bahia Blanca', name: 'Comandante Espora' },
  BHJ: { city: 'Bhuj', name: 'Bhuj' },
  BHK: { city: 'Bukhara', name: 'Bukhara' },
  BHM: { city: 'Birmingham', name: 'Birmingham-Shuttlesworth International' },
  BHN: { city: 'Beihan', name: 'Beihan' },
  BHO: { city: 'Bhopal', name: 'Raja Bhoj International' },
  BHP: { city: 'Bhojpur', name: 'Bhojpur' },
  BHQ: { city: 'Broken Hill', name: 'Broken Hill' },
  BHR: { city: 'Bharatpur', name: 'Bharatpur' },
  BHS: { city: 'Bathurst', name: 'Bathurst' },
  BHU: { city: 'Bhaunagar', name: 'Bhavnagar' },
  BHV: { city: 'Bahawalpur', name: 'Bahawalpur' },
  BHW: { city: 'Bhagtanwala', name: 'Bhagatanwala' },
  BHX: { city: 'Birmingham', name: 'Birmingham International' },
  BHY: { city: 'Beihai', name: 'Beihai' },
  BIA: { city: 'Bastia', name: 'Bastia-Poretta' },
  BIB: { city: 'Baidoa', name: 'Baidoa' },
  BID: { city: 'Block Island', name: 'Block Island State' },
  BIF: { city: 'El Paso', name: 'Biggs Army Air Field (Fort Bliss)' },
  BIG: { city: 'Delta Junction', name: 'Allen Army' },
  BIH: { city: 'Bishop', name: 'Eastern Sierra Regional' },
  BIK: { city: 'Biak', name: 'Frans Kaisiepo' },
  BIL: { city: 'Billings', name: 'Billings Logan International' },
  BIM: { city: 'Alice Town', name: 'South Bimini' },
  BIN: { city: 'Bamyan', name: 'Bamiyan' },
  BIO: { city: 'Bilbao', name: 'Bilbao' },
  BIQ: { city: 'Biarritz-bayonne', name: 'Biarritz-Anglet-Bayonne' },
  BIR: { city: 'Biratnagar', name: 'Biratnagar' },
  BIS: { city: 'Bismarck', name: 'Bismarck Municipal' },
  BIU: { city: 'Bildudalur', name: 'Bildudalur' },
  BIX: { city: 'Biloxi', name: 'Keesler Air Force Base' },
  BIY: { city: 'Bisho', name: 'Bisho' },
  BJA: { city: 'Bejaja', name: 'Soummam' },
  BJB: { city: 'Bojnourd', name: 'Bojnord' },
  BJC: { city: 'Broomfield-CO', name: 'Rocky Mountain Metropolitan' },
  BJF: { city: 'Batsfjord', name: 'Båtsfjord' },
  BJH: { city: 'Bajhang', name: 'Bajhang' },
  BJI: { city: 'Bemidji', name: 'Bemidji Regional' },
  BJL: { city: 'Banjul', name: 'Banjul International' },
  BJM: { city: 'Bujumbura', name: 'Bujumbura International' },
  BJO: { city: 'Bermejo', name: 'Bermejo' },
  BJP: { city: 'Braganca Paulista', name: 'Estadual Arthur Siqueira' },
  BJR: { city: 'Bahar Dar', name: 'Bahir Dar' },
  BJU: { city: 'Bajura', name: 'Bajura' },
  BJV: { city: 'Bodrum', name: 'Milas Bodrum International' },
  BJW: { city: 'Bajawa', name: 'Bajawa Soa' },
  BJX: { city: 'Del Bajio', name: 'Del Bajío International' },
  BJY: { city: 'Batajnica', name: 'Batajnica Air Base' },
  BJZ: { city: 'Badajoz', name: 'Badajoz' },
  BKA: { city: 'Moscow', name: 'Bykovo' },
  BKB: { city: 'Bikaner', name: 'Nal' },
  BKC: { city: 'Buckland', name: 'Buckland' },
  BKD: { city: 'Breckenridge', name: 'Stephens County' },
  BKE: { city: 'Baker City', name: 'Baker City Municipal' },
  BKG: { city: 'Branson', name: 'Branson' },
  BKH: { city: 'Barking Sands', name: 'Barking Sands' },
  BKI: { city: 'Kota Kinabalu', name: 'Kota Kinabalu International' },
  BKK: { city: 'Bangkok', name: 'Suvarnabhumi' },
  BKL: { city: 'Cleveland', name: 'Burke Lakefront' },
  BKM: { city: 'Bakalalan', name: 'Bakalalan' },
  BKO: { city: 'Bamako', name: 'Modibo Keita International' },
  BKQ: { city: 'Blackall', name: 'Blackall' },
  BKS: { city: 'Bengkulu', name: 'Fatmawati Soekarno' },
  BKW: { city: 'Beckley', name: 'Raleigh County Memorial' },
  BKY: { city: 'Bukavu/kavumu', name: 'Bukavu Kavumu' },
  BKZ: { city: 'Bukoba', name: 'Bukoba' },
  BLA: { city: 'Barcelona', name: 'General José Antonio Anzoategui International' },
  BLB: { city: 'Howard', name: 'Panama Pacific International' },
  BLE: { city: 'Borlange', name: 'Borlange' },
  BLF: { city: 'Bluefield', name: 'Mercer County' },
  BLG: { city: 'Belaga', name: 'Belaga' },
  BLH: { city: 'Blythe', name: 'Blythe' },
  BLI: { city: 'Bellingham', name: 'Bellingham International' },
  BLJ: { city: 'Batna', name: 'Batna' },
  BLK: { city: 'Blackpool', name: 'Blackpool International' },
  BLL: { city: 'Billund', name: 'Billund' },
  BLQ: { city: 'Bologna', name: 'Bologna Guglielmo Marconi' },
  BLR: { city: 'Bangalore', name: 'Kempegowda International' },
  BLT: { city: 'Blackwater', name: 'Blackwater' },
  BLV: { city: 'Belleville', name: 'Scott AFB/Midamerica' },
  BLZ: { city: 'Blantyre', name: 'Chileka International' },
  BMA: { city: 'Stockholm', name: 'Stockholm-Bromma' },
  BMB: { city: 'Bumba', name: 'Bumbar' },
  BMC: { city: 'Brigham City', name: 'Brigham City Regional' },
  BMD: { city: 'Belo sur Tsiribihina', name: 'Belo sur Tsiribihina' },
  BME: { city: 'Broome', name: 'Broome International' },
  BMG: { city: 'Bloomington', name: 'Monroe County' },
  BMI: { city: 'Bloomington', name: 'Central Illinois Regional Airport at Bloomington-Normal' },
  BMK: { city: 'Borkum', name: 'Borkum' },
  BMM: { city: 'Bitam', name: 'Bitam' },
  BMO: { city: 'Banmaw', name: 'Banmaw' },
  BMP: { city: 'Brampton Island', name: 'Brampton Island' },
  BMR: { city: 'Baltrum', name: 'Baltrum' },
  BMT: { city: 'Beaumont', name: 'Beaumont Municipal' },
  BMU: { city: 'Bima', name: 'Muhammad Salahuddin' },
  BMV: { city: 'Buonmethuot', name: 'Buon Ma Thuot' },
  BMW: { city: 'Bordj Badji Mokhtar', name: 'Bordj Badji Mokhtar' },
  BMX: { city: 'Big Mountain', name: 'Big Mountain' },
  BMY: { city: 'Waala', name: 'Île Art - Waala' },
  BNA: { city: 'Nashville', name: 'Nashville International' },
  BNB: { city: 'Boende', name: 'Boende' },
  BNC: { city: 'Beni', name: 'Beni' },
  BND: { city: 'Bandar Abbas', name: 'Bandar Abbas International' },
  BNE: { city: 'Brisbane', name: 'Brisbane International' },
  BNG: { city: 'Banning', name: 'Banning Municipal' },
  BNI: { city: 'Benin', name: 'Benin' },
  BNJ: { city: 'Sankt-Augustin', name: 'Bonn-Hangelar' },
  BNK: { city: 'Ballina Byron Bay', name: 'Ballina Byron Gateway' },
  BNM: { city: 'Bodinumu', name: 'Bodinumu' },
  BNN: { city: 'Bronnoysund', name: 'Brønnøysund' },
  BNO: { city: 'Burns', name: 'Burns Municipal' },
  BNP: { city: 'Bannu', name: 'Bannu' },
  BNS: { city: 'Barinas', name: 'Barinas' },
  BNU: { city: 'BLUMENAU', name: 'Blumenau' },
  BNX: { city: 'Banja Luka', name: 'Banja Luka International' },
  BOA: { city: 'Boma', name: 'Boma' },
  BOB: { city: 'Bora Bora', name: 'Bora Bora' },
  BOC: { city: 'Bocas Del Toro', name: 'Bocas Del Toro International' },
  BOD: { city: 'Bordeaux', name: 'Bordeaux-Mérignac' },
  BOG: { city: 'Bogota', name: 'El Dorado International' },
  BOH: { city: 'Bournemouth', name: 'Bournemouth' },
  BOI: { city: 'Boise', name: 'Boise Air Terminal/Gowen Field' },
  BOJ: { city: 'Bourgas', name: 'Burgas' },
  BOM: { city: 'Mumbai', name: 'Chhatrapati Shivaji International' },
  BON: { city: 'Kralendijk', name: 'Flamingo International' },
  BOO: { city: 'Bodo', name: 'Bodø' },
  BOR: { city: 'Belfort', name: 'Fontaine' },
  BOS: { city: 'Boston', name: 'General Edward Lawrence Logan International' },
  BOU: { city: 'Bourges', name: 'Bourges' },
  BOW: { city: 'Bartow', name: 'Bartow Municipal' },
  BOX: { city: 'Borroloola', name: 'Borroloola' },
  BOY: { city: 'Bobo-dioulasso', name: 'Bobo Dioulasso' },
  BPC: { city: 'Bamenda', name: 'Bamenda' },
  BPE: { city: 'Bagan', name: 'Qinhuangdao Beidaihe' },
  BPF: { city: 'Batuna', name: 'Batuna Aerodrome' },
  BPG: { city: 'Barra Do Garcas', name: 'Barra do Garças' },
  BPI: { city: 'Big Piney', name: 'Miley Memorial Field' },
  BPL: { city: 'Bole', name: 'Alashankou Bole (Bortala) airport' },
  BPM: { city: 'Hyderabad', name: 'Begumpet' },
  BPN: { city: 'Balikpapan', name: 'Sultan Aji Muhamad Sulaiman' },
  BPS: { city: 'Porto Seguro', name: 'Porto Seguro' },
  BPT: { city: 'Beaumont', name: 'Southeast Texas Regional' },
  BPX: { city: 'Bangda', name: 'Qamdo Bangda' },
  BPY: { city: 'Besalampy', name: 'Besalampy' },
  BQA: { city: 'Baler', name: 'Dr.Juan C. Angara' },
  BQB: { city: 'Brusselton', name: 'Busselton Regional' },
  BQE: { city: 'Bubaque', name: 'Bubaque' },
  BQG: { city: 'Bogorodskoe', name: 'Bogorodskoye' },
  BQH: { city: 'Biggin Hill', name: 'London Biggin Hill' },
  BQJ: { city: 'Batagay', name: 'Batagay' },
  BQK: { city: 'Brunswick', name: 'Brunswick Golden Isles' },
  BQL: { city: 'Boulia', name: 'Boulia' },
  BQN: { city: 'Aguadilla', name: 'Rafael Hernandez' },
  BQS: { city: 'Blagoveschensk', name: 'Ignatyevo' },
  BQT: { city: 'Brest', name: 'Brest' },
  BQU: { city: 'Bequia', name: 'J F Mitchell' },
  BRA: { city: 'Barreiras', name: 'Barreiras' },
  BRC: { city: 'San Carlos De Bariloche', name: 'San Carlos De Bariloche' },
  BRD: { city: 'Brainerd', name: 'Brainerd Lakes Regional' },
  BRE: { city: 'Bremen', name: 'Bremen' },
  BRI: { city: 'Bari', name: 'Bari Karol Wojtyła' },
  BRK: { city: 'Bourke', name: 'Bourke' },
  BRL: { city: 'Burlington', name: 'Southeast Iowa Regional' },
  BRM: { city: 'Barquisimeto', name: 'Barquisimeto International' },
  BRN: { city: 'Bern', name: 'Bern Belp' },
  BRO: { city: 'Brownsville', name: 'Brownsville South Padre Island International' },
  BRQ: { city: 'Brno', name: 'Brno-Tuřany' },
  BRR: { city: 'Barra', name: 'Barra' },
  BRS: { city: 'Bristol', name: 'Bristol' },
  BRT: { city: 'Bathurst Island', name: 'Bathurst Island' },
  BRU: { city: 'Brussels', name: 'Brussels' },
  BRV: { city: 'Bremerhaven', name: 'Bremerhaven' },
  BRW: { city: 'Barrow', name: 'Wiley Post Will Rogers Memorial' },
  BRX: { city: 'Barahona', name: 'Maria Montez International' },
  BSA: { city: 'Bosaso', name: 'Bosaso' },
  BSB: { city: 'Brasilia', name: 'Presidente Juscelino Kubistschek International' },
  BSC: { city: 'Bahia Solano', name: 'José Celestino Mutis' },
  BSD: { city: 'Baoshan', name: 'Baoshan Yunduan' },
  BSF: { city: 'Bradshaw Field', name: 'Bradshaw Army' },
  BSG: { city: 'Bata', name: 'Bata' },
  BSJ: { city: 'Bairnsdale', name: 'Bairnsdale' },
  BSK: { city: 'Biskra', name: 'Biskra' },
  BSL: { city: 'Mulhouse', name: 'EuroAirport Basel-Mulhouse-Freiburg' },
  BSO: { city: 'Basco', name: 'Basco' },
  BSR: { city: 'Basrah', name: 'Basrah International' },
  BST: { city: 'Lashkar Gah', name: 'Bost' },
  BSU: { city: 'Basankusu', name: 'Basankusu' },
  BSX: { city: 'Pathein', name: 'Pathein' },
  BTC: { city: 'Batticaloa', name: 'Batticaloa' },
  BTE: { city: 'Bonthe', name: 'Sherbro International' },
  BTH: { city: 'Batam', name: 'Hang Nadim International' },
  BTI: { city: 'Barter Island', name: 'Barter Island LRRS' },
  BTJ: { city: 'Banda Aceh', name: 'Sultan Iskandar Muda International' },
  BTK: { city: 'Bratsk', name: 'Bratsk' },
  BTL: { city: 'Battle Creek', name: 'W K Kellogg' },
  BTM: { city: 'Butte', name: 'Bert Mooney' },
  BTR: { city: 'Baton Rouge', name: 'Baton Rouge Metropolitan' },
  BTS: { city: 'Bratislava', name: 'M. R. Štefánik' },
  BTT: { city: 'Bettles', name: 'Bettles' },
  BTU: { city: 'Bintulu', name: 'Bintulu' },
  BTV: { city: 'Burlington', name: 'Burlington International' },
  BTW: { city: 'Batu Licin', name: 'Batu Licin' },
  BTZ: { city: 'Bursa', name: 'Bursa' },
  BUA: { city: 'Buka Island', name: 'Buka' },
  BUC: { city: 'Burketown', name: 'Burketown' },
  BUD: { city: 'Budapest', name: 'Budapest Liszt Ferenc International' },
  BUF: { city: 'Buffalo', name: 'Buffalo Niagara International' },
  BUG: { city: 'Benguela', name: 'Benguela' },
  BUI: { city: 'Bokondini-Papua Island', name: 'Bokondini' },
  BUJ: { city: 'Bou Saada', name: 'Bou Saada' },
  BUL: { city: 'Bulolo', name: 'Bulolo' },
  BUN: { city: 'Buenaventura', name: 'Gerardo Tobar López' },
  BUO: { city: 'Burao', name: 'Burao' },
  BUP: { city: 'Bhatinda', name: 'Bhatinda Air Force Station' },
  BUQ: { city: 'Bulawayo', name: 'Joshua Mqabuko Nkomo International' },
  BUR: { city: 'Burbank', name: 'Bob Hope' },
  BUS: { city: 'Batumi', name: 'Batumi International' },
  BUT: { city: 'Jakar', name: 'Bathpalathang' },
  BUU: { city: 'Muara Bungo', name: 'Muara Bungo' },
  BUW: { city: 'Bau-Bau', name: 'Betoambari' },
  BUX: { city: 'Bunia', name: 'Bunia' },
  BUY: { city: 'Bunbury', name: 'Bunbury' },
  BUZ: { city: 'Bushehr', name: 'Bushehr' },
  BVA: { city: 'Beauvais', name: 'Paris Beauvais Tillé' },
  BVB: { city: 'Boa Vista', name: 'Atlas Brasil Cantanhede' },
  BVC: { city: 'Boa Vista', name: 'Rabil' },
  BVE: { city: 'Brive', name: 'Brive Souillac' },
  BVG: { city: 'Berlevag', name: 'Berlevåg' },
  BVH: { city: 'Vilhena', name: 'Brigadeiro Camarão' },
  BVI: { city: 'Birdsville', name: 'Birdsville' },
  BVS: { city: 'Breves', name: 'Breves' },
  BVY: { city: 'Beverly', name: 'Beverly Municipal' },
  BWA: { city: 'Bhairawa', name: 'Gautam Buddha' },
  BWB: { city: 'Barrow Island', name: 'Barrow Island' },
  BWE: { city: 'Braunschweig', name: 'Braunschweig-Wolfsburg' },
  BWF: { city: 'Barrow Island', name: 'Barrow Walney Island' },
  BWG: { city: 'Bowling Green', name: 'Bowling Green Warren County Regional' },
  BWH: { city: 'Butterworth', name: 'Butterworth' },
  BWI: { city: 'Baltimore', name: 'Baltimore/Washington International Thurgood Marshall' },
  BWK: { city: 'Brac', name: 'Bol' },
  BWN: { city: 'Bandar Seri Begawan', name: 'Brunei International' },
  BWO: { city: 'Balakovo', name: 'Balakovo' },
  BWT: { city: 'Burnie', name: 'Wynyard' },
  BWU: { city: 'Sydney', name: 'Sydney Bankstown' },
  BWW: { city: 'Cayo Santa Maria', name: 'Las Brujas' },
  BWX: { city: 'Banyuwangi', name: 'Blimbingsari' },
  BXB: { city: 'Babo', name: 'Babo' },
  BXE: { city: 'Bakel', name: 'Bakel' },
  BXG: { city: 'Bendigo', name: 'Bendigo' },
  BXH: { city: 'Balkhash', name: 'Balkhash' },
  BXK: { city: 'Buckeye', name: 'Buckeye Municipal' },
  BXN: { city: 'Bodrum', name: 'Imsık' },
  BXO: { city: 'Buochs', name: 'Buochs' },
  BXP: { city: 'Biała Podlaska', name: 'Biała Podlaska' },
  BXR: { city: 'Bam', name: 'Bam' },
  BXU: { city: 'Butuan', name: 'Bancasi' },
  BXY: { city: 'Baikonur', name: 'Krainiy' },
  BYC: { city: 'Yacuiba', name: 'Yacuiba' },
  BYF: { city: 'Albert', name: 'Albert-Bray' },
  BYH: { city: 'Blytheville', name: 'Arkansas International' },
  BYI: { city: 'Burley', name: 'Burley Municipal' },
  BYJ: { city: 'Beja (madeira)', name: 'Beja Airport / Airbase' },
  BYK: { city: 'Bouake', name: 'Bouaké' },
  BYM: { city: 'Bayamo', name: 'Carlos Manuel de Cespedes' },
  BYN: { city: 'Bayankhongor', name: 'Bayankhongor' },
  BYO: { city: 'Bointo', name: 'Bonito' },
  BYP: { city: 'Barimunya', name: 'Barimunya' },
  BYQ: { city: 'Bunyu', name: 'Bunyu' },
  BYR: { city: 'Laeso', name: 'Læsø' },
  BYS: { city: 'Fort Irwin', name: 'Bicycle Lake Army Air Field' },
  BYT: { city: 'Bantry', name: 'Bantry Aerodrome' },
  BYU: { city: 'Bayreuth', name: 'Bayreuth' },
  BZA: { city: 'Bonanza', name: 'San Pedro' },
  BZC: { city: 'Buzios', name: 'Umberto Modiano' },
  BZE: { city: 'Belize City', name: 'Philip S. W. Goldson International' },
  BZG: { city: 'Bydgoszcz', name: 'Bydgoszcz Ignacy Jan Paderewski' },
  BZH: { city: 'Bumi Hills', name: 'Bumi' },
  BZI: { city: 'Balikesir', name: 'Balıkesir Merkez' },
  BZK: { city: 'Bryansk', name: 'Bryansk' },
  BZL: { city: 'Barisal', name: 'Barisal' },
  BZN: { city: 'Bozeman', name: 'Gallatin Field' },
  BZO: { city: 'Bolzano', name: 'Bolzano' },
  BZR: { city: 'Beziers', name: 'Béziers-Vias' },
  BZU: { city: 'Buta Zega', name: 'Buta Zega' },
  BZV: { city: 'Brazzaville', name: 'Maya-Maya' },
  BZY: { city: 'Saltsy', name: 'Bălți International' },
  BZZ: { city: 'Brize Norton', name: 'RAF Brize Norton' },
  CAB: { city: 'Cabinda', name: 'Cabinda' },
  CAC: { city: 'Cascavel', name: 'Cascavel' },
  CAE: { city: 'Columbia', name: 'Columbia Metropolitan' },
  CAF: { city: 'Carauari', name: 'Carauari' },
  CAG: { city: 'Cagliari', name: 'Cagliari Elmas' },
  CAH: { city: 'Ca Mau', name: 'Cà Mau' },
  CAI: { city: 'Cairo', name: 'Cairo International' },
  CAJ: { city: 'Canaima', name: 'Canaima' },
  CAK: { city: 'Akron', name: 'Akron Canton Regional' },
  CAL: { city: 'Campbeltown', name: 'Campbeltown' },
  CAN: { city: 'Guangzhou', name: 'Guangzhou Baiyun International' },
  CAP: { city: 'Cap Haitien', name: 'Cap Haitien International' },
  CAQ: { city: 'Caucasia', name: 'Juan H White' },
  CAR: { city: 'Caribou', name: 'Caribou Municipal' },
  CAT: { city: 'Cascais', name: 'Cascais' },
  CAU: { city: 'Caruaru', name: 'Caruaru' },
  CAW: { city: 'Campos', name: 'Bartolomeu Lisandro' },
  CAX: { city: 'Carlisle', name: 'Carlisle' },
  CAY: { city: 'Cayenne', name: 'Cayenne-Rochambeau' },
  CAZ: { city: 'Cobar', name: 'Cobar' },
  CBB: { city: 'Cochabamba', name: 'Jorge Wilsterman International' },
  CBD: { city: 'Carnicobar', name: 'Car Nicobar Air Force Station' },
  CBE: { city: 'Cumberland', name: 'Greater Cumberland Regional' },
  CBF: { city: 'Council Bluffs', name: 'Council Bluffs Municipal' },
  CBG: { city: 'Cambridge', name: 'Cambridge' },
  CBH: { city: 'Béchar', name: 'Béchar Boudghene Ben Ali Lotfi' },
  CBJ: { city: 'Cabo Rojo', name: 'Cabo Rojo' },
  CBL: { city: 'Ciudad Bolivar', name: 'Aeropuerto General Tomas de Heres. Ciudad Bolivar' },
  CBM: { city: 'Colombus', name: 'Columbus Air Force Base' },
  CBN: { city: 'Cirebon', name: 'Penggung' },
  CBO: { city: 'Cotabato', name: 'Awang' },
  CBQ: { city: 'Calabar', name: 'Margaret Ekpo International' },
  CBR: { city: 'Canberra', name: 'Canberra International' },
  CBT: { city: 'Catumbela', name: 'Catumbela' },
  CBU: { city: 'Cottbus', name: 'Cottbus-Drewitz' },
  CBV: { city: 'Coban', name: 'Coban' },
  CCA: { city: 'Chapacura', name: 'Chimore' },
  CCB: { city: 'Upland', name: 'Cable' },
  CCC: { city: 'Cunagua', name: 'Jardines Del Rey' },
  CCF: { city: 'Carcassonne', name: 'Carcassonne' },
  CCH: { city: 'Chile Chico', name: 'Chile Chico' },
  CCI: { city: 'Concordia', name: 'Concórdia' },
  CCJ: { city: 'Calicut', name: 'Calicut International' },
  CCK: { city: 'Cocos Keeling Island', name: 'Cocos (Keeling) Islands' },
  CCL: { city: 'Chinchilla', name: 'Chinchilla' },
  CCM: { city: 'Criciuma', name: 'Diomício Freitas' },
  CCN: { city: 'Chaghcharan', name: 'Chakcharan' },
  CCP: { city: 'Concepcion', name: 'Carriel Sur' },
  CCR: { city: 'Concord', name: 'Buchanan Field' },
  CCS: { city: 'Caracas', name: 'Simón Bolívar International' },
  CCU: { city: 'Kolkata', name: 'Netaji Subhash Chandra Bose International' },
  CCV: { city: 'Craig Cove', name: 'Craig Cove' },
  CCX: { city: 'Caceres', name: 'Cáceres' },
  CCY: { city: 'Charles City', name: 'Northeast Iowa Regional' },
  CCZ: { city: 'Chub Cay', name: 'Chub Cay' },
  CDA: { city: 'Cooinda', name: 'Cooinda' },
  CDB: { city: 'Cold Bay', name: 'Cold Bay' },
  CDC: { city: 'Cedar City', name: 'Cedar City Regional' },
  CDE: { city: 'Chengde', name: 'Chengde Puning' },
  CDG: { city: 'Paris', name: 'Charles de Gaulle International' },
  CDJ: { city: 'Conceicao Do Araguaia', name: 'Conceição do Araguaia' },
  CDN: { city: 'Camden', name: 'Woodward Field' },
  CDP: { city: 'Cuddapah', name: 'Kadapa' },
  CDR: { city: 'Chadron', name: 'Chadron Municipal' },
  CDS: { city: 'Childress', name: 'Childress Municipal' },
  CDT: { city: 'Castellón de la Plana', name: 'Castellón-Costa Azahar' },
  CDU: { city: 'Camden', name: 'Camden' },
  CDV: { city: 'Cordova', name: 'Merle K (Mudhole) Smith' },
  CDW: { city: 'Caldwell', name: 'Essex County' },
  CEB: { city: 'Cebu', name: 'Mactan Cebu International' },
  CEC: { city: 'Crescent City', name: 'Jack Mc Namara Field' },
  CED: { city: 'Ceduna', name: 'Ceduna' },
  CEE: { city: 'Cherepovets', name: 'Cherepovets' },
  CEF: { city: 'Chicopee Falls', name: 'Westover ARB/Metropolitan' },
  CEG: { city: 'Hawarden', name: 'Hawarden' },
  CEI: { city: 'Chiang Rai', name: 'Chiang Rai International' },
  CEJ: { city: 'Chernigov', name: 'Chernihiv Shestovitsa' },
  CEK: { city: 'Chelyabinsk', name: 'Chelyabinsk Balandino' },
  CEM: { city: 'Central', name: 'Central' },
  CEN: { city: 'Ciudad Obregon', name: 'Ciudad Obregón International' },
  CEQ: { city: 'Cannes', name: 'Cannes-Mandelieu' },
  CER: { city: 'Cherbourg', name: 'Cherbourg-Maupertus' },
  CES: { city: 'Cessnock', name: 'Cessnock' },
  CET: { city: 'Cholet', name: 'Cholet Le Pontreau' },
  CEU: { city: 'Clemson', name: 'Oconee County Regional' },
  CEW: { city: 'Crestview', name: 'Bob Sikes' },
  CEZ: { city: 'Cortez', name: 'Cortez Municipal' },
  CFB: { city: 'Cabo Frio', name: 'Cabo Frio' },
  CFC: { city: 'Cacador', name: 'Caçador' },
  CFD: { city: 'Bryan', name: 'Coulter Field' },
  CFE: { city: 'Clermont-Ferrand', name: 'Clermont-Ferrand Auvergne' },
  CFG: { city: 'Cienfuegos', name: 'Jaime Gonzalez' },
  CFK: { city: 'Ech-cheliff', name: 'Ech Cheliff' },
  CFN: { city: 'Dongloe', name: 'Donegal' },
  CFO: { city: 'Confresa', name: 'Confresa' },
  CFR: { city: 'Caen', name: 'Caen-Carpiquet' },
  CFS: { city: 'Coffs Harbour', name: 'Coffs Harbour' },
  CFU: { city: 'Kerkyra/corfu', name: 'Ioannis Kapodistrias International' },
  CFV: { city: 'Coffeyville', name: 'Coffeyville Municipal' },
  CGB: { city: 'Cuiaba', name: 'Marechal Rondon' },
  CGD: { city: 'Changde', name: 'Changde' },
  CGF: { city: 'Richmond Heights', name: 'Cuyahoga County' },
  CGH: { city: 'Sao Paulo', name: 'Congonhas' },
  CGI: { city: 'Cape Girardeau', name: 'Cape Girardeau Regional' },
  CGJ: { city: 'Kasompe', name: 'Kasompe' },
  CGK: { city: 'Jakarta', name: 'Soekarno-Hatta International' },
  CGM: { city: 'Camiguin', name: 'Camiguin' },
  CGN: { city: 'Cologne', name: 'Cologne Bonn' },
  CGO: { city: 'Zhengzhou', name: 'Zhengzhou Xinzheng International' },
  CGP: { city: 'Chittagong', name: 'Shah Amanat International' },
  CGQ: { city: 'Changchun', name: 'Longjia' },
  CGR: { city: 'Campo Grande', name: 'Campo Grande' },
  CGX: { city: 'Chicago', name: 'Chicago Meigs' },
  CGY: { city: 'Cagayan de Oro City', name: 'Laguindingan' },
  CGZ: { city: 'Casa Grande', name: 'Casa Grande Municipal' },
  CHA: { city: 'Chattanooga', name: 'Lovell Field' },
  CHC: { city: 'Christchurch', name: 'Christchurch International' },
  CHF: { city: 'Chinhae', name: 'Jinhae Airbase/Airport (G-813/K-10)' },
  CHG: { city: 'Chaoyang', name: 'Chaoyang' },
  CHH: { city: 'Chachapoyas', name: 'Chachapoyas' },
  CHM: { city: 'Chimbote', name: 'Teniente FAP Jaime A De Montreuil Morales' },
  CHN: { city: 'Jhunju', name: 'Jeon Ju Airport (G-703)' },
  CHO: { city: 'Charlottesville VA', name: 'Charlottesville Albemarle' },
  CHQ: { city: 'Chania', name: 'Chania International' },
  CHR: { city: 'Chateauroux', name: 'Châteauroux-Déols Marcel Dassault' },
  CHS: { city: 'Charleston', name: 'Charleston Air Force Base-International' },
  CHT: { city: 'Chatham Island', name: 'Chatham Islands-Tuuta' },
  CHU: { city: 'Chuathbaluk', name: 'Chuathbaluk' },
  CHX: { city: 'Changuinola', name: 'Cap Manuel Niño International' },
  CHY: { city: 'Choiseul Bay', name: 'Choiseul Bay' },
  CIA: { city: 'Rome', name: 'Ciampino–G. B. Pastine International' },
  CIC: { city: 'Chico', name: 'Chico Municipal' },
  CID: { city: 'Cedar Rapids', name: 'The Eastern Iowa' },
  CIF: { city: 'Chifeng', name: 'Chifeng' },
  CIH: { city: 'Changzhi', name: 'Changzhi' },
  CIJ: { city: 'Cobija', name: 'Capitán Aníbal Arab' },
  CIK: { city: 'Chalkyitsik', name: 'Chalkyitsik' },
  CIO: { city: 'Conception', name: 'Teniente Col Carmelo Peralta' },
  CIP: { city: 'Chipata', name: 'Chipata' },
  CIS: { city: 'Canton Island', name: 'Canton Island' },
  CIT: { city: 'Chimkent', name: 'Shymkent' },
  CIU: { city: 'Sault Ste Marie', name: 'Chippewa County International' },
  CIW: { city: 'Canouan Island', name: 'Canouan' },
  CIX: { city: 'Chiclayo', name: 'Capitan FAP Jose A Quinones Gonzales International' },
  CIY: { city: 'Comiso', name: 'Comiso' },
  CIZ: { city: 'Coari', name: 'Coari' },
  CJA: { city: 'Cajamarca', name: 'Mayor General FAP Armando Revoredo Iglesias' },
  CJB: { city: 'Coimbatore', name: 'Coimbatore International' },
  CJC: { city: 'Calama', name: 'El Loa' },
  CJF: { city: 'Coondewanna', name: 'Coondewanna' },
  CJJ: { city: 'Chongju', name: 'Cheongju International Airport/Cheongju Air Base (K-59/G-513)' },
  CJL: { city: 'Chitral', name: 'Chitral' },
  CJM: { city: 'Chumphon', name: 'Chumphon' },
  CJN: { city: 'Nusawiru', name: 'Nusawiru' },
  CJS: { city: 'Ciudad Juarez', name: 'Abraham González International' },
  CJU: { city: 'Cheju', name: 'Jeju International' },
  CKB: { city: 'Clarksburg', name: 'North Central West Virginia' },
  CKC: { city: 'Cherkassy', name: 'Cherkasy International' },
  CKG: { city: 'Chongqing', name: 'Chongqing Jiangbei International' },
  CKH: { city: 'Chokurdah', name: 'Chokurdakh' },
  CKI: { city: 'Croker Island', name: 'Croker Island' },
  CKL: { city: 'Shchyolkovo', name: 'Chkalovskiy Air Base' },
  CKS: { city: 'Parauapebas', name: 'Carajás' },
  CKT: { city: 'Sarakhs', name: 'Sarakhs' },
  CKV: { city: 'Clarksville', name: 'Clarksville–Montgomery County Regional' },
  CKY: { city: 'Conakry', name: 'Conakry International' },
  CKZ: { city: 'Canakkale', name: 'Çanakkale' },
  CLD: { city: 'Carlsbad', name: 'Mc Clellan-Palomar' },
  CLE: { city: 'Cleveland', name: 'Cleveland Hopkins International' },
  CLJ: { city: 'Cluj-napoca', name: 'Cluj-Napoca International' },
  CLL: { city: 'College Station', name: 'Easterwood Field' },
  CLM: { city: 'Port Angeles', name: 'William R Fairchild International' },
  CLN: { city: 'Carolina', name: 'Brig. Lysias Augusto Rodrigues' },
  CLO: { city: 'Cali', name: 'Alfonso Bonilla Aragon International' },
  CLP: { city: 'Clarks Point', name: 'Clarks Point' },
  CLQ: { city: 'Colima', name: 'Licenciado Miguel de la Madrid' },
  CLS: { city: 'Chehalis', name: 'Chehalis Centralia' },
  CLT: { city: 'Charlotte', name: 'Charlotte Douglas International' },
  CLU: { city: 'Columbus', name: 'Columbus Municipal' },
  CLV: { city: 'Caldas Novas', name: 'Nelson Ribeiro Guimarães' },
  CLW: { city: 'Clearwater', name: 'Clearwater Air Park' },
  CLY: { city: 'Calvi', name: 'Calvi-Sainte-Catherine' },
  CLZ: { city: 'Calabozo', name: 'Calabozo' },
  CMA: { city: 'Cunnamulla', name: 'Cunnamulla' },
  CMB: { city: 'Colombo', name: 'Bandaranaike International Colombo' },
  CME: { city: 'Ciudad Del Carmen', name: 'Ciudad del Carmen International' },
  CMF: { city: 'Chambery', name: 'Chambéry-Savoie' },
  CMG: { city: 'Corumba', name: 'Corumbá International' },
  CMH: { city: 'Columbus', name: 'John Glenn Columbus International' },
  CMI: { city: 'Champaign', name: 'University of Illinois Willard' },
  CMJ: { city: 'Cimei', name: 'Chi Mei' },
  CMK: { city: 'Club Makokola', name: 'Club Makokola' },
  CMN: { city: 'Casablanca', name: 'Mohammed V International' },
  CMP: { city: 'Santana do Araguaia', name: 'Santana do Araguaia' },
  CMQ: { city: 'Clermont', name: 'Clermont' },
  CMR: { city: 'Colmar', name: 'Colmar-Houssen' },
  CMU: { city: 'Kundiawa', name: 'Chimbu' },
  CMW: { city: 'Camaguey', name: 'Ignacio Agramonte International' },
  CMX: { city: 'Hancock', name: 'Houghton County Memorial' },
  CNB: { city: 'Coonamble', name: 'Coonamble' },
  CNC: { city: 'Coconut Island', name: 'Coconut Island' },
  CND: { city: 'Constanta', name: 'Mihail Kogălniceanu International' },
  CNF: { city: 'Belo Horizonte', name: 'Tancredo Neves International' },
  CNG: { city: 'Cognac', name: 'Cognac-Châteaubernard (BA 709) Air Base' },
  CNI: { city: 'Changhai', name: 'Changhai' },
  CNJ: { city: 'Cloncurry', name: 'Cloncurry' },
  CNL: { city: 'Sindal', name: 'Sindal' },
  CNM: { city: 'Carlsbad', name: 'Cavern City Air Terminal' },
  CNN: { city: 'Kannur', name: 'Kannur International' },
  CNO: { city: 'Chino', name: 'Chino' },
  CNP: { city: 'Neerlerit Inaat', name: 'Neerlerit Inaat' },
  CNQ: { city: 'Corrientes', name: 'Corrientes' },
  CNR: { city: 'Chañaral', name: 'Chañaral' },
  CNS: { city: 'Cairns', name: 'Cairns International' },
  CNU: { city: 'Chanute', name: 'Chanute Martin Johnson' },
  CNW: { city: 'Waco', name: 'TSTC Waco' },
  CNX: { city: 'Chiang Mai', name: 'Chiang Mai International' },
  CNY: { city: 'Moab', name: 'Canyonlands Field' },
  COC: { city: 'Concordia', name: 'Comodoro Pierrestegui' },
  COD: { city: 'Cody', name: 'Yellowstone Regional' },
  COE: { city: 'Coeur dAlene', name: 'Coeur DAlene - Pappy Boyington Field' },
  COF: { city: 'Coco Beach', name: 'Patrick Air Force Base' },
  COG: { city: 'Condoto', name: 'Mandinga' },
  COH: { city: 'Cooch-behar', name: 'Cooch Behar' },
  COJ: { city: 'Coonabarabran', name: 'Coonabarabran' },
  COK: { city: 'Kochi', name: 'Cochin International' },
  CON: { city: 'Concord NH', name: 'Concord Municipal' },
  COO: { city: 'Cotonou', name: 'Cadjehoun' },
  COQ: { city: 'Choibalsan', name: 'Choibalsan' },
  COR: { city: 'Cordoba', name: 'Ingeniero Ambrosio Taravella' },
  COS: { city: 'Colorado Springs', name: 'City of Colorado Springs Municipal' },
  COT: { city: 'Cotulla', name: 'Cotulla-La Salle County' },
  COU: { city: 'Columbia', name: 'Columbia Regional' },
  COX: { city: 'Andros', name: 'Congo Town' },
  COZ: { city: 'Constanza', name: 'Constanza - Expedición 14 de Junio National' },
  CPA: { city: 'Greenville', name: 'Cape Palmas' },
  CPB: { city: 'Capurgana', name: 'Capurganá' },
  CPC: { city: 'San Martin Des Andes', name: 'Aviador C. Campos' },
  CPD: { city: 'Coober Pedy', name: 'Coober Pedy' },
  CPE: { city: 'Campeche', name: 'Ingeniero Alberto Acuña Ongay International' },
  CPH: { city: 'Copenhagen', name: 'Copenhagen Kastrup' },
  CPO: { city: 'Copiapo', name: 'Desierto de Atacama' },
  CPQ: { city: 'Campinas', name: 'Amarais' },
  CPR: { city: 'Casper', name: 'Casper-Natrona County International' },
  CPT: { city: 'Cape Town', name: 'Cape Town International' },
  CPV: { city: 'Campina Grande', name: 'Presidente João Suassuna' },
  CPX: { city: 'Culebra Island', name: 'Benjamin Rivera Noriega' },
  CQA: { city: 'Canarana', name: 'Canarana' },
  CQD: { city: 'Shahre Kord', name: 'Shahrekord' },
  CQF: { city: 'Calais', name: 'Calais-Dunkerque' },
  CQM: { city: 'Ciudad Real', name: 'Ciudad Real Central' },
  CQS: { city: 'COSTA MARQUES', name: 'Costa Marques' },
  CRA: { city: 'Craiova', name: 'Craiova' },
  CRC: { city: 'Cartago', name: 'Santa Ana' },
  CRD: { city: 'Comodoro Rivadavia', name: 'General E. Mosconi' },
  CRE: { city: 'North Myrtle Beach', name: 'Grand Strand' },
  CRG: { city: 'Jacksonville', name: 'Jacksonville Executive at Craig' },
  CRI: { city: 'Colonel Hill', name: 'Colonel Hill' },
  CRK: { city: 'Angeles City', name: 'Diosdado Macapagal International' },
  CRL: { city: 'Charleroi', name: 'Brussels South Charleroi' },
  CRM: { city: 'Catarman', name: 'Catarman National' },
  CRP: { city: 'Corpus Christi', name: 'Corpus Christi International' },
  CRQ: { city: 'Caravelas', name: 'Caravelas' },
  CRV: { city: 'Crotone', name: 'Crotone' },
  CRW: { city: 'Charleston', name: 'Yeager' },
  CRZ: { city: 'Chardzhou', name: 'Turkmenabat' },
  CSA: { city: 'Colonsay', name: 'Colonsay Airstrip' },
  CSB: { city: 'Caransebes', name: 'Caransebeş' },
  CSF: { city: 'Creil', name: 'Creil Air Base' },
  CSG: { city: 'Columbus', name: 'Columbus Metropolitan' },
  CSH: { city: 'Solovetsky Islands', name: 'Solovki' },
  CSK: { city: 'Cap Skiring', name: 'Cap Skirring' },
  CSM: { city: 'Clinton', name: 'Clinton Sherman' },
  CSO: { city: 'Cochstedt', name: 'Cochstedt' },
  CSV: { city: 'Crossville', name: 'Crossville Memorial Whitson Field' },
  CSX: { city: 'Changcha', name: 'Changsha Huanghua International' },
  CSY: { city: 'Cheboksary', name: 'Cheboksary' },
  CSZ: { city: 'Colonel Suarez', name: 'Brigadier D.H.E. Ruiz' },
  CTA: { city: 'Catania', name: 'Catania-Fontanarossa' },
  CTB: { city: 'Cutbank', name: 'Cut Bank International' },
  CTC: { city: 'Catamarca', name: 'Catamarca' },
  CTD: { city: 'Chitré', name: 'Alonso Valderrama' },
  CTG: { city: 'Cartagena', name: 'Rafael Nuñez International' },
  CTH: { city: 'Coatesville', name: 'Chester County G O Carlson' },
  CTL: { city: 'Charlieville', name: 'Charleville' },
  CTM: { city: 'Chetumal', name: 'Chetumal International' },
  CTN: { city: 'Cooktown', name: 'Cooktown' },
  CTS: { city: 'Sapporo', name: 'New Chitose' },
  CTT: { city: 'Le Castellet', name: 'Le Castellet' },
  CTU: { city: 'Chengdu', name: 'Chengdu Shuangliu International' },
  CTY: { city: 'Cross City', name: 'Cross City' },
  CUA: { city: 'Ciudad Constitución', name: 'Ciudad Constitución' },
  CUB: { city: 'Columbia', name: 'Jim Hamilton L.B. Owens' },
  CUC: { city: 'Cucuta', name: 'Camilo Daza International' },
  CUD: { city: 'Caloundra', name: 'Caloundra' },
  CUE: { city: 'Cuenca', name: 'Mariscal Lamar' },
  CUF: { city: 'Cuneo', name: 'Cuneo International' },
  CUH: { city: 'Cushing', name: 'Cushing Municipal' },
  CUL: { city: 'Culiacan', name: 'Bachigualato Federal International' },
  CUM: { city: 'Cumana', name: 'Cumaná (Antonio José de Sucre)' },
  CUN: { city: 'Cancun', name: 'Cancún International' },
  CUP: { city: 'Carupano', name: 'General Francisco Bermúdez' },
  CUQ: { city: 'Coen', name: 'Coen' },
  CUR: { city: 'Willemstad', name: 'Hato International' },
  CUT: { city: 'Cutralco', name: 'Cutral-Co' },
  CUU: { city: 'Chihuahua', name: 'General Roberto Fierro Villalobos International' },
  CUZ: { city: 'Cuzco', name: 'Alejandro Velasco Astete International' },
  CVE: { city: 'Coveñas', name: 'Coveñas' },
  CVF: { city: 'Courcheval', name: 'Courchevel' },
  CVG: { city: 'Cincinnati', name: 'Cincinnati Northern Kentucky International' },
  CVJ: { city: 'Cuernavaca', name: 'General Mariano Matamoros' },
  CVM: { city: 'Ciudad Victoria', name: 'General Pedro Jose Mendez International' },
  CVN: { city: 'Clovis', name: 'Clovis Municipal' },
  CVO: { city: 'Corvallis', name: 'Corvallis Municipal' },
  CVQ: { city: 'Carnarvon', name: 'Carnarvon' },
  CVS: { city: 'Clovis', name: 'Cannon Air Force Base' },
  CVT: { city: 'Coventry', name: 'Coventry' },
  CVU: { city: 'Corvo', name: 'Corvo' },
  CWA: { city: 'Wassau', name: 'Central Wisconsin' },
  CWB: { city: 'Curitiba', name: 'Afonso Pena' },
  CWC: { city: 'Chernovtsk', name: 'Chernivtsi International' },
  CWE: { city: 'Cairo', name: 'Cairo West' },
  CWI: { city: 'Clinton', name: 'Clinton Municipal' },
  CWJ: { city: 'Cangyuan', name: 'Cangyuan Washan' },
  CWL: { city: 'Cardiff', name: 'Cardiff International' },
  CWT: { city: 'Chatsworth', name: 'Cowra' },
  CXA: { city: 'Caicara De Orinoco', name: 'Caicara del Orinoco' },
  CXB: { city: 'Coxs Bazar', name: 'Coxs Bazar' },
  CXH: { city: 'Vancouver', name: 'Vancouver Harbour Water Aerodrome' },
  CXI: { city: 'Kiritimati', name: 'Cassidy International' },
  CXJ: { city: 'Caxias Do Sul', name: 'Hugo Cantergiani Regional' },
  CXL: { city: 'Calexico', name: 'Calexico International' },
  CXO: { city: 'Conroe', name: 'Conroe-North Houston Regional' },
  CXP: { city: 'Cilacap', name: 'Tunggul Wulung' },
  CXR: { city: 'Nha Trang', name: 'Cam Ranh' },
  CYA: { city: 'Cayes', name: 'Les Cayes' },
  CYB: { city: 'Cayman Brac', name: 'Gerrard Smith International' },
  CYF: { city: 'Chefornak', name: 'Chefornak' },
  CYI: { city: 'Chiayi', name: 'Chiayi' },
  CYO: { city: 'Cayo Largo del Sur', name: 'Vilo Acuña International' },
  CYP: { city: 'Calbayog City', name: 'Calbayog' },
  CYR: { city: 'Colonia', name: 'Laguna de Los Patos International' },
  CYS: { city: 'Cheyenne', name: 'Cheyenne Regional Jerry Olson Field' },
  CYT: { city: 'Yakataga', name: 'Yakataga' },
  CYU: { city: 'Cuyo', name: 'Cuyo' },
  CYW: { city: 'Celaya', name: 'Captain Rogelio Castillo National' },
  CYX: { city: 'Cherskiy', name: 'Cherskiy' },
  CYZ: { city: 'Cauayan', name: 'Cauayan' },
  CZA: { city: 'Chichen Itza', name: 'Chichen Itza International' },
  CZE: { city: 'Coro', name: 'José Leonardo Chirinos' },
  CZF: { city: 'Cape Romanzof', name: 'Cape Romanzof LRRS' },
  CZL: { city: 'Constantine', name: 'Mohamed Boudiaf International' },
  CZM: { city: 'Cozumel', name: 'Cozumel International' },
  CZS: { city: 'Cruzeiro do Sul', name: 'Cruzeiro do Sul' },
  CZU: { city: 'Corozal', name: 'Las Brujas' },
  CZX: { city: 'Changzhou', name: 'Changzhou Benniu' },
  DAA: { city: 'Fort Belvoir', name: 'Davison Army Air Field' },
  DAB: { city: 'Daytona Beach', name: 'Daytona Beach International' },
  DAC: { city: 'Dhaka', name: 'Hazrat Shahjalal International' },
  DAD: { city: 'Danang', name: 'Da Nang International' },
  DAG: { city: 'Daggett', name: 'Barstow Daggett' },
  DAL: { city: 'Dallas', name: 'Dallas Love Field' },
  DAM: { city: 'Damascus', name: 'Damascus International' },
  DAN: { city: 'Danville', name: 'Danville Regional' },
  DAR: { city: 'Dar Es Salaam', name: 'Julius Nyerere International' },
  DAT: { city: 'Datong', name: 'Datong' },
  DAU: { city: 'Daru', name: 'Daru' },
  DAV: { city: 'David', name: 'Enrique Malek International' },
  DAX: { city: 'Dazhou', name: 'Dachuan' },
  DAY: { city: 'Dayton', name: 'James M Cox Dayton International' },
  DBA: { city: 'Dalbandin', name: 'Dalbandin' },
  DBB: { city: 'Dabaa City', name: 'El Alamein International' },
  DBC: { city: 'Baicheng', name: 'Baicheng Changan' },
  DBD: { city: 'Dhanbad', name: 'Dhanbad' },
  DBM: { city: 'Debre Marqos', name: 'Debra Marcos' },
  DBN: { city: 'Dublin', name: 'W H Bud Barron' },
  DBO: { city: 'Dubbo', name: 'Dubbo City Regional' },
  DBQ: { city: 'Dubuque IA', name: 'Dubuque Regional' },
  DBT: { city: 'Debre Tabor', name: 'Debre Tabor' },
  DBV: { city: 'Dubrovnik', name: 'Dubrovnik' },
  DCA: { city: 'Washington', name: 'Ronald Reagan Washington National' },
  DCF: { city: 'Canefield', name: 'Canefield' },
  DCI: { city: 'Decimomannu', name: 'Decimomannu Air Base' },
  DCM: { city: 'Castres', name: 'Castres-Mazamet' },
  DCN: { city: 'Derby', name: 'RAAF Base Curtin' },
  DCT: { city: 'Duncan Town', name: 'Duncan Town' },
  DCU: { city: 'Decatur', name: 'Pryor Field Regional' },
  DCY: { city: 'Daocheng', name: 'Daocheng Yading' },
  DDC: { city: 'Dodge City', name: 'Dodge City Regional' },
  DDG: { city: 'Dandong', name: 'Dandong' },
  DEA: { city: 'Dera Ghazi Khan', name: 'Dera Ghazi Khan' },
  DEB: { city: 'Debrecen', name: 'Debrecen International' },
  DEC: { city: 'Decatur', name: 'Decatur' },
  DED: { city: 'Dehra Dun', name: 'Dehradun' },
  DEE: { city: 'Yuzhno-Kurilsk', name: 'Mendeleyevo' },
  DEF: { city: 'Dezful', name: 'Dezful' },
  DEL: { city: 'Delhi', name: 'Indira Gandhi International' },
  DEM: { city: 'Dembidollo', name: 'Dembidollo' },
  DEN: { city: 'Denver', name: 'Denver International' },
  DES: { city: 'Desroches', name: 'Desroches' },
  DET: { city: 'Detroit', name: 'Coleman A. Young Municipal' },
  DEX: { city: 'Dekai', name: 'Nop Goliat' },
  DEZ: { city: 'Deire Zor', name: 'Deir ez-Zor Air Base' },
  DFW: { city: 'Dallas-Fort Worth', name: 'Dallas Fort Worth International' },
  DGE: { city: 'Mudgee', name: 'Mudgee' },
  DGL: { city: 'Douglas', name: 'Douglas Municipal' },
  DGO: { city: 'Durango', name: 'General Guadalupe Victoria International' },
  DGP: { city: 'Daugavpils', name: 'Daugavpils Intrenational' },
  DGT: { city: 'Dumaguete', name: 'Sibulan' },
  DHA: { city: 'Dhahran', name: 'King Abdulaziz Air Base' },
  DHF: { city: 'Abu Dhabi', name: 'Al Dhafra Air Base' },
  DHI: { city: 'Dhangarhi', name: 'Dhangarhi' },
  DHM: { city: 'Kangra', name: 'Kangra' },
  DHN: { city: 'Dothan', name: 'Dothan Regional' },
  DHR: { city: 'De Kooy', name: 'De Kooy' },
  DHT: { city: 'Dalhart', name: 'Dalhart Municipal' },
  DIA: { city: 'Doha', name: 'Doha International' },
  DIB: { city: 'Mohanbari', name: 'Dibrugarh' },
  DIE: { city: 'Antsiranana', name: 'Arrachart' },
  DIG: { city: 'Shangri-La', name: 'Diqing' },
  DIJ: { city: 'Dijon', name: 'Dijon-Bourgogne' },
  DIK: { city: 'Dickinson', name: 'Dickinson Theodore Roosevelt Regional' },
  DIL: { city: 'Dili', name: 'Presidente Nicolau Lobato International' },
  DIN: { city: 'Dienbienphu', name: 'Dien Bien Phu' },
  DIQ: { city: 'Divinopolis', name: 'Brigadeiro Cabral' },
  DIR: { city: 'Dire Dawa', name: 'Aba Tenna Dejazmach Yilma International' },
  DIS: { city: 'Loubomo', name: 'Ngot Nzoungou' },
  DIU: { city: 'Diu', name: 'Diu' },
  DIY: { city: 'Diyabakir', name: 'Diyarbakir' },
  DJB: { city: 'Jambi', name: 'Sultan Thaha' },
  DJE: { city: 'Djerba', name: 'Djerba Zarzis International' },
  DJG: { city: 'Djanet', name: 'Djanet Inedbirene' },
  DJJ: { city: 'Jayapura', name: 'Sentani International' },
  DJO: { city: 'Daloa', name: 'Daloa' },
  DKI: { city: 'Dunk Island', name: 'Dunk Island' },
  DKK: { city: 'Dunkirk', name: 'Chautauqua County-Dunkirk' },
  DKR: { city: 'Dakar', name: 'Léopold Sédar Senghor International' },
  DKS: { city: 'Dikson', name: 'Dikson' },
  DKV: { city: 'Docker River', name: 'Docker River' },
  DLA: { city: 'Douala', name: 'Douala International' },
  DLC: { city: 'Dalian', name: 'Zhoushuizi' },
  DLD: { city: 'Geilo', name: 'Geilo Airport Dagali' },
  DLE: { city: 'Dole', name: 'Dole-Tavaux' },
  DLF: { city: 'Del Rio', name: 'DLF' },
  DLG: { city: 'Dillingham', name: 'Dillingham' },
  DLH: { city: 'Duluth', name: 'Duluth International' },
  DLI: { city: 'Dalat', name: 'Lien Khuong' },
  DLK: { city: 'Dulkaninna', name: 'Dulkaninna' },
  DLM: { city: 'Dalaman', name: 'Dalaman International' },
  DLS: { city: 'The Dalles', name: 'Columbia Gorge Regional the Dalles Municipal' },
  DLU: { city: 'Dali', name: 'Dali' },
  DLY: { city: 'Dillons Bay', name: 'Dillons Bay' },
  DLZ: { city: 'Dalanzadgad', name: 'Dalanzadgad' },
  DMA: { city: 'Tucson', name: 'Davis Monthan Air Force Base' },
  DMB: { city: 'Dzhambul', name: 'Taraz' },
  DMD: { city: 'Doomadgee', name: 'Doomadgee' },
  DME: { city: 'Moscow', name: 'Domodedovo International' },
  DMK: { city: 'Bangkok', name: 'Don Mueang International' },
  DMM: { city: 'Dammam', name: 'King Fahd International' },
  DMN: { city: 'Deming', name: 'Deming Municipal' },
  DMT: { city: 'Diamantino', name: 'Diamantino' },
  DMU: { city: 'Dimapur', name: 'Dimapur' },
  DNA: { city: 'Kadena', name: 'Kadena Air Base' },
  DND: { city: 'Dundee', name: 'Dundee' },
  DNH: { city: 'Dunhuang', name: 'Dunhuang' },
  DNK: { city: 'Dnepropetrovsk', name: 'Dnipropetrovsk International' },
  DNL: { city: 'Augusta', name: 'Daniel Field' },
  DNN: { city: 'Dalton', name: 'Dalton Municipal' },
  DNP: { city: 'Dang', name: 'Tulsipur' },
  DNQ: { city: 'Deniliquin', name: 'Deniliquin' },
  DNR: { city: 'Dinard', name: 'Dinard-Pleurtuit-Saint-Malo' },
  DNV: { city: 'Danville', name: 'Vermilion Regional' },
  DNZ: { city: 'Denizli', name: 'Çardak' },
  DOB: { city: 'Dobo', name: 'Rar Gwamar' },
  DOD: { city: 'Dodoma', name: 'Dodoma' },
  DOG: { city: 'Dongola', name: 'Dongola' },
  DOH: { city: 'Doha', name: 'Hamad International' },
  DOK: { city: 'Donetsk', name: 'Donetsk International' },
  DOL: { city: 'Deauville', name: 'Deauville-Saint-Gatien' },
  DOM: { city: 'Dominica', name: 'Douglas-Charles' },
  DOP: { city: 'Dolpa', name: 'Dolpa' },
  DOU: { city: 'Dourados', name: 'Dourados' },
  DOV: { city: 'Dover', name: 'Dover Air Force Base' },
  DOY: { city: 'Dongying', name: 'Dongying Shengli' },
  DPA: { city: 'West Chicago', name: 'Dupage' },
  DPL: { city: 'Dipolog', name: 'Dipolog' },
  DPO: { city: 'Devonport', name: 'Devonport' },
  DPS: { city: 'Denpasar', name: 'Ngurah Rai (Bali) International' },
  DQA: { city: 'Daqing', name: 'Saertu' },
  DQM: { city: 'Duqm', name: 'Duqm International' },
  DRA: { city: 'Mercury', name: 'Desert Rock' },
  DRB: { city: 'Derby', name: 'Derby' },
  DRE: { city: 'Drummond Island', name: 'Drummond Island' },
  DRG: { city: 'Deering', name: 'Deering' },
  DRI: { city: 'Deridder', name: 'Beauregard Regional' },
  DRJ: { city: 'Drietabbetje', name: 'Drietabbetje' },
  DRK: { city: 'Puntarenas', name: 'Drake Bay' },
  DRO: { city: 'Durango', name: 'Durango La Plata County' },
  DRS: { city: 'Dresden', name: 'Dresden' },
  DRT: { city: 'Del Rio', name: 'Del Rio International' },
  DRV: { city: 'DHARAVANDHOO', name: 'Dharavandhoo' },
  DRW: { city: 'Darwin', name: 'Darwin International' },
  DSA: { city: 'Doncaster, Sheffield', name: 'Robin Hood Doncaster Sheffield' },
  DSD: { city: 'Grande Anse', name: 'La Désirade' },
  DSE: { city: 'Dessie', name: 'Combolcha' },
  DSI: { city: 'Destin', name: 'Destin Executive' },
  DSK: { city: 'Dera Ismael Khan', name: 'Dera Ismael Khan' },
  DSM: { city: 'Des Moines', name: 'Des Moines International' },
  DSN: { city: 'Dongsheng', name: 'Ordos Ejin Horo' },
  DSO: { city: 'Hamhung', name: 'Sondok' },
  DSS: { city: 'Diass', name: 'Blaise Diagne International' },
  DTA: { city: 'Delta', name: 'Delta Municipal' },
  DTB: { city: 'Siborong-Borong', name: 'Silangit' },
  DTD: { city: 'Datadawai-Borneo Island', name: 'Datadawai' },
  DTE: { city: 'Daet', name: 'Daet' },
  DTI: { city: 'Diamantina', name: 'Diamantina' },
  DTM: { city: 'Dortmund', name: 'Dortmund' },
  DTN: { city: 'Shreveport', name: 'Shreveport Downtown' },
  DTU: { city: 'Wudalianchi', name: 'Wudalianchi Dedu' },
  DTW: { city: 'Detroit', name: 'Detroit Metropolitan Wayne County' },
  DU9: { city: 'Dunnville', name: 'Dunnville' },
  DUB: { city: 'Dublin', name: 'Dublin' },
  DUC: { city: 'Duncan', name: 'Halliburton Field' },
  DUD: { city: 'Dunedin', name: 'Dunedin' },
  DUE: { city: 'Dundo', name: 'Dundo' },
  DUG: { city: 'Douglas', name: 'Bisbee Douglas International' },
  DUJ: { city: 'Du Bois', name: 'DuBois Regional' },
  DUM: { city: 'Dumai', name: 'Pinang Kampai' },
  DUR: { city: 'Durban', name: 'King Shaka International' },
  DUS: { city: 'Duesseldorf', name: 'Düsseldorf' },
  DUT: { city: 'Unalaska', name: 'Unalaska' },
  DVL: { city: 'Devils Lake', name: 'Devils Lake Regional' },
  DVO: { city: 'Davao', name: 'Francisco Bangoy International' },
  DVT: { city: 'Phoenix', name: 'Phoenix Deer Valley' },
  DWA: { city: 'Dwangwa', name: 'Dwangwa' },
  DWB: { city: 'Soalala', name: 'Soalala' },
  DWC: { city: 'Dubai', name: 'Al Maktoum International' },
  DWH: { city: 'Houston', name: 'David Wayne Hooks Memorial' },
  DXB: { city: 'Dubai', name: 'Dubai International' },
  DXR: { city: 'Danbury', name: 'Danbury Municipal' },
  DYG: { city: 'Dayong', name: 'Dayong' },
  DYL: { city: 'Doylestown', name: 'Doylestown' },
  DYR: { city: 'Anadyr', name: 'Ugolny' },
  DYS: { city: 'Abilene', name: 'Dyess Air Force Base' },
  DYU: { city: 'Dushanbe', name: 'Dushanbe' },
  DZA: { city: 'Dzaoudzi', name: 'Dzaoudzi Pamandzi International' },
  DZN: { city: 'Zhezkazgan', name: 'Zhezkazgan' },
  DZO: { city: 'Durazno', name: 'Santa Bernardina International' },
  EAA: { city: 'Eagle', name: 'Eagle' },
  EAE: { city: 'Sangafa', name: 'Siwo' },
  EAM: { city: 'Nejran', name: 'Nejran' },
  EAS: { city: 'San Sebastian', name: 'San Sebastian' },
  EAT: { city: 'Wenatchee', name: 'Pangborn Memorial' },
  EAU: { city: 'Eau Claire', name: 'Chippewa Valley Regional' },
  EBA: { city: 'Marina Di Campo', name: 'Marina Di Campo' },
  EBB: { city: 'Entebbe', name: 'Entebbe International' },
  EBD: { city: 'El Obeid', name: 'El Obeid' },
  EBG: { city: 'El Bagre', name: 'El Bagre' },
  EBH: { city: 'El Bayadh', name: 'El Bayadh' },
  EBJ: { city: 'Esbjerg', name: 'Esbjerg' },
  EBL: { city: 'Erbil', name: 'Erbil International' },
  EBM: { city: 'El Borma', name: 'El Borma' },
  EBU: { city: 'St-Etienne', name: 'Saint-Étienne-Bouthéon' },
  ECA: { city: 'East Tawas', name: 'Iosco County' },
  ECG: { city: 'Elizabeth City', name: 'Elizabeth City Regional Airport & Coast Guard Air Station' },
  ECI: { city: 'Tola', name: 'Costa Esmeralda' },
  ECN: { city: 'Nicosia', name: 'Ercan International' },
  ECP: { city: 'Panama City', name: 'Northwest Florida Beaches International' },
  ECV: { city: 'Madrid', name: 'Cuatro Vientos' },
  EDD: { city: 'Erldunda', name: 'Erldunda' },
  EDF: { city: 'Anchorage', name: 'Elmendorf Air Force Base' },
  EDI: { city: 'Edinburgh', name: 'Edinburgh' },
  EDL: { city: 'Eldoret', name: 'Eldoret International' },
  EDM: { city: 'La Roche-sur-yon', name: 'La Roche-sur-Yon' },
  EDO: { city: 'Balikesir Korfez', name: 'Balıkesir Körfez' },
  EDR: { city: 'Pormpuraaw', name: 'Pormpuraaw' },
  EDW: { city: 'Edwards Afb', name: 'Edwards Air Force Base' },
  EED: { city: 'Needles', name: 'Needles' },
  EEK: { city: 'Eek', name: 'Eek' },
  EEN: { city: 'Keene', name: 'Dillant Hopkins' },
  EFD: { city: 'Houston', name: 'Ellington' },
  EFG: { city: 'Efogi', name: 'Efogi' },
  EFL: { city: 'Keffallinia', name: 'Kefallinia' },
  EGC: { city: 'Bergerac', name: 'Bergerac-Roumanière' },
  EGE: { city: 'Vail', name: 'Eagle County Regional' },
  EGH: { city: 'El Gorah', name: 'El Gora' },
  EGI: { city: 'Crestview', name: 'Duke Field' },
  EGM: { city: 'Sege', name: 'Sege' },
  EGN: { city: 'Geneina', name: 'Geneina' },
  EGO: { city: 'Belgorod', name: 'Belgorod International' },
  EGS: { city: 'Egilsstadir', name: 'Egilsstaðir' },
  EGV: { city: 'Eagle River', name: 'Eagle River Union' },
  EGX: { city: 'Egegik', name: 'Egegik' },
  EHL: { city: 'El Bolson', name: 'El Bolson' },
  EHM: { city: 'Cape Newenham', name: 'Cape Newenham LRRS' },
  EIB: { city: 'Eisenach', name: 'Eisenach-Kindel' },
  EIE: { city: 'Yeniseysk', name: 'Yeniseysk' },
  EIK: { city: 'Eysk', name: 'Yeysk' },
  EIL: { city: 'Fairbanks', name: 'Eielson Air Force Base' },
  EIN: { city: 'Eindhoven', name: 'Eindhoven' },
  EIS: { city: 'Tortola', name: 'Terrance B. Lettsome International' },
  EIY: { city: 'Eyn-yahav', name: 'Ein Yahav' },
  EJA: { city: 'Barrancabermeja', name: 'Yariguíes' },
  EJH: { city: 'Wejh', name: 'Al Wajh Domestic' },
  EJN: { city: 'Ejin Banner', name: 'Ejin Banner-Taolai' },
  EKA: { city: 'Eureka', name: 'Murray Field' },
  EKB: { city: 'Ekibastuz', name: 'Ekibastuz' },
  EKI: { city: 'Elkhart', name: 'Elkhart Municipal' },
  EKN: { city: 'Elkins', name: 'Elkins-Randolph Co-Jennings Randolph Field' },
  EKO: { city: 'Elko', name: 'Elko Regional' },
  EKS: { city: 'Shakhtyorsk', name: 'Shakhtyorsk' },
  EKT: { city: 'Eskilstuna', name: 'Eskilstuna' },
  ELB: { city: 'El Banco', name: 'Las Flores' },
  ELC: { city: 'Elcho Island', name: 'Elcho Island' },
  ELD: { city: 'El Dorado', name: 'South Arkansas Regional At Goodwin Field' },
  ELF: { city: 'El Fasher', name: 'El Fasher' },
  ELG: { city: 'El Golea', name: 'El Golea' },
  ELH: { city: 'North Eleuthera', name: 'North Eleuthera' },
  ELI: { city: 'Elim', name: 'Elim' },
  ELM: { city: 'Elmira', name: 'Elmira Corning Regional' },
  ELO: { city: 'El Dorado', name: 'El Dorado' },
  ELP: { city: 'El Paso', name: 'El Paso International' },
  ELQ: { city: 'Gassim', name: 'Gassim' },
  ELS: { city: 'East London', name: 'Ben Schoeman' },
  ELT: { city: 'El-tor', name: 'El Tor' },
  ELU: { city: 'Guemar', name: 'Guemar' },
  ELV: { city: 'Elfin Cove', name: 'Elfin Cove Seaplane Base' },
  ELY: { city: 'Ely', name: 'Ely Airport Yelland Field' },
  EMA: { city: 'East Midlands', name: 'East Midlands' },
  EMD: { city: 'Emerald', name: 'Emerald' },
  EME: { city: 'Emden', name: 'Emden' },
  EMK: { city: 'Emmonak', name: 'Emmonak' },
  EML: { city: 'Emmen', name: 'Emmen Air Base' },
  EMN: { city: 'Nema', name: 'Néma' },
  EMP: { city: 'Kempten', name: 'Emporia Municipal' },
  EMT: { city: 'El Monte', name: 'San Gabriel Valley' },
  ENA: { city: 'Kenai', name: 'Kenai Municipal' },
  ENC: { city: 'Nancy', name: 'Nancy-Essey' },
  END: { city: 'Enid', name: 'Vance Air Force Base' },
  ENE: { city: 'Ende', name: 'Ende (H Hasan Aroeboesman)' },
  ENF: { city: 'Enontekio', name: 'Enontekio' },
  ENH: { city: 'Enshi', name: 'Enshi' },
  ENK: { city: 'Enniskillen', name: 'St Angelo' },
  ENN: { city: 'Nenana', name: 'Nenana Municipal' },
  ENO: { city: 'Encarnacion', name: 'Encarnación' },
  ENS: { city: 'Enschede', name: 'Twente' },
  ENT: { city: 'Eniwetok Atoll', name: 'Eniwetok' },
  ENU: { city: 'Enugu', name: 'Akanu Ibiam International' },
  ENV: { city: 'Wendover', name: 'Wendover' },
  ENW: { city: 'Kenosha', name: 'Kenosha Regional' },
  ENY: { city: 'Yanan', name: 'Yanan Ershilipu' },
  EOH: { city: 'Medellin', name: 'Enrique Olaya Herrera' },
  EOI: { city: 'Eday', name: 'Eday' },
  EOK: { city: 'Keokuk', name: 'Keokuk Municipal' },
  EOR: { city: 'El Dorado', name: 'El Dorado' },
  EOZ: { city: 'Elorza', name: 'Elorza' },
  EPA: { city: 'El Palomar', name: 'El Palomar' },
  EPL: { city: 'Epinal', name: 'Épinal-Mirecourt' },
  EPR: { city: 'Esperance', name: 'Esperance' },
  EPU: { city: 'Parnu', name: 'Pärnu' },
  EQS: { city: 'Esquel', name: 'Brigadier Antonio Parodi' },
  ERC: { city: 'Erzincan', name: 'Erzincan' },
  ERD: { city: 'Berdyansk', name: 'Berdyansk' },
  ERF: { city: 'Erfurt', name: 'Erfurt' },
  ERG: { city: 'Yerbogachen', name: 'Yerbogachen' },
  ERH: { city: 'Er-rachidia', name: 'Moulay Ali Cherif' },
  ERI: { city: 'Erie', name: 'Erie International Tom Ridge Field' },
  ERL: { city: 'Erenhot', name: 'Erenhot Saiwusu International' },
  ERM: { city: 'Erechim', name: 'Erechim' },
  ERN: { city: 'Eirunepe', name: 'Eirunepé' },
  ERS: { city: 'Windhoek', name: 'Eros' },
  ERV: { city: 'Kerrville', name: 'Kerrville Municipal Louis Schreiner Field' },
  ERZ: { city: 'Erzurum', name: 'Erzurum International' },
  ESB: { city: 'Ankara', name: 'Esenboğa International' },
  ESC: { city: 'Escanaba', name: 'Delta County' },
  ESD: { city: 'Eastsound', name: 'Orcas Island' },
  ESE: { city: 'Ensenada', name: 'Ensenada International' },
  ESF: { city: 'Alexandria', name: 'Esler Regional' },
  ESG: { city: 'Mariscal Estigarribia', name: 'Dr. Luis Maria Argaña International' },
  ESH: { city: 'Shoreham By Sea', name: 'Shoreham' },
  ESK: { city: 'Eskisehir', name: 'Eskişehir Air Base' },
  ESL: { city: 'Elista', name: 'Elista' },
  ESM: { city: 'Esmeraldas', name: 'General Rivadeneira' },
  ESN: { city: 'Easton', name: 'Easton Newnam Field' },
  ESR: { city: 'El Salvador', name: 'Ricardo García Posada' },
  ESS: { city: 'Essen', name: 'Essen Mulheim' },
  ESU: { city: 'Essadouira', name: 'Mogador' },
  ETB: { city: 'WEST BEND', name: 'West Bend Municipal' },
  ETH: { city: 'Elat', name: 'Eilat' },
  ETM: { city: 'Eilat', name: 'Ramon' },
  ETR: { city: 'Santa Rosa', name: 'Santa Rosa International' },
  ETS: { city: 'Enterprise', name: 'Enterprise Municipal' },
  ETZ: { city: 'Metz', name: 'Metz-Nancy-Lorraine' },
  EUA: { city: 'Eua Island', name: 'Kaufana' },
  EUF: { city: 'Eufala', name: 'Weedon Field' },
  EUG: { city: 'Eugene', name: 'Mahlon Sweet Field' },
  EUM: { city: 'Neumuenster', name: 'Neumünster' },
  EUN: { city: 'El Aaiún', name: 'Hassan I' },
  EUQ: { city: 'San Jose', name: 'Evelio Javier' },
  EUX: { city: 'Oranjestad', name: 'F. D. Roosevelt' },
  EVE: { city: 'Harstad/Narvik', name: 'Harstad/Narvik Airport, Evenes' },
  EVG: { city: 'Sveg', name: 'Sveg' },
  EVN: { city: 'Yerevan', name: 'Zvartnots International' },
  EVV: { city: 'Evansville', name: 'Evansville Regional' },
  EVW: { city: 'Evanston', name: 'Evanston-Uinta County Airport-Burns Field' },
  EVX: { city: 'Evreux', name: 'Évreux-Fauville (BA 105) Air Base' },
  EWB: { city: 'New Bedford', name: 'New Bedford Regional' },
  EWK: { city: 'Newton', name: 'Newton City-County' },
  EWN: { city: 'New Bern', name: 'Coastal Carolina Regional' },
  EWR: { city: 'Newark', name: 'Newark Liberty International' },
  EXT: { city: 'Exeter', name: 'Exeter International' },
  EYK: { city: 'Beloyarsky', name: 'Beloyarskiy' },
  EYP: { city: 'Yopal', name: 'El Yopal' },
  EYW: { city: 'Key West', name: 'Key West International' },
  EZE: { city: 'Buenos Aires', name: 'Ministro Pistarini International' },
  EZS: { city: 'Elazig', name: 'Elazığ' },
  EZV: { city: 'Berezovo', name: 'Berezovo' },
  FAA: { city: 'Faranah', name: 'Faranah' },
  FAB: { city: 'Farnborough', name: 'Farnborough' },
  FAC: { city: 'Faaite', name: 'Faaite' },
  FAE: { city: 'Vagar', name: 'Vagar' },
  FAF: { city: 'Fort Eustis', name: 'Felker Army Air Field' },
  FAH: { city: 'Farah', name: 'Farah' },
  FAI: { city: 'Fairbanks', name: 'Fairbanks International' },
  FAJ: { city: 'Fajardo', name: 'Diego Jimenez Torres' },
  FAN: { city: 'Farsund', name: 'Lista' },
  FAO: { city: 'Faro', name: 'Faro' },
  FAR: { city: 'Fargo', name: 'Hector International' },
  FAT: { city: 'Fresno', name: 'Fresno Yosemite International' },
  FAV: { city: 'Fakarava', name: 'Fakarava' },
  FAY: { city: 'Fayetteville', name: 'Fayetteville Regional Grannis Field' },
  FAZ: { city: 'Fasa', name: 'Fasa' },
  FBA: { city: 'Fonte Boa', name: 'Fonte Boa' },
  FBD: { city: 'Faizabad', name: 'Fayzabad' },
  FBE: { city: 'Francisco Beltrao', name: 'Francisco Beltrão' },
  FBG: { city: 'Fredericksburg', name: 'Simmons Army Air Field' },
  FBK: { city: 'Fort Wainwright', name: 'Ladd AAF' },
  FBM: { city: 'Lubumashi', name: 'Lubumbashi International' },
  FBR: { city: 'Fort Bridger', name: 'Fort Bridger' },
  FBU: { city: 'Oslo', name: 'Oslo, Fornebu' },
  FCA: { city: 'Kalispell', name: 'Glacier Park International' },
  FCB: { city: 'Ficksburg', name: 'Ficksburg Sentraoes' },
  FCM: { city: 'Eden Prairie', name: 'Flying Cloud' },
  FCN: { city: 'Nordholz', name: 'Nordholz Naval Airbase' },
  FCO: { city: 'Rome', name: 'Leonardo da Vinci–Fiumicino' },
  FCS: { city: 'Fort Carson', name: 'Butts AAF (Fort Carson) Air Field' },
  FDF: { city: 'Fort-de-france', name: 'Martinique Aimé Césaire International' },
  FDH: { city: 'Friedrichshafen', name: 'Friedrichshafen' },
  FDO: { city: 'San Fernando', name: 'San Fernando' },
  FDU: { city: 'Bandoundu', name: 'Bandundu' },
  FDY: { city: 'Findley', name: 'Findlay' },
  FEG: { city: 'Fergana', name: 'Fergana International' },
  FEL: { city: 'Fuerstenfeldbruck', name: 'Fürstenfeldbruck Air Base' },
  FEN: { city: 'Fernando Do Noronha', name: 'Fernando de Noronha' },
  FET: { city: 'Fremont', name: 'Fremont Municipal' },
  FEZ: { city: 'Fes', name: 'Saïss' },
  FFA: { city: 'Kill Devil Hills', name: 'First Flight' },
  FFD: { city: 'Fairford', name: 'RAF Fairford' },
  FFO: { city: 'Dayton', name: 'Wright-Patterson Air Force Base' },
  FFT: { city: 'Frankfort', name: 'Capital City' },
  FFU: { city: 'Futaleufu', name: 'Futaleufú' },
  FGI: { city: 'Apia', name: 'Fagalii' },
  FGU: { city: 'Fangatau', name: 'Fangatau' },
  FHU: { city: 'Fort Huachuca', name: 'Sierra Vista Municipal Libby Army Air Field' },
  FIE: { city: 'Fair Isle', name: 'Fair Isle' },
  FIG: { city: 'Fira', name: 'Fria' },
  FIH: { city: 'Kinshasa', name: 'Ndjili International' },
  FIK: { city: 'Finke', name: 'Finke' },
  FIZ: { city: 'Fitzroy Crossing', name: 'Fitzroy Crossing' },
  FJR: { city: 'Fujeirah', name: 'Fujairah International' },
  FKB: { city: 'Karlsruhe/Baden-Baden', name: 'Karlsruhe Baden-Baden' },
  FKI: { city: 'Kisangani', name: 'Bangoka International' },
  FKJ: { city: 'Fukui', name: 'Fukui' },
  FKL: { city: 'Franklin', name: 'Venango Regional' },
  FKQ: { city: 'Fak Fak', name: 'Fakfak' },
  FKS: { city: 'Fukushima', name: 'Fukushima' },
  FLA: { city: 'Florencia', name: 'Gustavo Artunduaga Paredes' },
  FLB: { city: 'Floriano', name: 'Cangapara' },
  FLD: { city: 'Fond du Lac', name: 'Fond du Lac County' },
  FLF: { city: 'Flensburg', name: 'Flensburg-Schäferhaus' },
  FLG: { city: 'Flagstaff', name: 'Flagstaff Pulliam' },
  FLL: { city: 'Fort Lauderdale', name: 'Fort Lauderdale Hollywood International' },
  FLN: { city: 'Florianopolis', name: 'Hercílio Luz International' },
  FLO: { city: 'Florence', name: 'Florence Regional' },
  FLP: { city: 'Flippin', name: 'Marion County Regional' },
  FLR: { city: 'Florence', name: 'Peretola' },
  FLS: { city: 'Flinders Island', name: 'Flinders Island' },
  FLV: { city: 'Fort Leavenworth', name: 'Sherman Army Air Field' },
  FLW: { city: 'Flores', name: 'Flores' },
  FLZ: { city: 'Sibolga', name: 'Dr Ferdinand Lumban Tobing' },
  FMA: { city: 'Formosa', name: 'Formosa' },
  FME: { city: 'Fort Meade', name: 'Tipton' },
  FMH: { city: 'Falmouth', name: 'Cape Cod Coast Guard Air Station' },
  FMI: { city: 'Kalemie', name: 'Kalemie' },
  FMM: { city: 'Memmingen', name: 'Memmingen Allgau' },
  FMN: { city: 'Farmington', name: 'Four Corners Regional' },
  FMO: { city: 'Munster', name: 'Münster Osnabrück' },
  FMY: { city: 'Fort Myers', name: 'Page Field' },
  FNA: { city: 'Freetown', name: 'Lungi International' },
  FNB: { city: 'Neubrandenburg', name: 'Neubrandenburg' },
  FNC: { city: 'Funchal', name: 'Madeira' },
  FNI: { city: 'Nimes', name: 'Nîmes-Arles-Camargue' },
  FNJ: { city: 'Pyongyang', name: 'Pyongyang Sunan International' },
  FNL: { city: 'Fort Collins', name: 'Northern Colorado Regional' },
  FNR: { city: 'Funter Bay', name: 'Funter Bay Seaplane Base' },
  FNT: { city: 'Flint', name: 'Bishop International' },
  FNU: { city: 'Oristano', name: 'Oristano-Fenosu' },
  FOC: { city: 'Fuzhou', name: 'Fuzhou Changle International' },
  FOD: { city: 'Fort Dodge', name: 'Fort Dodge Regional' },
  FOE: { city: 'Topeka', name: 'Topeka Regional Airport - Forbes Field' },
  FOG: { city: 'Foggia', name: 'Foggia Gino Lisa' },
  FOK: { city: 'West Hampton Beach', name: 'Francis S Gabreski' },
  FOM: { city: 'Foumban', name: 'Foumban Nkounja' },
  FON: { city: 'La Fortuna/San Carlos', name: 'Arenal' },
  FOR: { city: 'Fortaleza', name: 'Pinto Martins International' },
  FOS: { city: 'Forrest', name: 'Forrest' },
  FPO: { city: 'Freeport', name: 'Grand Bahama International' },
  FPR: { city: 'Fort Pierce', name: 'St Lucie County International' },
  FRA: { city: 'Frankfurt', name: 'Frankfurt am Main' },
  FRB: { city: 'Forbes', name: 'Forbes' },
  FRC: { city: 'Franca', name: 'Tenente Lund Pressoto' },
  FRD: { city: 'Friday Harbor', name: 'Friday Harbor' },
  FRE: { city: 'Fera Island', name: 'Fera/Maringe' },
  FRG: { city: 'Farmingdale', name: 'Republic' },
  FRI: { city: 'Fort Riley', name: 'Marshall Army Air Field' },
  FRJ: { city: 'Frejus', name: 'Fréjus' },
  FRL: { city: 'Forli', name: 'Forlì' },
  FRN: { city: 'Fort Richardson', name: 'Bryant Army Heliport' },
  FRO: { city: 'Floro', name: 'Florø' },
  FRS: { city: 'Flores', name: 'Mundo Maya International' },
  FRU: { city: 'Bishkek', name: 'Manas International' },
  FRW: { city: 'Francistown', name: 'Francistown' },
  FRY: { city: 'Fryeburg', name: 'Eastern Slopes Regional' },
  FRZ: { city: 'Fritzlar', name: 'Fritzlar' },
  FSC: { city: 'Figari', name: 'Figari Sud-Corse' },
  FSD: { city: 'Sioux Falls', name: 'Joe Foss Field' },
  FSI: { city: 'Fort Sill', name: 'Henry Post Army Air Field (Fort Sill)' },
  FSM: { city: 'Fort Smith', name: 'Fort Smith Regional' },
  FSP: { city: 'St.-pierre', name: 'St Pierre' },
  FSS: { city: 'Kinloss', name: 'RAF Kinloss' },
  FST: { city: 'Fort Stockton', name: 'Fort Stockton Pecos County' },
  FTA: { city: 'Futuna Island', name: 'Futuna' },
  FTE: { city: 'El Calafate', name: 'El Calafate' },
  FTI: { city: 'Fitiuta', name: 'Fitiuta' },
  FTK: { city: 'Fort Knox', name: 'Godman Army Air Field' },
  FTU: { city: 'Tolagnaro', name: 'Tôlanaro' },
  FTW: { city: 'Fort Worth', name: 'Fort Worth Meacham International' },
  FTX: { city: 'Owando', name: 'Owando' },
  FTY: { city: 'Atlanta', name: 'Fulton County Airport Brown Field' },
  FUE: { city: 'Fuerteventura', name: 'Fuerteventura' },
  FUG: { city: 'Fuyang', name: 'Fuyang Xiguan' },
  FUJ: { city: 'Fukue', name: 'Fukue' },
  FUK: { city: 'Fukuoka', name: 'Fukuoka' },
  FUL: { city: 'Fullerton', name: 'Fullerton Municipal' },
  FUN: { city: 'Funafuti', name: 'Funafuti International' },
  FUO: { city: 'Foshan', name: 'Foshan Shadi' },
  FUT: { city: 'Futuna Island', name: 'Pointe Vele' },
  FWA: { city: 'Fort Wayne', name: 'Fort Wayne International' },
  FWH: { city: 'Dallas', name: 'NAS Fort Worth JRB/Carswell Field' },
  FXE: { city: 'Fort Lauderdale', name: 'Fort Lauderdale Executive' },
  FXO: { city: 'Cuamba', name: 'Cuamba' },
  FYJ: { city: 'Fuyuan', name: 'Dongji Aiport' },
  FYN: { city: 'Fuyun', name: 'Fuyun Koktokay' },
  FYT: { city: 'Faya-largeau', name: 'Faya Largeau' },
  FYU: { city: 'Fort Yukon', name: 'Fort Yukon' },
  FYV: { city: 'Fayetteville', name: 'Drake Field' },
  FZO: { city: 'Bristol', name: 'Bristol Filton' },
  GAD: { city: 'Gadsden', name: 'Northeast Alabama Regional' },
  GAE: { city: 'Gabes', name: 'Gabès Matmata International' },
  GAF: { city: 'Gafsa', name: 'Gafsa Ksar International' },
  GAH: { city: 'Gayndah', name: 'Gayndah' },
  GAI: { city: 'Gaithersburg', name: 'Montgomery County Airpark' },
  GAJ: { city: 'Yamagata', name: 'Yamagata' },
  GAL: { city: 'Galena', name: 'Edward G. Pitka Sr' },
  GAM: { city: 'Gambell', name: 'Gambell' },
  GAN: { city: 'Gan Island', name: 'Gan International' },
  GAO: { city: 'Guantanamo', name: 'Mariana Grajales' },
  GAQ: { city: 'Gao', name: 'Gao' },
  GAS: { city: 'Garissa', name: 'Garissa' },
  GAU: { city: 'Guwahati', name: 'Lokpriya Gopinath Bordoloi International' },
  GAY: { city: 'Gaya', name: 'Gaya' },
  GBA: { city: 'Pailton', name: 'Cotswold' },
  GBB: { city: 'Qabala', name: 'Gabala International' },
  GBD: { city: 'Great Bend', name: 'Great Bend Municipal' },
  GBE: { city: 'Gaberone', name: 'Sir Seretse Khama International' },
  GBG: { city: 'Galesburg', name: 'Galesburg Municipal' },
  GBJ: { city: 'Grand Bourg', name: 'Les Bases' },
  GBK: { city: 'Gbangbatok', name: 'Gbangbatok' },
  GBT: { city: 'Gorgan', name: 'Gorgan' },
  GBZ: { city: 'Claris', name: 'Great Barrier Aerodrome' },
  GCC: { city: 'Gillette', name: 'Gillette Campbell County' },
  GCH: { city: 'Gachsaran', name: 'Gachsaran' },
  GCI: { city: 'Guernsey', name: 'Guernsey' },
  GCJ: { city: 'Johannesburg', name: 'Grand Central' },
  GCK: { city: 'Garden City', name: 'Garden City Regional' },
  GCM: { city: 'Georgetown', name: 'Owen Roberts International' },
  GCN: { city: 'Grand Canyon', name: 'Grand Canyon National Park' },
  GDC: { city: 'Greenville', name: 'Donaldson Field' },
  GDE: { city: 'Gode', name: 'Gode' },
  GDL: { city: 'Guadalajara', name: 'Don Miguel Hidalgo Y Costilla International' },
  GDN: { city: 'Gdansk', name: 'Gdańsk Lech Wałęsa' },
  GDO: { city: 'Guasdualito', name: 'Guasdalito' },
  GDQ: { city: 'Gondar', name: 'Gonder' },
  GDT: { city: 'Cockburn Town', name: 'JAGS McCartney International' },
  GDV: { city: 'Glendive', name: 'Dawson Community' },
  GDW: { city: 'Gladwin', name: 'Gladwin Zettel Memorial' },
  GDX: { city: 'Magadan', name: 'Sokol' },
  GDZ: { city: 'Gelendzhik', name: 'Gelendzhik' },
  GEA: { city: 'Noumea', name: 'Nouméa Magenta' },
  GEC: { city: 'Geçitkale', name: 'Lefkoniko' },
  GED: { city: 'Georgetown', name: 'Sussex County' },
  GEG: { city: 'Spokane', name: 'Spokane International' },
  GEL: { city: 'Santo Angelo', name: 'Santo Ângelo' },
  GEO: { city: 'Georgetown', name: 'Cheddi Jagan International' },
  GER: { city: 'Nueva Gerona', name: 'Rafael Cabrera' },
  GES: { city: 'Romblon', name: 'General Santos International' },
  GET: { city: 'Geraldton', name: 'Geraldton' },
  GEV: { city: 'Gallivare', name: 'Gällivare' },
  GEX: { city: 'Geelong', name: 'Geelong' },
  GFF: { city: 'Griffith', name: 'Griffith' },
  GFK: { city: 'Grand Forks', name: 'Grand Forks International' },
  GFL: { city: 'Queensbury', name: 'Floyd Bennett Memorial' },
  GFN: { city: 'Grafton', name: 'Grafton' },
  GFO: { city: 'Bartica', name: 'Bartica A' },
  GFR: { city: 'Granville', name: 'Granville' },
  GFY: { city: 'Grootfontein', name: 'Grootfontein' },
  GGE: { city: 'Georgetown', name: 'Georgetown County' },
  GGG: { city: 'Longview', name: 'East Texas Regional' },
  GGM: { city: 'Kakamega', name: 'Kakamega' },
  GGS: { city: 'Gobernador Gregores', name: 'Gobernador Gregores' },
  GGT: { city: 'Great Exuma', name: 'Exuma International' },
  GGW: { city: 'Glasgow', name: 'Wokal Field Glasgow International' },
  GHA: { city: 'Ghardaia', name: 'Noumérat - Moufdi Zakaria' },
  GHB: { city: 'Governors Harbor', name: 'Governors Harbour' },
  GHC: { city: 'Bullocks Harbour', name: 'Great Harbour Cay' },
  GHF: { city: 'Giebelstadt', name: '[Duplicate] Giebelstadt Army Air Field' },
  GHT: { city: 'Ghat', name: 'Ghat' },
  GHU: { city: 'Gualeguaychu', name: 'Gualeguaychu' },
  GIB: { city: 'Gibraltar', name: 'Gibraltar' },
  GIC: { city: 'Boigu', name: 'Boigu' },
  GID: { city: 'Gitega', name: 'Gitega' },
  GIF: { city: 'Winter Haven', name: 'Winter Haven Regional Airport - Gilbert Field' },
  GIG: { city: 'Rio De Janeiro', name: 'Rio Galeão – Tom Jobim International' },
  GII: { city: 'Siguiri', name: 'Siguiri' },
  GIL: { city: 'Gilgit', name: 'Gilgit' },
  GIR: { city: 'Girardot', name: 'Santiago Vila' },
  GIS: { city: 'Gisborne', name: 'Gisborne' },
  GIT: { city: 'Geita', name: 'Mchauru' },
  GIU: { city: 'Sigiriya', name: 'Sigiriya Air Force Base' },
  GIZ: { city: 'Gizan', name: 'Jizan Regional' },
  GJA: { city: 'Guanaja', name: 'La Laguna' },
  GJL: { city: 'Jijel', name: 'Jijel Ferhat Abbas' },
  GJM: { city: 'Guajara-mirim', name: 'Guajará-Mirim' },
  GJR: { city: 'Gjogur', name: 'Gjögur' },
  GJT: { city: 'Grand Junction', name: 'Grand Junction Regional' },
  GKA: { city: 'Goroka', name: 'Goroka' },
  GKE: { city: 'Geilenkirchen', name: 'Geilenkirchen Air Base' },
  GKK: { city: 'Kooddoo', name: 'Kooddoo' },
  GKL: { city: 'Great Keppel Island', name: 'Great Keppel Is' },
  GKN: { city: 'Gulkana', name: 'Gulkana' },
  GLA: { city: 'Glasgow', name: 'Glasgow International' },
  GLD: { city: 'Goodland', name: 'Renner Field-Goodland Municipal' },
  GLF: { city: 'Golfito', name: 'Golfito' },
  GLH: { city: 'Greenville', name: 'Mid Delta Regional' },
  GLI: { city: 'Glen Innes', name: 'Glen Innes' },
  GLK: { city: 'Galcaio', name: 'Galcaio' },
  GLO: { city: 'Golouchestershire', name: 'Gloucestershire' },
  GLR: { city: 'GAYLORD', name: 'Gaylord Regional' },
  GLS: { city: 'Galveston', name: 'Scholes International At Galveston' },
  GLT: { city: 'Gladstone', name: 'Gladstone' },
  GLU: { city: 'Gelephu', name: 'Gelephu' },
  GLV: { city: 'Golovin', name: 'Golovin' },
  GLW: { city: 'Glasgow', name: 'Glasgow Municipal' },
  GLZ: { city: 'Gilze-rijen', name: 'Gilze Rijen Air Base' },
  GMA: { city: 'Gemena', name: 'Gemena' },
  GMB: { city: 'Gambella', name: 'Gambella' },
  GMD: { city: 'Ben Slimane', name: 'Ben Slimane' },
  GME: { city: 'Gomel', name: 'Gomel' },
  GML: { city: 'Kiev', name: 'Gostomel' },
  GMO: { city: 'Gombe', name: 'Gombe Lawanti International' },
  GMP: { city: 'Seoul', name: 'Gimpo International' },
  GMQ: { city: 'Golog', name: 'Golog Maqin' },
  GMR: { city: 'Totegegie', name: 'Totegegie' },
  GMU: { city: 'Greenville', name: 'Greenville Downtown' },
  GMV: { city: 'Monument Valley', name: 'Monument Valley' },
  GMZ: { city: 'La Gomera', name: 'La Gomera' },
  GNA: { city: 'Hrodna', name: 'Hrodna' },
  GNB: { city: 'Grenoble', name: 'Grenoble-Isère' },
  GND: { city: 'Point Salines', name: 'Point Salines International' },
  GNI: { city: 'Green Island', name: 'Lyudao' },
  GNM: { city: 'Guanambi', name: 'Guanambi' },
  GNR: { city: 'Fuerte Gral Roca', name: 'Dr. Arturo H. Illia' },
  GNS: { city: 'Gunung Sitoli', name: 'Binaka' },
  GNT: { city: 'Grants', name: 'Grants-Milan Municipal' },
  GNV: { city: 'Gainesville', name: 'Gainesville Regional' },
  GNY: { city: 'Sanliurfa', name: 'Şanlıurfa GAP' },
  GNZ: { city: 'Ghanzi', name: 'Ghanzi' },
  GOA: { city: 'Genoa', name: 'Genoa Cristoforo Colombo' },
  GOB: { city: 'Goba', name: 'Robe' },
  GOH: { city: 'Godthaab', name: 'Godthaab / Nuuk' },
  GOI: { city: 'Goa', name: 'Dabolim' },
  GOJ: { city: 'Nizhniy Novgorod', name: 'Nizhny Novgorod Strigino International' },
  GOM: { city: 'Goma', name: 'Goma International' },
  GON: { city: 'Groton CT', name: 'Groton New London' },
  GOO: { city: 'Goondiwindi', name: 'Goondiwindi' },
  GOP: { city: 'Gorakhpur', name: 'Gorakhpur' },
  GOQ: { city: 'Golmud', name: 'Golmud' },
  GOR: { city: 'Gore', name: 'Gore' },
  GOT: { city: 'Gothenborg', name: 'Gothenburg-Landvetter' },
  GOU: { city: 'Garoua', name: 'Garoua International' },
  GOV: { city: 'Gove', name: 'Gove' },
  GOZ: { city: 'Gorna Orechovica', name: 'Gorna Oryahovitsa' },
  GPA: { city: 'Patras', name: 'Araxos' },
  GPB: { city: 'Guarapuava', name: 'Tancredo Thomas de Faria' },
  GPI: { city: 'Guapi', name: 'Juan Casiano' },
  GPL: { city: 'Guapiles', name: 'Guapiles' },
  GPN: { city: 'Pirlangimpi', name: 'Garden Point' },
  GPO: { city: 'General Pico', name: 'General Pico' },
  GPS: { city: 'Galapagos', name: 'Seymour' },
  GPT: { city: 'Gulfport', name: 'Gulfport Biloxi International' },
  GPZ: { city: 'Grand Rapids MN', name: 'Grand Rapids Itasca Co-Gordon Newstrom field' },
  GQQ: { city: 'Galion', name: 'Galion Municipal' },
  GRB: { city: 'Green Bay', name: 'Austin Straubel International' },
  GRF: { city: 'Fort Lewis', name: 'Gray Army Air Field' },
  GRI: { city: 'Grand Island', name: 'Central Nebraska Regional' },
  GRJ: { city: 'George', name: 'George' },
  GRK: { city: 'Killeen', name: 'Robert Gray Army Air Field' },
  GRM: { city: 'Grand Marais', name: 'Grand Marais Cook County' },
  GRO: { city: 'Gerona', name: 'Girona' },
  GRP: { city: 'Gurupi', name: 'Gurupi' },
  GRQ: { city: 'Groningen', name: 'Eelde' },
  GRR: { city: 'Grand Rapids', name: 'Gerald R. Ford International' },
  GRS: { city: 'Grosseto', name: 'Grosseto Air Base' },
  GRU: { city: 'Sao Paulo', name: 'Guarulhos - Governador André Franco Montoro International' },
  GRW: { city: 'Graciosa Island', name: 'Graciosa' },
  GRX: { city: 'Granada', name: 'Federico Garcia Lorca' },
  GRY: { city: 'Grímsey', name: 'Grímsey' },
  GRZ: { city: 'Graz', name: 'Graz' },
  GSB: { city: 'Goldsboro', name: 'Seymour Johnson Air Force Base' },
  GSE: { city: 'Gothenborg', name: 'Gothenburg City' },
  GSI: { city: 'Grand-Santi', name: 'Grand-Santi' },
  GSJ: { city: 'San Jose', name: 'San José' },
  GSO: { city: 'Greensboro', name: 'Piedmont Triad International' },
  GSP: { city: 'Greenville', name: 'Greenville Spartanburg International' },
  GSQ: { city: 'Sharq Al-Owainat', name: 'Shark El Oweinat International' },
  GST: { city: 'Gustavus', name: 'Gustavus' },
  GTE: { city: 'Groote Eylandt', name: 'Groote Eylandt' },
  GTF: { city: 'Great Falls', name: 'Great Falls International' },
  GTI: { city: 'Ruegen', name: 'Rügen' },
  GTN: { city: 'Glentanner', name: 'Glentanner' },
  GTO: { city: 'Gorontalo', name: 'Jalaluddin' },
  GTR: { city: 'Columbus Mississippi', name: 'Golden Triangle Regional' },
  GUA: { city: 'Guatemala City', name: 'La Aurora' },
  GUB: { city: 'Guerrero Negro', name: 'Guerrero Negro' },
  GUC: { city: 'Gunnison', name: 'Gunnison Crested Butte Regional' },
  GUF: { city: 'Gulf Shores', name: 'Jack Edwards' },
  GUI: { city: 'Guiria', name: 'Guiria' },
  GUJ: { city: 'Guaratingueta', name: 'Guaratinguetá' },
  GUL: { city: 'Goulburn', name: 'Goulburn' },
  GUM: { city: 'Agana', name: 'Antonio B. Won Pat International' },
  GUP: { city: 'Gallup', name: 'Gallup Municipal' },
  GUQ: { city: 'Guanare', name: 'Guanare' },
  GUR: { city: 'Gurney', name: 'Gurney' },
  GUS: { city: 'Peru', name: 'Grissom Air Reserve Base' },
  GUT: { city: 'Guetersloh', name: 'Gütersloh Air Base' },
  GUU: { city: 'Grundarfjordur', name: 'Grundarfjörður' },
  GUW: { city: 'Atyrau', name: 'Atyrau' },
  GUX: { city: 'Guna', name: 'Guna' },
  GUY: { city: 'Guymon', name: 'Guymon Municipal' },
  GUZ: { city: 'Guarapari', name: 'Guarapari' },
  GVA: { city: 'Geneva', name: 'Geneva Cointrin International' },
  GVL: { city: 'Gainesville', name: 'Lee Gilmer Memorial' },
  GVN: { city: 'Sovetskaya Gavan', name: 'Maygatka Airport.' },
  GVR: { city: 'Governador Valadares', name: 'Coronel Altino Machado de Oliveira' },
  GVT: { city: 'Greenvile', name: 'Majors' },
  GVX: { city: 'Gavle', name: 'Gävle Sandviken' },
  GWD: { city: 'Gwadar', name: 'Gwadar International' },
  GWE: { city: 'Gwert', name: 'Thornhill Air Base' },
  GWL: { city: 'Gwalior', name: 'Gwalior' },
  GWO: { city: 'Greenwood', name: 'Greenwood–Leflore' },
  GWT: { city: 'Westerland', name: 'Westerland Sylt' },
  GWY: { city: 'Galway', name: 'Galway' },
  GXF: { city: 'Sayun Intl', name: 'Sayun International' },
  GXG: { city: 'Negage', name: 'Negage' },
  GXH: { city: 'Xiahe city', name: 'Gannan Xiahe' },
  GXQ: { city: 'Coyhaique', name: 'Teniente Vidal' },
  GXY: { city: 'Greeley', name: 'Greeley–Weld County' },
  GYA: { city: 'Guayaramerín', name: 'Capitán de Av. Emilio Beltrán' },
  GYD: { city: 'Baku', name: 'Heydar Aliyev International' },
  GYE: { city: 'Guayaquil', name: 'José Joaquín de Olmedo International' },
  GYG: { city: 'Yakutsk', name: 'Magan' },
  GYI: { city: 'Gisenyi', name: 'Gisenyi' },
  GYL: { city: 'Argyle', name: 'Argyle' },
  GYM: { city: 'Guaymas', name: 'General José María Yáñez International' },
  GYN: { city: 'Goiania', name: 'Santa Genoveva' },
  GYR: { city: 'Goodyear', name: 'Phoenix Goodyear' },
  GYS: { city: 'Guangyuan', name: 'Guangyuan' },
  GYU: { city: 'Guyuan', name: 'Guyuan Liupanshan' },
  GYY: { city: 'Gary', name: 'Gary Chicago International' },
  GZA: { city: 'Gaza', name: 'Yasser Arafat International' },
  GZI: { city: 'Ghazni', name: 'Ghazni' },
  GZM: { city: 'Gozo', name: 'Xewkija Heliport' },
  GZO: { city: 'Gizo', name: 'Nusatupe' },
  GZP: { city: 'Alanya', name: 'Gazipaşa' },
  GZT: { city: 'Gaziantep', name: 'Gaziantep International' },
  GZW: { city: 'Ghazvin', name: 'Qazvin' },
  HAA: { city: 'Hasvik', name: 'Hasvik' },
  HAC: { city: 'Hachijojima', name: 'Hachijojima' },
  HAD: { city: 'Halmstad', name: 'Halmstad' },
  HAF: { city: 'Half Moon Bay', name: 'Half Moon Bay' },
  HAH: { city: 'Moroni', name: 'Prince Said Ibrahim International' },
  HAJ: { city: 'Hannover', name: 'Hannover' },
  HAK: { city: 'Haikou', name: 'Haikou Meilan International' },
  HAM: { city: 'Hamburg', name: 'Hamburg' },
  HAN: { city: 'Hanoi', name: 'Noi Bai International' },
  HAO: { city: 'Hamilton', name: 'Butler Co Regional Airport - Hogan Field' },
  HAQ: { city: 'Haa Dhaalu Atoll', name: 'Hanimaadhoo' },
  HAR: { city: 'Harrisburg', name: 'Capital City' },
  HAS: { city: 'Hail', name: 'Hail' },
  HAU: { city: 'Haugesund', name: 'Haugesund' },
  HAV: { city: 'Havana', name: 'José Martí International' },
  HAW: { city: 'Haverfordwest', name: 'Haverfordwest' },
  HBA: { city: 'Hobart', name: 'Hobart International' },
  HBE: { city: 'Alexandria', name: 'Borg El Arab International' },
  HBG: { city: 'Hattiesburg', name: 'Hattiesburg Bobby L Chain Municipal' },
  HBR: { city: 'Hobart', name: 'Hobart Regional' },
  HBX: { city: 'Hubli', name: 'Hubli' },
  HCJ: { city: 'Hechi', name: 'Hechi Jinchengjiang' },
  HCN: { city: 'Hengchun', name: 'Hengchun' },
  HCQ: { city: 'Halls Creek', name: 'Halls Creek' },
  HCR: { city: 'Holy Cross', name: 'Holy Cross' },
  HCW: { city: 'Cheraw', name: 'Cheraw Municipal Airport/Lynch Bellinger Field' },
  HDD: { city: 'Hyderabad', name: 'Hyderabad' },
  HDE: { city: 'Holdredge', name: 'Brewster Field' },
  HDF: { city: 'Heringsdorf', name: 'Heringsdorf' },
  HDG: { city: 'Handan', name: 'Handan' },
  HDH: { city: 'Dillingham', name: 'Dillingham' },
  HDI: { city: 'Cleveland', name: 'Hardwick Field' },
  HDM: { city: 'Hamadan', name: 'Hamadan' },
  HDN: { city: 'Hayden', name: 'Yampa Valley' },
  HDR: { city: 'Bandar Abbas', name: 'Havadarya' },
  HDS: { city: 'Hoedspruit', name: 'Hoedspruit Air Force Base' },
  HDY: { city: 'Hat Yai', name: 'Hat Yai International' },
  HEA: { city: 'Herat', name: 'Herat' },
  HEH: { city: 'Heho', name: 'Heho' },
  HEI: { city: 'Büsum', name: 'Heide-Büsum' },
  HEK: { city: 'Heihe', name: 'Heihe' },
  HEL: { city: 'Helsinki', name: 'Helsinki Vantaa' },
  HEM: { city: 'Helsinki', name: 'Helsinki Malmi' },
  HER: { city: 'Heraklion', name: 'Heraklion International Nikos Kazantzakis' },
  HET: { city: 'Hohhot', name: 'Baita International' },
  HEW: { city: 'Athens', name: 'Athen Helenikon' },
  HEX: { city: 'Santo Domingo', name: 'Herrera' },
  HFA: { city: 'Haifa', name: 'Haifa International' },
  HFD: { city: 'Hartford', name: 'Hartford Brainard' },
  HFE: { city: 'Hefei', name: 'Hefei Luogang International' },
  HFN: { city: 'Hofn', name: 'Hornafjörður' },
  HFS: { city: 'Hagfors', name: 'Hagfors' },
  HFT: { city: 'Hammerfest', name: 'Hammerfest' },
  HGA: { city: 'Hargeisa', name: 'Egal International' },
  HGD: { city: 'Hughenden', name: 'Hughenden' },
  HGE: { city: 'Higuerote', name: 'Higuerote' },
  HGH: { city: 'Hangzhou', name: 'Hangzhou Xiaoshan International' },
  HGI: { city: 'Higleig', name: 'Paloich Airport, Heliport' },
  HGL: { city: 'Helgoland', name: 'Helgoland-Düne' },
  HGN: { city: 'Mae Hong Son', name: 'Mae Hong Son' },
  HGO: { city: 'Korhogo', name: 'Korhogo' },
  HGR: { city: 'Hagerstown', name: 'Hagerstown Regional Richard A Henson Field' },
  HGS: { city: 'Freetown', name: 'Hastings' },
  HGU: { city: 'Mount Hagen', name: 'Mount Hagen Kagamuga' },
  HHE: { city: 'Hachinoe', name: 'Hachinohe' },
  HHH: { city: 'Hilton Head Island', name: 'Hilton Head' },
  HHI: { city: 'Wahiawa', name: 'Wheeler Army' },
  HHN: { city: 'Hahn', name: 'Frankfurt-Hahn' },
  HHP: { city: 'Hong Kong', name: 'Shun Tak Heliport' },
  HHQ: { city: 'Prachuap Khiri Khan', name: 'Hua Hin' },
  HHR: { city: 'Hawthorne', name: 'Jack Northrop Field Hawthorne Municipal' },
  HHZ: { city: 'Hikueru', name: 'Hikueru Atoll' },
  HIA: { city: 'Huai An', name: 'Lianshui' },
  HIB: { city: 'Hibbing', name: 'Range Regional' },
  HID: { city: 'Horn Island', name: 'Horn Island' },
  HIF: { city: 'Ogden', name: 'Hill Air Force Base' },
  HII: { city: 'Lake Havasu City', name: 'Lake Havasu City' },
  HIJ: { city: 'Hiroshima', name: 'Hiroshima' },
  HIM: { city: 'Polonnaruwa Town', name: 'Hingurakgoda Air Force Base' },
  HIN: { city: 'Sacheon', name: 'Sacheon Air Base/Airport' },
  HIO: { city: 'Hillsboro', name: 'Portland Hillsboro' },
  HIR: { city: 'Honiara', name: 'Honiara International' },
  HIW: { city: 'Hiroshima', name: 'Hiroshimanishi' },
  HJJ: { city: 'Zhijiang', name: 'Zhijiang' },
  HJR: { city: 'Khajuraho', name: 'Khajuraho' },
  HKD: { city: 'Hakodate', name: 'Hakodate' },
  HKG: { city: 'Hong Kong', name: 'Hong Kong International' },
  HKK: { city: 'Hokitika', name: 'Hokitika' },
  HKN: { city: 'Hoskins', name: 'Kimbe' },
  HKT: { city: 'Phuket', name: 'Phuket International' },
  HKY: { city: 'Hickory', name: 'Hickory Regional' },
  HLA: { city: 'Johannesburg', name: 'Lanseria' },
  HLD: { city: 'Hailar', name: 'Dongshan' },
  HLE: { city: 'Longwood', name: 'St. Helena' },
  HLF: { city: 'Hultsfred', name: 'Hultsfred' },
  HLG: { city: 'Wheeling', name: 'Wheeling Ohio County' },
  HLH: { city: 'Ulanhot', name: 'Ulanhot' },
  HLI: { city: 'Hollister', name: 'Hollister Municipal' },
  HLJ: { city: 'Barysiai', name: 'Barysiai' },
  HLN: { city: 'Helena', name: 'Helena Regional' },
  HLP: { city: 'Jakarta', name: 'Halim Perdanakusuma International' },
  HLR: { city: 'Fort Hood', name: 'Hood Army Air Field' },
  HLT: { city: 'Hamilton', name: 'Hamilton' },
  HLZ: { city: 'Hamilton', name: 'Hamilton International' },
  HMA: { city: 'Khanty-Mansiysk', name: 'Khanty Mansiysk' },
  HMB: { city: 'Sohag', name: 'Sohag International' },
  HME: { city: 'Hassi Messaoud', name: 'Oued Irara' },
  HMG: { city: 'Hermannsburg', name: 'Hermannsburg' },
  HMI: { city: 'Hami', name: 'Hami' },
  HMJ: { city: 'Khmeinitskiy', name: 'Khmelnytskyi' },
  HMN: { city: 'Alamogordo', name: 'Holloman Air Force Base' },
  HMO: { city: 'Hermosillo', name: 'General Ignacio P. Garcia International' },
  HMR: { city: 'Hamar', name: 'Stafsberg' },
  HMV: { city: 'Hemavan', name: 'Hemavan' },
  HMY: { city: 'Seosan', name: 'Seosan Air Base' },
  HNA: { city: 'Hanamaki', name: 'Hanamaki' },
  HND: { city: 'Tokyo', name: 'Tokyo Haneda International' },
  HNH: { city: 'Hoonah', name: 'Hoonah' },
  HNL: { city: 'Honolulu', name: 'Daniel K Inouye International' },
  HNM: { city: 'Hana', name: 'Hana' },
  HNS: { city: 'Haines', name: 'Haines' },
  HNY: { city: 'Hengyang', name: 'Hengyang Nanyue' },
  HOA: { city: 'Hola', name: 'Hola' },
  HOB: { city: 'Hobbs', name: 'Lea County Regional' },
  HOD: { city: 'Hodeidah', name: 'Hodeidah International' },
  HOE: { city: 'Huay Xai', name: 'Ban Huoeisay' },
  HOF: { city: 'Al-ahsa', name: 'Al Ahsa' },
  HOG: { city: 'Holguin', name: 'Frank Pais International' },
  HOH: { city: 'Hohenems', name: 'Hohenems-Dornbirn' },
  HOI: { city: 'Hao Island', name: 'Hao' },
  HOK: { city: 'Hooker Creek', name: 'Hooker Creek' },
  HOM: { city: 'Homer', name: 'Homer' },
  HON: { city: 'Huron', name: 'Huron Regional' },
  HOP: { city: 'Hopkinsville', name: 'Campbell AAF (Fort Campbell) Air Field' },
  HOQ: { city: 'Hof', name: 'Hof-Plauen' },
  HOR: { city: 'Horta', name: 'Horta' },
  HOS: { city: 'Chosmadal', name: 'Chos Malal' },
  HOT: { city: 'Hot Springs', name: 'Memorial Field' },
  HOU: { city: 'Houston', name: 'William P Hobby' },
  HOV: { city: 'Orsta-Volda', name: 'Ørsta-Volda Airport, Hovden' },
  HOX: { city: 'Hommalin', name: 'Hommalinn' },
  HPA: { city: 'Lifuka', name: 'Lifuka Island' },
  HPB: { city: 'Hooper Bay', name: 'Hooper Bay' },
  HPG: { city: 'Shennongjia', name: 'Shennongjia Hongping' },
  HPH: { city: 'Haiphong', name: 'Cat Bi International' },
  HPN: { city: 'White Plains', name: 'Westchester County' },
  HQM: { city: 'Hoquiam', name: 'Bowerman' },
  HRB: { city: 'Harbin', name: 'Taiping' },
  HRE: { city: 'Harare', name: 'Robert Gabriel Mugabe International' },
  HRG: { city: 'Hurghada', name: 'Hurghada International' },
  HRI: { city: 'Mattala', name: 'Mattala Rajapaksa International' },
  HRK: { city: 'Kharkov', name: 'Kharkiv International' },
  HRL: { city: 'Harlingen', name: 'Valley International' },
  HRM: { city: 'Tilrempt', name: 'Hassi RMel' },
  HRO: { city: 'Harrison', name: 'Boone County' },
  HRS: { city: 'Harrismith', name: 'Harrismith' },
  HRT: { city: 'Linton-on-ouse', name: 'RAF Linton-On-Ouse' },
  HSG: { city: 'Saga', name: 'Saga' },
  HSH: { city: 'Henderson', name: 'Henderson Executive' },
  HSK: { city: 'Huesca', name: 'Huesca/Pirineos' },
  HSL: { city: 'Huslia', name: 'Huslia' },
  HSM: { city: 'Horsham', name: 'Horsham' },
  HSN: { city: 'Zhoushan', name: 'Zhoushan' },
  HSS: { city: 'Hissar', name: 'Hissar' },
  HST: { city: 'Homestead', name: 'Homestead ARB' },
  HSV: { city: 'Huntsville', name: 'Huntsville International Carl T Jones Field' },
  HSZ: { city: 'Hsinchu', name: 'Hsinchu Air Base' },
  HTA: { city: 'Chita', name: 'Chita-Kadala' },
  HTG: { city: 'Khatanga', name: 'Khatanga' },
  HTI: { city: 'Hamilton Island', name: 'Hamilton Island' },
  HTL: { city: 'Houghton Lake', name: 'Roscommon County - Blodgett Memorial' },
  HTN: { city: 'Hotan', name: 'Hotan' },
  HTR: { city: 'Taketomi', name: 'Hateruma' },
  HTS: { city: 'Huntington', name: 'Tri-State/Milton J. Ferguson Field' },
  HTT: { city: 'Mengnai', name: 'Huatugou' },
  HTV: { city: 'Huntsville', name: 'Huntsville Regional' },
  HTY: { city: 'Hatay', name: 'Hatay' },
  HUA: { city: 'Redstone', name: 'Redstone Army Air Field' },
  HUE: { city: 'Humera', name: 'Humera' },
  HUF: { city: 'Terre Haute', name: 'Terre Haute Regional Airport, Hulman Field' },
  HUH: { city: 'Huahine Island', name: 'Huahine-Fare' },
  HUI: { city: 'Hue', name: 'Phu Bai' },
  HUL: { city: 'Houlton', name: 'Houlton International' },
  HUN: { city: 'Hualien', name: 'Hualien' },
  HUO: { city: 'Holingol', name: 'Holingol Huolinhe' },
  HUQ: { city: 'Hon', name: 'Hon' },
  HUS: { city: 'Hughes', name: 'Hughes' },
  HUT: { city: 'Hutchinson', name: 'Hutchinson Municipal' },
  HUU: { city: 'Huánuco', name: 'Alferez Fap David Figueroa Fernandini' },
  HUV: { city: 'Hudiksvall', name: 'Hudiksvall' },
  HUW: { city: 'Humaita', name: 'Humaitá' },
  HUX: { city: 'Huatulco', name: 'Bahías de Huatulco International' },
  HUY: { city: 'Humberside', name: 'Humberside' },
  HUZ: { city: 'Huizhou', name: 'Huizhou' },
  HVA: { city: 'Analalava', name: 'Analalava' },
  HVB: { city: 'Hervey Bay', name: 'Hervey Bay' },
  HVD: { city: 'Khovd', name: 'Khovd' },
  HVG: { city: 'Honningsvag', name: 'Valan' },
  HVN: { city: 'New Haven', name: 'Tweed New Haven' },
  HVR: { city: 'Havre', name: 'Havre City County' },
  HVS: { city: 'Hartsville', name: 'Hartsville Regional' },
  HWD: { city: 'Hayward', name: 'Hayward Executive' },
  HWN: { city: 'Hwange National Park', name: 'Hwange National Park' },
  HWO: { city: 'Hollywood', name: 'North Perry' },
  HXD: { city: 'Haixi', name: 'Delingha' },
  HYA: { city: 'Barnstable', name: 'Barnstable Municipal Boardman Polando Field' },
  HYC: { city: 'Wycombe', name: 'Wycombe Air Park' },
  HYD: { city: 'Hyderabad', name: 'Rajiv Gandhi International' },
  HYG: { city: 'Hydaburg', name: 'Hydaburg Seaplane Base' },
  HYN: { city: 'Huangyan', name: 'Huangyan Luqiao' },
  HYR: { city: 'Hayward', name: 'Sawyer County' },
  HYS: { city: 'Hays', name: 'Hays Regional' },
  HYV: { city: 'Hyvinkaa', name: 'Hyvinkää' },
  HZB: { city: 'Merville', name: 'Merville-Calonne' },
  HZG: { city: 'Hanzhong', name: 'Hanzhong Chenggu' },
  HZH: { city: 'Liping', name: 'Liping' },
  HZK: { city: 'Husavik', name: 'Húsavík' },
  HZL: { city: 'Hazleton', name: 'Hazleton Municipal' },
  HZP: { city: 'Wood Buffalo', name: 'Fort Mackay / Horizon' },
  IAA: { city: 'Igarka', name: 'Igarka' },
  IAB: { city: 'Wichita', name: 'Mc Connell Air Force Base' },
  IAD: { city: 'Washington', name: 'Washington Dulles International' },
  IAG: { city: 'Niagara Falls', name: 'Niagara Falls International' },
  IAH: { city: 'Houston', name: 'George Bush Intercontinental Houston' },
  IAM: { city: 'Zarzaitine', name: 'In Aménas' },
  IAN: { city: 'Kiana', name: 'Bob Baker Memorial' },
  IAO: { city: 'Siargao', name: 'Siargao' },
  IAR: { city: 'Yaroslavl', name: 'Tunoshna' },
  IAS: { city: 'Iasi', name: 'Iaşi' },
  IBA: { city: 'Ibadan', name: 'Ibadan' },
  IBB: { city: 'Isabela', name: 'General Villamil' },
  IBE: { city: 'Ibague', name: 'Perales' },
  IBP: { city: 'Iberia', name: 'Iberia' },
  IBR: { city: 'Ibaraki', name: 'Hyakuri' },
  IBZ: { city: 'Ibiza', name: 'Ibiza' },
  ICC: { city: 'Isla De Coche', name: 'Andrés Miguel Salazar Marcano' },
  ICI: { city: 'Cicia', name: 'Cicia' },
  ICK: { city: 'Nieuw Nickerie', name: 'Nieuw Nickerie' },
  ICN: { city: 'Seoul', name: 'Incheon International' },
  ICT: { city: 'Wichita', name: 'Wichita Eisenhower National' },
  IDA: { city: 'Idaho Falls', name: 'Idaho Falls Regional' },
  IDP: { city: 'Independence', name: 'Independence Municipal' },
  IDR: { city: 'Indore', name: 'Devi Ahilyabai Holkar' },
  IDY: { city: 'Île dYeu', name: 'Île dYeu' },
  IEG: { city: 'Zielona Gora', name: 'Zielona Góra-Babimost' },
  IEJ: { city: 'Ie', name: 'Ie Jima' },
  IES: { city: 'Riesa', name: 'Riesa-Göhlis' },
  IEV: { city: 'Kiev', name: 'Kiev Zhuliany International' },
  IFH: { city: 'Daran', name: 'Hesa' },
  IFJ: { city: 'Isafjordur', name: 'Ísafjörður' },
  IFL: { city: 'Innisfail', name: 'Innisfail' },
  IFN: { city: 'Esfahan', name: 'Esfahan Shahid Beheshti International' },
  IFO: { city: 'Ivano-Frankivsk', name: 'Ivano-Frankivsk International' },
  IFU: { city: 'Ifuru', name: 'Ifuru' },
  IGA: { city: 'Matthew Town', name: 'Inagua' },
  IGB: { city: 'Ingeniero Jacobacci', name: 'Cabo F.A.A. H. R. Bordón' },
  IGD: { city: 'Igdir', name: 'Iğdır' },
  IGG: { city: 'Igiugig', name: 'Igiugig' },
  IGL: { city: 'Izmir', name: 'Çiğli' },
  IGR: { city: 'Iguazu Falls', name: 'Cataratas Del Iguazú International' },
  IGS: { city: 'Ingolstadt', name: 'Ingolstadt Manching' },
  IGT: { city: 'Magas', name: 'Magas' },
  IGU: { city: 'Foz Do Iguacu', name: 'Cataratas International' },
  IHC: { city: 'Inhaca', name: 'Inhaca' },
  IHR: { city: 'Iran Shahr', name: 'Iran Shahr' },
  IIA: { city: 'Inishmaan', name: 'Inishmaan Aerodrome' },
  IIL: { city: 'Ilam', name: 'Ilam' },
  IJK: { city: 'Izhevsk', name: 'Izhevsk' },
  IKA: { city: 'Tehran', name: 'Imam Khomeini International' },
  IKB: { city: 'North Wilkesboro', name: 'Wilkes County' },
  IKI: { city: 'Iki', name: 'Iki' },
  IKK: { city: 'Kankakee', name: 'Greater Kankakee' },
  IKL: { city: 'Ikela', name: 'Ikela' },
  IKO: { city: 'Nikolski', name: 'Nikolski Air Station' },
  IKS: { city: 'Tiksi', name: 'Tiksi' },
  IKT: { city: 'Irkutsk', name: 'Irkutsk' },
  IKU: { city: 'Tamchy', name: 'Issyk-Kul International' },
  ILA: { city: 'Illaga', name: 'Illaga' },
  ILD: { city: 'Lleida', name: 'Lleida-Alguaire' },
  ILF: { city: 'Ilford', name: 'Ilford' },
  ILG: { city: 'Wilmington', name: 'New Castle' },
  ILI: { city: 'Iliamna', name: 'Iliamna' },
  ILM: { city: 'Wilmington', name: 'Wilmington International' },
  ILN: { city: 'Wilmington', name: 'Wilmington Airpark' },
  ILO: { city: 'Iloilo', name: 'Iloilo International' },
  ILP: { city: 'Île des Pins', name: 'Île des Pins' },
  ILQ: { city: 'Ilo', name: 'Ilo' },
  ILR: { city: 'Ilorin', name: 'Ilorin International' },
  ILU: { city: 'Kilaguni', name: 'Kilaguni' },
  ILY: { city: 'Islay', name: 'Islay' },
  ILZ: { city: 'Žilina', name: 'Žilina' },
  IMB: { city: 'Imbaimadai', name: 'Imbaimadai' },
  IMF: { city: 'Imphal', name: 'Imphal' },
  IMK: { city: 'Simikot', name: 'Simikot' },
  IMM: { city: 'Immokalee', name: 'Immokalee Regional' },
  IMP: { city: 'Imperatriz', name: 'Prefeito Renato Moreira' },
  IMT: { city: 'Iron Mountain', name: 'Ford' },
  INA: { city: 'Inta', name: 'Inta' },
  IND: { city: 'Indianapolis', name: 'Indianapolis International' },
  ING: { city: 'El Calafate', name: 'Lago Argentino' },
  INH: { city: 'Inhambane', name: 'Inhambane' },
  INI: { city: 'Nis', name: 'Nis' },
  INK: { city: 'Wink', name: 'Winkler County' },
  INL: { city: 'International Falls', name: 'Falls International' },
  INN: { city: 'Innsbruck', name: 'Innsbruck' },
  INO: { city: 'Inongo', name: 'Inongo' },
  INQ: { city: 'Inisheer', name: 'Inisheer Aerodrome' },
  INS: { city: 'Indian Springs', name: 'Creech Air Force Base' },
  INT: { city: 'Winston-salem', name: 'Smith Reynolds' },
  INU: { city: 'Nauru', name: 'Nauru International' },
  INV: { city: 'Inverness', name: 'Inverness' },
  INW: { city: 'Winslow', name: 'Winslow Lindbergh Regional' },
  INZ: { city: 'In Salah', name: 'In Salah' },
  IOA: { city: 'Ioannina', name: 'Ioannina' },
  IOM: { city: 'Isle Of Man', name: 'Isle of Man' },
  ION: { city: 'Impfondo', name: 'Impfondo' },
  IOR: { city: 'Inis Mor', name: 'Inishmore Aerodrome' },
  IOS: { city: 'Ilheus', name: 'Bahia - Jorge Amado' },
  IOW: { city: 'Iowa City', name: 'Iowa City Municipal' },
  IPA: { city: 'Ipota', name: 'Ipota' },
  IPC: { city: 'Easter Island', name: 'Mataveri' },
  IPH: { city: 'Ipoh', name: 'Sultan Azlan Shah' },
  IPI: { city: 'Ipiales', name: 'San Luis' },
  IPL: { city: 'Imperial', name: 'Imperial County' },
  IPN: { city: 'Ipatinga', name: 'Usiminas' },
  IPT: { city: 'Williamsport', name: 'Williamsport Regional' },
  IQA: { city: 'Al Asad', name: 'Al Asad Air Base' },
  IQM: { city: 'Qiemo', name: 'Qiemo Yudu' },
  IQN: { city: 'Qingyang', name: 'Qingyang' },
  IQQ: { city: 'Iquique', name: 'Diego Aracena' },
  IQT: { city: 'Iquitos', name: 'Coronel FAP Francisco Secada Vignetta International' },
  IRA: { city: 'Kirakira', name: 'Ngorangora' },
  IRB: { city: 'Iraan', name: 'Iraan Municipal' },
  IRC: { city: 'Circle', name: 'Circle City /New/' },
  IRD: { city: 'Ishurdi', name: 'Ishurdi' },
  IRG: { city: 'Lockhart River', name: 'Lockhart River' },
  IRI: { city: 'Iringa', name: 'Iringa' },
  IRJ: { city: 'La Rioja', name: 'Capitan V A Almonacid' },
  IRK: { city: 'Kirksville', name: 'Kirksville Regional' },
  IRP: { city: 'Isiro', name: 'Matari' },
  IRZ: { city: 'Santa Isabel do Rio Negro', name: 'Tapuruquara' },
  ISA: { city: 'Mount Isa', name: 'Mount Isa' },
  ISB: { city: 'Islamabad', name: 'New Islamabad International' },
  ISC: { city: 'ST MARYS', name: 'St. Marys' },
  ISE: { city: 'Isparta', name: 'Süleyman Demirel International' },
  ISG: { city: 'Ishigaki', name: 'New Ishigaki' },
  ISJ: { city: 'Isla Mujeres', name: 'Isla Mujeres' },
  ISK: { city: 'Nasik Road', name: 'Nashik' },
  ISL: { city: 'Istanbul', name: 'Atatürk International' },
  ISM: { city: 'Kissimmee', name: 'Kissimmee Gateway' },
  ISN: { city: 'Williston', name: 'Sloulin Field International' },
  ISO: { city: 'Kinston', name: 'Kinston Regional Jetport At Stallings Field' },
  ISP: { city: 'Islip', name: 'Long Island Mac Arthur' },
  IST: { city: 'Istanbul', name: 'Istanbul' },
  ISU: { city: 'Sulaymaniyah', name: 'Sulaymaniyah International' },
  ISW: { city: 'Wisconsin Rapids', name: 'Alexander Field South Wood County' },
  ITA: { city: 'Itaituba', name: 'Itacoatiara' },
  ITB: { city: 'Itaituba', name: 'Itaituba' },
  ITH: { city: 'Ithaca', name: 'Ithaca Tompkins Regional' },
  ITM: { city: 'Osaka', name: 'Osaka International' },
  ITO: { city: 'Hilo', name: 'Hilo International' },
  ITP: { city: 'Itaperuna', name: 'Itaperuna' },
  ITR: { city: 'Itumbiara', name: 'Francisco Vilela do Amaral' },
  IUE: { city: 'Alofi', name: 'Niue International' },
  IVA: { city: 'Ampampamena', name: 'Ampampamena' },
  IVC: { city: 'Invercargill', name: 'Invercargill' },
  IVL: { city: 'Ivalo', name: 'Ivalo' },
  IVR: { city: 'Inverell', name: 'Inverell' },
  IWA: { city: 'Ivanovo', name: 'Ivanovo South' },
  IWJ: { city: 'Iwami', name: 'Iwami' },
  IWK: { city: 'Iwakuni', name: 'Iwakuni Marine Corps Air Station' },
  IWO: { city: 'Iwojima', name: 'Iwo Jima' },
  IWS: { city: 'Houston', name: 'West Houston' },
  IXA: { city: 'Agartala', name: 'Agartala' },
  IXB: { city: 'Baghdogra', name: 'Bagdogra' },
  IXC: { city: 'Chandigarh', name: 'Chandigarh' },
  IXD: { city: 'Allahabad', name: 'Allahabad' },
  IXE: { city: 'Mangalore', name: 'Mangalore International' },
  IXG: { city: 'Belgaum', name: 'Belgaum' },
  IXH: { city: 'Kailashahar', name: 'Kailashahar' },
  IXI: { city: 'Lilabari', name: 'North Lakhimpur' },
  IXJ: { city: 'Jammu', name: 'Jammu' },
  IXK: { city: 'Keshod', name: 'Keshod' },
  IXL: { city: 'Leh', name: 'Leh Kushok Bakula Rimpochee' },
  IXM: { city: 'Madurai', name: 'Madurai' },
  IXP: { city: 'Pathankot', name: 'Pathankot' },
  IXR: { city: 'Ranchi', name: 'Birsa Munda' },
  IXS: { city: 'Silchar', name: 'Silchar' },
  IXT: { city: 'Pasighat', name: 'Pasighat' },
  IXU: { city: 'Aurangabad', name: 'Aurangabad' },
  IXV: { city: 'Along', name: 'Along' },
  IXW: { city: 'Jamshedpur', name: 'Sonari' },
  IXY: { city: 'Kandla', name: 'Kandla' },
  IXZ: { city: 'Port Blair', name: 'Vir Savarkar International' },
  IYK: { city: 'Inyokern', name: 'Inyokern' },
  IZA: { city: 'Juiz de Fora', name: 'Zona da Mata Regional' },
  IZO: { city: 'Izumo', name: 'Izumo' },
  IZT: { city: 'Iztepec', name: 'Ixtepec' },
  JAA: { city: 'Jalalabad', name: 'Jalalabad' },
  JAB: { city: 'Jabiru', name: 'Jabiru' },
  JAC: { city: 'Jacksn Hole', name: 'Jackson Hole' },
  JAD: { city: 'Perth', name: 'Perth Jandakot' },
  JAE: { city: 'Jaén', name: 'Shumba' },
  JAF: { city: 'Jaffna', name: 'Kankesanturai' },
  JAG: { city: 'Jacobsbad', name: 'Shahbaz Air Base' },
  JAI: { city: 'Jaipur', name: 'Jaipur International' },
  JAK: { city: 'Jacmel', name: 'Jacmel' },
  JAL: { city: 'Jalapa', name: 'El Lencero' },
  JAM: { city: 'Yambol', name: 'Bezmer Air Base' },
  JAN: { city: 'Jackson', name: 'Jackson-Medgar Wiley Evers International' },
  JAP: { city: 'Chacarita', name: 'Chacarita' },
  JAR: { city: 'Jahrom', name: 'Jahrom' },
  JAS: { city: 'Jasper', name: 'Jasper County Airport-Bell Field' },
  JAU: { city: 'Jauja', name: 'Francisco Carle' },
  JAV: { city: 'Ilulissat', name: 'Ilulissat' },
  JAX: { city: 'Jacksonville', name: 'Jacksonville International' },
  JBQ: { city: 'La Isabela', name: 'La Isabela International' },
  JBR: { city: 'Jonesboro', name: 'Jonesboro Municipal' },
  JCB: { city: 'Joacaba', name: 'Santa Terezinha' },
  JCH: { city: 'Qasigiannguit', name: 'Qasigiannguit Heliport' },
  JCI: { city: 'Olathe', name: 'New Century Aircenter' },
  JCK: { city: 'Julia Creek', name: 'Julia Creek' },
  JCR: { city: 'Jacare-acanga', name: 'Jacareacanga' },
  JCT: { city: 'Junction', name: 'Kimble County' },
  JDF: { city: 'Juiz De Fora', name: 'Francisco de Assis' },
  JDG: { city: 'Seogwipo', name: 'Jeongseok' },
  JDH: { city: 'Jodhpur', name: 'Jodhpur' },
  JDO: { city: 'Juazeiro Do Norte', name: 'Orlando Bezerra de Menezes' },
  JDZ: { city: 'Jingdezhen', name: 'Jingdezhen' },
  JED: { city: 'Jeddah', name: 'King Abdulaziz International' },
  JEE: { city: 'Jeremie', name: 'Jérémie' },
  JEF: { city: 'Jefferson City', name: 'Jefferson City Memorial' },
  JEG: { city: 'Aasiaat', name: 'Aasiaat' },
  JER: { city: 'Jersey', name: 'Jersey' },
  JFK: { city: 'New York', name: 'John F Kennedy International' },
  JFR: { city: 'Paamiut', name: 'Paamiut Heliport' },
  JGA: { city: 'Jamnagar', name: 'Jamnagar' },
  JGD: { city: 'Jiagedaqi District', name: 'Jiagedaqi' },
  JGN: { city: 'Jiayuguan', name: 'Jiayuguan' },
  JGO: { city: 'Qeqertarsuaq Airport', name: 'Qeqertarsuaq Heliport' },
  JGS: { city: 'Jian', name: 'Jinggangshan' },
  JHB: { city: 'Johor Bahru', name: 'Senai International' },
  JHG: { city: 'Jinghonggasa', name: 'Xishuangbanna Gasa' },
  JHM: { city: 'Lahania-kapalua', name: 'Kapalua' },
  JHQ: { city: 'Shute Harbour', name: 'Shute Harbour' },
  JHS: { city: 'Sisimiut', name: 'Sisimiut' },
  JHW: { city: 'Jamestown', name: 'Chautauqua County-Jamestown' },
  JIA: { city: 'Juina', name: 'Juína' },
  JIB: { city: 'Djibouti', name: 'Djibouti-Ambouli' },
  JIC: { city: 'Jinchuan', name: 'Jinchuan' },
  JIJ: { city: 'Jijiga', name: 'Wilwal International' },
  JIK: { city: 'Ikaria', name: 'Ikaria' },
  JIM: { city: 'Jimma', name: 'Jimma' },
  JIQ: { city: 'Qianjiang', name: 'Qianjiang Wulingshan' },
  JIU: { city: 'Jiujiang', name: 'Jiujiang Lushan' },
  JIW: { city: 'Jiwani', name: 'Jiwani' },
  JJG: { city: 'Jaguaruna', name: 'Humberto Ghizzo Bortoluzzi Regional' },
  JJI: { city: 'Juanjui', name: 'Juanjui' },
  JJM: { city: 'Meru National Park', name: 'Mulika Lodge' },
  JJN: { city: 'Quanzhou', name: 'Quanzhou Jinjiang International' },
  JJU: { city: 'Qaqortoq', name: 'Qaqortoq Heliport' },
  JKG: { city: 'Joenkoeping', name: 'Jönköping' },
  JKH: { city: 'Chios', name: 'Chios Island National' },
  JKL: { city: 'Kalymnos', name: 'Kalymnos' },
  JKR: { city: 'Janakpur', name: 'Janakpur' },
  JLN: { city: 'Joplin', name: 'Joplin Regional' },
  JLR: { city: 'Jabalpur', name: 'Jabalpur' },
  JMJ: { city: 'Lancang Lahu', name: 'Lancang Jingmai' },
  JMK: { city: 'Mykonos', name: 'Mikonos' },
  JMO: { city: 'Jomsom', name: 'Jomsom' },
  JMS: { city: 'Jamestown', name: 'Jamestown Regional' },
  JMU: { city: 'Jiamusi', name: 'Jiamusi' },
  JNB: { city: 'Johannesburg', name: 'OR Tambo International' },
  JNG: { city: 'Jining', name: 'Jining Qufu' },
  JNI: { city: 'Junin', name: 'Junin' },
  JNN: { city: 'Nanortalik', name: 'Nanortalik Heliport' },
  JNS: { city: 'Narsaq', name: 'Narsaq Heliport' },
  JNU: { city: 'Juneau', name: 'Juneau International' },
  JNX: { city: 'Cyclades Islands', name: 'Naxos' },
  JNZ: { city: 'Jinzhou', name: 'Jinzhou' },
  JOE: { city: 'Joensuu', name: 'Joensuu' },
  JOG: { city: 'Yogyakarta', name: 'Adi Sutjipto International' },
  JOH: { city: 'Port Saint Johns', name: 'Port St Johns' },
  JOI: { city: 'Joinville', name: 'Lauro Carneiro de Loyola' },
  JOJ: { city: 'Doris Lake', name: 'Doris Lake' },
  JOK: { city: 'Yoshkar-Ola', name: 'Yoshkar-Ola' },
  JOL: { city: 'Jolo', name: 'Jolo' },
  JON: { city: 'Johnston Island', name: 'Johnston Atoll' },
  JOS: { city: 'Jos', name: 'Yakubu Gowon' },
  JOT: { city: 'Joliet', name: 'Joliet Regional' },
  JPA: { city: 'Joao Pessoa', name: 'Presidente Castro Pinto International' },
  JPR: { city: 'Ji-Paraná', name: 'Ji-Paraná' },
  JQA: { city: 'Uummannaq', name: 'Qaarsut' },
  JQE: { city: 'Jaqué', name: 'Jaqué' },
  JRA: { city: 'New York', name: 'West 30th St. Heliport' },
  JRB: { city: 'New York', name: 'Downtown-Manhattan/Wall St Heliport' },
  JRF: { city: 'Kapolei', name: 'Kalaeloa' },
  JRH: { city: 'Jorhat', name: 'Jorhat' },
  JRN: { city: 'Juruena', name: 'Juruena' },
  JRO: { city: 'Kilimanjaro', name: 'Kilimanjaro International' },
  JSA: { city: 'Jaisalmer', name: 'Jaisalmer' },
  JSH: { city: 'Sitia', name: 'Sitia' },
  JSI: { city: 'Skiathos', name: 'Skiathos Island National' },
  JSJ: { city: 'Jiansanjiang', name: 'Jiansanjiang' },
  JSK: { city: 'Jask', name: 'Jask' },
  JSM: { city: 'Jose de San Martin', name: 'Jose De San Martin' },
  JSR: { city: 'Jessore', name: 'Jessore' },
  JST: { city: 'Johnstown', name: 'John Murtha Johnstown Cambria County' },
  JSU: { city: 'Maniitsoq', name: 'Maniitsoq' },
  JSY: { city: 'Syros Island', name: 'Syros' },
  JTC: { city: 'Bauru', name: 'Bauru - Arealva' },
  JTR: { city: 'Thira', name: 'Santorini' },
  JTY: { city: 'Astypalaia', name: 'Astypalaia' },
  JUA: { city: 'Juara', name: 'Inácio Luís do Nascimento' },
  JUB: { city: 'Juba', name: 'Juba International' },
  JUH: { city: 'Chizhou', name: 'Jiuhuashan' },
  JUI: { city: 'Juist', name: 'Juist' },
  JUJ: { city: 'Jujuy', name: 'Gobernador Horacio Guzman International' },
  JUL: { city: 'Juliaca', name: 'Inca Manco Capac International' },
  JUM: { city: 'Jumla', name: 'Jumla' },
  JUV: { city: 'Upernavik', name: 'Upernavik' },
  JUZ: { city: 'Quzhou', name: 'Quzhou' },
  JVA: { city: 'Ankavandra', name: 'Ankavandra' },
  JVL: { city: 'Janesville', name: 'Southern Wisconsin Regional' },
  JWA: { city: 'Jwaneng', name: 'Jwaneng' },
  JWN: { city: 'Zanjan', name: 'Zanjan' },
  JXA: { city: 'Jixi', name: 'Jixi Xingkaihu' },
  JXN: { city: 'Jackson', name: 'Jackson County Reynolds Field' },
  JYR: { city: 'Jiroft', name: 'Jiroft' },
  JYV: { city: 'Jyvaskyla', name: 'Jyvaskyla' },
  JZH: { city: 'Jiuzhaigou', name: 'Jiuzhai Huanglong' },
  KAA: { city: 'Kasama', name: 'Kasama' },
  KAB: { city: 'Kariba', name: 'Kariba International' },
  KAC: { city: 'Kamishly', name: 'Kamishly' },
  KAD: { city: 'Kaduna', name: 'Kaduna' },
  KAG: { city: 'Kangnung', name: 'Gangneung Airport (K-18)' },
  KAI: { city: 'Kaieteur', name: 'Kaieteur International' },
  KAJ: { city: 'Kajaani', name: 'Kajaani' },
  KAL: { city: 'Kaltag', name: 'Kaltag' },
  KAN: { city: 'Kano', name: 'Mallam Aminu International' },
  KAO: { city: 'Kuusamo', name: 'Kuusamo' },
  KAR: { city: 'Kamarang', name: 'Kamarang' },
  KAT: { city: 'Kaitaia', name: 'Kaitaia' },
  KAU: { city: 'Kauhava', name: 'Kauhava' },
  KAW: { city: 'Kawthoung', name: 'Kawthoung' },
  KAX: { city: 'Kalbarri', name: 'Kalbarri' },
  KAZ: { city: 'Kao', name: 'Kao' },
  KBL: { city: 'Kabul', name: 'Hamid Karzai International' },
  KBN: { city: 'Kabinda', name: 'Tunta' },
  KBP: { city: 'Kiev', name: 'Boryspil International' },
  KBQ: { city: 'Kasungu', name: 'Kasungu' },
  KBR: { city: 'Kota Bahru', name: 'Sultan Ismail Petra' },
  KBS: { city: 'Bo', name: 'Bo' },
  KBV: { city: 'Krabi', name: 'Krabi' },
  KBZ: { city: 'Kaikoura', name: 'Kaikoura' },
  KCA: { city: 'Kuqa', name: 'Kuqa' },
  KCF: { city: 'Kadanwari', name: 'Kadanwari' },
  KCH: { city: 'Kuching', name: 'Kuching International' },
  KCK: { city: 'Kirensk', name: 'Kirensk' },
  KCM: { city: 'Kahramanmaras', name: 'Kahramanmaraş' },
  KCO: { city: 'Topel', name: 'Cengiz Topel' },
  KCS: { city: 'Petermann', name: 'Kings Creek' },
  KCT: { city: 'Koggala', name: 'Koggala' },
  KCZ: { city: 'Kochi', name: 'Kōchi Ryōma' },
  KDA: { city: 'Kolda', name: 'Kolda North' },
  KDC: { city: 'Kandi', name: 'Kandi' },
  KDD: { city: 'Khuzdar', name: 'Khuzdar' },
  KDH: { city: 'Kandahar', name: 'Kandahar' },
  KDI: { city: 'Kendari', name: 'Wolter Monginsidi' },
  KDL: { city: 'Kardla', name: 'Kärdla' },
  KDM: { city: 'Kaadedhdhoo', name: 'Kaadedhdhoo' },
  KDO: { city: 'Laamu Atoll', name: 'Kadhdhoo' },
  KDT: { city: 'Nakhon Pathom', name: 'Kamphaeng Saen' },
  KDU: { city: 'Skardu', name: 'Skardu' },
  KDV: { city: 'Vunisea', name: 'Vunisea' },
  KDX: { city: 'Kadugli', name: 'Kadugli' },
  KDY: { city: 'Khandyga', name: 'Typliy Klyuch' },
  KED: { city: 'Kaedi', name: 'Kaédi' },
  KEF: { city: 'Keflavik', name: 'Keflavik International' },
  KEJ: { city: 'Kemorovo', name: 'Kemerovo' },
  KEL: { city: 'Kiel', name: 'Kiel-Holtenau' },
  KEM: { city: 'Kemi', name: 'Kemi-Tornio' },
  KEN: { city: 'Kenema', name: 'Kenema' },
  KEO: { city: 'Odienne', name: 'Odienne' },
  KEP: { city: 'Nepalgunj', name: 'Nepalgunj' },
  KER: { city: 'Kerman', name: 'Kerman' },
  KES: { city: 'Kelsey', name: 'Kelsey' },
  KET: { city: 'Kengtung', name: 'Kengtung' },
  KEV: { city: 'Halli', name: 'Halli' },
  KEW: { city: 'Keewaywin', name: 'Keewaywin' },
  KEY: { city: 'Kericho', name: 'Kericho' },
  KFA: { city: 'Kiffa', name: 'Kiffa' },
  KFE: { city: 'Cloudbreak', name: 'Fortescue - Dave Forrest Aerodrome' },
  KFG: { city: 'Kalkgurung', name: 'Kalkgurung' },
  KFP: { city: 'False Pass', name: 'False Pass' },
  KFS: { city: 'Kastamonu', name: 'Kastamonu' },
  KGA: { city: 'Kananga', name: 'Kananga' },
  KGC: { city: 'Kingscote', name: 'Kingscote' },
  KGD: { city: 'Kaliningrad', name: 'Khrabrovo' },
  KGE: { city: 'Kagau Island', name: 'Kaghau' },
  KGF: { city: 'Karaganda', name: 'Sary-Arka' },
  KGG: { city: 'Kedougou', name: 'Kédougou' },
  KGI: { city: 'Kalgoorlie', name: 'Kalgoorlie Boulder' },
  KGJ: { city: 'Karonga', name: 'Karonga' },
  KGK: { city: 'Koliganek', name: 'Koliganek' },
  KGL: { city: 'Kigali', name: 'Kigali International' },
  KGO: { city: 'Kirovograd', name: 'Kirovograd' },
  KGP: { city: 'Kogalym', name: 'Kogalym International' },
  KGS: { city: 'Kos', name: 'Kos' },
  KGT: { city: 'Kangding', name: 'Kangding' },
  KGW: { city: 'Kagi', name: 'Kagi' },
  KHC: { city: 'Kerch', name: 'Kerch' },
  KHD: { city: 'Khorram Abad', name: 'Khoram Abad' },
  KHE: { city: 'Kherson', name: 'Kherson International' },
  KHG: { city: 'Kashi', name: 'Kashgar' },
  KHH: { city: 'Kaohsiung', name: 'Kaohsiung International' },
  KHI: { city: 'Karachi', name: 'Jinnah International' },
  KHJ: { city: 'Kauhajoki', name: 'Kauhajoki' },
  KHK: { city: 'Khark Island', name: 'Khark Island' },
  KHM: { city: 'Khamti', name: 'Kanti' },
  KHN: { city: 'Nanchang', name: 'Nanchang Changbei International' },
  KHS: { city: 'Khasab', name: 'Khasab Air Base' },
  KHT: { city: 'Khost', name: 'Khost' },
  KHV: { city: 'Khabarovsk', name: 'Khabarovsk-Novy' },
  KHW: { city: 'Khwai River', name: 'Khwai River Lodge' },
  KHY: { city: 'Khoy', name: 'Khoy' },
  KHZ: { city: 'Kauehi', name: 'Kauehi' },
  KID: { city: 'Kristianstad', name: 'Kristianstad' },
  KIF: { city: 'Kingfisher Lake', name: 'Kingfisher Lake' },
  KIH: { city: 'Kish Island', name: 'Kish International' },
  KIJ: { city: 'Niigata', name: 'Niigata' },
  KIK: { city: 'Kirkuk', name: 'Kirkuk Air Base' },
  KIM: { city: 'Kimberley', name: 'Kimberley' },
  KIN: { city: 'Kingston', name: 'Norman Manley International' },
  KIO: { city: 'Kili Island', name: 'Kili' },
  KIR: { city: 'Kerry', name: 'Kerry' },
  KIS: { city: 'Kisumu', name: 'Kisumu' },
  KIT: { city: 'Kithira', name: 'Kithira' },
  KIV: { city: 'Chisinau', name: 'Chişinău International' },
  KIW: { city: 'Southdowns', name: 'Southdowns' },
  KIX: { city: 'Osaka', name: 'Kansai International' },
  KIY: { city: 'Kilwa Masoko', name: 'Kilwa Masoko' },
  KJA: { city: 'Krasnoyarsk', name: 'Yemelyanovo' },
  KJH: { city: 'Kaili', name: 'Kaili' },
  KJI: { city: 'Burqin', name: 'Kanas' },
  KJK: { city: 'Kortrijk-vevelgem', name: 'Wevelgem' },
  KJP: { city: 'Kerama', name: 'Kerama' },
  KKA: { city: 'Koyuk', name: 'Koyuk Alfred Adams' },
  KKC: { city: 'Khon Kaen', name: 'Khon Kaen' },
  KKE: { city: 'Kerikeri', name: 'Kerikeri' },
  KKH: { city: 'Kongiganak', name: 'Kongiganak' },
  KKJ: { city: 'Kitakyushu', name: 'Kitakyūshū' },
  KKN: { city: 'Kirkenes', name: 'Kirkenes Airport (Høybuktmoen)' },
  KKR: { city: 'Kaukura Atoll', name: 'Kaukura' },
  KKS: { city: 'Kashan', name: 'Kashan' },
  KKW: { city: 'Kikwit', name: 'Kikwit' },
  KKX: { city: 'Kikai', name: 'Kikai' },
  KLC: { city: 'Kaolack', name: 'Kaolack' },
  KLD: { city: 'Tver', name: 'Migalovo Air Base' },
  KLF: { city: 'Kaluga', name: 'Grabtsevo' },
  KLG: { city: 'Kalskag', name: 'Kalskag' },
  KLH: { city: 'Kolhapur', name: 'Kolhapur' },
  KLI: { city: 'Kotakoli', name: 'Kotakoli' },
  KLJ: { city: 'Klaipeda', name: 'Klaipėda' },
  KLM: { city: 'Kalaleh', name: 'Kalaleh' },
  KLN: { city: 'Larsen Bay', name: 'Larsen Bay' },
  KLO: { city: 'Kalibo', name: 'Kalibo International' },
  KLR: { city: 'Kalkmar', name: 'Kalmar' },
  KLS: { city: 'Kelso', name: 'Southwest Washington Regional' },
  KLU: { city: 'Klagenfurt', name: 'Klagenfurt' },
  KLV: { city: 'Karlovy Vary', name: 'Karlovy Vary International' },
  KLW: { city: 'Klawock', name: 'Klawock' },
  KLX: { city: 'Kalamata', name: 'Kalamata' },
  KLZ: { city: 'Kleinsee', name: 'Kleinsee' },
  KMA: { city: 'Kerema', name: 'Kerema' },
  KMC: { city: 'King Khalid Mil.city', name: 'King Khaled Military City' },
  KME: { city: 'Kamembe', name: 'Kamembe' },
  KMG: { city: 'Kunming', name: 'Kunming Changshui International' },
  KMH: { city: 'Kuruman', name: 'Johan Pienaar' },
  KMI: { city: 'Miyazaki', name: 'Miyazaki' },
  KMJ: { city: 'Kumamoto', name: 'Kumamoto' },
  KMN: { city: 'Kamina Base', name: 'Kamina Base' },
  KMO: { city: 'Manokotak', name: 'Manokotak' },
  KMP: { city: 'Keetmanshoop', name: 'Keetmanshoop' },
  KMQ: { city: 'Kanazawa', name: 'Komatsu' },
  KMS: { city: 'Kumasi', name: 'Kumasi' },
  KMU: { city: 'Kismayu', name: 'Kisimayu' },
  KMV: { city: 'Kalemyo', name: 'Kalay' },
  KMW: { city: 'Kostroma', name: 'Kostroma Sokerkino' },
  KNA: { city: 'Vina del Mar', name: 'Viña del mar' },
  KND: { city: 'Kindu', name: 'Kindu' },
  KNF: { city: 'Marham', name: 'RAF Marham' },
  KNG: { city: 'Kaimana', name: 'Kaimana' },
  KNH: { city: 'Kinmen', name: 'Kinmen' },
  KNO: { city: 'Medan', name: 'Kualanamu International' },
  KNP: { city: 'Kapanda', name: 'Capanda' },
  KNQ: { city: 'Kone', name: 'Koné' },
  KNR: { city: 'Kangan', name: 'Jam' },
  KNS: { city: 'King Island', name: 'King Island' },
  KNU: { city: 'Kanpur', name: 'Kanpur' },
  KNW: { city: 'New Stuyahok', name: 'New Stuyahok' },
  KNX: { city: 'Kununurra', name: 'Kununurra' },
  KOA: { city: 'Kona', name: 'Ellison Onizuka Kona International At Keahole' },
  KOC: { city: 'Koumac', name: 'Koumac' },
  KOE: { city: 'Kupang', name: 'El Tari' },
  KOI: { city: 'Kirkwall', name: 'Kirkwall' },
  KOJ: { city: 'Kagoshima', name: 'Kagoshima' },
  KOK: { city: 'Kruunupyy', name: 'Kokkola-Pietarsaari' },
  KOO: { city: 'Kongolo', name: 'Kongolo' },
  KOP: { city: 'Nakhon Phanom', name: 'Nakhon Phanom' },
  KOQ: { city: 'Koethen', name: 'Köthen' },
  KOS: { city: 'Sihanoukville', name: 'Sihanoukville International' },
  KOT: { city: 'Kotlik', name: 'Kotlik' },
  KOU: { city: 'Koulamoutou', name: 'Koulamoutou Mabimbi' },
  KOV: { city: 'Kokshetau', name: 'Kokshetau' },
  KOW: { city: 'Ganzhou', name: 'Ganzhou' },
  KOX: { city: 'Kokonau', name: 'Kokonau' },
  KPC: { city: 'Port Clarence', name: 'Port Clarence Coast Guard Station' },
  KPN: { city: 'Kipnuk', name: 'Kipnuk' },
  KPO: { city: 'Pohang', name: 'Pohang Airport (G-815/K-3)' },
  KPV: { city: 'Perryville', name: 'Perryville' },
  KQA: { city: 'Akutan', name: 'Akutan Seaplane Base' },
  KQH: { city: 'Ajmer', name: 'Kishangarh' },
  KQT: { city: 'Kurgan Tyube', name: 'Qurghonteppa International' },
  KRB: { city: 'Karumba', name: 'Karumba' },
  KRC: { city: 'Kerinci Regency', name: 'Departi Parbo' },
  KRF: { city: 'Kramfors', name: 'Kramfors Sollefteå' },
  KRH: { city: 'Redhill', name: 'Redhill Aerodrome' },
  KRI: { city: 'Kikori', name: 'Kikori' },
  KRK: { city: 'Krakow', name: 'Kraków John Paul II International' },
  KRL: { city: 'Korla', name: 'Korla' },
  KRN: { city: 'Kiruna', name: 'Kiruna' },
  KRO: { city: 'Kurgan', name: 'Kurgan' },
  KRP: { city: 'Karup', name: 'Karup' },
  KRQ: { city: 'Kramatorsk', name: 'Kramatorsk' },
  KRR: { city: 'Krasnodar', name: 'Krasnodar Pashkovsky International' },
  KRS: { city: 'Kristiansand', name: 'Kristiansand' },
  KRT: { city: 'Khartoum', name: 'Khartoum International' },
  KRW: { city: 'Krasnovodsk', name: 'Turkmenbashi' },
  KRY: { city: 'Karamay', name: 'Karamay' },
  KRZ: { city: 'Kiri', name: 'Basango Mboliasa' },
  KSA: { city: 'Kosrae', name: 'Kosrae International' },
  KSC: { city: 'Kosice', name: 'Košice' },
  KSD: { city: 'Karlstad', name: 'Karlstad' },
  KSE: { city: 'Kasese', name: 'Kasese' },
  KSF: { city: 'Kassel', name: 'Kassel-Calden' },
  KSH: { city: 'Bakhtaran', name: 'Shahid Ashrafi Esfahani' },
  KSI: { city: 'Kissidougou', name: 'Kissidougou' },
  KSJ: { city: 'Kasos', name: 'Kasos' },
  KSK: { city: 'Karlskoga', name: 'Karlskoga' },
  KSL: { city: 'Kassala', name: 'Kassala' },
  KSM: { city: 'St Marys', name: 'St Marys' },
  KSN: { city: 'Kostanay', name: 'Kostanay West' },
  KSO: { city: 'Kastoria', name: 'Kastoria National' },
  KSQ: { city: 'Khanabad', name: 'Karshi Khanabad' },
  KSS: { city: 'Sikasso', name: 'Sikasso' },
  KSU: { city: 'Kristiansund', name: 'Kristiansund Airport (Kvernberget)' },
  KSY: { city: 'Kars', name: 'Kars' },
  KSZ: { city: 'Kotlas', name: 'Kotlas' },
  KTA: { city: 'Karratha', name: 'Karratha' },
  KTD: { city: 'Kitadaito', name: 'Kitadaito' },
  KTE: { city: 'Kerteh', name: 'Kerteh' },
  KTF: { city: 'Takaka', name: 'Takaka' },
  KTG: { city: 'Ketapang', name: 'Ketapang(Rahadi Usman)' },
  KTI: { city: 'Kratie', name: 'Kratie' },
  KTL: { city: 'Kitale', name: 'Kitale' },
  KTM: { city: 'Kathmandu', name: 'Tribhuvan International' },
  KTN: { city: 'Ketchikan', name: 'Ketchikan International' },
  KTP: { city: 'Kingston', name: 'Tinson Pen' },
  KTQ: { city: 'Kitee', name: 'Kitee' },
  KTR: { city: 'Katherine', name: 'Tindal' },
  KTS: { city: 'Brevig Mission', name: 'Brevig Mission' },
  KTT: { city: 'Kittila', name: 'Kittilä' },
  KTU: { city: 'Kota', name: 'Kota' },
  KTW: { city: 'Katowice', name: 'Katowice International' },
  KUA: { city: 'Kuantan', name: 'Kuantan' },
  KUC: { city: 'Kuria', name: 'Kuria' },
  KUD: { city: 'Kudat', name: 'Kudat' },
  KUF: { city: 'Samara', name: 'Kurumoch International' },
  KUG: { city: 'Kubin', name: 'Kubin' },
  KUH: { city: 'Kushiro', name: 'Kushiro' },
  KUK: { city: 'Kasigluk', name: 'Kasigluk' },
  KUL: { city: 'Kuala Lumpur', name: 'Kuala Lumpur International' },
  KUM: { city: 'Yakushima', name: 'Yakushima' },
  KUN: { city: 'Kaunas', name: 'Kaunas International' },
  KUO: { city: 'Kuopio', name: 'Kuopio' },
  KUT: { city: 'Kutaisi', name: 'Kopitnari' },
  KUU: { city: 'Kulu', name: 'Kullu Manali' },
  KUV: { city: 'Kunsan', name: 'Kunsan Air Base' },
  KVA: { city: 'Kavala', name: 'Alexander the Great International' },
  KVB: { city: 'Skovde', name: 'Skövde' },
  KVC: { city: 'King Cove', name: 'King Cove' },
  KVD: { city: 'Ganja', name: 'Ganja' },
  KVG: { city: 'Kavieng', name: 'Kavieng' },
  KVK: { city: 'Apatity', name: 'Kirovsk-Apatity' },
  KVL: { city: 'Kivalina', name: 'Kivalina' },
  KVM: { city: 'Markovo', name: 'Markovo' },
  KVR: { city: 'Kavalerovo', name: 'Kavalerovo' },
  KVX: { city: 'Kirov', name: 'Pobedilovo' },
  KWA: { city: 'Kwajalein', name: 'Bucholz Army Air Field' },
  KWB: { city: 'Karimunjawa', name: 'Dewadaru - Kemujan Island' },
  KWE: { city: 'Guiyang', name: 'Longdongbao' },
  KWG: { city: 'Krivoy Rog', name: 'Kryvyi Rih International' },
  KWI: { city: 'Kuwait', name: 'Kuwait International' },
  KWJ: { city: 'Kwangju', name: 'Gwangju' },
  KWK: { city: 'Kwigillingok', name: 'Kwigillingok' },
  KWL: { city: 'Guilin', name: 'Guilin Liangjiang International' },
  KWM: { city: 'Kowanyama', name: 'Kowanyama' },
  KWN: { city: 'Quinhagak', name: 'Quinhagak' },
  KWT: { city: 'Kwethluk', name: 'Kwethluk' },
  KWZ: { city: 'Kolwezi', name: 'Kolwezi' },
  KXE: { city: 'Klerksdorp', name: 'P C Pelser' },
  KXF: { city: 'Koro Island', name: 'Koro Island' },
  KXK: { city: 'Komsomolsk-on-Amur', name: 'Komsomolsk-on-Amur' },
  KYA: { city: 'Konya', name: 'Konya' },
  KYD: { city: 'Lanyu', name: 'Lanyu' },
  KYE: { city: 'Kleiat', name: 'Rene Mouawad Air Base' },
  KYI: { city: 'Yalata', name: 'Yalata Mission' },
  KYK: { city: 'Karluk', name: 'Karluk' },
  KYP: { city: 'Kyaukpyu', name: 'Kyaukpyu' },
  KYS: { city: 'Kayes', name: 'Kayes Dag Dag' },
  KYU: { city: 'Koyukuk', name: 'Koyukuk' },
  KYZ: { city: 'Kyzyl', name: 'Kyzyl' },
  KZC: { city: 'Kompong Chnang', name: 'Kampong Chhnang' },
  KZF: { city: 'Kieta', name: 'Kaintiba' },
  KZG: { city: 'Kitzingen', name: 'Flugplatz Kitzingen' },
  KZI: { city: 'Kozani', name: 'Filippos' },
  KZN: { city: 'Kazan', name: 'Kazan International' },
  KZO: { city: 'Kzyl-Orda', name: 'Kzyl-Orda Southwest' },
  KZR: { city: 'Kutahya', name: 'Zafer' },
  KZS: { city: 'Kastelorizo', name: 'Kastelorizo' },
  LAA: { city: 'Lamar', name: 'Lamar Municipal' },
  LAD: { city: 'Luanda', name: 'Quatro de Fevereiro' },
  LAE: { city: 'Nadzab', name: 'Nadzab' },
  LAF: { city: 'Lafayette', name: 'Purdue University' },
  LAI: { city: 'Lannion', name: 'Lannion-Côte de Granit' },
  LAJ: { city: 'Lajes', name: 'Lages' },
  LAK: { city: 'Aklavik', name: 'Aklavik/Freddie Carmichael' },
  LAL: { city: 'Lakeland', name: 'Lakeland Linder International' },
  LAM: { city: 'Los Alamos', name: 'Los Alamos' },
  LAN: { city: 'Lansing', name: 'Capital City' },
  LAO: { city: 'Laoag', name: 'Laoag International' },
  LAP: { city: 'La Paz', name: 'Manuel Márquez de León International' },
  LAQ: { city: 'Al Bayda', name: 'La Abraq' },
  LAR: { city: 'Laramie', name: 'Laramie Regional' },
  LAS: { city: 'Las Vegas', name: 'McCarran International' },
  LAU: { city: 'Lamu', name: 'Manda Airstrip' },
  LAW: { city: 'Lawton', name: 'Lawton Fort Sill Regional' },
  LAX: { city: 'Los Angeles', name: 'Los Angeles International' },
  LAY: { city: 'Ladysmith', name: 'Ladysmith' },
  LAZ: { city: 'Bom Jesus Da Lapa', name: 'Bom Jesus da Lapa' },
  LBA: { city: 'Leeds', name: 'Leeds Bradford' },
  LBB: { city: 'Lubbock', name: 'Lubbock Preston Smith International' },
  LBC: { city: 'Luebeck', name: 'Lübeck Blankensee' },
  LBD: { city: 'Khudzhand', name: 'Khudzhand' },
  LBE: { city: 'Latrobe', name: 'Arnold Palmer Regional' },
  LBF: { city: 'North Platte', name: 'North Platte Regional Airport Lee Bird Field' },
  LBG: { city: 'Paris', name: 'Paris-Le Bourget' },
  LBI: { city: 'Albi', name: 'Albi-Le Séquestre' },
  LBJ: { city: 'Labuhan Bajo', name: 'Komodo' },
  LBL: { city: 'Liberal', name: 'Liberal Mid-America Regional' },
  LBQ: { city: 'Lambarene', name: 'Lambarene' },
  LBR: { city: 'Labrea', name: 'Lábrea' },
  LBS: { city: 'Lambasa', name: 'Labasa' },
  LBT: { city: 'Lumberton', name: 'Lumberton Regional' },
  LBU: { city: 'Labuan', name: 'Labuan' },
  LBV: { city: 'Libreville', name: 'Libreville Leon Mba International' },
  LBW: { city: 'Long Bawan-Borneo Island', name: 'Long Bawan' },
  LBX: { city: 'Lubang', name: 'Lubang' },
  LBY: { city: 'La Baule', name: 'La Baule-Escoublac' },
  LBZ: { city: 'Lucapa', name: 'Lucapa' },
  LCA: { city: 'Larnaca', name: 'Larnaca International' },
  LCC: { city: 'Lecce', name: 'Lecce Galatina Air Base' },
  LCE: { city: 'La Ceiba', name: 'Goloson International' },
  LCG: { city: 'La Coruna', name: 'A Coruña' },
  LCH: { city: 'Lake Charles', name: 'Lake Charles Regional' },
  LCJ: { city: 'Lodz', name: 'Łódź Władysław Reymont' },
  LCK: { city: 'Columbus', name: 'Rickenbacker International' },
  LCL: { city: 'La Coloma', name: 'La Coloma' },
  LCQ: { city: 'Lake City', name: 'Lake City Gateway' },
  LCX: { city: 'Longyan', name: 'Longyan Guanzhishan' },
  LCY: { city: 'London', name: 'London City' },
  LDB: { city: 'Londrina', name: 'Governador José Richa' },
  LDE: { city: 'Tarbes', name: 'Tarbes-Lourdes-Pyrénées' },
  LDG: { city: 'Arkhangelsk', name: 'Leshukonskoye' },
  LDH: { city: 'Lord Howe Island', name: 'Lord Howe Island' },
  LDI: { city: 'Lindi', name: 'Lindi' },
  LDJ: { city: 'Linden', name: 'Linden' },
  LDK: { city: 'Lidkoping', name: 'Lidköping-Hovby' },
  LDM: { city: 'Ludington', name: 'Mason County' },
  LDN: { city: 'Lamidanda', name: 'Lamidanda' },
  LDS: { city: 'Yinchun', name: 'Lindu' },
  LDU: { city: 'Lahad Datu', name: 'Lahad Datu' },
  LDV: { city: 'Landivisiau', name: 'Landivisiau Air Base' },
  LDX: { city: 'Saint-Laurent-du-Maroni', name: 'Saint-Laurent-du-Maroni' },
  LDY: { city: 'Londonderry', name: 'City of Derry' },
  LEA: { city: 'Learmonth', name: 'Learmonth' },
  LEB: { city: 'Lebanon', name: 'Lebanon Municipal' },
  LEC: { city: 'Lençóis', name: 'Coronel Horácio de Mattos' },
  LED: { city: 'St. Petersburg', name: 'Pulkovo' },
  LEE: { city: 'Leesburg', name: 'Leesburg International' },
  LEH: { city: 'Le Havre', name: 'Le Havre Octeville' },
  LEI: { city: 'Almeria', name: 'Almería International' },
  LEJ: { city: 'Leipzig', name: 'Leipzig/Halle' },
  LEK: { city: 'Labe', name: 'Tata' },
  LEL: { city: 'Lake Evella', name: 'Lake Evella' },
  LEN: { city: 'Leon', name: 'Leon' },
  LEQ: { city: 'Lands End', name: 'Lands End' },
  LER: { city: 'Leinster', name: 'Leinster' },
  LET: { city: 'Leticia', name: 'Alfredo Vásquez Cobo International' },
  LEU: { city: 'Seo De Urgel', name: 'Pirineus - la Seu dUrgel' },
  LEV: { city: 'Levuka', name: 'Levuka' },
  LEW: { city: 'Lewiston', name: 'Auburn Lewiston Municipal' },
  LEX: { city: 'Lexington KY', name: 'Blue Grass' },
  LEY: { city: 'Lelystad', name: 'Lelystad' },
  LFB: { city: 'Lumbo', name: 'Lumbo' },
  LFI: { city: 'Hampton', name: 'Langley Air Force Base' },
  LFK: { city: 'Lufkin', name: 'Angelina County' },
  LFM: { city: 'Lamerd', name: 'Lamerd' },
  LFQ: { city: 'LINFEN', name: 'Linfen Qiaoli' },
  LFR: { city: 'La Fria', name: 'La Fria' },
  LFT: { city: 'Lafayette', name: 'Lafayette Regional' },
  LFW: { city: 'Lome', name: 'Lomé-Tokoin' },
  LGA: { city: 'New York', name: 'La Guardia' },
  LGB: { city: 'Long Beach', name: 'Long Beach /Daugherty Field/' },
  LGC: { city: 'LaGrange', name: 'LaGrange Callaway' },
  LGD: { city: 'La Grande', name: 'La Grande/Union County' },
  LGG: { city: 'Liege', name: 'Liège' },
  LGH: { city: 'Leigh Creek', name: 'Leigh Creek' },
  LGI: { city: 'Dead Mans Cay', name: 'Deadmans Cay' },
  LGK: { city: 'Langkawi', name: 'Langkawi International' },
  LGL: { city: 'Long Datih', name: 'Long Lellang' },
  LGO: { city: 'Langeoog', name: 'Langeoog' },
  LGP: { city: 'Legazpi', name: 'Legazpi City International' },
  LGS: { city: 'Malargue', name: 'Comodoro D.R. Salomón' },
  LGU: { city: 'Logan', name: 'Logan-Cache' },
  LGW: { city: 'London', name: 'London Gatwick' },
  LHA: { city: 'Lahr', name: 'Lahr' },
  LHE: { city: 'Lahore', name: 'Alama Iqbal International' },
  LHG: { city: 'Lightning Ridge', name: 'Lightning Ridge' },
  LHK: { city: 'Guanghua', name: 'Guangzhou MR Air Base' },
  LHR: { city: 'London', name: 'London Heathrow' },
  LHS: { city: 'Las Heras', name: 'Las Heras' },
  LHV: { city: 'Lock Haven', name: 'William T. Piper Memorial' },
  LHW: { city: 'Lanzhou', name: 'Lanzhou Zhongchuan' },
  LID: { city: 'Valkenburg', name: 'Valkenburg Naval Air Base' },
  LIF: { city: 'Lifou', name: 'Lifou' },
  LIG: { city: 'Limoges', name: 'Limoges' },
  LIH: { city: 'Lihue', name: 'Lihue' },
  LII: { city: 'Mulia', name: 'Mulia' },
  LIL: { city: 'Lille', name: 'Lille-Lesquin' },
  LIM: { city: 'Lima', name: 'Jorge Chávez International' },
  LIN: { city: 'Milan', name: 'Milano Linate' },
  LIO: { city: 'Limon', name: 'Limon International' },
  LIP: { city: 'Lins', name: 'Lins' },
  LIQ: { city: 'Lisala', name: 'Lisala' },
  LIR: { city: 'Liberia', name: 'Daniel Oduber Quiros International' },
  LIS: { city: 'Lisbon', name: 'Humberto Delgado Airport (Lisbon Portela Airport)' },
  LIT: { city: 'Little Rock', name: 'Bill & Hillary Clinton National Airport/Adams Field' },
  LIW: { city: 'Loikaw', name: 'Loikaw' },
  LIX: { city: 'Likoma Island', name: 'Likoma Island' },
  LIY: { city: 'Wright', name: 'Wright AAF (Fort Stewart)/Midcoast Regional' },
  LJA: { city: 'Lodja', name: 'Lodja' },
  LJG: { city: 'Lijiang', name: 'Lijiang' },
  LJN: { city: 'Angleton', name: 'Texas Gulf Coast Regional' },
  LJU: { city: 'Ljubljana', name: 'Ljubljana Jože Pučnik' },
  LKB: { city: 'Lakeba Island', name: 'Lakeba Island' },
  LKG: { city: 'Lokichoggio', name: 'Lokichoggio' },
  LKH: { city: 'Long Akah', name: 'Long Akah' },
  LKL: { city: 'Lakselv', name: 'Banak' },
  LKN: { city: 'Leknes', name: 'Leknes' },
  LKO: { city: 'Lucknow', name: 'Chaudhary Charan Singh International' },
  LKP: { city: 'Lake Placid', name: 'Lake Placid' },
  LKV: { city: 'Lakeview', name: 'Lake County' },
  LKY: { city: 'Lake Manyara', name: 'Lake Manyara' },
  LKZ: { city: 'Lakenheath', name: 'RAF Lakenheath' },
  LLA: { city: 'Lulea', name: 'Luleå' },
  LLB: { city: 'Libo', name: 'Libo' },
  LLE: { city: 'Malalane', name: 'Riverside' },
  LLF: { city: 'Yongzhou', name: 'Lingling' },
  LLI: { city: 'Lalibella', name: 'Lalibella' },
  LLK: { city: 'Lankaran', name: 'Lankaran International' },
  LLU: { city: 'Alluitsup Paa', name: 'Alluitsup Paa Heliport' },
  LLV: { city: 'Lvliang', name: 'Lüliang' },
  LLW: { city: 'Lilongwe', name: 'Lilongwe International' },
  LLY: { city: 'Mount Holly', name: 'South Jersey Regional' },
  LMA: { city: 'Lake Minchumina', name: 'Minchumina' },
  LME: { city: 'Le Mans', name: 'Le Mans-Arnage' },
  LMM: { city: 'Los Mochis', name: 'Valle del Fuerte International' },
  LMN: { city: 'Limbang', name: 'Limbang' },
  LMO: { city: 'Lossiemouth', name: 'RAF Lossiemouth' },
  LMP: { city: 'Lampedusa', name: 'Lampedusa' },
  LMQ: { city: 'Marsa Brega', name: 'Marsa Brega' },
  LMR: { city: 'Lime Acres', name: 'Lime Acres Finsch Mine' },
  LMT: { city: 'Klamath Falls', name: 'Crater Lake-Klamath Regional' },
  LNA: { city: 'West Palm Beach', name: 'Palm Beach County Park' },
  LNB: { city: 'Lamen Bay', name: 'Lamen Bay' },
  LND: { city: 'Lindau', name: 'Hunt Field' },
  LNE: { city: 'Lonorore', name: 'Lonorore' },
  LNJ: { city: 'Lincang', name: 'Lintsang' },
  LNK: { city: 'Lincoln', name: 'Lincoln' },
  LNL: { city: 'Longnan', name: 'Longnan Chengzhou' },
  LNN: { city: 'Willoughby', name: 'Willoughby Lost Nation Municipal' },
  LNO: { city: 'Leonora', name: 'Leonora' },
  LNR: { city: 'Lone Rock', name: 'Tri-County Regional' },
  LNS: { city: 'Lancaster', name: 'Lancaster' },
  LNX: { city: 'Smolensk', name: 'Smolensk North' },
  LNY: { city: 'Lanai', name: 'Lanai' },
  LNZ: { city: 'Linz', name: 'Linz Hörsching' },
  LOD: { city: 'Longana', name: 'Longana' },
  LOE: { city: 'Loei', name: 'Loei' },
  LOH: { city: 'La Toma (Catamayo)', name: 'Camilo Ponce Enriquez' },
  LOK: { city: 'Lodwar', name: 'Lodwar' },
  LOL: { city: 'Lovelock', name: 'Derby Field' },
  LOO: { city: 'Laghouat', name: 'Laghouat' },
  LOP: { city: 'Praya', name: 'Lombok International' },
  LOS: { city: 'Lagos', name: 'Murtala Muhammed International' },
  LOT: { city: 'Lockport', name: 'Lewis University' },
  LOU: { city: 'Louisville', name: 'Bowman Field' },
  LOV: { city: 'Monclova', name: 'Monclova International' },
  LOZ: { city: 'London', name: 'London-Corbin Airport/Magee Field' },
  LPA: { city: 'Gran Canaria', name: 'Gran Canaria' },
  LPB: { city: 'La Paz', name: 'El Alto International' },
  LPC: { city: 'Lompoc', name: 'Lompoc' },
  LPD: { city: 'La Pedrera', name: 'La Pedrera' },
  LPF: { city: 'Liupanshui', name: 'Liupanshui Yuezhao' },
  LPG: { city: 'La Plata', name: 'La Plata' },
  LPI: { city: 'Linkoeping', name: 'Linköping City' },
  LPK: { city: 'Lipetsk', name: 'Lipetsk' },
  LPL: { city: 'Liverpool', name: 'Liverpool John Lennon' },
  LPM: { city: 'Lamap', name: 'Lamap' },
  LPP: { city: 'Lappeenranta', name: 'Lappeenranta' },
  LPQ: { city: 'Luang Prabang', name: 'Luang Phabang International' },
  LPS: { city: 'Lopez', name: 'Lopez Island' },
  LPT: { city: 'Lampang', name: 'Lampang' },
  LPU: { city: 'Long Apung-Borneo Island', name: 'Long Apung' },
  LPX: { city: 'Liepaja', name: 'Liepāja International' },
  LPY: { city: 'Le Puy', name: 'Le Puy-Loudes' },
  LQM: { city: 'Puerto Leguízamo', name: 'Caucaya' },
  LRA: { city: 'Larissa', name: 'Larisa' },
  LRD: { city: 'Laredo', name: 'Laredo International' },
  LRE: { city: 'Longreach', name: 'Longreach' },
  LRF: { city: 'Jacksonville', name: 'Little Rock Air Force Base' },
  LRH: { city: 'La Rochelle', name: 'La Rochelle-Île de Ré' },
  LRL: { city: 'Niatougou', name: 'Niamtougou International' },
  LRM: { city: 'La Romana', name: 'Casa De Campo International' },
  LRR: { city: 'Lar', name: 'Lar' },
  LRS: { city: 'Leros', name: 'Leros' },
  LRT: { city: 'Lorient', name: 'Lorient South Brittany (Bretagne Sud)' },
  LRU: { city: 'Las Cruces', name: 'Las Cruces International' },
  LRV: { city: 'Los Roques', name: 'Los Roques' },
  LSC: { city: 'La Serena', name: 'La Florida' },
  LSE: { city: 'La Crosse', name: 'La Crosse Municipal' },
  LSF: { city: 'Fort Benning', name: 'Lawson Army Air Field (Fort Benning)' },
  LSH: { city: 'Lashio', name: 'Lashio' },
  LSI: { city: 'Sumburgh', name: 'Sumburgh' },
  LSL: { city: 'Los Chiles', name: 'Los Chiles' },
  LSP: { city: 'Paraguana', name: 'Josefa Camejo International' },
  LSQ: { city: 'Los Angeles', name: 'María Dolores' },
  LSS: { city: 'Les Saintes', name: 'Terre-de-Haut' },
  LST: { city: 'Launceston', name: 'Launceston' },
  LSV: { city: 'Las Vegas', name: 'Nellis Air Force Base' },
  LSW: { city: 'Lhok Seumawe-Sumatra Island', name: 'Malikus Saleh' },
  LSX: { city: 'Lhok Sukon', name: 'Lhok Sukon' },
  LSY: { city: 'Lismore', name: 'Lismore' },
  LSZ: { city: 'Mali Losinj', name: 'Lošinj Island' },
  LTA: { city: 'Tzaneen', name: 'Tzaneen' },
  LTD: { city: 'Ghadames', name: 'Ghadames East' },
  LTI: { city: 'Altai', name: 'Altai' },
  LTK: { city: 'Latakia', name: 'Bassel Al-Assad International' },
  LTM: { city: 'Lethem', name: 'Lethem' },
  LTN: { city: 'London', name: 'London Luton' },
  LTO: { city: 'Loreto', name: 'Loreto International' },
  LTQ: { city: 'Le Tourquet', name: 'Le Touquet-Côte dOpale' },
  LTS: { city: 'Altus', name: 'Altus Air Force Base' },
  LTT: { city: 'La Môle', name: 'La Môle' },
  LTX: { city: 'Latacunga', name: 'Cotopaxi International' },
  LUA: { city: 'Lukla', name: 'Lukla' },
  LUC: { city: 'Laucala', name: 'Laucala Island' },
  LUD: { city: 'Luderitz', name: 'Luderitz' },
  LUF: { city: 'Phoenix', name: 'Luke Air Force Base' },
  LUG: { city: 'Lugano', name: 'Lugano' },
  LUH: { city: 'Ludhiaha', name: 'Ludhiana' },
  LUK: { city: 'Cincinnati', name: 'Cincinnati Municipal Airport Lunken Field' },
  LUM: { city: 'Luxi', name: 'Mangshi' },
  LUN: { city: 'Lusaka', name: 'Kenneth Kaunda International Airport Lusaka' },
  LUO: { city: 'Luena', name: 'Luena' },
  LUP: { city: 'Molokai', name: 'Kalaupapa' },
  LUQ: { city: 'San Luis', name: 'Brigadier Mayor D Cesar Raul Ojeda' },
  LUR: { city: 'Cape Lisburne', name: 'Cape Lisburne LRRS' },
  LUV: { city: 'Langgur-Kei Islands', name: 'Dumatumbun' },
  LUW: { city: 'Luwuk', name: 'Syukuran Aminuddin Amir' },
  LUX: { city: 'Luxemburg', name: 'Luxembourg-Findel International' },
  LUZ: { city: 'Lublin', name: 'Lublin' },
  LVA: { city: 'Laval', name: 'Laval-Entrammes' },
  LVI: { city: 'Livingstone', name: 'Livingstone' },
  LVK: { city: 'Livermore', name: 'Livermore Municipal' },
  LVM: { city: 'Livingston-Montana', name: 'Mission Field' },
  LVO: { city: 'Laverton', name: 'Laverton' },
  LVP: { city: 'Lavan Island', name: 'Lavan Island' },
  LVS: { city: 'Las Vegas', name: 'Las Vegas Municipal' },
  LWB: { city: 'Lewisburg', name: 'Greenbrier Valley' },
  LWC: { city: 'Lawrence', name: 'Lawrence Municipal' },
  LWK: { city: 'Lerwick', name: 'Lerwick / Tingwall' },
  LWM: { city: 'Lawrence', name: 'Lawrence Municipal' },
  LWN: { city: 'Gyumri', name: 'Gyumri Shirak' },
  LWO: { city: 'Lvov', name: 'Lviv International' },
  LWR: { city: 'Leeuwarden', name: 'Leeuwarden Air Base' },
  LWS: { city: 'Lewiston', name: 'Lewiston Nez Perce County' },
  LWT: { city: 'Lewistown', name: 'Lewistown Municipal' },
  LWY: { city: 'Lawas', name: 'Lawas' },
  LXA: { city: 'Lhasa', name: 'Lhasa Gonggar' },
  LXG: { city: 'Luang Namtha', name: 'Luang Namtha' },
  LXN: { city: 'Lexington', name: 'Jim Kelly Field' },
  LXR: { city: 'Luxor', name: 'Luxor International' },
  LXS: { city: 'Limnos', name: 'Limnos' },
  LYA: { city: 'Luoyang', name: 'Luoyang' },
  LYB: { city: 'Little Cayman', name: 'Edward Bodden' },
  LYC: { city: 'Lycksele', name: 'Lycksele' },
  LYE: { city: 'Lyneham', name: 'RAF Lyneham' },
  LYG: { city: 'Lianyungang', name: 'Lianyungang' },
  LYH: { city: 'Lynchburg', name: 'Lynchburg Regional Preston Glenn Field' },
  LYI: { city: 'Linyi', name: 'Shubuling' },
  LYM: { city: 'Lympne', name: 'Lympne' },
  LYN: { city: 'Lyon', name: 'Lyon-Bron' },
  LYP: { city: 'Faisalabad', name: 'Faisalabad International' },
  LYR: { city: 'Svalbard', name: 'Svalbard Airport, Longyear' },
  LYS: { city: 'Lyon', name: 'Lyon Saint-Exupéry' },
  LYU: { city: 'Ely', name: 'Ely Municipal' },
  LYX: { city: 'Lydd', name: 'Lydd' },
  LZC: { city: 'Lazard Cardenas', name: 'Lázaro Cárdenas' },
  LZH: { city: 'Liuzhou', name: 'Liuzhou Bailian' },
  LZN: { city: 'Matsu Islands', name: 'Matsu Nangan' },
  LZO: { city: 'Luzhou', name: 'Luzhou' },
  LZR: { city: 'Lizard Island', name: 'Lizard Island' },
  LZU: { city: 'Lawrenceville', name: 'Gwinnett County Briscoe Field' },
  LZY: { city: 'Nyingchi', name: 'Nyingchi' },
  MAA: { city: 'Madras', name: 'Chennai International' },
  MAB: { city: 'Maraba', name: 'João Correa da Rocha' },
  MAD: { city: 'Madrid', name: 'Adolfo Suárez Madrid–Barajas' },
  MAE: { city: 'Madera', name: 'Madera Municipal' },
  MAF: { city: 'Midland', name: 'Midland International' },
  MAG: { city: 'Madang', name: 'Madang' },
  MAH: { city: 'Menorca', name: 'Menorca' },
  MAI: { city: 'Mangochi', name: 'Mangochi' },
  MAJ: { city: 'Majuro', name: 'Marshall Islands International' },
  MAK: { city: 'Malakal', name: 'Malakal' },
  MAM: { city: 'Matamoros', name: 'General Servando Canales International' },
  MAN: { city: 'Manchester', name: 'Manchester' },
  MAO: { city: 'Manaus', name: 'Eduardo Gomes International' },
  MAQ: { city: 'Tak', name: 'Mae Sot' },
  MAR: { city: 'Maracaibo', name: 'La Chinita International' },
  MAS: { city: 'Momote', name: 'Momote' },
  MAT: { city: 'Matadi', name: 'Tshimpi' },
  MAU: { city: 'Maupiti', name: 'Maupiti' },
  MAX: { city: 'Matam', name: 'Ouro Sogui' },
  MAY: { city: 'Clarence Bain', name: 'Clarence A. Bain' },
  MAZ: { city: 'Mayaguez', name: 'Eugenio Maria De Hostos' },
  MBA: { city: 'Mombasa', name: 'Mombasa Moi International' },
  MBD: { city: 'Mafeking', name: 'Mmabatho International' },
  MBE: { city: 'Monbetsu', name: 'Monbetsu' },
  MBG: { city: 'Mobridge', name: 'Mobridge Municipal' },
  MBH: { city: 'Maryborough', name: 'Maryborough' },
  MBI: { city: 'Mbeya', name: 'Songwe' },
  MBJ: { city: 'Montego Bay', name: 'Sangster International' },
  MBL: { city: 'Manistee', name: 'Manistee Co Blacker' },
  MBO: { city: 'Mamburao', name: 'Mamburao' },
  MBS: { city: 'Saginaw', name: 'MBS International' },
  MBT: { city: 'Masbate', name: 'Moises R. Espinosa' },
  MBU: { city: 'Mbambanakira', name: 'Babanakira' },
  MBW: { city: 'Melbourne', name: 'Melbourne Moorabbin' },
  MBX: { city: 'Maribor', name: 'Maribor' },
  MBZ: { city: 'Maues', name: 'Maués' },
  MCB: { city: 'Mc Comb', name: 'Mc Comb/Pike County Airport/John E Lewis Field' },
  MCC: { city: 'Sacramento', name: 'Mc Clellan' },
  MCE: { city: 'Merced', name: 'Merced Regional Macready Field' },
  MCF: { city: 'Tampa', name: 'Mac Dill Air Force Base' },
  MCG: { city: 'Mcgrath', name: 'McGrath' },
  MCH: { city: 'Machala', name: 'General Manuel Serrano' },
  MCI: { city: 'Kansas City', name: 'Kansas City International' },
  MCJ: { city: 'La Mina', name: 'Jorge Isaac' },
  MCK: { city: 'McCook', name: 'Mc Cook Ben Nelson Regional' },
  MCL: { city: 'McKinley Park', name: 'McKinley National Park' },
  MCN: { city: 'Macon', name: 'Middle Georgia Regional' },
  MCO: { city: 'Orlando', name: 'Orlando International' },
  MCP: { city: 'Macapa', name: 'Alberto Alcolumbre' },
  MCS: { city: 'Monte Caseros', name: 'Monte Caseros' },
  MCT: { city: 'Muscat', name: 'Muscat International' },
  MCU: { city: 'Montlucon-gueret', name: 'Montluçon-Guéret' },
  MCV: { city: 'McArthur River Mine', name: 'McArthur River Mine' },
  MCW: { city: 'Mason City', name: 'Mason City Municipal' },
  MCX: { city: 'Makhachkala', name: 'Uytash' },
  MCY: { city: 'Maroochydore', name: 'Sunshine Coast' },
  MCZ: { city: 'Maceio', name: 'Zumbi dos Palmares' },
  MDC: { city: 'Manado', name: 'Sam Ratulangi' },
  MDE: { city: 'Rio Negro', name: 'Jose Maria Córdova International' },
  MDG: { city: 'Mudanjiang', name: 'Mudanjiang Hailang International' },
  MDH: { city: 'Carbondale/Murphysboro', name: 'Southern Illinois' },
  MDI: { city: 'Makurdi', name: 'Makurdi' },
  MDK: { city: 'Mbandaka', name: 'Mbandaka' },
  MDL: { city: 'Mandalay', name: 'Mandalay International' },
  MDQ: { city: 'Mar Del Plata', name: 'Ástor Piazzola International' },
  MDS: { city: 'Middle Caicos', name: 'Middle Caicos' },
  MDT: { city: 'Harrisburg', name: 'Harrisburg International' },
  MDU: { city: 'Mendi', name: 'Mendi' },
  MDW: { city: 'Chicago', name: 'Chicago Midway International' },
  MDY: { city: 'Midway', name: 'Henderson Field' },
  MDZ: { city: 'Mendoza', name: 'El Plumerillo' },
  MEA: { city: 'Macaé', name: 'Macaé' },
  MEB: { city: 'Melbourne', name: 'Melbourne Essendon' },
  MEC: { city: 'Manta', name: 'Eloy Alfaro International' },
  MED: { city: 'Madinah', name: 'Prince Mohammad Bin Abdulaziz' },
  MEE: { city: 'Mare', name: 'Maré' },
  MEG: { city: 'Malanje', name: 'Malanje' },
  MEH: { city: 'Mehamn', name: 'Mehamn' },
  MEI: { city: 'Meridian', name: 'Key Field' },
  MEK: { city: 'Meknes', name: 'Bassatine' },
  MEL: { city: 'Melbourne', name: 'Melbourne International' },
  MEM: { city: 'Memphis', name: 'Memphis International' },
  MEN: { city: 'Mende', name: 'Mende-Brenoux' },
  MEO: { city: 'Manteo', name: 'Dare County Regional' },
  MEQ: { city: 'Nagan Raya', name: 'Seunagan' },
  MER: { city: 'Merced', name: 'Castle' },
  MES: { city: 'Medan', name: 'Soewondo Air Force Base' },
  MEU: { city: 'Almeirim', name: 'Monte Dourado' },
  MEX: { city: 'Mexico City', name: 'Licenciado Benito Juarez International' },
  MEY: { city: 'Meghauli', name: 'Meghauli' },
  MFA: { city: 'Mafia Island', name: 'Mafia Island' },
  MFD: { city: 'Mansfield', name: 'Mansfield Lahm Regional' },
  MFE: { city: 'Mcallen', name: 'Mc Allen Miller International' },
  MFG: { city: 'Muzaffarabad', name: 'Muzaffarabad' },
  MFI: { city: 'Marshfield', name: 'Marshfield Municipal' },
  MFJ: { city: 'Moala', name: 'Moala' },
  MFK: { city: 'Matsu Islands', name: 'Matsu Beigan' },
  MFM: { city: 'Macau', name: 'Macau International' },
  MFN: { city: 'Milford Sound', name: 'Milford Sound' },
  MFQ: { city: 'Maradi', name: 'Maradi' },
  MFR: { city: 'Medford', name: 'Rogue Valley International Medford' },
  MFU: { city: 'Mfuwe', name: 'Mfuwe' },
  MFX: { city: 'Ajaccio', name: 'Méribel Altiport' },
  MGA: { city: 'Managua', name: 'Augusto C. Sandino (Managua) International' },
  MGB: { city: 'Mount Gambier', name: 'Mount Gambier' },
  MGC: { city: 'Michigan City', name: 'Michigan City Municipal' },
  MGE: { city: 'Marietta', name: 'Dobbins Air Reserve Base' },
  MGF: { city: 'Maringa', name: 'Regional de Maringá - Sílvio Nane Junior' },
  MGH: { city: 'Margate', name: 'Margate' },
  MGJ: { city: 'Montgomery', name: 'Orange County' },
  MGL: { city: 'Moenchengladbach', name: 'Mönchengladbach' },
  MGM: { city: 'MONTGOMERY', name: 'Montgomery Regional (Dannelly Field)' },
  MGN: { city: 'Magangue', name: 'Baracoa' },
  MGQ: { city: 'Mogadishu', name: 'Aden Adde International' },
  MGS: { city: 'Mangaia Island', name: 'Mangaia Island' },
  MGT: { city: 'Milingimbi', name: 'Milingimbi' },
  MGW: { city: 'Morgantown', name: 'Morgantown Municipal Walter L. Bill Hart Field' },
  MGY: { city: 'Dayton', name: 'Dayton-Wright Brothers' },
  MGZ: { city: 'Myeik', name: 'Myeik' },
  MHA: { city: 'Mahdia', name: 'Mahdia' },
  MHC: { city: 'Castro', name: 'Mocopulli' },
  MHD: { city: 'Mashhad', name: 'Mashhad International' },
  MHE: { city: 'Mitchell', name: 'Mitchell Municipal' },
  MHG: { city: 'Mannheim', name: 'Mannheim-City' },
  MHH: { city: 'Marsh Harbor', name: 'Leonard M Thompson International' },
  MHK: { city: 'Manhattan', name: 'Manhattan Regional' },
  MHP: { city: 'Minsk', name: 'Minsk 1' },
  MHQ: { city: 'Mariehamn', name: 'Mariehamn' },
  MHR: { city: 'Sacramento', name: 'Sacramento Mather' },
  MHT: { city: 'Manchester NH', name: 'Manchester-Boston Regional' },
  MHU: { city: 'Mount Hotham', name: 'Mount Hotham' },
  MHV: { city: 'Mojave', name: 'Mojave' },
  MHX: { city: 'Manihiki Island', name: 'Manihiki Island' },
  MHZ: { city: 'Mildenhall', name: 'RAF Mildenhall' },
  MIA: { city: 'Miami', name: 'Miami International' },
  MIB: { city: 'Minot', name: 'Minot Air Force Base' },
  MID: { city: 'Merida', name: 'Licenciado Manuel Crescencio Rejon Int' },
  MIE: { city: 'Muncie', name: 'Delaware County Johnson Field' },
  MIG: { city: 'Mianyang', name: 'Mianyang' },
  MII: { city: 'Marília', name: 'Frank Miloye Milenkowichi–Marília State' },
  MIJ: { city: 'Mili Island', name: 'Mili Island' },
  MIK: { city: 'Mikkeli', name: 'Mikkeli' },
  MIM: { city: 'Merimbula', name: 'Merimbula' },
  MIP: { city: 'Ramon', name: 'Ramon Air Base' },
  MIR: { city: 'Monastir', name: 'Monastir Habib Bourguiba International' },
  MIS: { city: 'Misima Island', name: 'Misima Island' },
  MIU: { city: 'Maiduguri', name: 'Maiduguri International' },
  MIV: { city: 'Millville', name: 'Millville Municipal' },
  MJA: { city: 'Manja', name: 'Manja' },
  MJC: { city: 'Man', name: 'Man' },
  MJD: { city: 'Moenjodaro', name: 'Moenjodaro' },
  MJF: { city: 'Mosjoen', name: 'Mosjøen Airport (Kjærstad)' },
  MJI: { city: 'Tripoli', name: 'Mitiga' },
  MJK: { city: 'Shark Bay', name: 'Shark Bay' },
  MJL: { city: 'Mouila', name: 'Mouilla Ville' },
  MJM: { city: 'Mbuji-mayi', name: 'Mbuji Mayi' },
  MJN: { city: 'Mahajanga', name: 'Amborovy' },
  MJT: { city: 'Mytilini', name: 'Mytilene International' },
  MJV: { city: 'Murcia', name: 'San Javier' },
  MJZ: { city: 'Mirnyj', name: 'Mirny' },
  MKC: { city: 'Kansas City', name: 'Charles B. Wheeler Downtown' },
  MKE: { city: 'Milwaukee', name: 'General Mitchell International' },
  MKG: { city: 'Muskegon', name: 'Muskegon County' },
  MKK: { city: 'Molokai', name: 'Molokai' },
  MKL: { city: 'Jackson', name: 'McKellar-Sipes Regional' },
  MKM: { city: 'Mukah', name: 'Mukah' },
  MKP: { city: 'Makemo', name: 'Makemo' },
  MKQ: { city: 'Merauke', name: 'Mopah' },
  MKR: { city: 'Meekatharra', name: 'Meekatharra' },
  MKS: { city: 'Mekane Selam', name: 'Mekane Selam' },
  MKU: { city: 'Makokou', name: 'Makokou' },
  MKW: { city: 'Manokwari', name: 'Rendani' },
  MKY: { city: 'Mackay', name: 'Mackay' },
  MKZ: { city: 'Malacca', name: 'Malacca' },
  MLA: { city: 'Malta', name: 'Malta International' },
  MLB: { city: 'Melbourne', name: 'Melbourne International' },
  MLC: { city: 'Mcalester', name: 'Mc Alester Regional' },
  MLE: { city: 'Male', name: 'Malé International' },
  MLG: { city: 'Malang', name: 'Abdul Rachman Saleh' },
  MLI: { city: 'Moline', name: 'Quad City International' },
  MLL: { city: 'Marshall', name: 'Marshall Don Hunter Sr' },
  MLM: { city: 'Morelia', name: 'General Francisco J. Mujica International' },
  MLN: { city: 'Melilla', name: 'Melilla' },
  MLO: { city: 'Milos', name: 'Milos' },
  MLS: { city: 'Miles City', name: 'Frank Wiley Field' },
  MLU: { city: 'Monroe', name: 'Monroe Regional' },
  MLW: { city: 'Monrovia', name: 'Spriggs Payne' },
  MLX: { city: 'Malatya', name: 'Malatya Erhaç' },
  MLY: { city: 'Manley Hot Springs', name: 'Manley Hot Springs' },
  MLZ: { city: 'Melo', name: 'Cerro Largo International' },
  MMB: { city: 'Memanbetsu', name: 'Memanbetsu' },
  MMD: { city: 'Minami Daito', name: 'Minami-Daito' },
  MME: { city: 'Teesside', name: 'Durham Tees Valley' },
  MMG: { city: 'Mount Magnet', name: 'Mount Magnet' },
  MMH: { city: 'Mammoth Lakes', name: 'Mammoth Yosemite' },
  MMI: { city: 'Athens', name: 'McMinn County' },
  MMJ: { city: 'Matsumoto', name: 'Matsumoto' },
  MMK: { city: 'Murmansk', name: 'Murmansk' },
  MMO: { city: 'Maio', name: 'Maio' },
  MMT: { city: 'Eastover', name: 'Mc Entire Joint National Guard Base' },
  MMU: { city: 'Morristown', name: 'Morristown Municipal' },
  MMX: { city: 'Malmoe', name: 'Malmö Sturup' },
  MMY: { city: 'Miyako', name: 'Miyako' },
  MMZ: { city: 'Maimama', name: 'Maimana' },
  MNA: { city: 'Melonguane', name: 'Melangguane' },
  MNB: { city: 'Muanda', name: 'Muanda' },
  MNC: { city: 'Nacala', name: 'Nacala' },
  MNF: { city: 'Mana Island', name: 'Mana Island' },
  MNG: { city: 'Maningrida', name: 'Maningrida' },
  MNH: { city: 'Al Masnaah', name: 'Rustaq' },
  MNI: { city: 'Geralds', name: 'John A. Osborne' },
  MNJ: { city: 'Mananjary', name: 'Mananjary' },
  MNK: { city: 'Maiana', name: 'Maiana' },
  MNL: { city: 'Manila', name: 'Ninoy Aquino International' },
  MNM: { city: 'Macon', name: 'Menominee Regional' },
  MNR: { city: 'Mongu', name: 'Mongu' },
  MNS: { city: 'Mansa', name: 'Mansa' },
  MNU: { city: 'Mawlamyine', name: 'Mawlamyine' },
  MNX: { city: 'Manicore', name: 'Manicoré' },
  MNY: { city: 'Stirling Island', name: 'Mono' },
  MNZ: { city: 'Manassas', name: 'Manassas Regional Airport/Harry P. Davis Field' },
  MOA: { city: 'Moa', name: 'Orestes Acosta' },
  MOB: { city: 'Mobile', name: 'Mobile Regional' },
  MOC: { city: 'Montes Claros', name: 'Mário Ribeiro' },
  MOD: { city: 'Modesto', name: 'Modesto City Co-Harry Sham Field' },
  MOE: { city: 'Momeik', name: 'Momeik' },
  MOF: { city: 'Maumere', name: 'Maumere(Wai Oti)' },
  MOG: { city: 'Mong Hsat', name: 'Mong Hsat' },
  MOI: { city: 'Mitiaro Island', name: 'Mitiaro Island' },
  MOJ: { city: 'Moengo', name: 'Moengo Airstrip' },
  MOL: { city: 'Molde', name: 'Molde' },
  MON: { city: 'Mount Cook', name: 'Mount Cook' },
  MOO: { city: 'Moomba', name: 'Moomba' },
  MOQ: { city: 'Morondava', name: 'Morondava' },
  MOT: { city: 'Minot', name: 'Minot International' },
  MOU: { city: 'Mountain Village', name: 'Mountain Village' },
  MOV: { city: 'Moranbah', name: 'Moranbah' },
  MOZ: { city: 'Moorea', name: 'Moorea' },
  MPA: { city: 'Mpacha', name: 'Katima Mulilo' },
  MPH: { city: 'Caticlan', name: 'Godofredo P. Ramos' },
  MPK: { city: 'Mokpo', name: 'Mokpo Heliport' },
  MPL: { city: 'Montpellier', name: 'Montpellier-Méditerranée' },
  MPM: { city: 'Maputo', name: 'Maputo' },
  MPN: { city: 'Mount Pleasant', name: 'Mount Pleasant' },
  MPO: { city: 'Mount Pocono', name: 'Pocono Mountains Municipal' },
  MPV: { city: 'Montpelier', name: 'Edward F Knapp State' },
  MPW: { city: 'Mariupol International', name: 'Mariupol International' },
  MPY: { city: 'Maripasoula', name: 'Maripasoula' },
  MQC: { city: 'Miquelon', name: 'Miquelon' },
  MQF: { city: 'Magnetiogorsk', name: 'Magnitogorsk International' },
  MQH: { city: 'Minacu', name: 'Minaçu' },
  MQJ: { city: 'Honuu', name: 'Moma' },
  MQL: { city: 'Mildura', name: 'Mildura' },
  MQM: { city: 'Mardin', name: 'Mardin' },
  MQN: { city: 'Mo i Rana', name: 'Mo i Rana Airport, Røssvoll' },
  MQP: { city: 'Mpumalanga', name: 'Kruger Mpumalanga International' },
  MQQ: { city: 'Moundou', name: 'Moundou' },
  MQS: { city: 'Mustique', name: 'Mustique' },
  MQT: { city: 'Gwinn', name: 'Sawyer International' },
  MQU: { city: 'Mariquita', name: 'Mariquita' },
  MQX: { city: 'Makale', name: 'Mekele' },
  MQY: { city: 'Smyrna', name: 'Smyrna' },
  MRB: { city: 'Martinsburg', name: 'Eastern WV Regional Airport/Shepherd Field' },
  MRD: { city: 'Merida', name: 'Alberto Carnevalli' },
  MRE: { city: 'Masai Mara', name: 'Mara Serena Lodge Airstrip' },
  MRF: { city: 'Marfa', name: 'Marfa Municipal' },
  MRI: { city: 'Anchorage', name: 'Merrill Field' },
  MRK: { city: 'Marco Island Airport', name: 'Marco Island Executive' },
  MRN: { city: 'Morganton', name: 'Foothills Regional' },
  MRO: { city: 'Masterton', name: 'Hood' },
  MRQ: { city: 'Gasan', name: 'Marinduque' },
  MRR: { city: 'Macara', name: 'Jose Maria Velasco Ibarra' },
  MRS: { city: 'Marseille', name: 'Marseille Provence' },
  MRU: { city: 'Plaisance', name: 'Sir Seewoosagur Ramgoolam International' },
  MRV: { city: 'Mineralnye Vody', name: 'Mineralnyye Vody' },
  MRW: { city: 'Maribo', name: 'Lolland Falster Maribo' },
  MRX: { city: 'Bandar Mahshahr', name: 'Mahshahr' },
  MRY: { city: 'Monterey', name: 'Monterey Peninsula' },
  MRZ: { city: 'Moree', name: 'Moree' },
  MSA: { city: 'Muskrat Dam', name: 'Muskrat Dam' },
  MSC: { city: 'Mesa', name: 'Falcon Field' },
  MSE: { city: 'Manston', name: 'Kent International' },
  MSH: { city: 'Masirah', name: 'Masirah Air Base' },
  MSJ: { city: 'Misawa', name: 'Misawa Air Base' },
  MSL: { city: 'Muscle Shoals', name: 'Northwest Alabama Regional' },
  MSN: { city: 'Madison', name: 'Dane County Regional Truax Field' },
  MSO: { city: 'Missoula', name: 'Missoula International' },
  MSP: { city: 'Minneapolis', name: 'Minneapolis-St Paul International/Wold-Chamberlain' },
  MSQ: { city: 'Minsk 2', name: 'Minsk National' },
  MSR: { city: 'Mus', name: 'Muş' },
  MSS: { city: 'Massena', name: 'Massena International Richards Field' },
  MST: { city: 'Maastricht', name: 'Maastricht Aachen' },
  MSU: { city: 'Maseru', name: 'Moshoeshoe I International' },
  MSW: { city: 'Massawa', name: 'Massawa International' },
  MSY: { city: 'New Orleans', name: 'Louis Armstrong New Orleans International' },
  MSZ: { city: 'Mocamedes', name: 'Namibe' },
  MTC: { city: 'Mount Clemens', name: 'Selfridge Air National Guard Base' },
  MTF: { city: 'Mizan Teferi', name: 'Mizan Teferi' },
  MTG: { city: 'Vila Bela da Santissima Trindade', name: 'Vila Bela da Santíssima Trindade' },
  MTH: { city: 'Marathon', name: 'The Florida Keys Marathon' },
  MTJ: { city: 'Montrose CO', name: 'Montrose Regional' },
  MTK: { city: 'Makin', name: 'Makin Island' },
  MTL: { city: 'Maitland', name: 'Maitland' },
  MTM: { city: 'Metakatla', name: 'Metlakatla Seaplane Base' },
  MTN: { city: 'Baltimore', name: 'Martin State' },
  MTP: { city: 'Montauk', name: 'Montauk' },
  MTR: { city: 'Monteria', name: 'Los Garzones' },
  MTS: { city: 'Manzini', name: 'Matsapha' },
  MTT: { city: 'Minatitlan', name: 'Minatitlán/Coatzacoalcos National' },
  MTV: { city: 'Ablow', name: 'Mota Lava' },
  MTY: { city: 'Monterrey', name: 'General Mariano Escobedo International' },
  MTZ: { city: 'Metzada', name: 'Bar Yehuda' },
  MUA: { city: 'Munda', name: 'Munda' },
  MUB: { city: 'Maun', name: 'Maun' },
  MUC: { city: 'Munich', name: 'Munich' },
  MUD: { city: 'Mueda', name: 'Mueda' },
  MUE: { city: 'Kamuela', name: 'Waimea Kohala' },
  MUH: { city: 'Mersa-matruh', name: 'Mersa Matruh' },
  MUI: { city: 'Muir', name: 'Muir Army Air Field (Fort Indiantown Gap)' },
  MUK: { city: 'Mauke Island', name: 'Mauke' },
  MUN: { city: 'Maturin', name: 'Maturín' },
  MUO: { city: 'Mountain Home', name: 'Mountain Home Air Force Base' },
  MUR: { city: 'Marudi', name: 'Marudi' },
  MUS: { city: 'Minami Tori Shima', name: 'Minami Torishima' },
  MUW: { city: 'Ghriss', name: 'Ghriss' },
  MUX: { city: 'Multan', name: 'Multan International' },
  MUZ: { city: 'Musoma', name: 'Musoma' },
  MVA: { city: 'Myvatn', name: 'Reykjahlíð' },
  MVB: { city: 'Franceville', name: 'MVengue El Hadj Omar Bongo Ondimba International' },
  MVD: { city: 'Montevideo', name: 'Carrasco International /General C L Berisso' },
  MVF: { city: 'Mocord', name: 'Dix-Sept Rosado' },
  MVL: { city: 'Morrisville', name: 'Morrisville Stowe State' },
  MVP: { city: 'Mitu', name: 'Fabio Alberto Leon Bentley' },
  MVQ: { city: 'Mogilev', name: 'Mogilev' },
  MVR: { city: 'Maroua', name: 'Salak' },
  MVS: { city: 'Mucuri', name: 'Mucuri' },
  MVT: { city: 'Mataiva', name: 'Mataiva' },
  MVV: { city: 'Verdun', name: 'Megève' },
  MVW: { city: 'Skagit', name: 'Skagit Regional' },
  MVY: { city: 'Vineyard Haven MA', name: 'Marthas Vineyard' },
  MVZ: { city: 'Masvingo', name: 'Masvingo International' },
  MWA: { city: 'Marion', name: 'Williamson County Regional' },
  MWC: { city: 'Milwaukee', name: 'Lawrence J Timmerman' },
  MWD: { city: 'Mianwali', name: 'Mianwali Air Base' },
  MWE: { city: 'Merowe', name: 'Merowe New' },
  MWF: { city: 'Maewo Island', name: 'Maewo-Naone' },
  MWH: { city: 'Grant County Airport', name: 'Grant County International' },
  MWK: { city: 'Anambas Islands', name: 'Tarempa' },
  MWL: { city: 'Mineral Wells', name: 'Mineral Wells' },
  MWQ: { city: 'Magwe', name: 'Magway' },
  MWX: { city: 'Muan', name: 'Muan International' },
  MWZ: { city: 'Mwanza', name: 'Mwanza' },
  MXB: { city: 'Masamba', name: 'Andi Jemma' },
  MXF: { city: 'Montgomery', name: 'Maxwell Air Force Base' },
  MXH: { city: 'Moro', name: 'Moro' },
  MXJ: { city: 'Minna', name: 'Minna' },
  MXL: { city: 'Mexicali', name: 'General Rodolfo Sánchez Taboada International' },
  MXM: { city: 'Morombe', name: 'Morombe' },
  MXN: { city: 'Morlaix', name: 'Morlaix-Ploujean' },
  MXP: { city: 'Milano', name: 'Malpensa International' },
  MXS: { city: 'Savaii Island', name: 'Maota' },
  MXT: { city: 'Maintirano', name: 'Maintirano' },
  MXV: { city: 'Muren', name: 'Mörön' },
  MXX: { city: 'Mora', name: 'Mora' },
  MXZ: { city: 'Meixian', name: 'Meixian' },
  MYA: { city: 'Moruya', name: 'Moruya' },
  MYB: { city: 'Mayumba', name: 'Mayumba' },
  MYC: { city: 'Maracay', name: 'Escuela Mariscal Sucre' },
  MYD: { city: 'Malindi', name: 'Malindi' },
  MYE: { city: 'Miyakejima', name: 'Miyakejima' },
  MYG: { city: 'Mayaguana', name: 'Mayaguana' },
  MYI: { city: 'Murray Island', name: 'Murray Island' },
  MYJ: { city: 'Matsuyama', name: 'Matsuyama' },
  MYL: { city: 'McCall', name: 'McCall Municipal' },
  MYP: { city: 'Mary', name: 'Mary' },
  MYQ: { city: 'Mysore', name: 'Mysore' },
  MYR: { city: 'Myrtle Beach', name: 'Myrtle Beach International' },
  MYT: { city: 'Myitkyina', name: 'Myitkyina' },
  MYU: { city: 'Mekoryuk', name: 'Mekoryuk' },
  MYV: { city: 'Yuba City', name: 'Yuba County' },
  MYW: { city: 'Mtwara', name: 'Mtwara' },
  MYY: { city: 'Miri', name: 'Miri' },
  MYZ: { city: 'Monkey Bay', name: 'Monkey Bay' },
  MZB: { city: 'Mocimboa Da Praia', name: 'Mocímboa da Praia' },
  MZG: { city: 'Makung', name: 'Makung' },
  MZH: { city: 'Merzifon', name: 'Amasya Merzifon' },
  MZI: { city: 'Mopti', name: 'Mopti' },
  MZJ: { city: 'Marana', name: 'Pinal Airpark' },
  MZK: { city: 'Marakei', name: 'Marakei' },
  MZL: { city: 'Manizales', name: 'La Nubia' },
  MZM: { city: 'Metz', name: 'Metz-Frescaty (BA 128) Air Base' },
  MZO: { city: 'Manzanillo', name: 'Sierra Maestra' },
  MZP: { city: 'Motueka', name: 'Motueka' },
  MZQ: { city: 'Mkuze', name: 'Mkuze' },
  MZR: { city: 'Mazar-i-sharif', name: 'Mazar I Sharif' },
  MZT: { city: 'Mazatlan', name: 'General Rafael Buelna International' },
  MZU: { city: 'Mazuffarpur', name: 'Muzaffarpur' },
  MZV: { city: 'Mulu', name: 'Mulu' },
  MZW: { city: 'Mecheria', name: 'Mecheria' },
  NAA: { city: 'Narrabri', name: 'Narrabri' },
  NAC: { city: 'Naracoorte', name: 'Naracoorte' },
  NAG: { city: 'Nagpur', name: 'Dr. Babasaheb Ambedkar International' },
  NAH: { city: 'Naha', name: 'Naha' },
  NAI: { city: 'Annai', name: 'Annai' },
  NAJ: { city: 'Nakhchivan', name: 'Nakhchivan' },
  NAK: { city: 'Nakhon Ratchasima', name: 'Nakhon Ratchasima' },
  NAL: { city: 'Nalchik', name: 'Nalchik' },
  NAM: { city: 'Namlea', name: 'Namlea' },
  NAN: { city: 'Nandi', name: 'Nadi International' },
  NAO: { city: 'Nanchong', name: 'Nanchong' },
  NAP: { city: 'Naples', name: 'Naples International' },
  NAQ: { city: 'Qaanaaq', name: 'Qaanaaq' },
  NAS: { city: 'Nassau', name: 'Lynden Pindling International' },
  NAT: { city: 'Natal', name: 'Governador Aluízio Alves International' },
  NAU: { city: 'Napuka', name: 'Napuka Island' },
  NAV: { city: 'Nevsehir', name: 'Nevşehir Kapadokya' },
  NAW: { city: 'Narathiwat', name: 'Narathiwat' },
  NAY: { city: 'Beijing', name: 'Beijing Nanyuan' },
  NBC: { city: 'Nizhnekamsk', name: 'Begishevo' },
  NBE: { city: 'Enfidha', name: 'Enfidha - Hammamet International' },
  NBG: { city: 'New Orleans', name: 'New Orleans NAS JRB/Alvin Callender Field' },
  NBN: { city: 'San Antonio de Pale', name: 'Annobón' },
  NBO: { city: 'Nairobi', name: 'Jomo Kenyatta International' },
  NBS: { city: 'Baishan', name: 'Changbaishan' },
  NBW: { city: 'Guantanamo', name: 'Leeward Point Field' },
  NBX: { city: 'Nabire', name: 'Nabire' },
  NCA: { city: 'North Caicos', name: 'North Caicos' },
  NCE: { city: 'Nice', name: 'Nice-Côte dAzur' },
  NCG: { city: 'Nuevo Casas Grandes', name: 'Nuevo Casas Grandes' },
  NCJ: { city: 'Sunchales', name: 'Sunchales Aeroclub' },
  NCL: { city: 'Newcastle', name: 'Newcastle' },
  NCN: { city: 'Chenega', name: 'Chenega Bay' },
  NCO: { city: 'North Kingstown', name: 'Quonset State' },
  NCR: { city: 'San Carlos', name: 'San Carlos' },
  NCS: { city: 'Newcastle', name: 'Newcastle' },
  NCU: { city: 'Nukus', name: 'Nukus' },
  NCY: { city: 'Annecy', name: 'Annecy-Haute-Savoie-Mont Blanc' },
  NDB: { city: 'Nouadhibou', name: 'Nouadhibou International' },
  NDC: { city: 'Nanded', name: 'Nanded' },
  NDD: { city: 'Sumbe', name: 'Sumbe' },
  NDG: { city: 'Qiqihar', name: 'Qiqihar Sanjiazi' },
  NDJ: { city: 'Ndjamena', name: 'NDjamena International' },
  NDN: { city: 'Nadunumu', name: 'Nadunumu' },
  NDR: { city: 'El Aroui', name: 'Nador International' },
  NDU: { city: 'Rundu', name: 'Rundu' },
  NDY: { city: 'Sanday', name: 'Sanday' },
  NEC: { city: 'Necochea', name: 'Necochea' },
  NEG: { city: 'Negril', name: 'Negril' },
  NEL: { city: 'Lakehurst', name: 'Lakehurst Maxfield Field' },
  NER: { city: 'Neryungri', name: 'Chulman' },
  NEU: { city: 'Sam Neua', name: 'Sam Neua' },
  NEV: { city: 'Charlestown', name: 'Vance W. Amory International' },
  NEW: { city: 'New Orleans', name: 'Lakefront' },
  NFG: { city: 'Nefteyugansk', name: 'Nefteyugansk' },
  NFL: { city: 'Fallon', name: 'Fallon Naval Air Station' },
  NFO: { city: 'Angaha, Niuafoou Island', name: 'Mataaho' },
  NGB: { city: 'Ninbo', name: 'Ningbo Lishe International' },
  NGD: { city: 'Anegada', name: 'Captain Auguste George' },
  NGE: { city: 'Ngaoundere', name: 'NGaoundéré' },
  NGF: { city: 'Kaneohe Bay', name: 'Kaneohe Bay MCAS (Marion E. Carl Field)' },
  NGI: { city: 'Ngau', name: 'Ngau' },
  NGK: { city: 'Nogliki', name: 'Nogliki' },
  NGO: { city: 'Nagoya', name: 'Chubu Centrair International' },
  NGQ: { city: 'Shiquanhe', name: 'Ngari Gunsa' },
  NGS: { city: 'Nagasaki', name: 'Nagasaki' },
  NGU: { city: 'Norfolk', name: 'Norfolk Naval Station (Chambers Field)' },
  NGX: { city: 'Manang', name: 'Manang' },
  NGZ: { city: 'Alameda', name: 'Alameda Naval Air Station' },
  NHA: { city: 'Nhatrang', name: 'Nha Trang Air Base' },
  NHD: { city: 'Minhad AB', name: 'Al Minhad Air Base' },
  NHK: { city: 'Patuxent River', name: 'Patuxent River Naval Air Station (Trapnell Field)' },
  NHT: { city: 'Northolt', name: 'RAF Northolt' },
  NHV: { city: 'Nuku Hiva', name: 'Nuku Hiva' },
  NHZ: { city: 'Brunswick', name: 'Brunswick Executive' },
  NIB: { city: 'Nikolai', name: 'Nikolai' },
  NIG: { city: 'Nikunau', name: 'Nikunau' },
  NIM: { city: 'Niamey', name: 'Diori Hamani International' },
  NIO: { city: 'Nioki', name: 'Nioki' },
  NIP: { city: 'Jacksonville', name: 'Jacksonville Naval Air Station (Towers Field)' },
  NIS: { city: 'Simberi Island', name: 'Simberi' },
  NIT: { city: 'Niort', name: 'Niort-Souché' },
  NIU: { city: 'Niau', name: 'Naiu' },
  NJA: { city: 'Atsugi', name: 'Atsugi Naval Air Facility' },
  NJC: { city: 'Nizhnevartovsk', name: 'Nizhnevartovsk' },
  NJF: { city: 'Najaf', name: 'Al Najaf International' },
  NJK: { city: 'El Centro', name: 'El Centro NAF Airport (Vraciu Field)' },
  NKB: { city: 'Noonkanbah', name: 'Noonkanbah' },
  NKC: { city: 'Nouakschott', name: 'Nouakchott–Oumtounsy International' },
  NKG: { city: 'Nanjing', name: 'Nanjing Lukou' },
  NKM: { city: 'Nagoya', name: 'Nagoya' },
  NKT: { city: 'Cizre', name: 'Şırnak Şerafettin Elçi' },
  NKW: { city: 'Diego Garcia Island', name: 'Diego Garcia Naval Support Facility' },
  NKX: { city: 'Miramar', name: 'Miramar Marine Corps Air Station - Mitscher Field' },
  NLA: { city: 'Ndola', name: 'Simon Mwansa Kapwepwe International' },
  NLC: { city: 'Lemoore', name: 'Lemoore Naval Air Station (Reeves Field)' },
  NLD: { city: 'Nuevo Laredo', name: 'Quetzalcóatl International' },
  NLF: { city: 'Darnley Island', name: 'Darnley Island' },
  NLG: { city: 'Nelson Lagoon', name: 'Nelson Lagoon' },
  NLH: { city: 'Ninglang', name: 'Ninglang Luguhu' },
  NLI: { city: 'Nikolayevsk-na-Amure Airport', name: 'Nikolayevsk-na-Amure' },
  NLK: { city: 'Norfolk Island', name: 'Norfolk Island International' },
  NLO: { city: 'Kinshasa', name: 'Ndolo' },
  NLP: { city: 'Nelspruit', name: 'Nelspruit' },
  NLT: { city: 'Xinyuan', name: 'Xinyuan Nalati' },
  NLV: { city: 'Nikolayev', name: 'Mykolaiv International' },
  NMA: { city: 'Namangan', name: 'Namangan' },
  NMB: { city: 'Daman', name: 'Daman' },
  NMC: { city: 'Normans Cay', name: 'Normans Cay' },
  NME: { city: 'Nightmute', name: 'Nightmute' },
  NMS: { city: 'Namsang', name: 'Namsang' },
  NMT: { city: 'Naypyidaw', name: 'Namtu' },
  NNA: { city: 'Kentira', name: 'Kenitra' },
  NNB: { city: 'Santa Ana', name: 'Santa Ana' },
  NNG: { city: 'Nanning', name: 'Nanning Wuxu' },
  NNL: { city: 'Nondalton', name: 'Nondalton' },
  NNM: { city: 'Naryan-Mar', name: 'Naryan Mar' },
  NNR: { city: 'Indreabhan', name: 'Connemara Regional' },
  NNT: { city: 'Nan', name: 'Nan' },
  NNX: { city: 'Nunukan-Nunukan Island', name: 'Nunukan' },
  NNY: { city: 'Nanyang', name: 'Nanyang Jiangying' },
  NOA: { city: 'Nowra', name: 'Nowra' },
  NOB: { city: 'Nosara Beach', name: 'Nosara' },
  NOC: { city: 'Connaught', name: 'Ireland West Knock' },
  NOD: { city: 'Norden', name: 'Norden-Norddeich' },
  NOG: { city: 'Nogales', name: 'Nogales International' },
  NOJ: { city: 'Noyabrsk', name: 'Noyabrsk' },
  NON: { city: 'Nonouti', name: 'Nonouti' },
  NOP: { city: 'Sinop', name: 'Sinop' },
  NOR: { city: 'Nordfjordur', name: 'Norðfjörður' },
  NOS: { city: 'Nosy-be', name: 'Fascene' },
  NOT: { city: 'Novato', name: 'Marin County Airport - Gnoss Field' },
  NOU: { city: 'Noumea', name: 'La Tontouta International' },
  NOV: { city: 'Huambo', name: 'Nova Lisboa' },
  NOZ: { city: 'Novokuznetsk', name: 'Spichenkovo' },
  NPA: { city: 'Pensacola', name: 'Pensacola Naval Air Station/Forrest Sherman Field' },
  NPE: { city: 'NAPIER', name: 'Hawkes Bay' },
  NPL: { city: 'New Plymouth', name: 'New Plymouth' },
  NPO: { city: 'Nangapinoh', name: 'Nanga Pinoh' },
  NPR: { city: 'Novo Progresso', name: 'Novo Progresso' },
  NQA: { city: 'Millington', name: 'Millington-Memphis' },
  NQI: { city: 'Kingsville', name: 'Kingsville Naval Air Station' },
  NQN: { city: 'Neuquen', name: 'Presidente Peron' },
  NQT: { city: 'Nottingham', name: 'Nottingham' },
  NQU: { city: 'Nuquí', name: 'Reyes Murillo' },
  NQX: { city: 'Key West', name: 'Naval Air Station Key West/Boca Chica Field' },
  NQY: { city: 'Newquai', name: 'Newquay Cornwall' },
  NRA: { city: 'Narrandera', name: 'Narrandera' },
  NRB: { city: 'Mayport', name: 'Naval Station Mayport (Admiral David L. Mcdonald Field)' },
  NRD: { city: 'Norderney', name: 'Norderney' },
  NRE: { city: 'Buru Island', name: 'Namrole' },
  NRK: { city: 'Norrkoeping', name: 'Norrköping' },
  NRL: { city: 'North Ronaldsay', name: 'North Ronaldsay' },
  NRN: { city: 'Weeze', name: 'Weeze' },
  NRR: { city: 'Ceiba', name: 'José Aponte de la Torre' },
  NRT: { city: 'Tokyo', name: 'Narita International' },
  NSE: { city: 'Milton', name: 'Whiting Field Naval Air Station - North' },
  NSH: { city: 'Noshahr', name: 'Noshahr' },
  NSI: { city: 'Yaounde', name: 'Yaoundé Nsimalen International' },
  NSK: { city: 'Norilsk', name: 'Norilsk-Alykel' },
  NSN: { city: 'Nelson', name: 'Nelson' },
  NSO: { city: 'Scone', name: 'Scone' },
  NST: { city: 'Nakhon Si Thammarat', name: 'Nakhon Si Thammarat' },
  NSY: { city: 'Sigonella', name: 'Sigonella Navy Air Base' },
  NTB: { city: 'Notodden', name: 'Notodden' },
  NTD: { city: 'Point Mugu', name: 'Point Mugu Naval Air Station (Naval Base Ventura Co)' },
  NTE: { city: 'Nantes', name: 'Nantes Atlantique' },
  NTI: { city: 'Bintuni', name: 'Stenkol' },
  NTL: { city: 'Newcastle', name: 'Newcastle' },
  NTN: { city: 'Normanton', name: 'Normanton' },
  NTQ: { city: 'Wajima', name: 'Noto' },
  NTR: { city: 'Monterrey', name: 'Del Norte International' },
  NTT: { city: 'Niuatoputapu', name: 'Kuini Lavenia' },
  NTU: { city: 'Oceana', name: 'Oceana Naval Air Station' },
  NTX: { city: 'Ranai-Natuna Besar Island', name: 'Ranai' },
  NTY: { city: 'Pilanesberg', name: 'Pilanesberg International' },
  NUE: { city: 'Nuernberg', name: 'Nuremberg' },
  NUI: { city: 'Nuiqsut', name: 'Nuiqsut' },
  NUK: { city: 'Nukutavake', name: 'Nukutavake' },
  NUL: { city: 'Nulato', name: 'Nulato' },
  NUQ: { city: 'Mountain View', name: 'Moffett Federal' },
  NUS: { city: 'Norsup', name: 'Norsup' },
  NUW: { city: 'Whidbey Island', name: 'Whidbey Island Naval Air Station (Ault Field)' },
  NUX: { city: 'Novy Urengoy', name: 'Novy Urengoy' },
  NVA: { city: 'Neiva', name: 'Benito Salas' },
  NVI: { city: 'Navoi', name: 'Navoi' },
  NVK: { city: 'Narvik', name: 'Narvik Framnes' },
  NVP: { city: 'Novo Aripuana', name: 'Novo Aripuanã' },
  NVS: { city: 'Nevers', name: 'Nevers-Fourchambault' },
  NVT: { city: 'Navegantes', name: 'Ministro Victor Konder International' },
  NWA: { city: 'Moheli', name: 'Mohéli Bandar Es Eslam' },
  NWI: { city: 'Norwich', name: 'Norwich International' },
  NXX: { city: 'Willow Grove', name: 'Willow Grove Naval Air Station/Joint Reserve Base' },
  NYA: { city: 'Nyagan', name: 'Nyagan' },
  NYE: { city: 'NYERI', name: 'Nyeri' },
  NYI: { city: 'Sunyani', name: 'Sunyani' },
  NYK: { city: 'Nanyuki', name: 'Nanyuki' },
  NYM: { city: 'Nadym', name: 'Nadym' },
  NYO: { city: 'Stockholm', name: 'Stockholm Skavsta' },
  NYR: { city: 'Nyurba', name: 'Nyurba' },
  NYT: { city: 'Naypyidaw', name: 'Naypyidaw' },
  NYU: { city: 'Bagan', name: 'Bagan' },
  NYW: { city: 'Monywa', name: 'Monywar' },
  NZA: { city: 'Nzagi', name: 'Nzagi' },
  NZC: { city: 'Nazca', name: 'Maria Reiche Neuman' },
  NZE: { city: 'Nzerekore', name: 'Nzérékoré' },
  NZH: { city: 'Manzhouli', name: 'Manzhouli Xijiao' },
  NZJ: { city: 'Santa Ana', name: 'El Toro Marine Corps Air Station' },
  NZL: { city: 'Zhalantun', name: 'Chengjisihan' },
  NZY: { city: 'San Diego', name: 'North Island Naval Air Station-Halsey Field' },
  OAA: { city: 'Shank', name: 'Shank Air Base' },
  OAG: { city: 'Orange', name: 'Orange' },
  OAH: { city: 'Shindand', name: 'Shindand' },
  OAI: { city: 'Kabul', name: 'Bagram Air Base' },
  OAJ: { city: 'Jacksonville NC', name: 'Albert J Ellis' },
  OAK: { city: 'Oakland', name: 'Metropolitan Oakland International' },
  OAL: { city: 'Cacoal', name: 'Cacoal' },
  OAM: { city: 'Oamaru', name: 'Oamaru' },
  OAR: { city: 'Fort Ord', name: 'Marina Municipal' },
  OAS: { city: 'Sharona', name: 'Sharana Airstrip' },
  OAX: { city: 'Oaxaca', name: 'Xoxocotlán International' },
  OAZ: { city: 'Camp Bastion', name: 'Camp Bastion' },
  OBC: { city: 'Obock', name: 'Obock' },
  OBE: { city: 'Okeechobee', name: 'Okeechobee County' },
  OBF: { city: 'Oberpfaffenhofen', name: 'Oberpfaffenhofen' },
  OBL: { city: 'Zoersel', name: 'Zoersel (Oostmalle)' },
  OBN: { city: 'North Connel', name: 'Oban' },
  OBO: { city: 'Obihiro', name: 'Tokachi-Obihiro' },
  OBS: { city: 'Aubenas-vals-lanas', name: 'Aubenas-Ardèche Méridional' },
  OBU: { city: 'Kobuk', name: 'Kobuk' },
  OBY: { city: 'Ittoqqortoormiit', name: 'Ittoqqortoormiit Heliport' },
  OCA: { city: 'Ocean Reef Club Airport', name: 'Ocean Reef Club' },
  OCC: { city: 'Coca', name: 'Francisco De Orellana' },
  OCF: { city: 'Ocala', name: 'Ocala International Airport - Jim Taylor Field' },
  OCJ: { city: 'Ocho Rios', name: 'Boscobel Aerodrome' },
  OCM: { city: 'Brockman', name: 'Boolgeeda' },
  OCN: { city: 'Fraser Island', name: 'Oceanside Municipal' },
  OCV: { city: 'Ocana', name: 'Aguas Claras' },
  OCW: { city: 'Washington', name: 'Warren Field' },
  ODB: { city: 'Cordoba', name: 'Córdoba' },
  ODE: { city: 'Odense', name: 'Odense' },
  ODH: { city: 'Odiham', name: 'RAF Odiham' },
  ODN: { city: 'Long Seridan', name: 'Long Seridan' },
  ODO: { city: 'Bodaibo', name: 'Bodaybo' },
  ODS: { city: 'Odessa', name: 'Odessa International' },
  ODY: { city: 'Muang Xay', name: 'Oudomsay' },
  OEL: { city: 'Oakley', name: 'Oryol Yuzhny' },
  OEM: { city: 'Paloemeu', name: 'Vincent Fayks' },
  OER: { city: 'Ornskoldsvik', name: 'Örnsköldsvik' },
  OES: { city: 'San Antonio Oeste', name: 'Antoine de Saint Exupéry' },
  OFF: { city: 'Omaha', name: 'Offutt Air Force Base' },
  OFK: { city: 'Norfolk Nebraska', name: 'Karl Stefan Memorial' },
  OGB: { city: 'Orangeburg', name: 'Orangeburg Municipal' },
  OGD: { city: 'Ogden', name: 'Ogden Hinckley' },
  OGG: { city: 'Kahului', name: 'Kahului' },
  OGL: { city: 'Georgetown', name: 'Eugene F. Correira International' },
  OGN: { city: 'Yonaguni Jima', name: 'Yonaguni' },
  OGS: { city: 'Ogdensburg', name: 'Ogdensburg International' },
  OGU: { city: 'Ordu-Giresun', name: 'Ordu Giresun' },
  OGX: { city: 'Ouargla', name: 'Ain el Beida' },
  OGZ: { city: 'Beslan', name: 'Beslan' },
  OHA: { city: 'Ohakea', name: 'RNZAF Base Ohakea' },
  OHD: { city: 'Ohrid', name: 'Ohrid St. Paul the Apostle' },
  OHE: { city: 'Mohe County', name: 'Gu-Lian' },
  OHO: { city: 'Okhotsk', name: 'Okhotsk' },
  OHS: { city: 'Sohar', name: 'Sohar' },
  OIA: { city: 'Ourilandia do Norte', name: 'Ourilândia do Norte' },
  OIM: { city: 'Oshima', name: 'Oshima' },
  OIR: { city: 'Okushiri', name: 'Okushiri' },
  OIT: { city: 'Oita', name: 'Oita' },
  OJC: { city: 'Olathe', name: 'Johnson County Executive' },
  OKA: { city: 'Okinawa', name: 'Naha' },
  OKC: { city: 'Oklahoma City', name: 'Will Rogers World' },
  OKD: { city: 'Sapporo', name: 'Okadama' },
  OKE: { city: 'Okierabu', name: 'Okierabu' },
  OKF: { city: 'Okaukuejo', name: 'Okaukuejo' },
  OKI: { city: 'Oki Island', name: 'Oki' },
  OKJ: { city: 'Okayama', name: 'Okayama' },
  OKK: { city: 'Kokomo', name: 'Kokomo Municipal' },
  OKL: { city: 'Oksibil', name: 'Oksibil' },
  OKM: { city: 'Okmulgee', name: 'Okmulgee Regional' },
  OKN: { city: 'Okondja', name: 'Okondja' },
  OKO: { city: 'Yokota', name: 'Yokota Air Base' },
  OKR: { city: 'Yorke Island', name: 'Yorke Island' },
  OKU: { city: 'Mokuti Lodge', name: 'Mokuti Lodge' },
  OKY: { city: 'Oakey', name: 'Oakey' },
  OLA: { city: 'Orland', name: 'Ørland' },
  OLB: { city: 'Olbia', name: 'Olbia Costa Smeralda' },
  OLC: { city: 'Sao Paulo de Olivenca', name: 'Senadora Eunice Micheles' },
  OLF: { city: 'Wolf Point', name: 'L M Clayton' },
  OLJ: { city: 'Olpoi', name: 'North West Santo' },
  OLL: { city: 'Oyo', name: 'Oyo Ollombo' },
  OLM: { city: 'Olympia', name: 'Olympia Regional' },
  OLP: { city: 'Olympic Dam', name: 'Olympic Dam' },
  OLS: { city: 'Nogales', name: 'Nogales International' },
  OLV: { city: 'Olive Branch', name: 'Olive Branch' },
  OLZ: { city: 'Olekminsk', name: 'Olyokminsk' },
  OMA: { city: 'Omaha', name: 'Eppley' },
  OMB: { city: 'Omboue Hospial', name: 'Omboue Hopital' },
  OMC: { city: 'Ormoc City', name: 'Ormoc' },
  OMD: { city: 'Oranjemund', name: 'Oranjemund' },
  OME: { city: 'Nome', name: 'Nome' },
  OMF: { city: 'Mafraq', name: 'King Hussein Air College' },
  OMH: { city: 'Uromiyeh', name: 'Urmia' },
  OMI: { city: 'Omidyeh', name: 'Omidiyeh' },
  OMO: { city: 'Mostar', name: 'Mostar International' },
  OMR: { city: 'Oradea', name: 'Oradea International' },
  OMS: { city: 'Omsk', name: 'Omsk Central' },
  OND: { city: 'Ondangwa', name: 'Ondangwa' },
  ONG: { city: 'Mornington Island', name: 'Mornington Island' },
  ONJ: { city: 'Odate Noshiro', name: 'Odate Noshiro' },
  ONK: { city: 'Olenyok', name: 'Olenyok' },
  ONO: { city: 'Ontario', name: 'Ontario Municipal' },
  ONP: { city: 'Newport', name: 'Newport Municipal' },
  ONQ: { city: 'Zonguldak', name: 'Zonguldak' },
  ONS: { city: 'Onslow', name: 'Onslow' },
  ONT: { city: 'Ontario', name: 'Ontario International' },
  ONX: { city: 'Colón', name: 'Enrique Adolfo Jimenez' },
  OOK: { city: 'Toksook Bay', name: 'Toksook Bay' },
  OOL: { city: 'Coolangatta', name: 'Gold Coast' },
  OOM: { city: 'Cooma', name: 'Cooma Snowy Mountains' },
  OPF: { city: 'Miami', name: 'Opa-locka Executive' },
  OPO: { city: 'Porto', name: 'Francisco de Sá Carneiro' },
  OPS: { city: 'Sinop', name: 'Presidente João Batista Figueiredo' },
  OPU: { city: 'Balimo', name: 'Balimo' },
  ORA: { city: 'Oran', name: 'Orán' },
  ORB: { city: 'Orebro', name: 'Örebro' },
  ORD: { city: 'Chicago', name: 'Chicago OHare International' },
  ORE: { city: 'Orleans', name: 'Orléans-Bricy (BA 123) Air Base' },
  ORF: { city: 'Norfolk', name: 'Norfolk International' },
  ORG: { city: 'Paramaribo', name: 'Zorg en Hoop' },
  ORH: { city: 'Worcester', name: 'Worcester Regional' },
  ORJ: { city: 'Orinduik', name: 'Orinduik' },
  ORK: { city: 'Cork', name: 'Cork' },
  ORL: { city: 'Orlando', name: 'Orlando Executive' },
  ORN: { city: 'Oran', name: 'Es Senia' },
  ORP: { city: 'Orapa', name: 'Orapa' },
  ORT: { city: 'Northway', name: 'Northway' },
  ORU: { city: 'Oruro', name: 'Juan Mendoza' },
  ORV: { city: 'Noorvik', name: 'Robert (Bob) Curtis Memorial' },
  ORW: { city: 'Ormara Raik', name: 'Ormara' },
  ORX: { city: 'Oriximina', name: 'Oriximiná' },
  ORY: { city: 'Paris', name: 'Paris-Orly' },
  OSC: { city: 'Oscoda', name: 'Oscoda Wurtsmith' },
  OSD: { city: 'Östersund', name: 'Åre Östersund' },
  OSF: { city: 'Moscow', name: 'Ostafyevo International' },
  OSH: { city: 'Oshkosh', name: 'Wittman Regional' },
  OSI: { city: 'Osijek', name: 'Osijek' },
  OSK: { city: 'Oskarshamn', name: 'Oskarshamn' },
  OSL: { city: 'Oslo', name: 'Oslo Lufthavn' },
  OSM: { city: 'Mosul', name: 'Mosul International' },
  OSN: { city: 'Osan', name: 'Osan Air Base' },
  OSP: { city: 'Slupsk', name: 'Redzikowo Air Base' },
  OSR: { city: 'Ostrava', name: 'Ostrava Leos Janáček' },
  OSS: { city: 'Osh', name: 'Osh' },
  OST: { city: 'Ostend', name: 'Ostend-Bruges International' },
  OSU: { city: 'Columbus', name: 'The Ohio State University Airport - Don Scott Field' },
  OSW: { city: 'Orsk', name: 'Orsk' },
  OSY: { city: 'Namsos', name: 'Namsos Høknesøra' },
  OTH: { city: 'North Bend', name: 'Southwest Oregon Regional' },
  OTI: { city: 'Morotai Island', name: 'Pitu' },
  OTJ: { city: 'Otjiwarongo', name: 'Otjiwarongo' },
  OTK: { city: 'Tillamook', name: 'Tillamook' },
  OTM: { city: 'Ottumwa', name: 'Ottumwa Regional' },
  OTP: { city: 'Bucharest', name: 'Henri Coandă International' },
  OTR: { city: 'Coto 47', name: 'Coto 47' },
  OTU: { city: 'Otu', name: 'Otu' },
  OTZ: { city: 'Kotzebue', name: 'Ralph Wien Memorial' },
  OUA: { city: 'Ouagadougou', name: 'Ouagadougou' },
  OUD: { city: 'Oujda', name: 'Angads' },
  OUE: { city: 'Ouesso', name: 'Ouesso' },
  OUH: { city: 'Oudtshoorn', name: 'Oudtshoorn' },
  OUK: { city: 'Outer Skerries', name: 'Outer Skerries' },
  OUL: { city: 'Oulu', name: 'Oulu' },
  OUZ: { city: 'Zouerat', name: 'Tazadit' },
  OVA: { city: 'Bekily', name: 'Bekily' },
  OVB: { city: 'Novosibirsk', name: 'Tolmachevo' },
  OVD: { city: 'Aviles', name: 'Asturias' },
  OVG: { city: 'Overberg', name: 'Overberg' },
  OVR: { city: 'Olavarria', name: 'Olavarria' },
  OVS: { city: 'Sovetskiy', name: 'Sovetskiy' },
  OWB: { city: 'Owensboro', name: 'Owensboro Daviess County' },
  OWD: { city: 'Norwood', name: 'Norwood Memorial' },
  OXB: { city: 'Bissau', name: 'Osvaldo Vieira International' },
  OXC: { city: 'Oxford', name: 'Waterbury Oxford' },
  OXF: { city: 'Oxford', name: 'Oxford (Kidlington)' },
  OXR: { city: 'Oxnard', name: 'Oxnard' },
  OYA: { city: 'Goya', name: 'Goya' },
  OYE: { city: 'Oyem', name: 'Oyem' },
  OYK: { city: 'Oioiapoque', name: 'Oiapoque' },
  OYL: { city: 'Moyale', name: 'Moyale' },
  OYO: { city: 'Tres Arroyos', name: 'Tres Arroyos' },
  OYP: { city: 'St.-georges Oyapock', name: 'Saint-Georges-de-lOyapock' },
  OZA: { city: 'Ozona', name: 'Ozona Municipal' },
  OZC: { city: 'Ozamis', name: 'Labo' },
  OZG: { city: 'Zagora', name: 'Zagora' },
  OZH: { city: 'Zaporozhye', name: 'Zaporizhzhia International' },
  OZP: { city: 'Sevilla', name: 'Moron Air Base' },
  OZR: { city: 'Fort Rucker/Ozark', name: 'Cairns AAF (Fort Rucker) Air Field' },
  OZZ: { city: 'Ouarzazate', name: 'Ouarzazate' },
  PAA: { city: 'Hpa-an', name: 'Hpa-N' },
  PAB: { city: 'Bilaspur', name: 'Bilaspur' },
  PAC: { city: 'Panama', name: 'Marcos A. Gelabert International' },
  PAD: { city: 'Paderborn', name: 'Paderborn Lippstadt' },
  PAE: { city: 'Everett', name: 'Snohomish County (Paine Field)' },
  PAG: { city: 'Pagadian', name: 'Pagadian' },
  PAH: { city: 'PADUCAH', name: 'Barkley Regional' },
  PAJ: { city: 'Parachinar', name: 'Parachinar' },
  PAL: { city: 'La Dorada', name: 'German Olano Air Base' },
  PAM: { city: 'Panama City', name: 'Tyndall Air Force Base' },
  PAN: { city: 'Pattani', name: 'Pattani' },
  PAO: { city: 'Palo Alto', name: 'Palo Alto Airport of Santa Clara County' },
  PAP: { city: 'Port-au-prince', name: 'Toussaint Louverture International' },
  PAQ: { city: 'Palmer', name: 'Warren Bud Woods Palmer Municipal' },
  PAS: { city: 'Paros', name: 'Paros National' },
  PAT: { city: 'Patina', name: 'Lok Nayak Jayaprakash' },
  PAV: { city: 'Paulo Alfonso', name: 'Paulo Afonso' },
  PAX: { city: 'Port-de-Paix', name: 'Port-de-Paix' },
  PAZ: { city: 'Poza Rico', name: 'El Tajín National' },
  PBC: { city: 'Puebla', name: 'Hermanos Serdán International' },
  PBD: { city: 'Porbandar', name: 'Porbandar' },
  PBF: { city: 'Pine Bluff', name: 'Pine Bluff Regional Airport, Grider Field' },
  PBG: { city: 'Plattsburgh', name: 'Plattsburgh International' },
  PBH: { city: 'Thimphu', name: 'Paro' },
  PBI: { city: 'West Palm Beach', name: 'Palm Beach International' },
  PBJ: { city: 'Paama Island', name: 'Tavie' },
  PBL: { city: 'Puerto Cabello', name: 'General Bartolome Salom International' },
  PBM: { city: 'Zandery', name: 'Johan Adolf Pengel International' },
  PBN: { city: 'Porto Amboim', name: 'Porto Amboim' },
  PBO: { city: 'Paraburdoo', name: 'Paraburdoo' },
  PBP: { city: 'Nandayure', name: 'Islita' },
  PBQ: { city: 'Pimenta Bueno', name: 'Pimenta Bueno' },
  PBR: { city: 'Puerto Barrios', name: 'Puerto Barrios' },
  PBU: { city: 'Putao', name: 'Putao' },
  PBZ: { city: 'Plettenberg Bay', name: 'Plettenberg Bay' },
  PCB: { city: 'Jakarta', name: 'Pondok Cabe Air Base' },
  PCD: { city: 'Prairie du Chien', name: 'Prairie Du Chien Municipal' },
  PCF: { city: 'Potchefstroom', name: 'Potchefstroom' },
  PCL: { city: 'Pucallpa', name: 'Cap FAP David Abenzur Rengifo International' },
  PCN: { city: 'Picton', name: 'Picton Aerodrome' },
  PCP: { city: 'Principe', name: 'Principe' },
  PCQ: { city: 'Phongsaly', name: 'Boun Neau' },
  PCR: { city: 'Puerto Carreno', name: 'German Olano' },
  PCS: { city: 'Picos', name: 'Picos' },
  PDA: { city: 'Puerto Inírida', name: 'Obando' },
  PDG: { city: 'Padang', name: 'Minangkabau International' },
  PDK: { city: 'Atlanta', name: 'DeKalb Peachtree' },
  PDL: { city: 'Ponta Delgada', name: 'João Paulo II' },
  PDO: { city: 'Talang Gudang-Sumatra Island', name: 'Pendopo' },
  PDP: { city: 'Punta del Este', name: 'Capitan Corbeta CA Curbelo International' },
  PDS: { city: 'Piedras Negras', name: 'Piedras Negras International' },
  PDT: { city: 'Pendleton', name: 'Eastern Oregon Regional At Pendleton' },
  PDU: { city: 'Paysandu', name: 'Tydeo Larre Borges' },
  PDV: { city: 'Plovdiv', name: 'Plovdiv International' },
  PDX: { city: 'Portland', name: 'Portland International' },
  PEA: { city: 'Penneshaw', name: 'Penneshaw' },
  PED: { city: 'Pardubice', name: 'Pardubice' },
  PEE: { city: 'Perm', name: 'Bolshoye Savino' },
  PEF: { city: 'Peenemunde', name: 'Peenemünde' },
  PEG: { city: 'Perugia', name: 'Perugia San Francesco dAssisi – Umbria International' },
  PEH: { city: 'Pehuajo', name: 'Comodoro Pedro Zanni' },
  PEI: { city: 'Pereira', name: 'Matecaña International' },
  PEK: { city: 'Beijing', name: 'Beijing Capital International' },
  PEM: { city: 'Puerto Maldonado', name: 'Padre Aldamiz International' },
  PEN: { city: 'Penang', name: 'Penang International' },
  PEQ: { city: 'Pecos', name: 'Pecos Municipal' },
  PER: { city: 'Perth', name: 'Perth International' },
  PES: { city: 'Petrozavodsk', name: 'Petrozavodsk' },
  PET: { city: 'Pelotas', name: 'João Simões Lopes Neto International' },
  PEU: { city: 'Puerto Lempira', name: 'Puerto Lempira' },
  PEV: { city: 'Pécs-Pogány', name: 'Pécs-Pogány' },
  PEW: { city: 'Peshawar', name: 'Peshawar International' },
  PEX: { city: 'Pechora', name: 'Pechora' },
  PEZ: { city: 'Penza', name: 'Penza' },
  PFB: { city: 'Passo Fundo', name: 'Lauro Kurtz' },
  PFJ: { city: 'Patreksfjordur', name: 'Patreksfjörður' },
  PFN: { city: 'Panama City', name: 'Panama City-Bay Co International' },
  PFO: { city: 'Paphos', name: 'Paphos International' },
  PFQ: { city: 'Parsabad', name: 'Parsabade Moghan' },
  PFR: { city: 'Ilebo', name: 'Ilebo' },
  PGA: { city: 'Page', name: 'Page Municipal' },
  PGD: { city: 'Punta Gorda', name: 'Charlotte County' },
  PGF: { city: 'Perpignan', name: 'Perpignan-Rivesaltes (Llabanère)' },
  PGH: { city: 'Nainital', name: 'Pantnagar' },
  PGK: { city: 'Pangkal Pinang', name: 'Pangkal Pinang (Depati Amir)' },
  PGU: { city: 'Khalije Fars', name: 'Persian Gulf International' },
  PGV: { city: 'Greenville', name: 'Pitt Greenville' },
  PGX: { city: 'Perigueux', name: 'Périgueux-Bassillac' },
  PGZ: { city: 'Ponta Grossa', name: 'Ponta Grossa Airport - Comandante Antonio Amilton Beraldo' },
  PHA: { city: 'Phan Rang', name: 'Phan Rang' },
  PHB: { city: 'Parnaiba', name: 'Prefeito Doutor João Silva Filho' },
  PHC: { city: 'Port Hartcourt', name: 'Port Harcourt International' },
  PHD: { city: 'New Philadelpha', name: 'Harry Clever Field' },
  PHE: { city: 'Port Hedland', name: 'Port Hedland International' },
  PHF: { city: 'Newport News', name: 'Newport News Williamsburg International' },
  PHK: { city: 'Pahokee', name: 'Palm Beach County Glades' },
  PHL: { city: 'Philadelphia', name: 'Philadelphia International' },
  PHN: { city: 'Port Huron', name: 'St Clair County International' },
  PHS: { city: 'Phitsanulok', name: 'Phitsanulok' },
  PHW: { city: 'Phalaborwa', name: 'Hendrik Van Eck' },
  PHX: { city: 'Phoenix', name: 'Phoenix Sky Harbor International' },
  PHY: { city: 'Phetchabun', name: 'Phetchabun' },
  PIA: { city: 'Peoria', name: 'General Wayne A. Downing Peoria International' },
  PIB: { city: 'Hattiesburg/Laurel', name: 'Hattiesburg Laurel Regional' },
  PID: { city: 'Nassau', name: 'Nassau Paradise Island' },
  PIE: { city: 'St. Petersburg', name: 'St Petersburg Clearwater International' },
  PIF: { city: 'Pingtung', name: 'Pingtung North' },
  PIH: { city: 'Pocatello', name: 'Pocatello Regional' },
  PIK: { city: 'Prestwick', name: 'Glasgow Prestwick' },
  PIL: { city: 'Pilar', name: 'Carlos Miguel Gimenez' },
  PIM: { city: 'Pine Mountain', name: 'Harris County' },
  PIN: { city: 'Parintins', name: 'Parintins' },
  PIO: { city: 'Pisco', name: 'Capitán FAP Renán Elías Olivera International' },
  PIP: { city: 'Pilot Point', name: 'Pilot Point' },
  PIR: { city: 'Pierre', name: 'Pierre Regional' },
  PIS: { city: 'Poitiers', name: 'Poitiers-Biard' },
  PIT: { city: 'Pittsburgh', name: 'Pittsburgh International' },
  PIU: { city: 'Piura', name: 'Capitán FAP Guillermo Concha Iberico International' },
  PIW: { city: 'Pikwitonei', name: 'Pikwitonei' },
  PIX: { city: 'Pico', name: 'Pico' },
  PIZ: { city: 'Point Lay', name: 'Point Lay LRRS' },
  PJA: { city: 'Pajala', name: 'Pajala' },
  PJC: { city: 'Pedro Juan Caballero', name: 'Dr Augusto Roberto Fuster International' },
  PJG: { city: 'Panjgur', name: 'Panjgur' },
  PJM: { city: 'Puerto Jimenez', name: 'Puerto Jimenez' },
  PKA: { city: 'Napaskiak', name: 'Napaskiak' },
  PKB: { city: 'PARKERSBURG', name: 'Mid Ohio Valley Regional' },
  PKC: { city: 'Petropavlovsk', name: 'Yelizovo' },
  PKE: { city: 'Parkes', name: 'Parkes' },
  PKG: { city: 'Pangkor Island', name: 'Pulau Pangkor' },
  PKH: { city: 'Porto Heli', name: 'Porto Cheli' },
  PKK: { city: 'Pakhokku', name: 'Pakhokku' },
  PKN: { city: 'Pangkalan Bun', name: 'Iskandar' },
  PKO: { city: 'Parakou', name: 'Parakou' },
  PKP: { city: 'Puka Puka', name: 'Puka Puka' },
  PKR: { city: 'Pokhara', name: 'Pokhara' },
  PKT: { city: 'Wadeye', name: 'Port Keats' },
  PKU: { city: 'Pekanbaru', name: 'Sultan Syarif Kasim Ii (Simpang Tiga)' },
  PKV: { city: 'Pskov', name: 'Pskov' },
  PKW: { city: 'Selebi-phikwe', name: 'Selebi Phikwe' },
  PKX: { city: 'Beijing', name: 'Beijing Daxing International' },
  PKY: { city: 'Palangkaraya', name: 'Tjilik Riwut' },
  PKZ: { city: 'Pakse', name: 'Pakse International' },
  PLD: { city: 'Carrillo', name: 'Playa Samara/Carrillo' },
  PLH: { city: 'Plymouth', name: 'Plymouth City' },
  PLL: { city: 'Manaus', name: 'Ponta Pelada' },
  PLM: { city: 'Palembang', name: 'Sultan Mahmud Badaruddin II' },
  PLN: { city: 'Pellston', name: 'Pellston Regional Airport of Emmet County' },
  PLO: { city: 'Port Lincoln', name: 'Port Lincoln' },
  PLP: { city: 'La Palma', name: 'Captain Ramon Xatruch' },
  PLQ: { city: 'Palanga', name: 'Palanga International' },
  PLS: { city: 'Providenciales', name: 'Providenciales' },
  PLU: { city: 'Belo Horizonte', name: 'Pampulha - Carlos Drummond de Andrade' },
  PLV: { city: 'Poltava', name: 'Suprunovka' },
  PLW: { city: 'Palu', name: 'Mutiara' },
  PLX: { city: 'Semiplatinsk', name: 'Semipalatinsk' },
  PLZ: { city: 'Port Elizabeth', name: 'Port Elizabeth' },
  PMA: { city: 'Pemba', name: 'Pemba' },
  PMB: { city: 'Pembina', name: 'Pembina Municipal' },
  PMC: { city: 'Puerto Montt', name: 'El Tepual' },
  PMD: { city: 'Palmdale', name: 'Palmdale Regional/USAF Plant 42' },
  PMF: { city: 'Parma', name: 'Parma' },
  PMG: { city: 'Ponta Pora', name: 'Ponta Porã' },
  PMH: { city: 'Portsmouth', name: 'Greater Portsmouth Regional' },
  PMI: { city: 'Palma de Mallorca', name: 'Palma De Mallorca' },
  PMK: { city: 'Palm Island', name: 'Palm Island' },
  PML: { city: 'Cold Bay', name: 'Port Moller' },
  PMO: { city: 'Palermo', name: 'Falcone–Borsellino' },
  PMQ: { city: 'Perito Moreno', name: 'Perito Moreno' },
  PMR: { city: 'Palmerston North', name: 'Palmerston North' },
  PMS: { city: 'Palmyra', name: 'Palmyra' },
  PMV: { city: 'Porlamar', name: 'Del Caribe Santiago Mariño International' },
  PMW: { city: 'Palmas', name: 'Brigadeiro Lysias Rodrigues' },
  PMY: { city: 'Puerto Madryn', name: 'El Tehuelche' },
  PMZ: { city: 'Palmar Sur', name: 'Palmar Sur' },
  PNA: { city: 'Pamplona', name: 'Pamplona' },
  PNB: { city: 'Porto Nacional', name: 'Porto Nacional' },
  PNC: { city: 'Ponca City', name: 'Ponca City Regional' },
  PNE: { city: 'Philadelphia', name: 'Northeast Philadelphia' },
  PNH: { city: 'Phnom-penh', name: 'Phnom Penh International' },
  PNI: { city: 'Pohnpei', name: 'Pohnpei International' },
  PNK: { city: 'Pontianak', name: 'Supadio' },
  PNL: { city: 'Pantelleria', name: 'Pantelleria' },
  PNP: { city: 'Girua', name: 'Girua' },
  PNQ: { city: 'Pune', name: 'Pune' },
  PNR: { city: 'Pointe-noire', name: 'Pointe Noire' },
  PNS: { city: 'Pensacola', name: 'Pensacola Regional' },
  PNT: { city: 'Puerto Natales', name: 'Tte. Julio Gallardo' },
  PNV: { city: 'Panevezys', name: 'Panevėžys Air Base' },
  PNY: { city: 'Pendicherry', name: 'Pondicherry' },
  PNZ: { city: 'Petrolina', name: 'Senador Nilo Coelho' },
  POA: { city: 'Porto Alegre', name: 'Salgado Filho' },
  POB: { city: 'Fort Bragg', name: 'Pope Field' },
  POC: { city: 'La Verne', name: 'Brackett Field' },
  POE: { city: 'Fort Polk', name: 'Polk Army Air Field' },
  POF: { city: 'Poplar Bluff', name: 'Poplar Bluff Municipal' },
  POG: { city: 'Port Gentil', name: 'Port Gentil' },
  POI: { city: 'Potosi', name: 'Capitan Nicolas Rojas' },
  POJ: { city: 'Patos de Minas', name: 'Patos de Minas' },
  POL: { city: 'Pemba', name: 'Pemba' },
  POM: { city: 'Port Moresby', name: 'Port Moresby Jacksons International' },
  POO: { city: 'Pocos De Caldas', name: 'Poços de Caldas - Embaixador Walther Moreira Salles' },
  POP: { city: 'Puerto Plata', name: 'Gregorio Luperon International' },
  POR: { city: 'Pori', name: 'Pori' },
  POS: { city: 'Port-of-spain', name: 'Piarco International' },
  POT: { city: 'Port Antonio', name: 'Ken Jones' },
  POU: { city: 'Poughkeepsie', name: 'Dutchess County' },
  POW: { city: 'Portoroz', name: 'Portoroz' },
  POX: { city: 'Pontoise', name: 'Pontoise - Cormeilles-en-Vexin' },
  POZ: { city: 'Poznan', name: 'Poznań-Ławica' },
  PPA: { city: 'Pampa', name: 'Perry Lefors Field' },
  PPB: { city: 'President Prudente', name: 'Presidente Prudente' },
  PPC: { city: 'Prospect Creek', name: 'Prospect Creek' },
  PPE: { city: 'Punta Penasco', name: 'Mar de Cortés International' },
  PPF: { city: 'Parsons', name: 'Tri-City' },
  PPG: { city: 'Pago Pago', name: 'Pago Pago International' },
  PPK: { city: 'Petropavlosk', name: 'Petropavlosk South' },
  PPL: { city: 'Phaplu', name: 'Phaplu' },
  PPM: { city: 'Pompano Beach', name: 'Pompano Beach Airpark' },
  PPN: { city: 'Popayan', name: 'Guillermo León Valencia' },
  PPP: { city: 'Prosserpine', name: 'Proserpine Whitsunday Coast' },
  PPQ: { city: 'Paraparaumu', name: 'Paraparaumu' },
  PPR: { city: 'Pasir Pangaraian', name: 'Pasir Pangaraan' },
  PPS: { city: 'Puerto Princesa', name: 'Puerto Princesa' },
  PPT: { city: 'Papeete', name: 'Faaa International' },
  PPW: { city: 'Papa Westray', name: 'Papa Westray' },
  PPY: { city: 'Pouso Alegre', name: 'Pouso Alegre' },
  PQC: { city: 'Phuquoc', name: 'Phu Quoc International' },
  PQI: { city: 'Presque Isle', name: 'Northern Maine Regional Airport at Presque Isle' },
  PQM: { city: 'Palenque', name: 'Palenque International' },
  PQQ: { city: 'Port Macquarie', name: 'Port Macquarie' },
  PRA: { city: 'Parana', name: 'General Urquiza' },
  PRB: { city: 'Paso Robles', name: 'Paso Robles Municipal' },
  PRC: { city: 'Prescott', name: 'Ernest A. Love Field' },
  PRG: { city: 'Prague', name: 'Václav Havel Airport Prague' },
  PRH: { city: 'Phrae', name: 'Phrae' },
  PRI: { city: 'Praslin', name: 'Praslin' },
  PRM: { city: 'Portimao', name: 'Portimão' },
  PRN: { city: 'Pristina', name: 'Priština International' },
  PRP: { city: 'Propriano', name: 'Propriano' },
  PRQ: { city: 'Presidencia R.s.pena', name: 'Termal' },
  PRU: { city: 'Pyay', name: 'Pyay' },
  PRV: { city: 'Prerov', name: 'Přerov Air Base' },
  PRX: { city: 'Paris', name: 'Cox Field' },
  PRY: { city: 'Pretoria', name: 'Wonderboom' },
  PRZ: { city: 'Prineville', name: 'Prineville' },
  PSA: { city: 'Pisa', name: 'Pisa International' },
  PSC: { city: 'Pasco', name: 'Tri Cities' },
  PSD: { city: 'Port Said', name: 'Port Said' },
  PSE: { city: 'Ponce', name: 'Mercedita' },
  PSG: { city: 'Petersburg', name: 'Petersburg James A Johnson' },
  PSH: { city: 'Sankt Peter-Ording', name: 'St. Peter-Ording' },
  PSI: { city: 'Pasni', name: 'Pasni' },
  PSJ: { city: 'Poso', name: 'Kasiguncu' },
  PSL: { city: 'Perth', name: 'Perth/Scone' },
  PSM: { city: 'Portsmouth', name: 'Portsmouth International at Pease' },
  PSO: { city: 'Pasto', name: 'Antonio Narino' },
  PSP: { city: 'Palm Springs', name: 'Palm Springs International' },
  PSR: { city: 'Pescara', name: 'Pescara International' },
  PSS: { city: 'Posadas', name: 'Libertador Gral D Jose De San Martin' },
  PSU: { city: 'Putussibau-Borneo Island', name: 'Pangsuma' },
  PSX: { city: 'Palacios', name: 'Palacios Municipal' },
  PSY: { city: 'Stanley', name: 'Port Stanley' },
  PSZ: { city: 'Puerto Suarez', name: 'Capitán Av. Salvador Ogaya G. airport' },
  PTA: { city: 'Port alsworth', name: 'Port Alsworth' },
  PTB: { city: 'Petersburg', name: 'Dinwiddie County' },
  PTF: { city: 'Malolo Lailai Island', name: 'Malolo Lailai Island' },
  PTG: { city: 'Potgietersrus', name: 'Polokwane International' },
  PTH: { city: 'Port Heiden', name: 'Port Heiden' },
  PTJ: { city: 'Portland', name: 'Portland' },
  PTK: { city: 'Pontiac', name: 'Oakland County International' },
  PTM: { city: 'Palmarito', name: 'Palmarito' },
  PTP: { city: 'Pointe-a-pitre', name: 'Pointe-à-Pitre Le Raizet' },
  PTT: { city: 'Pratt', name: 'Pratt Regional' },
  PTU: { city: 'Port Moller', name: 'Platinum' },
  PTX: { city: 'Pitalito', name: 'Pitalito' },
  PTY: { city: 'Panama City', name: 'Tocumen International' },
  PTZ: { city: 'Pastaza', name: 'Rio Amazonas' },
  PUB: { city: 'Pueblo', name: 'Pueblo Memorial' },
  PUC: { city: 'Price', name: 'Carbon County Regional/Buck Davis Field' },
  PUD: { city: 'Puerto Deseado', name: 'Puerto Deseado' },
  PUE: { city: 'Puerto Obaldia', name: 'Puerto Obaldia' },
  PUF: { city: 'Pau', name: 'Pau Pyrénées' },
  PUG: { city: 'Argyle', name: 'Port Augusta' },
  PUJ: { city: 'Punta Cana', name: 'Punta Cana International' },
  PUK: { city: 'Pukarua', name: 'Pukarua' },
  PUQ: { city: 'Punta Arenas', name: 'Pdte. Carlos Ibañez del Campo' },
  PUR: { city: 'Puerto Rico/Manuripi', name: 'Puerto Rico' },
  PUS: { city: 'Busan', name: 'Gimhae International' },
  PUT: { city: 'Puttaparthi', name: 'Sri Sathya Sai' },
  PUU: { city: 'Puerto Asis', name: 'Tres De Mayo' },
  PUW: { city: 'Pullman', name: 'Pullman Moscow Regional' },
  PUY: { city: 'Pula', name: 'Pula' },
  PUZ: { city: 'Puerto Cabezas', name: 'Puerto Cabezas' },
  PVA: { city: 'Providencia', name: 'El Embrujo' },
  PVC: { city: 'Provincetown', name: 'Provincetown Municipal' },
  PVD: { city: 'Providence', name: 'Theodore Francis Green State' },
  PVG: { city: 'Shanghai', name: 'Shanghai Pudong International' },
  PVH: { city: 'Porto Velho', name: 'Governador Jorge Teixeira de Oliveira' },
  PVK: { city: 'Preveza', name: 'Aktion National' },
  PVL: { city: 'Pikeville', name: 'Pike County-Hatcher Field' },
  PVO: { city: 'Portoviejo', name: 'Reales Tamarindos' },
  PVR: { city: 'Puerto Vallarta', name: 'Licenciado Gustavo Díaz Ordaz International' },
  PVS: { city: 'Provideniya Bay', name: 'Provideniya Bay' },
  PVU: { city: 'Provo', name: 'Provo Municipal' },
  PWA: { city: 'Oklahoma City', name: 'Wiley Post' },
  PWE: { city: 'Pevek', name: 'Pevek' },
  PWK: { city: 'Chicago-Wheeling', name: 'Chicago Executive' },
  PWM: { city: 'Portland', name: 'Portland International Jetport' },
  PWQ: { city: 'Pavlodar', name: 'Pavlodar' },
  PWT: { city: 'Bremerton', name: 'Bremerton National' },
  PWY: { city: 'Pinedale', name: 'Ralph Wenz Field' },
  PXH: { city: 'Prominent Hill', name: 'Prominent Hill' },
  PXM: { city: 'Puerto Escondido', name: 'Puerto Escondido International' },
  PXO: { city: 'Porto Santo', name: 'Porto Santo' },
  PXR: { city: 'Surin', name: 'Surin' },
  PXU: { city: 'Pleiku', name: 'Pleiku' },
  PYB: { city: 'Jeypore', name: 'Jeypore' },
  PYE: { city: 'Penrhyn Island', name: 'Tongareva' },
  PYH: { city: 'Puerto Ayacucho', name: 'Cacique Aramare' },
  PYJ: { city: 'Yakutia', name: 'Polyarny' },
  PYK: { city: 'Karaj', name: 'Payam International' },
  PYM: { city: 'Plymouth', name: 'Plymouth Municipal' },
  PYR: { city: 'Andravida', name: 'Andravida Air Base' },
  PYY: { city: 'Pai', name: 'Mae Hong Son' },
  PZA: { city: 'Paz De Ariporo', name: 'Paz De Ariporo' },
  PZB: { city: 'Pietermaritzburg', name: 'Pietermaritzburg' },
  PZE: { city: 'Penzance', name: 'Penzance Heliport' },
  PZH: { city: 'Zhob', name: 'Zhob' },
  PZI: { city: 'Panzhihua', name: 'Baoanying' },
  PZL: { city: 'Phinda', name: 'Zulu Inyala' },
  PZO: { city: 'Guayana', name: 'General Manuel Carlos Piar International' },
  PZS: { city: 'Temuco', name: 'Maquehue' },
  PZU: { city: 'Port Sudan', name: 'Port Sudan New International' },
  PZY: { city: 'Piestany', name: 'Piešťany' },
  QBC: { city: 'Bella Coola', name: 'Bella Coola' },
  QCJ: { city: 'Botucatu', name: 'Botucatu - Tancredo de Almeida Neves' },
  QCY: { city: 'Coningsby', name: 'RAF Coningsby' },
  QDJ: { city: 'Djelfa', name: 'Tsletsi' },
  QEF: { city: 'Egelsbach', name: 'Frankfurt-Egelsbach' },
  QFG: { city: 'Eqalugaarsuit', name: 'Eqalugaarsuit Heliport' },
  QFO: { city: 'Duxford', name: 'Duxford Aerodrome' },
  QGQ: { city: 'Attu', name: 'Attu Heliport' },
  QGU: { city: 'Gifu', name: 'Gifu' },
  QHP: { city: 'Taubaté', name: 'Base de Aviação de Taubaté' },
  QHR: { city: 'Debre Zeyit', name: 'Harar Meda' },
  QIG: { city: 'Iguatu', name: 'Iguatu' },
  QJB: { city: 'Jubail', name: 'Jubail' },
  QJE: { city: 'Kitsissuarsuit', name: 'Kitsissuarsuit Heliport' },
  QJI: { city: 'Ikamiut', name: 'Ikamiut Heliport' },
  QKX: { city: 'Kautokeino', name: 'Kautokeino Air Base' },
  QLA: { city: 'Lasham', name: 'Lasham' },
  QLD: { city: 'Blida', name: 'Blida' },
  QLF: { city: 'Vesivehmaa', name: 'Lahti Vesivehmaa' },
  QLP: { city: 'Sarzana (SP)', name: 'Sarzana-Luni Air Base' },
  QLR: { city: 'Monte Real', name: 'Monte Real Air Base' },
  QLS: { city: 'Lausanne', name: 'Lausanne-Blécherette' },
  QLT: { city: 'Latina', name: 'Latina Air Base' },
  QNC: { city: 'Neuchatel', name: 'Neuchatel' },
  QND: { city: 'Novi Sad', name: 'Cenej' },
  QNJ: { city: 'Annemasse', name: 'Annemasse' },
  QNV: { city: 'Nova Iguacu', name: 'Aeroclube' },
  QOW: { city: 'Imo', name: 'Sam Mbakwe International' },
  QPA: { city: 'Padova', name: 'Padova' },
  QPD: { city: 'Pinar Del Rio Norte', name: 'Pinar Del Rio' },
  QPG: { city: 'Paya Lebar', name: 'Paya Lebar Air Base' },
  QPS: { city: 'Piracununga', name: 'Campo Fontenelle' },
  QPW: { city: 'Kangaatsiaq', name: 'Kangaatsiaq Heliport' },
  QQT: { city: 'Qeqertaq', name: 'Qeqertaq Heliport' },
  QRA: { city: 'Johannesburg', name: 'Rand' },
  QRC: { city: 'Rancagua', name: 'De La Independencia' },
  QRO: { city: 'Queretaro', name: 'Querétaro Intercontinental' },
  QRW: { city: 'Osubi', name: 'Warri' },
  QRY: { city: 'Ikerasaarsuk', name: 'Ikerassaarsuk Heliport' },
  QSA: { city: 'Sabadell', name: 'Sabadell' },
  QSC: { city: 'Sao Carlos', name: 'Mário Pereira Lopes–São Carlos' },
  QSF: { city: 'Setif', name: 'Ain Arnat' },
  QSI: { city: 'Moshi', name: 'Moshi' },
  QSN: { city: 'San Nicolás', name: 'San Nicolas De Bari' },
  QSR: { city: 'Salerno', name: 'Salerno Costa dAmalfi' },
  QSZ: { city: 'Yarkant', name: 'Yeerqiang' },
  QUG: { city: 'Goodwood', name: 'Chichester/Goodwood' },
  QUO: { city: 'Uyo', name: 'Akwa Ibom International' },
  QUY: { city: 'Wyton', name: 'RAF Wyton' },
  QXH: { city: 'Schoenhagen', name: 'Schönhagen' },
  QYD: { city: 'Gdynia', name: 'Oksywie Military Air Base' },
  RAB: { city: 'Tokua', name: 'Tokua' },
  RAC: { city: 'Racine', name: 'John H Batten' },
  RAE: { city: 'Arar', name: 'Arar Domestic' },
  RAH: { city: 'Rafha', name: 'Rafha Domestic' },
  RAI: { city: 'Praia, Santiago Island', name: 'Praia International' },
  RAJ: { city: 'Rajkot', name: 'Rajkot' },
  RAK: { city: 'Marrakech', name: 'Menara' },
  RAL: { city: 'Riverside', name: 'Riverside Municipal' },
  RAM: { city: 'Ramingining', name: 'Ramingining' },
  RAO: { city: 'Ribeirao Preto', name: 'Leite Lopes' },
  RAP: { city: 'Rapid City', name: 'Rapid City Regional' },
  RAQ: { city: 'Raha', name: 'Sugimanuru' },
  RAR: { city: 'Avarua', name: 'Rarotonga International' },
  RAS: { city: 'Rasht', name: 'Sardar-e-Jangal' },
  RAT: { city: 'Raduzhnyi', name: 'Raduzhny' },
  RAZ: { city: 'Rawala Kot', name: 'Rawalakot' },
  RBA: { city: 'Rabat', name: 'Rabat-Salé' },
  RBB: { city: 'Borba', name: 'Borba' },
  RBD: { city: 'Dallas', name: 'Dallas Executive' },
  RBE: { city: 'Ratanakiri', name: 'Ratanakiri' },
  RBK: { city: 'Murrieta-Temecula', name: 'French Valley' },
  RBL: { city: 'Red Bluff', name: 'Red Bluff Municipal' },
  RBM: { city: 'Straubing', name: 'Straubing' },
  RBQ: { city: 'Rerrenabaque', name: 'Rurenabaque' },
  RBR: { city: 'Rio Branco', name: 'Plácido de Castro' },
  RBV: { city: 'Ramata', name: 'Ramata' },
  RBX: { city: 'Rumbek', name: 'Rumbek' },
  RBY: { city: 'Ruby', name: 'Ruby' },
  RCA: { city: 'Rapid City', name: 'Ellsworth Air Force Base' },
  RCB: { city: 'Richards Bay', name: 'Richards Bay' },
  RCH: { city: 'Rio Hacha', name: 'Almirante Padilla' },
  RCL: { city: 'Redcliffe', name: 'Redcliffe' },
  RCM: { city: 'Richmond', name: 'Richmond' },
  RCO: { city: 'Rochefort', name: 'Rochefort-Saint-Agnant (BA 721)' },
  RCQ: { city: 'Reconquista', name: 'Reconquista' },
  RCS: { city: 'Rochester', name: 'Rochester' },
  RCU: { city: 'Rio Cuarto', name: 'Area De Material' },
  RCY: { city: 'Port Nelson', name: 'Rum Cay' },
  RDB: { city: 'Red Dog', name: 'Red Dog' },
  RDC: { city: 'Redencao', name: 'Redenção' },
  RDD: { city: 'Redding', name: 'Redding Municipal' },
  RDG: { city: 'Reading', name: 'Reading Regional Carl A Spaatz Field' },
  RDM: { city: 'Redmond-Bend', name: 'Roberts Field' },
  RDN: { city: 'Redang', name: 'LTS Pulau Redang' },
  RDO: { city: 'RADOM', name: 'Radom' },
  RDP: { city: 'Durgapur', name: 'Kazi Nazrul Islam' },
  RDR: { city: 'Red River', name: 'Grand Forks Air Force Base' },
  RDS: { city: 'Rincon de los Sauces', name: 'Rincon De Los Sauces' },
  RDU: { city: 'Raleigh-durham', name: 'Raleigh Durham International' },
  RDZ: { city: 'Rodez', name: 'Rodez-Marcillac' },
  REA: { city: 'Reao', name: 'Reao' },
  REB: { city: 'Rechlin-laerz', name: 'Rechlin-Lärz' },
  REC: { city: 'Recife', name: 'Guararapes - Gilberto Freyre International' },
  REG: { city: 'Reggio Calabria', name: 'Reggio Calabria' },
  REL: { city: 'Trelew', name: 'Almirante Marco Andres Zar' },
  REN: { city: 'Orenburg', name: 'Orenburg Central' },
  REP: { city: 'Siem-reap', name: 'Siem Reap International' },
  RER: { city: 'Retalhuleu', name: 'Retalhuleu' },
  RES: { city: 'Resistencia', name: 'Resistencia International' },
  RET: { city: 'Røst', name: 'Røst' },
  REU: { city: 'Reus', name: 'Reus Air Base' },
  REX: { city: 'Reynosa', name: 'General Lucio Blanco International' },
  REY: { city: 'Reyes', name: 'Reyes' },
  REZ: { city: 'Resende', name: 'Resende' },
  RFD: { city: 'Rockford', name: 'Chicago Rockford International' },
  RFP: { city: 'Raiatea Island', name: 'Raiatea' },
  RFS: { city: 'Rosita', name: 'Rosita' },
  RGA: { city: 'Rio Grande', name: 'Hermes Quijada International' },
  RGI: { city: 'Rangiroa', name: 'Rangiroa' },
  RGK: { city: 'Gorno-Altaysk', name: 'Gorno-Altaysk' },
  RGL: { city: 'Rio Gallegos', name: 'Piloto Civil N. Fernández' },
  RGN: { city: 'Yangon', name: 'Yangon International' },
  RGO: { city: 'Chongjin', name: 'Orang' },
  RGS: { city: 'Burgos', name: 'Burgos' },
  RGT: { city: 'Rengat', name: 'Japura' },
  RHD: { city: 'Rio Hondo', name: 'Termas de Río Hondo international' },
  RHE: { city: 'Reims', name: 'Reims-Champagne (BA 112) Air Base' },
  RHI: { city: 'Rhinelander', name: 'Rhinelander Oneida County' },
  RHO: { city: 'Rhodos', name: 'Diagoras' },
  RHP: { city: 'Ramechhap', name: 'Ramechhap' },
  RHT: { city: 'Alxa Right Banner', name: 'Alxa Right Banner Badanjilin' },
  RHV: { city: 'San Jose', name: 'Reid-Hillview Airport of Santa Clara County' },
  RIA: { city: 'Santa Maria', name: 'Santa Maria' },
  RIB: { city: 'Riberalta', name: 'Capitán Av. Selin Zeitun Lopez' },
  RIC: { city: 'Richmond', name: 'Richmond International' },
  RIH: { city: 'Rio Hato', name: 'Scarlett Martinez International' },
  RIJ: { city: 'Rioja', name: 'Juan Simons Vela' },
  RIL: { city: 'Rifle', name: 'Garfield County Regional' },
  RIN: { city: 'Ringi Cove', name: 'Ringi Cove' },
  RIS: { city: 'Rishiri Island', name: 'Rishiri' },
  RIV: { city: 'Riverside', name: 'March ARB' },
  RIW: { city: 'Riverton WY', name: 'Riverton Regional' },
  RIX: { city: 'Riga', name: 'Riga International' },
  RIY: { city: 'Mukalla', name: 'Mukalla International' },
  RIZ: { city: 'Rizhao', name: 'Rizhao Shanzihe' },
  RJA: { city: 'Rajahmundry', name: 'Rajahmundry' },
  RJB: { city: 'Rajbiraj', name: 'Rajbiraj' },
  RJH: { city: 'Rajshahi', name: 'Shah Mokhdum' },
  RJK: { city: 'Rijeka', name: 'Rijeka' },
  RJL: { city: 'Logroño-Agoncillo', name: 'Logroño-Agoncillo' },
  RJN: { city: 'Rafsanjan', name: 'Rafsanjan' },
  RKD: { city: 'Rockland', name: 'Knox County Regional' },
  RKE: { city: 'Copenhagen', name: 'Copenhagen Roskilde' },
  RKH: { city: 'Rock Hill', name: 'Rock Hill - York County' },
  RKO: { city: 'Sipora', name: 'Rokot' },
  RKP: { city: 'Rockport', name: 'Aransas County' },
  RKS: { city: 'Rock Springs', name: 'Southwest Wyoming Regional' },
  RKT: { city: 'Ras Al Khaimah', name: 'Ras Al Khaimah International' },
  RKV: { city: 'Reykjavik', name: 'Reykjavik' },
  RKZ: { city: 'Shigatse', name: 'Shigatse Air Base' },
  RLG: { city: 'Laage', name: 'Rostock-Laage' },
  RLK: { city: 'Bayannur', name: 'Bayannur Tianjitai' },
  RMA: { city: 'Roma', name: 'Roma' },
  RME: { city: 'Rome', name: 'Griffiss International' },
  RMF: { city: 'Marsa Alam', name: 'Marsa Alam International' },
  RMG: { city: 'Rome', name: 'Richard B Russell' },
  RMI: { city: 'Rimini', name: 'Federico Fellini International' },
  RMK: { city: 'Renmark', name: 'Renmark' },
  RML: { city: 'Colombo', name: 'Colombo Ratmalana' },
  RMQ: { city: 'Taichung', name: 'Taichung Ching Chuang Kang' },
  RMS: { city: 'Ramstein', name: 'Ramstein Air Base' },
  RMT: { city: 'Rimatara', name: 'Rimatara' },
  RMU: { city: 'Murcia', name: 'Región de Murcia International' },
  RMY: { city: 'Mariposa', name: 'Mariposa Yosemite' },
  RNA: { city: 'Ulawa', name: 'Ulawa' },
  RNB: { city: 'Ronneby', name: 'Ronneby' },
  RND: { city: 'San Antonio', name: 'Randolph Air Force Base' },
  RNE: { city: 'Roanne', name: 'Roanne-Renaison' },
  RNI: { city: 'Corn Island', name: 'Corn Island' },
  RNJ: { city: 'Yoron', name: 'Yoron' },
  RNL: { city: 'Rennell Island', name: 'Rennell/Tingoa' },
  RNN: { city: 'Ronne', name: 'Bornholm' },
  RNO: { city: 'Reno', name: 'Reno Tahoe International' },
  RNS: { city: 'Rennes', name: 'Rennes-Saint-Jacques' },
  RNT: { city: 'Renton', name: 'Renton Municipal' },
  RNZ: { city: 'Rensselaer', name: 'Jasper County' },
  ROA: { city: 'Roanoke VA', name: 'Roanoke–Blacksburg Regional' },
  ROB: { city: 'Monrovia', name: 'Roberts International' },
  ROC: { city: 'Rochester', name: 'Greater Rochester International' },
  ROD: { city: 'Robertson', name: 'Robertson' },
  ROI: { city: 'Roi Et', name: 'Roi Et' },
  ROK: { city: 'Rockhampton', name: 'Rockhampton' },
  ROO: { city: 'Rondonopolis', name: 'Maestro Marinho Franco' },
  ROP: { city: 'Rota', name: 'Rota International' },
  ROR: { city: 'Babelthuap', name: 'Babelthuap' },
  ROS: { city: 'Rosario', name: 'Islas Malvinas' },
  ROT: { city: 'Rotorua', name: 'Rotorua Regional' },
  ROV: { city: 'Rostov', name: 'Platov International' },
  ROW: { city: 'Roswell', name: 'Roswell International Air Center' },
  ROZ: { city: 'Rota', name: 'Rota Naval Station' },
  RPB: { city: 'Roper Bar', name: 'Roper Bar' },
  RPN: { city: 'Rosh Pina', name: 'Ben Yaakov' },
  RPR: { city: 'Raipur', name: 'Raipur' },
  RQW: { city: 'Qayyarah', name: 'Qayyarah West' },
  RRG: { city: 'Rodriguez Island', name: 'Sir Charles Gaetan Duval' },
  RRK: { city: 'Rourkela', name: 'Rourkela' },
  RRR: { city: 'Raroia', name: 'Raroia' },
  RRS: { city: 'Roros', name: 'Røros' },
  RSA: { city: 'Santa Rosa', name: 'Santa Rosa' },
  RSD: { city: 'Rock Sound', name: 'Rock Sound' },
  RSH: { city: 'Russian Mission', name: 'Russian Mission' },
  RSL: { city: 'Russell', name: 'Russell Municipal' },
  RSS: { city: 'Damazin', name: 'Damazin' },
  RST: { city: 'Rochester', name: 'Rochester International' },
  RSU: { city: 'Yeosu', name: 'Yeosu' },
  RSW: { city: 'Fort Myers', name: 'Southwest Florida International' },
  RTA: { city: 'Rotuma', name: 'Rotuma' },
  RTB: { city: 'Roatan', name: 'Juan Manuel Galvez International' },
  RTG: { city: 'Ruteng', name: 'Frans Sales Lega' },
  RTM: { city: 'Rotterdam', name: 'Rotterdam The Hague' },
  RTN: { city: 'Raton', name: 'Raton Municipal-Crews Field' },
  RTS: { city: 'Rottnest Island', name: 'Rottnest Island' },
  RTW: { city: 'Saratov', name: 'Saratov Central' },
  RUA: { city: 'Arua', name: 'Arua' },
  RUD: { city: 'Emam Shahr', name: 'Shahroud' },
  RUG: { city: 'Rugao', name: 'Rugao Air Base' },
  RUH: { city: 'Riyadh', name: 'King Khaled International' },
  RUI: { city: 'Ruidoso', name: 'Sierra Blanca Regional' },
  RUK: { city: 'Rukumkot', name: 'Rukum Chaurjahari' },
  RUM: { city: 'Rumjatar', name: 'Rumjatar' },
  RUN: { city: 'St.-denis', name: 'Roland Garros' },
  RUR: { city: 'Rurutu', name: 'Rurutu' },
  RUS: { city: 'Marau', name: 'Marau' },
  RUT: { city: 'Rutland', name: 'Rutland - Southern Vermont Regional' },
  RUV: { city: 'Rubelsanto', name: 'Rubelsanto' },
  RVA: { city: 'Farafangana', name: 'Farafangana' },
  RVD: { city: 'Rio Verde', name: 'General Leite de Castro' },
  RVE: { city: 'Saravena', name: 'Los Colonizadores' },
  RVK: { city: 'Rørvik', name: 'Rørvik Airport, Ryum' },
  RVN: { city: 'Rovaniemi', name: 'Rovaniemi' },
  RVS: { city: 'Tulsa', name: 'Richard Lloyd Jones Jr' },
  RVT: { city: 'Ravensthorpe', name: 'Ravensthorpe' },
  RVV: { city: 'Raivavae', name: 'Raivavae' },
  RVY: { city: 'Rivera', name: 'Presidente General Don Oscar D. Gestido International' },
  RWF: { city: 'Redwood Falls', name: 'Redwood Falls Municipal' },
  RWI: { city: 'Rocky Mount', name: 'Rocky Mount Wilson Regional' },
  RWL: { city: 'Rawlins', name: 'Rawlins Municipal Airport/Harvey Field' },
  RWN: { city: 'Rivne', name: 'Rivne International' },
  RXS: { city: 'Roxas City', name: 'Roxas' },
  RYB: { city: 'Rybinsk', name: 'Staroselye' },
  RYG: { city: 'Rygge', name: 'Moss Airport, Rygge' },
  RYK: { city: 'Rahim Yar Khan', name: 'Shaikh Zaid' },
  RYN: { city: 'Royan', name: 'Royan-Médis' },
  RZA: { city: 'Santa Cruz', name: 'Santa Cruz' },
  RZE: { city: 'Rzeszow', name: 'Rzeszów-Jasionka' },
  RZP: { city: 'Taytay', name: 'Cesar Lim Rodriguez' },
  RZR: { city: 'Ramsar', name: 'Ramsar' },
  RZS: { city: 'Sindh', name: 'Sawan' },
  SAA: { city: 'SARATOGA', name: 'Shively Field' },
  SAB: { city: 'Saba', name: 'Juancho E. Yrausquin' },
  SAC: { city: 'Sacramento', name: 'Sacramento Executive' },
  SAD: { city: 'Safford', name: 'Safford Regional' },
  SAF: { city: 'Santa Fe', name: 'Santa Fe Municipal' },
  SAG: { city: 'Shirdi', name: 'Shirdi' },
  SAH: { city: 'Sanaa', name: 'Sanaa International' },
  SAK: { city: 'Saudarkrokur', name: 'Sauðárkrókur' },
  SAL: { city: 'San Salvador', name: 'Monseñor Óscar Arnulfo Romero International' },
  SAN: { city: 'San Diego', name: 'San Diego International' },
  SAP: { city: 'San Pedro Sula', name: 'Ramón Villeda Morales International' },
  SAQ: { city: 'San Andros', name: 'San Andros' },
  SAT: { city: 'San Antonio', name: 'San Antonio International' },
  SAV: { city: 'Savannah', name: 'Savannah Hilton Head International' },
  SAW: { city: 'Istanbul', name: 'Sabiha Gökçen International' },
  SAY: { city: 'Siena', name: 'Siena-Ampugnano' },
  SBA: { city: 'Santa Barbara', name: 'Santa Barbara Municipal' },
  SBB: { city: 'Santa Barbara', name: 'Santa Bárbara de Barinas' },
  SBD: { city: 'San Bernardino', name: 'San Bernardino International' },
  SBG: { city: 'Sabang', name: 'Maimun Saleh' },
  SBH: { city: 'Gustavia', name: 'Gustaf III' },
  SBK: { city: 'St.-brieuc Armor', name: 'Saint-Brieuc-Armor' },
  SBL: { city: 'Santa Ana', name: 'Santa Ana Del Yacuma' },
  SBM: { city: 'Sheboygan', name: 'Sheboygan County Memorial' },
  SBN: { city: 'South Bend', name: 'South Bend Regional' },
  SBP: { city: 'San Luis Obispo', name: 'San Luis County Regional' },
  SBR: { city: 'Saibai Island', name: 'Saibai Island' },
  SBS: { city: 'Steamboat Springs', name: 'Steamboat Springs Bob Adams Field' },
  SBT: { city: 'Sabetta', name: 'Sabetta International' },
  SBU: { city: 'Springbok', name: 'Springbok' },
  SBW: { city: 'Sibu', name: 'Sibu' },
  SBY: { city: 'Salisbury', name: 'Salisbury Ocean City Wicomico Regional' },
  SBZ: { city: 'Sibiu', name: 'Sibiu International' },
  SCC: { city: 'Deadhorse', name: 'Deadhorse' },
  SCE: { city: 'State College Pennsylvania', name: 'University Park' },
  SCF: { city: 'Scottsdale', name: 'Scottsdale' },
  SCH: { city: 'Scotia NY', name: 'Schenectady County' },
  SCI: { city: 'San Cristobal', name: 'Paramillo' },
  SCK: { city: 'Stockton', name: 'Stockton Metropolitan' },
  SCL: { city: 'Santiago', name: 'Comodoro Arturo Merino Benítez International' },
  SCM: { city: 'Scammon Bay', name: 'Scammon Bay' },
  SCN: { city: 'Saarbruecken', name: 'Saarbrücken' },
  SCO: { city: 'Aktau', name: 'Aktau' },
  SCQ: { city: 'Santiago', name: 'Santiago de Compostela' },
  SCS: { city: 'Scatsta', name: 'Scatsta' },
  SCT: { city: 'Socotra', name: 'Socotra International' },
  SCU: { city: 'Santiago De Cuba', name: 'Antonio Maceo International' },
  SCV: { city: 'Suceava', name: 'Suceava Stefan cel Mare' },
  SCW: { city: 'Syktyvkar', name: 'Syktyvkar' },
  SCY: { city: 'San Cristóbal', name: 'San Cristóbal' },
  SCZ: { city: 'Santa Cruz/Graciosa Bay/Luova', name: 'Santa Cruz/Graciosa Bay/Luova' },
  SDB: { city: 'Langebaanweg', name: 'Langebaanweg' },
  SDD: { city: 'Lubango', name: 'Lubango' },
  SDE: { city: 'Santiago Del Estero', name: 'Vicecomodoro Angel D. La Paz Aragonés' },
  SDF: { city: 'Louisville', name: 'Louisville International Standiford Field' },
  SDG: { city: 'Sanandaj', name: 'Sanandaj' },
  SDJ: { city: 'Sendai', name: 'Sendai' },
  SDK: { city: 'Sandakan', name: 'Sandakan' },
  SDL: { city: 'Sundsvall', name: 'Sundsvall-Härnösand' },
  SDM: { city: 'San Diego', name: 'Brown Field Municipal' },
  SDN: { city: 'Sandane', name: 'Sandane Airport (Anda)' },
  SDP: { city: 'Sand Point', name: 'Sand Point' },
  SDQ: { city: 'Santo Domingo', name: 'Las Américas International' },
  SDR: { city: 'Santander', name: 'Santander' },
  SDS: { city: 'Sado', name: 'Sado' },
  SDT: { city: 'Saidu Sharif', name: 'Saidu Sharif' },
  SDU: { city: 'Rio De Janeiro', name: 'Santos Dumont' },
  SDV: { city: 'Tel-aviv', name: 'Sde Dov' },
  SDX: { city: 'Sedona', name: 'Sedona' },
  SDY: { city: 'Sidney', name: 'Sidney - Richland Regional' },
  SEA: { city: 'Seattle', name: 'Seattle Tacoma International' },
  SEB: { city: 'Sebha', name: 'Sabha' },
  SEE: { city: 'El Cajon', name: 'Gillespie Field' },
  SEF: { city: 'Sebring', name: 'Sebring Regional' },
  SEH: { city: 'Senggeh-Papua Island', name: 'Senggeh' },
  SEK: { city: 'Srednekolymsk', name: 'Srednekolymsk' },
  SEM: { city: 'Selma', name: 'Craig Field' },
  SEN: { city: 'Southend', name: 'Southend' },
  SEP: { city: 'Stephenville', name: 'Stephenville Clark Regional' },
  SEU: { city: 'Seronera', name: 'Seronera' },
  SEY: { city: 'Selibabi', name: 'Sélibaby' },
  SEZ: { city: 'Mahe', name: 'Seychelles International' },
  SFA: { city: 'Sfax', name: 'Sfax Thyna International' },
  SFB: { city: 'Sanford', name: 'Orlando Sanford International' },
  SFC: { city: 'St-François', name: 'St-François' },
  SFD: { city: 'San Fernando De Apure', name: 'San Fernando De Apure' },
  SFE: { city: 'San Fernando', name: 'San Fernando' },
  SFF: { city: 'Spokane', name: 'Felts Field' },
  SFG: { city: 'St. Martin', name: 'LEspérance' },
  SFH: { city: 'San Filipe', name: 'San Felipe International' },
  SFJ: { city: 'Sondrestrom', name: 'Kangerlussuaq' },
  SFK: { city: 'Soure', name: 'Soure' },
  SFL: { city: 'Sao Filipe, Fogo Island', name: 'São Filipe' },
  SFN: { city: 'Santa Fe', name: 'Sauce Viejo' },
  SFO: { city: 'San Francisco', name: 'San Francisco International' },
  SFQ: { city: 'Sanliurfa', name: 'Şanlıurfa' },
  SFS: { city: 'Olongapo City', name: 'Subic Bay International' },
  SFT: { city: 'Skelleftea', name: 'Skellefteå' },
  SFZ: { city: 'Smithfield', name: 'North Central State' },
  SGC: { city: 'Surgut', name: 'Surgut' },
  SGD: { city: 'Soenderborg', name: 'Sønderborg' },
  SGE: { city: 'Siegerland', name: 'Siegerland' },
  SGF: { city: 'Springfield', name: 'Springfield Branson National' },
  SGH: { city: 'Springfield', name: 'Springfield-Beckley Municipal' },
  SGI: { city: 'Sargodha', name: 'Mushaf Air Base' },
  SGN: { city: 'Ho Chi Minh City', name: 'Tan Son Nhat International' },
  SGO: { city: 'St George', name: 'St George' },
  SGQ: { city: 'Sanggata', name: 'Sanggata/Sangkimah' },
  SGR: { city: 'Sugar Land', name: 'Sugar Land Regional' },
  SGU: { city: 'Saint George', name: 'St George Municipal' },
  SGV: { city: 'Sierra Grande', name: 'Sierra Grande' },
  SGX: { city: 'Songea', name: 'Songea' },
  SGY: { city: 'Skagway', name: 'Skagway' },
  SGZ: { city: 'Songkhla', name: 'Songkhla' },
  SHA: { city: 'Shanghai', name: 'Shanghai Hongqiao International' },
  SHB: { city: 'Nakashibetsu', name: 'Nakashibetsu' },
  SHD: { city: 'Weyers Cave', name: 'Shenandoah Valley Regional' },
  SHE: { city: 'Shenyang', name: 'Taoxian' },
  SHG: { city: 'Shungnak', name: 'Shungnak' },
  SHH: { city: 'Shishmaref', name: 'Shishmaref' },
  SHI: { city: 'Shimojishima', name: 'Shimojishima' },
  SHJ: { city: 'Sharjah', name: 'Sharjah International' },
  SHL: { city: 'Shillong', name: 'Shillong' },
  SHM: { city: 'Nanki-shirahama', name: 'Nanki Shirahama' },
  SHN: { city: 'Shelton', name: 'Sanderson Field' },
  SHO: { city: 'Manzini', name: 'King Mswati III International' },
  SHP: { city: 'Qinhuangdao', name: 'Shanhaiguan' },
  SHR: { city: 'Sheridan', name: 'Sheridan County' },
  SHT: { city: 'Shepparton', name: 'Shepparton' },
  SHV: { city: 'Shreveport', name: 'Shreveport Regional' },
  SHW: { city: 'Sharurah', name: 'Sharurah' },
  SHX: { city: 'Shageluk', name: 'Shageluk' },
  SHY: { city: 'Shinyanga', name: 'Shinyanga' },
  SIA: { city: 'XiAN', name: 'Xian Xiguan' },
  SID: { city: 'Amilcar Cabral', name: 'Amílcar Cabral International' },
  SIF: { city: 'Simara', name: 'Simara' },
  SIG: { city: 'San Juan', name: 'Fernando Luis Ribas Dominicci' },
  SIJ: { city: 'Siglufjordur', name: 'Siglufjörður' },
  SIK: { city: 'Sikeston', name: 'Sikeston Memorial Municipal' },
  SIN: { city: 'Singapore', name: 'Singapore Changi' },
  SIP: { city: 'Simferopol', name: 'Simferopol International' },
  SIQ: { city: 'Singkep', name: 'Dabo' },
  SIR: { city: 'Sion', name: 'Sion' },
  SIS: { city: 'Sishen', name: 'Sishen' },
  SIT: { city: 'Sitka', name: 'Sitka Rocky Gutierrez' },
  SIU: { city: 'Siuna', name: 'Siuna' },
  SJC: { city: 'San Jose', name: 'Norman Y. Mineta San Jose International' },
  SJD: { city: 'San Jose Del Cabo', name: 'Los Cabos International' },
  SJE: { city: 'San Jose Del Guaviare', name: 'Jorge E. Gonzalez Torres' },
  SJI: { city: 'San Jose', name: 'San Jose' },
  SJJ: { city: 'Sarajevo', name: 'Sarajevo International' },
  SJK: { city: 'Sao Jose Dos Campos', name: 'Professor Urbano Ernesto Stumpf' },
  SJL: { city: 'Sao Gabriel', name: 'São Gabriel da Cachoeira' },
  SJO: { city: 'San Jose', name: 'Juan Santamaria International' },
  SJP: { city: 'Sao Jose Do Rio Preto', name: 'Prof. Eribelto Manoel Reino State' },
  SJT: { city: 'San Angelo', name: 'San Angelo Regional Mathis Field' },
  SJU: { city: 'San Juan', name: 'Luis Munoz Marin International' },
  SJW: { city: 'Shijiazhuang', name: 'Shijiazhuang Daguocun International' },
  SJY: { city: 'Seinäjoki / Ilmajoki', name: 'Seinäjoki' },
  SJZ: { city: 'Sao Jorge Island', name: 'São Jorge' },
  SKA: { city: 'Spokane', name: 'Fairchild Air Force Base' },
  SKB: { city: 'Basse Terre', name: 'Robert L. Bradshaw International' },
  SKD: { city: 'Samarkand', name: 'Samarkand' },
  SKE: { city: 'Skien', name: 'Skien' },
  SKF: { city: 'San Antonio', name: 'Lackland Air Force Base' },
  SKG: { city: 'Thessaloniki', name: 'Thessaloniki Macedonia International' },
  SKH: { city: 'Surkhet', name: 'Surkhet' },
  SKK: { city: 'Shaktoolik', name: 'Shaktoolik' },
  SKN: { city: 'Stokmarknes', name: 'Stokmarknes Skagen' },
  SKO: { city: 'Sokoto', name: 'Sadiq Abubakar III International' },
  SKP: { city: 'Skopje', name: 'Skopje Alexander the Great' },
  SKS: { city: 'Skrydstrup', name: 'Skrydstrup Air Base' },
  SKT: { city: 'Sialkot', name: 'Sialkot' },
  SKU: { city: 'Skiros', name: 'Skiros' },
  SKV: { city: 'St. Catherine', name: 'St Catherine International' },
  SKX: { city: 'Saransk', name: 'Saransk' },
  SKY: { city: 'Sandusky', name: 'Griffing Sandusky' },
  SKZ: { city: 'Sukkur', name: 'Sukkur' },
  SLA: { city: 'Salta', name: 'Martin Miguel De Guemes International' },
  SLC: { city: 'Salt Lake City', name: 'Salt Lake City International' },
  SLD: { city: 'Sliac', name: 'Sliač' },
  SLE: { city: 'Salem', name: 'Salem Municipal Airport/McNary Field' },
  SLF: { city: 'Sulayel', name: 'Sulayel' },
  SLH: { city: 'Sola', name: 'Sola' },
  SLJ: { city: 'Solomon', name: 'Solomon' },
  SLK: { city: 'Saranac Lake', name: 'Adirondack Regional' },
  SLL: { city: 'Salalah', name: 'Salalah' },
  SLM: { city: 'Salamanca', name: 'Salamanca' },
  SLN: { city: 'Salina', name: 'Salina Municipal' },
  SLP: { city: 'San Luis Potosi', name: 'Ponciano Arriaga International' },
  SLQ: { city: 'Sleetmute', name: 'Sleetmute' },
  SLU: { city: 'Castries', name: 'George F. L. Charles' },
  SLV: { city: 'Shimla', name: 'Shimla' },
  SLW: { city: 'Saltillo', name: 'Plan De Guadalupe International' },
  SLX: { city: 'Salt Cay', name: 'Salt Cay' },
  SLY: { city: 'Salekhard', name: 'Salekhard' },
  SLZ: { city: 'Sao Luis', name: 'Marechal Cunha Machado International' },
  SMA: { city: 'Santa Maria (island)', name: 'Santa Maria' },
  SMD: { city: 'Fort Wayne IN', name: 'Smith Field' },
  SME: { city: 'Somerset', name: 'Lake Cumberland Regional' },
  SMF: { city: 'Sacramento', name: 'Sacramento International' },
  SMI: { city: 'Samos', name: 'Samos' },
  SMK: { city: 'St. Michael', name: 'St Michael' },
  SML: { city: 'Stella Maris', name: 'Stella Maris' },
  SMN: { city: 'Salmon', name: 'Lemhi County' },
  SMO: { city: 'Santa Monica', name: 'Santa Monica Municipal' },
  SMQ: { city: 'Sampit-Borneo Island', name: 'Sampit(Hasan)' },
  SMR: { city: 'Santa Marta', name: 'Simón Bolívar International' },
  SMS: { city: 'Sainte Marie', name: 'Sainte Marie' },
  SMT: { city: 'Sorriso', name: 'Adolino Bedin Regional' },
  SMV: { city: 'Samedan', name: 'Samedan' },
  SMW: { city: 'Smara', name: 'Smara' },
  SMX: { city: 'Santa Maria', name: 'Santa Maria Pub/Capt G Allan Hancock Field' },
  SMZ: { city: 'Stoelmans Eiland', name: 'Stoelmanseiland' },
  SNA: { city: 'Santa Ana', name: 'John Wayne Airport-Orange County' },
  SNC: { city: 'Salinas', name: 'General Ulpiano Paez' },
  SNE: { city: 'Sao Nocolau Island', name: 'Preguiça' },
  SNF: { city: 'San Felipe', name: 'Sub Teniente Nestor Arias' },
  SNJ: { city: 'Pinar Del Rio', name: 'San Julian Air Base' },
  SNN: { city: 'Shannon', name: 'Shannon' },
  SNO: { city: 'Sakon Nakhon', name: 'Sakon Nakhon' },
  SNP: { city: 'St. Paul Island', name: 'St Paul Island' },
  SNR: { city: 'St.-nazaire', name: 'Saint-Nazaire-Montoir' },
  SNS: { city: 'Salinas', name: 'Salinas Municipal' },
  SNU: { city: 'Santa Clara', name: 'Abel Santamaria' },
  SNV: { city: 'Santa Ana De Uairen', name: 'Santa Elena de Uairen' },
  SNW: { city: 'Thandwe', name: 'Thandwe' },
  SNY: { city: 'Sidney', name: 'Sidney Municipal-Lloyd W Carr Field' },
  SNZ: { city: 'Rio De Janeiro', name: 'Santa Cruz Air Force Base' },
  SOB: { city: 'Sármellék', name: 'Sármellék International' },
  SOC: { city: 'Solo City', name: 'Adi Sumarmo Wiryokusumo' },
  SOD: { city: 'Sorocaba', name: 'Sorocaba' },
  SOF: { city: 'Sofia', name: 'Sofia' },
  SOG: { city: 'Sogndal', name: 'Sogndal' },
  SOJ: { city: 'Sorkjosen', name: 'Sørkjosen' },
  SOM: { city: 'San Tome', name: 'San Tomé' },
  SON: { city: 'Santo', name: 'Santo Pekoa International' },
  SOO: { city: 'Soderhamn', name: 'Söderhamn' },
  SOP: { city: 'Pinehurst-Southern Pines', name: 'Moore County' },
  SOQ: { city: 'Sorong', name: 'Dominique Edward Osok' },
  SOT: { city: 'Sodankyla', name: 'Sodankyla' },
  SOU: { city: 'Southampton', name: 'Southampton' },
  SOV: { city: 'Seldovia', name: 'Seldovia' },
  SOW: { city: 'Show Low', name: 'Show Low Regional' },
  SOY: { city: 'Stronsay', name: 'Stronsay' },
  SOZ: { city: 'Solenzara', name: 'Solenzara (BA 126) Air Base' },
  SPA: { city: 'Spartangurg', name: 'Spartanburg Downtown Memorial' },
  SPB: { city: 'Charlotte Amalie', name: 'Charlotte Amalie Harbor Seaplane Base' },
  SPC: { city: 'Santa Cruz De La Palma', name: 'La Palma' },
  SPD: { city: 'Saidpur', name: 'Saidpur' },
  SPF: { city: 'Spearfish-South Dakota', name: 'Black Hills Airport-Clyde Ice Field' },
  SPG: { city: 'St. Petersburg', name: 'Albert Whitted' },
  SPI: { city: 'Springfield', name: 'Abraham Lincoln Capital' },
  SPJ: { city: 'Sparti', name: 'Sparti' },
  SPM: { city: 'Spangdahlem', name: 'Spangdahlem Air Base' },
  SPN: { city: 'Saipan', name: 'Saipan International' },
  SPP: { city: 'Menongue', name: 'Menongue' },
  SPR: { city: 'San Pedro', name: 'San Pedro' },
  SPS: { city: 'Wichita Falls', name: 'Sheppard Air Force Base-Wichita Falls Municipal' },
  SPU: { city: 'Split', name: 'Split' },
  SPW: { city: 'Spencer', name: 'Spencer Municipal' },
  SPY: { city: 'San Pedro', name: 'San Pedro' },
  SQA: { city: 'Santa Ynez', name: 'Santa Ynez' },
  SQD: { city: 'Shangrao', name: 'Shangrao Sanqingshan' },
  SQG: { city: 'Sintang-Borneo Island', name: 'Sintang(Susilo)' },
  SQH: { city: 'Son-La', name: 'Na-San' },
  SQJ: { city: 'Sanming', name: 'Shaxian' },
  SQL: { city: 'San Carlos', name: 'San Carlos' },
  SQN: { city: 'Sanana', name: 'Emalamo Sanana' },
  SQO: { city: 'Mohed', name: 'Storuman' },
  SQQ: { city: 'Siauliai', name: 'Šiauliai International' },
  SQR: { city: 'Soroako', name: 'Soroako' },
  SQW: { city: 'Skive', name: 'Skive' },
  SQX: { city: 'Sao Miguel do Oeste', name: 'São Miguel do Oeste' },
  SQZ: { city: 'Scampton', name: 'RAF Scampton' },
  SRA: { city: 'Santa Rosa', name: 'Santa Rosa' },
  SRE: { city: 'Sucre', name: 'Juana Azurduy De Padilla' },
  SRG: { city: 'Semarang', name: 'Achmad Yani' },
  SRH: { city: 'Sarh', name: 'Sarh' },
  SRI: { city: 'Samarinda', name: 'Temindung' },
  SRJ: { city: 'San Borja', name: 'Capitán Av. German Quiroga G.' },
  SRN: { city: 'Strahan', name: 'Strahan' },
  SRP: { city: 'Stord', name: 'Stord' },
  SRQ: { city: 'Sarasota', name: 'Sarasota Bradenton International' },
  SRT: { city: 'Soroti', name: 'Soroti' },
  SRX: { city: 'Sirt', name: 'Gardabya' },
  SRY: { city: 'Dasht-e-naz', name: 'Dasht-e Naz' },
  SRZ: { city: 'Santa Cruz', name: 'El Trompillo' },
  SSA: { city: 'Salvador', name: 'Deputado Luiz Eduardo Magalhães International' },
  SSC: { city: 'Sumter', name: 'Shaw Air Force Base' },
  SSE: { city: 'Sholapur', name: 'Solapur' },
  SSF: { city: 'Stinson', name: 'Stinson Municipal' },
  SSG: { city: 'Malabo', name: 'Malabo' },
  SSH: { city: 'Sharm El Sheikh', name: 'Sharm El Sheikh International' },
  SSI: { city: 'Brunswick', name: 'Malcolm McKinnon' },
  SSJ: { city: 'Sandnessjoen', name: 'Sandnessjøen Airport (Stokka)' },
  SSN: { city: 'Seoul East', name: 'Seoul Air Base (K-16)' },
  SSR: { city: 'Pentecost Island', name: 'Sara' },
  SST: { city: 'Santa Teresita', name: 'Santa Teresita' },
  SSY: { city: 'Mbanza-congo', name: 'Mbanza Congo' },
  SSZ: { city: 'Santos', name: 'Base Aérea de Santos' },
  STA: { city: 'Stauning', name: 'Stauning' },
  STB: { city: 'Santa Barbara', name: 'Santa Bárbara del Zulia' },
  STC: { city: 'Saint Cloud', name: 'St Cloud Regional' },
  STD: { city: 'Santo Domingo', name: 'Mayor Buenaventura Vivas International' },
  STE: { city: 'Stevens Point', name: 'Stevens Point Municipal' },
  STG: { city: 'Point Barrow', name: 'St George' },
  STI: { city: 'Santiago', name: 'Cibao International' },
  STJ: { city: 'Rosecrans', name: 'Rosecrans Memorial' },
  STK: { city: 'Sterling', name: 'Sterling Municipal' },
  STL: { city: 'St. Louis', name: 'St Louis Lambert International' },
  STM: { city: 'Santarem', name: 'Maestro Wilson Fonseca' },
  STN: { city: 'London', name: 'London Stansted' },
  STP: { city: 'St. Paul', name: 'St Paul Downtown Holman Field' },
  STR: { city: 'Stuttgart', name: 'Stuttgart' },
  STS: { city: 'Santa Rosa', name: 'Charles M. Schulz Sonoma County' },
  STT: { city: 'St. Thomas', name: 'Cyril E. King' },
  STV: { city: 'Surat', name: 'Surat' },
  STW: { city: 'Stavropol', name: 'Stavropol Shpakovskoye' },
  STX: { city: 'St. Croix Island', name: 'Henry E Rohlsen' },
  STY: { city: 'Salto', name: 'Nueva Hesperides International' },
  STZ: { city: 'Santa Terezinha', name: 'Santa Terezinha' },
  SUA: { city: 'Stuart', name: 'Witham Field' },
  SUB: { city: 'Surabaya', name: 'Juanda International' },
  SUF: { city: 'Lamezia', name: 'Lamezia Terme' },
  SUG: { city: 'Sangley Point', name: 'Surigao' },
  SUI: { city: 'Sukhumi', name: 'Sukhumi Dranda' },
  SUJ: { city: 'Satu Mare', name: 'Satu Mare' },
  SUK: { city: 'Batagay-Alyta', name: 'Sakkyryr' },
  SUL: { city: 'Sui', name: 'Sui' },
  SUN: { city: 'Hailey', name: 'Friedman Memorial' },
  SUP: { city: 'Sumenep', name: 'Trunojoyo' },
  SUR: { city: 'Summer Beaver', name: 'Summer Beaver' },
  SUS: { city: 'Null', name: 'Spirit of St Louis' },
  SUU: { city: 'Fairfield', name: 'Travis Air Force Base' },
  SUV: { city: 'Nausori', name: 'Nausori International' },
  SUX: { city: 'Sioux City', name: 'Sioux Gateway Col. Bud Day Field' },
  SUY: { city: 'Suntar', name: 'Suntar' },
  SVA: { city: 'Savoonga', name: 'Savoonga' },
  SVB: { city: 'Sambava', name: 'Sambava' },
  SVD: { city: 'Kingstown', name: 'Argyle International' },
  SVG: { city: 'Stavanger', name: 'Stavanger Airport Sola' },
  SVH: { city: 'Statesville', name: 'Statesville Regional' },
  SVI: { city: 'San Vincente De Caguan', name: 'Eduardo Falla Solano' },
  SVJ: { city: 'Svolvær', name: 'Svolvær Helle' },
  SVL: { city: 'Savonlinna', name: 'Savonlinna' },
  SVN: { city: 'Hunter Aaf', name: 'Hunter Army Air Field' },
  SVO: { city: 'Moscow', name: 'Sheremetyevo International' },
  SVP: { city: 'Kuito', name: 'Kuito' },
  SVQ: { city: 'Sevilla', name: 'Sevilla' },
  SVU: { city: 'Savusavu', name: 'Savusavu' },
  SVW: { city: 'Sparrevohn', name: 'Sparrevohn LRRS' },
  SVX: { city: 'Yekaterinburg', name: 'Koltsovo' },
  SVZ: { city: 'San Antonio', name: 'San Antonio Del Tachira' },
  SWA: { city: 'Shantou', name: 'Jieyang Chaoshan International' },
  SWD: { city: 'Seward', name: 'Seward' },
  SWF: { city: 'Newburgh', name: 'Stewart International' },
  SWH: { city: 'Swan Hill', name: 'Swan Hill' },
  SWJ: { city: 'Malekula Island', name: 'Southwest Bay' },
  SWO: { city: 'Stillwater', name: 'Stillwater Regional' },
  SWP: { city: 'Swakopmund', name: 'Swakopmund' },
  SWQ: { city: 'Sumbawa Island', name: 'Sumbawa Besar' },
  SWS: { city: 'Swansea', name: 'Swansea' },
  SWT: { city: 'Strezhevoy', name: 'Strezhevoy' },
  SWU: { city: 'Suwon', name: 'Suwon' },
  SWX: { city: 'Shakawe', name: 'Shakawe' },
  SXB: { city: 'Strasbourg', name: 'Strasbourg' },
  SXE: { city: 'Sale', name: 'West Sale' },
  SXF: { city: 'Berlin', name: 'Berlin-Schönefeld' },
  SXI: { city: 'Siri Island', name: 'Sirri Island' },
  SXJ: { city: 'Shanshan', name: 'Shanshan' },
  SXK: { city: 'Saumlaki', name: 'Saumlaki/Olilit' },
  SXL: { city: 'Sligo', name: 'Sligo' },
  SXM: { city: 'Philipsburg', name: 'Princess Juliana International' },
  SXN: { city: 'Sowa', name: 'Sua Pan' },
  SXO: { city: 'Sao Felix do Araguaia', name: 'São Félix do Araguaia' },
  SXQ: { city: 'Soldotna', name: 'Soldotna' },
  SXR: { city: 'Srinagar', name: 'Sheikh ul Alam' },
  SXV: { city: 'Salem', name: 'Salem' },
  SXX: { city: 'Sao Felix do Xingu', name: 'São Félix do Xingu' },
  SXZ: { city: 'Siirt', name: 'Siirt' },
  SYA: { city: 'Shemya', name: 'Eareckson Air Station' },
  SYD: { city: 'Sydney', name: 'Sydney Kingsford Smith International' },
  SYH: { city: 'Syangboche', name: 'Syangboche' },
  SYJ: { city: 'Sirjan', name: 'Sirjan' },
  SYM: { city: 'Simao', name: 'Puer Simao' },
  SYO: { city: 'Shonai', name: 'Shonai' },
  SYP: { city: 'Santiago', name: 'Ruben Cantu' },
  SYQ: { city: 'San Jose', name: 'Tobias Bolanos International' },
  SYR: { city: 'Syracuse', name: 'Syracuse Hancock International' },
  SYS: { city: 'Saskylakh', name: 'Saskylakh' },
  SYT: { city: 'St.-yan', name: 'Saint-Yan' },
  SYU: { city: 'Sue Islet', name: 'Warraber Island' },
  SYW: { city: 'Sehwan Sharif', name: 'Sehwan Sharif' },
  SYX: { city: 'Sanya', name: 'Sanya Phoenix International' },
  SYY: { city: 'Stornoway', name: 'Stornoway' },
  SYZ: { city: 'Shiraz', name: 'Shiraz Shahid Dastghaib International' },
  SZA: { city: 'Soyo', name: 'Soyo' },
  SZB: { city: 'Kuala Lumpur', name: 'Sultan Abdul Aziz Shah International' },
  SZF: { city: 'Samsun', name: 'Samsun Çarşamba' },
  SZG: { city: 'Salzburg', name: 'Salzburg' },
  SZJ: { city: 'Siguanea', name: 'Siguanea' },
  SZK: { city: 'Skukuza', name: 'Skukuza' },
  SZL: { city: 'Knobnoster', name: 'Whiteman Air Force Base' },
  SZR: { city: 'Stara Zagora', name: 'Stara Zagora' },
  SZS: { city: 'Stewart Island', name: 'Ryans Creek Aerodrome' },
  SZT: { city: 'San Cristobal de las Casas', name: 'San Cristobal de las Casas' },
  SZV: { city: 'Suzhou', name: 'Suzhou Guangfu' },
  SZW: { city: 'Parchim', name: 'Schwerin Parchim' },
  SZX: { city: 'Shenzhen', name: 'Shenzhen Baoan International' },
  SZY: { city: 'Szczytno-Szymany', name: 'Olsztyn-Mazury' },
  SZZ: { city: 'Szczecin', name: 'Szczecin-Goleniów Solidarność' },
  TAB: { city: 'Scarborough', name: 'Tobago-Crown Point' },
  TAC: { city: 'Tacloban', name: 'Daniel Z. Romualdez' },
  TAE: { city: 'Taegu', name: 'Daegu' },
  TAF: { city: 'Oran', name: 'Tafaraoui' },
  TAG: { city: 'Tagbilaran', name: 'Tagbilaran' },
  TAH: { city: 'Tanna', name: 'Tanna' },
  TAI: { city: 'Taiz', name: 'Taizz International' },
  TAK: { city: 'Takamatsu', name: 'Takamatsu' },
  TAM: { city: 'Tampico', name: 'General Francisco Javier Mina International' },
  TAO: { city: 'Qingdao', name: 'Liuting' },
  TAP: { city: 'Tapachula', name: 'Tapachula International' },
  TAR: { city: 'Grottaglie', name: 'Taranto-Grottaglie Marcello Arlotta' },
  TAS: { city: 'Tashkent', name: 'Tashkent International' },
  TAT: { city: 'Poprad', name: 'Poprad-Tatry' },
  TAY: { city: 'Tartu', name: 'Tartu' },
  TAZ: { city: 'Dasoguz', name: 'Daşoguz' },
  TBB: { city: 'Tuy Hoa', name: 'Dong Tac' },
  TBF: { city: 'Tabiteuea North', name: 'Tabiteuea North' },
  TBG: { city: 'Tabubil', name: 'Tabubil' },
  TBH: { city: 'Romblon', name: 'Tugdan' },
  TBI: { city: 'Cat Island', name: 'New Bight' },
  TBJ: { city: 'Tabarka', name: 'Tabarka 7 Novembre' },
  TBN: { city: 'Fort Leonardwood', name: 'Waynesville-St. Robert Regional Forney field' },
  TBO: { city: 'Tabora', name: 'Tabora' },
  TBP: { city: 'Tumbes', name: 'Capitan FAP Pedro Canga Rodriguez' },
  TBR: { city: 'Statesboro', name: 'Statesboro Bulloch County' },
  TBS: { city: 'Tbilisi', name: 'Tbilisi International' },
  TBT: { city: 'Tabatinga', name: 'Tabatinga' },
  TBU: { city: 'Tongatapu', name: 'Fuaamotu International' },
  TBW: { city: 'Tambow', name: 'Donskoye' },
  TBZ: { city: 'Tabriz', name: 'Tabriz International' },
  TCA: { city: 'Tennant Creek', name: 'Tennant Creek' },
  TCB: { city: 'Treasure Cay', name: 'Treasure Cay' },
  TCC: { city: 'Tucumcari', name: 'Tucumcari Municipal' },
  TCE: { city: 'Tulcea', name: 'Tulcea' },
  TCG: { city: 'Tacheng', name: 'Tacheng' },
  TCH: { city: 'Tchibanga', name: 'Tchibanga' },
  TCL: { city: 'Tuscaloosa AL', name: 'Tuscaloosa Regional' },
  TCM: { city: 'Tacoma', name: 'McChord Air Force Base' },
  TCN: { city: 'Tehuacan', name: 'Tehuacan' },
  TCO: { city: 'Tumaco', name: 'La Florida' },
  TCP: { city: 'Taba', name: 'Taba International' },
  TCQ: { city: 'Tacna', name: 'Coronel FAP Carlos Ciriani Santa Rosa International' },
  TCS: { city: 'Truth Or Consequences', name: 'Truth Or Consequences Municipal' },
  TCX: { city: 'Tabas', name: 'Tabas' },
  TCZ: { city: 'Tengchong', name: 'Tengchong Tuofeng' },
  TDD: { city: 'Trinidad', name: 'Teniente Av. Jorge Henrich Arauz' },
  TDG: { city: 'Tandag', name: 'Tandag' },
  TDJ: { city: 'Tadjoura', name: 'Tadjoura' },
  TDL: { city: 'Tandil', name: 'Héroes De Malvinas' },
  TDR: { city: 'Theodore', name: 'Theodore' },
  TDS: { city: 'Sasereme', name: 'Sasereme' },
  TDX: { city: 'Trat', name: 'Trat' },
  TEA: { city: 'Tela', name: 'Tela' },
  TEB: { city: 'Teterboro', name: 'Teterboro' },
  TEC: { city: 'Telemaco Borba', name: 'Telêmaco Borba' },
  TED: { city: 'Thisted', name: 'Thisted' },
  TEE: { city: 'Tebessa', name: 'Cheikh Larbi Tébessi' },
  TEF: { city: 'Telfer', name: 'Telfer' },
  TEI: { city: 'Tezu', name: 'Tezu' },
  TEM: { city: 'Temora', name: 'Temora' },
  TEN: { city: 'Tongren', name: 'Tongren Fenghuang' },
  TEQ: { city: 'Çorlu', name: 'Tekirdağ Çorlu' },
  TER: { city: 'Lajes (terceira Island)', name: 'Lajes' },
  TET: { city: 'Tete', name: 'Chingozi' },
  TEU: { city: 'Manapouri', name: 'Manapouri' },
  TEV: { city: 'Teruel', name: 'Teruel' },
  TEX: { city: 'Telluride', name: 'Telluride Regional' },
  TEZ: { city: 'Tezpur', name: 'Tezpur' },
  TFF: { city: 'Tefe', name: 'Tefé' },
  TFL: { city: 'Teofilo Otoni', name: 'Juscelino Kubitscheck' },
  TFN: { city: 'Tenerife', name: 'Tenerife Norte' },
  TFS: { city: 'Tenerife', name: 'Tenerife South' },
  TGA: { city: 'Tengah', name: 'Tengah Air Base' },
  TGD: { city: 'Podgorica', name: 'Podgorica' },
  TGG: { city: 'Kuala Terengganu', name: 'Sultan Mahmud' },
  TGH: { city: 'Tongoa Island', name: 'Tongoa' },
  TGI: { city: 'Tingo Maria', name: 'Tingo Maria' },
  TGJ: { city: 'Tiga', name: 'Tiga' },
  TGK: { city: 'Taganrog', name: 'Taganrog Yuzhny' },
  TGM: { city: 'Tirgu Mures', name: 'Transilvania Târgu Mureş International' },
  TGN: { city: 'Morwell', name: 'Latrobe Valley' },
  TGO: { city: 'Tongliao', name: 'Tongliao' },
  TGP: { city: 'Bor', name: 'Podkamennaya Tunguska' },
  TGQ: { city: 'Tangara da Serra', name: 'Tangará da Serra' },
  TGR: { city: 'Touggourt', name: 'Touggourt Sidi Madhi' },
  TGT: { city: 'Tanga', name: 'Tanga' },
  TGU: { city: 'Tegucigalpa', name: 'Toncontín International' },
  TGZ: { city: 'Tuxtla Gutierrez', name: 'Angel Albino Corzo International' },
  THE: { city: 'Teresina', name: 'Senador Petrônio Portela' },
  THF: { city: 'Berlin', name: 'Berlin-Tempelhof International' },
  THG: { city: 'Biloela', name: 'Thangool' },
  THL: { city: 'Tachilek', name: 'Tachileik' },
  THN: { city: 'Trollhattan', name: 'Trollhättan-Vänersborg' },
  THO: { city: 'Thorshofn', name: 'Thorshofn' },
  THQ: { city: 'Tianshui', name: 'Tianshui Maijishan' },
  THR: { city: 'Teheran', name: 'Mehrabad International' },
  THS: { city: 'Sukhothai', name: 'Sukhothai' },
  THU: { city: 'Thule', name: 'Thule Air Base' },
  THX: { city: 'Turukhansk', name: 'Turukhansk' },
  THZ: { city: 'Tahoua', name: 'Tahoua' },
  TIA: { city: 'Tirana', name: 'Tirana International Airport Mother Teresa' },
  TID: { city: 'Tiaret', name: 'Bou Chekif' },
  TIE: { city: 'Tippi', name: 'Tippi' },
  TIF: { city: 'Taif', name: 'Ta’if Regional' },
  TIH: { city: 'Tikehau', name: 'Tikehau' },
  TII: { city: 'Tarin Kowt', name: 'Tarin Kowt' },
  TIJ: { city: 'Tijuana', name: 'General Abelardo L. Rodríguez International' },
  TIK: { city: 'Oklahoma City', name: 'Tinker Air Force Base' },
  TIM: { city: 'Timika', name: 'Moses Kilangin' },
  TIN: { city: 'Tindouf', name: 'Tindouf' },
  TIP: { city: 'Tripoli', name: 'Tripoli International' },
  TIQ: { city: 'West Tinian', name: 'Tinian International' },
  TIR: { city: 'Tirupeti', name: 'Tirupati' },
  TIU: { city: 'Timaru', name: 'Timaru' },
  TIV: { city: 'Tivat', name: 'Tivat' },
  TIW: { city: 'Tacoma', name: 'Tacoma Narrows' },
  TIX: { city: 'Titusville', name: 'Space Coast Regional' },
  TIY: { city: 'Tidjikja', name: 'Tidjikja' },
  TIZ: { city: 'Tari', name: 'Tari' },
  TJA: { city: 'Tarija', name: 'Capitan Oriel Lea Plaza' },
  TJB: { city: 'Tanjung Balai Karimun', name: 'Sei Bati' },
  TJG: { city: 'Tanjung-Borneo Island', name: 'Warukin' },
  TJH: { city: 'Toyooka', name: 'Tajima' },
  TJI: { city: 'Trujillo', name: 'Trujillo' },
  TJK: { city: 'Tokat', name: 'Tokat' },
  TJL: { city: 'Tres Lagoas', name: 'Plínio Alarcom' },
  TJM: { city: 'Tyumen', name: 'Roshchino International' },
  TJQ: { city: 'Tanjung Pandan', name: 'Buluh Tumbang (H A S Hanandjoeddin)' },
  TJS: { city: 'Tanjung Selor-Borneo Island', name: 'Tanjung Harapan' },
  TJU: { city: 'Kulyab', name: 'Kulob' },
  TJV: { city: 'Tanjore', name: 'Tanjore Air Force Base' },
  TKA: { city: 'Talkeetna', name: 'Talkeetna' },
  TKC: { city: 'Tiko', name: 'Tiko' },
  TKD: { city: 'Takoradi', name: 'Takoradi' },
  TKF: { city: 'Truckee', name: 'Truckee Tahoe' },
  TKG: { city: 'Bandar Lampung-Sumatra Island', name: 'Radin Inten II (Branti)' },
  TKH: { city: 'Nakhon Sawan', name: 'Takhli' },
  TKJ: { city: 'Tok', name: 'Tok Junction' },
  TKK: { city: 'Chuuk', name: 'Chuuk International' },
  TKN: { city: 'Tokunoshima', name: 'Tokunoshima' },
  TKP: { city: 'Takapoto', name: 'Takapoto' },
  TKQ: { city: 'Kigoma', name: 'Kigoma' },
  TKS: { city: 'Tokushima', name: 'Tokushima Airport/JMSDF Air Base' },
  TKT: { city: 'Tak', name: 'Tak' },
  TKU: { city: 'Turku', name: 'Turku' },
  TKV: { city: 'Tatakoto', name: 'Tatakoto' },
  TKX: { city: 'Takaroa', name: 'Takaroa' },
  TLA: { city: 'Teller', name: 'Teller' },
  TLC: { city: 'Toluca', name: 'Licenciado Adolfo Lopez Mateos International' },
  TLD: { city: 'Tuli Lodge', name: 'Limpopo Valley' },
  TLE: { city: 'Toliara', name: 'Toliara' },
  TLH: { city: 'Tallahassee', name: 'Tallahassee Regional' },
  TLI: { city: 'Toli-Toli', name: 'Sultan Bantilan' },
  TLJ: { city: 'Tatalina', name: 'Tatalina LRRS' },
  TLK: { city: 'Talakan', name: 'Talakan' },
  TLL: { city: 'Tallinn-ulemiste International', name: 'Lennart Meri Tallinn' },
  TLM: { city: 'Tlemcen', name: 'Zenata – Messali El Hadj' },
  TLN: { city: 'Hyeres', name: 'Toulon-Hyères' },
  TLQ: { city: 'Turpan', name: 'Turpan Jiaohe' },
  TLS: { city: 'Toulouse', name: 'Toulouse-Blagnac' },
  TLU: { city: 'Tolu', name: 'Golfo de Morrosquillo' },
  TLV: { city: 'Tel-aviv', name: 'Ben Gurion International' },
  TLX: { city: 'Talca', name: 'Panguilemo' },
  TMA: { city: 'Tifton', name: 'Henry Tift Myers' },
  TMB: { city: 'Kendall-tamiami', name: 'Kendall-Tamiami Executive' },
  TMC: { city: 'Waikabubak-Sumba Island', name: 'Tambolaka' },
  TME: { city: 'Tame', name: 'Gustavo Vargas' },
  TMF: { city: 'Thimarafushi', name: 'Thimarafushi' },
  TMG: { city: 'Tomanggong', name: 'Tomanggong' },
  TMH: { city: 'Boven Digoel', name: 'Tanah Merah' },
  TMI: { city: 'Tumling Tar', name: 'Tumling Tar' },
  TMJ: { city: 'Termez', name: 'Termez' },
  TML: { city: 'Tamale', name: 'Tamale' },
  TMM: { city: 'Toamasina', name: 'Toamasina' },
  TMN: { city: 'Tamana', name: 'Tamana Island' },
  TMO: { city: 'Tumeremo', name: 'Tumeremo' },
  TMP: { city: 'Tampere', name: 'Tampere-Pirkkala' },
  TMR: { city: 'Tamanrasset', name: 'Aguenar – Hadj Bey Akhamok' },
  TMS: { city: 'Sao Tome', name: 'São Tomé International' },
  TMT: { city: 'Oriximina', name: 'Trombetas' },
  TMU: { city: 'Nicoya', name: 'Tambor' },
  TMW: { city: 'Tamworth', name: 'Tamworth' },
  TMX: { city: 'Timimoun', name: 'Timimoun' },
  TNA: { city: 'Jinan', name: 'Yaoqiang' },
  TNC: { city: 'Tin City', name: 'Tin City Long Range Radar Station' },
  TND: { city: 'Trinidad', name: 'Alberto Delgado' },
  TNE: { city: 'Tanegashima', name: 'New Tanegashima' },
  TNF: { city: 'Toussous-le-noble', name: 'Toussus-le-Noble' },
  TNG: { city: 'Tanger', name: 'Ibn Batouta' },
  TNH: { city: 'Tonghua', name: 'Tonghua Sanyuanpu' },
  TNI: { city: 'Satna', name: 'Satna' },
  TNJ: { city: 'Tanjung Pinang', name: 'Raja Haji Fisabilillah International' },
  TNM: { city: 'Isla Rey Jorge', name: 'Teniente Rodolfo Marsh Martin Base' },
  TNN: { city: 'Tainan', name: 'Tainan' },
  TNR: { city: 'Antananarivo', name: 'Ivato' },
  TNT: { city: 'Miami', name: 'Dade Collier Training and Transition' },
  TNW: { city: 'Tena', name: 'Jumandy' },
  TNX: { city: 'Stung Treng', name: 'Stung Treng' },
  TOA: { city: 'Torrance', name: 'Zamperini Field' },
  TOB: { city: 'Tobruk', name: 'Gamal Abdel Nasser' },
  TOC: { city: 'Toccoa', name: 'Toccoa Airport - R.G. Letourneau Field' },
  TOD: { city: 'Tioman', name: 'Pulau Tioman' },
  TOE: { city: 'Tozeur', name: 'Tozeur Nefta International' },
  TOF: { city: 'Tomsk', name: 'Bogashevo' },
  TOG: { city: 'Togiak Village', name: 'Togiak' },
  TOH: { city: 'Loh/Linua', name: 'Torres Airstrip' },
  TOI: { city: 'Troy', name: 'Troy Municipal Airport at N Kenneth Campbell Field' },
  TOJ: { city: 'Madrid', name: 'Torrejón' },
  TOL: { city: 'Toledo', name: 'Toledo Express' },
  TOM: { city: 'Tombouctou', name: 'Timbuktu' },
  TOO: { city: 'San Vito De Jaba', name: 'San Vito De Java' },
  TOP: { city: 'Topeka', name: 'Philip Billard Municipal' },
  TOQ: { city: 'Tocopilla', name: 'Barriles' },
  TOS: { city: 'Tromso', name: 'Tromsø Airport,' },
  TOT: { city: 'Totness', name: 'Totness' },
  TOU: { city: 'Touho', name: 'Touho' },
  TOW: { city: 'Toledo', name: 'Toledo' },
  TOY: { city: 'Toyama', name: 'Toyama' },
  TPA: { city: 'Tampa', name: 'Tampa International' },
  TPC: { city: 'Tarapoa', name: 'Tarapoa' },
  TPE: { city: 'Taipei', name: 'Taiwan Taoyuan International' },
  TPF: { city: 'Tampa', name: 'Peter O Knight' },
  TPH: { city: 'Tonopah', name: 'Tonopah' },
  TPJ: { city: 'Taplejung', name: 'Taplejung' },
  TPL: { city: 'Temple', name: 'Draughon Miller Central Texas Regional' },
  TPN: { city: 'Tiputini', name: 'Tiputini' },
  TPP: { city: 'Tarapoto', name: 'Cadete FAP Guillermo Del Castillo Paredes' },
  TPQ: { city: 'Tepic', name: 'Amado Nervo National' },
  TPS: { city: 'Trapani', name: 'Vincenzo Florio Airport Trapani-Birgi' },
  TQD: { city: 'Al Taqaddum', name: 'Al Taqaddum Air Base' },
  TQL: { city: 'Tarko-Sale', name: 'Tarko-Sale' },
  TQQ: { city: 'Sulawesi Tenggara', name: 'Maranggo' },
  TQS: { city: 'Tres Esquinas', name: 'Tres Esquinas Air Base' },
  TRA: { city: 'Tarama', name: 'Tarama' },
  TRC: { city: 'Torreon', name: 'Francisco Sarabia International' },
  TRD: { city: 'Trondheim', name: 'Trondheim Airport Værnes' },
  TRE: { city: 'Tiree', name: 'Tiree' },
  TRF: { city: 'Sandefjord', name: 'Sandefjord Airport, Torp' },
  TRG: { city: 'Tauranga', name: 'Tauranga' },
  TRI: { city: 'BRISTOL', name: 'Tri-Cities Regional TN/VA' },
  TRK: { city: 'Taraken', name: 'Juwata' },
  TRM: { city: 'Palm Springs', name: 'Jacqueline Cochran Regional' },
  TRN: { city: 'Torino', name: 'Turin' },
  TRO: { city: 'Taree', name: 'Taree' },
  TRQ: { city: 'Tarauaca', name: 'Tarauacá' },
  TRR: { city: 'Trinciomalee', name: 'China Bay' },
  TRS: { city: 'Ronchi De Legionari', name: 'Trieste–Friuli Venezia Giulia' },
  TRU: { city: 'Trujillo', name: 'Capitan FAP Carlos Martinez De Pinillos International' },
  TRV: { city: 'Trivandrum', name: 'Trivandrum International' },
  TRW: { city: 'Tarawa', name: 'Bonriki International' },
  TRZ: { city: 'Tiruchirappalli', name: 'Tiruchirapally Civil Airport' },
  TSA: { city: 'Taipei', name: 'Taipei Songshan' },
  TSB: { city: 'Tsumeb', name: 'Tsumeb' },
  TSE: { city: 'Tselinograd', name: 'Astana International' },
  TSF: { city: 'Treviso', name: 'Treviso-SantAngelo' },
  TSH: { city: 'Tshikapa', name: 'Tshikapa' },
  TSJ: { city: 'Tsushima', name: 'Tsushima' },
  TSL: { city: 'Tamuin', name: 'Tamuin' },
  TSM: { city: 'Taos', name: 'Taos Regional' },
  TSN: { city: 'Tianjin', name: 'Tianjin Binhai International' },
  TSR: { city: 'Timisoara', name: 'Timişoara Traian Vuia' },
  TST: { city: 'Trang', name: 'Trang' },
  TSU: { city: 'Tabiteuea', name: 'Tabiteuea South' },
  TSV: { city: 'Townsville', name: 'Townsville' },
  TSX: { city: 'Tanjung Santan', name: 'Tanjung Santan' },
  TSY: { city: 'Tasikmalaya', name: 'Cibeureum' },
  TTA: { city: 'Tan Tan', name: 'Tan Tan' },
  TTB: { city: 'Tortoli', name: 'Tortolì' },
  TTC: { city: 'Taltal', name: 'Las Breas' },
  TTD: { city: 'Troutdale', name: 'Portland Troutdale' },
  TTE: { city: 'Ternate', name: 'Sultan Khairun Babullah' },
  TTG: { city: 'Tartagal', name: 'General Enrique Mosconi' },
  TTH: { city: 'Thumrait', name: 'Thumrait Air Base' },
  TTI: { city: 'Tetiaroa', name: 'Tetiaroa' },
  TTJ: { city: 'Tottori', name: 'Tottori' },
  TTL: { city: 'Turtle Island', name: 'Turtle Island Seaplane Base' },
  TTN: { city: 'Trenton', name: 'Trenton Mercer' },
  TTQ: { city: 'Roxana', name: 'Aerotortuguero' },
  TTR: { city: 'Makale', name: 'Pongtiku' },
  TTT: { city: 'Fengnin', name: 'Taitung' },
  TTU: { city: 'Tetouan', name: 'Saniat Rmel' },
  TUA: { city: 'Tulcan', name: 'Teniente Coronel Luis a Mantilla' },
  TUB: { city: 'Tubuai', name: 'Tubuai' },
  TUC: { city: 'Tucuman', name: 'Teniente Benjamin Matienzo' },
  TUD: { city: 'Tambacounda', name: 'Tambacounda' },
  TUF: { city: 'Tours', name: 'Tours-Val-de-Loire' },
  TUG: { city: 'Tuguegarao', name: 'Tuguegarao' },
  TUI: { city: 'Turaif', name: 'Turaif Domestic' },
  TUK: { city: 'Turbat', name: 'Turbat International' },
  TUL: { city: 'Tulsa', name: 'Tulsa International' },
  TUN: { city: 'Tunis', name: 'Tunis Carthage International' },
  TUO: { city: 'Taupo', name: 'Taupo' },
  TUP: { city: 'Tupelo', name: 'Tupelo Regional' },
  TUR: { city: 'Tucurui', name: 'Tucuruí' },
  TUS: { city: 'Tucson', name: 'Tucson International' },
  TUU: { city: 'Tabuk', name: 'Tabuk' },
  TUV: { city: 'Tucupita', name: 'Tucupita' },
  TVA: { city: 'Morafenobe', name: 'Morafenobe' },
  TVC: { city: 'Traverse City', name: 'Cherry Capital' },
  TVF: { city: 'Thief River Falls', name: 'Thief River Falls Regional' },
  TVI: { city: 'Thomasville', name: 'Thomasville Regional' },
  TVL: { city: 'South Lake Tahoe', name: 'Lake Tahoe' },
  TVU: { city: 'Matei', name: 'Matei' },
  TVY: { city: 'Dawei', name: 'Dawei' },
  TWB: { city: 'Toowoomba', name: 'Toowoomba' },
  TWF: { city: 'Twin Falls', name: 'Joslin Field Magic Valley Regional' },
  TWT: { city: 'Sanga Sanga', name: 'Sanga Sanga' },
  TWU: { city: 'Tawau', name: 'Tawau' },
  TWZ: { city: 'Pukaki', name: 'Pukaki' },
  TXF: { city: 'Teixeira de Freitas', name: '9 de Maio - Teixeira de Freitas' },
  TXG: { city: 'Taichung', name: 'Taichung' },
  TXK: { city: 'Texarkana', name: 'Texarkana Regional Webb Field' },
  TXL: { city: 'Berlin', name: 'Berlin-Tegel' },
  TXN: { city: 'Huangshan', name: 'Tunxi International' },
  TYF: { city: 'Torsby', name: 'Torsby' },
  TYL: { city: 'Talara', name: 'Capitan Montes' },
  TYM: { city: 'Staniel Cay', name: 'Staniel Cay' },
  TYN: { city: 'Taiyuan', name: 'Taiyuan Wusu' },
  TYR: { city: 'Tyler', name: 'Tyler Pounds Regional' },
  TYS: { city: 'Knoxville', name: 'McGhee Tyson' },
  TZL: { city: 'Null', name: 'Tuzla International' },
  TZR: { city: 'Columbus', name: 'Taszár Air Base' },
  TZX: { city: 'Trabzon', name: 'Trabzon International' },
  UAB: { city: 'Adana', name: 'İncirlik Air Base' },
  UAH: { city: 'Ua Huka', name: 'Ua Huka' },
  UAI: { city: 'Suai', name: 'Suai' },
  UAK: { city: 'Narssarssuaq', name: 'Narsarsuaq' },
  UAM: { city: 'Andersen', name: 'Andersen Air Force Base' },
  UAP: { city: 'Ua Pou', name: 'Ua Pou' },
  UAQ: { city: 'San Juan', name: 'Domingo Faustino Sarmiento' },
  UAR: { city: 'Bouarfa', name: 'Bouarfa' },
  UAS: { city: 'Samburu South', name: 'Buffalo Spring' },
  UBA: { city: 'Uberaba', name: 'Mário de Almeida Franco' },
  UBB: { city: 'Mabuiag Island', name: 'Mabuiag Island' },
  UBJ: { city: 'Yamaguchi', name: 'Yamaguchi Ube' },
  UBP: { city: 'Ubon Ratchathani', name: 'Ubon Ratchathani' },
  UBT: { city: 'Ubatuba', name: 'Ubatuba' },
  UCB: { city: 'Wulanchabu', name: 'Ulanqab Jining' },
  UCK: { city: 'Lutsk', name: 'Lutsk' },
  UCT: { city: 'Ukhta', name: 'Ukhta' },
  UDD: { city: 'Palm Springs', name: 'Bermuda Dunes' },
  UDI: { city: 'Uberlandia', name: 'Ten. Cel. Aviador César Bombonato' },
  UDJ: { city: 'Uzhgorod', name: 'Uzhhorod International' },
  UDR: { city: 'Udaipur', name: 'Maharana Pratap' },
  UEL: { city: 'Quelimane', name: 'Quelimane' },
  UEO: { city: 'Kumejima', name: 'Kumejima' },
  UET: { city: 'Quetta', name: 'Quetta International' },
  UFA: { city: 'Ufa', name: 'Ufa International' },
  UGA: { city: 'Bulgan', name: 'Bulgan' },
  UGC: { city: 'Urgench', name: 'Urgench' },
  UGN: { city: 'Chicago', name: 'Waukegan National' },
  UGO: { city: 'Uige', name: 'Uige' },
  UGU: { city: 'Sugapa-Papua Island', name: 'Bilogai-Sugapa' },
  UHE: { city: 'Kunovice', name: 'Kunovice' },
  UIB: { city: 'Quibdo', name: 'El Caraño' },
  UIH: { city: 'Phucat', name: 'Phu Cat' },
  UII: { city: 'Utila', name: 'Utila' },
  UIK: { city: 'Ust Ilimsk', name: 'Ust-Ilimsk' },
  UIN: { city: 'Quincy', name: 'Quincy Regional Baldwin Field' },
  UIO: { city: 'Quito', name: 'Mariscal Sucre International' },
  UIP: { city: 'Quimper', name: 'Quimper-Cornouaille' },
  UJE: { city: 'Ujae Atoll', name: 'Ujae Atoll' },
  UKA: { city: 'Ukunda', name: 'Ukunda Airstrip' },
  UKB: { city: 'Kobe', name: 'Kobe' },
  UKG: { city: 'Ust-Kuyga', name: 'Ust-Kuyga' },
  UKI: { city: 'Ukiah', name: 'Ukiah Municipal' },
  UKK: { city: 'Ust Kamenogorsk', name: 'Ust-Kamennogorsk' },
  UKS: { city: 'Sevastopol', name: 'Belbek' },
  UKT: { city: 'Quakertown', name: 'Quakertown' },
  UKX: { city: 'Ust-Kut', name: 'Ust-Kut' },
  ULA: { city: 'San Julian', name: 'Capitan D Daniel Vazquez' },
  ULB: { city: 'Ambryn Island', name: 'Uléi' },
  ULD: { city: 'Ulundi', name: 'Prince Mangosuthu Buthelezi' },
  ULG: { city: 'Olgii', name: 'Ulgii Mongolei' },
  ULH: { city: 'Al-Ula', name: 'Majeed Bin Abdulaziz' },
  ULK: { city: 'Lensk', name: 'Lensk' },
  ULN: { city: 'Ulan Bator', name: 'Chinggis Khaan International' },
  ULO: { city: 'Ulaangom', name: 'Ulaangom' },
  ULP: { city: 'Quilpie', name: 'Quilpie' },
  ULQ: { city: 'Tulua', name: 'Heriberto Gíl Martínez' },
  ULU: { city: 'Gulu', name: 'Gulu' },
  ULV: { city: 'Ulyanovsk', name: 'Ulyanovsk Baratayevka' },
  ULY: { city: 'Ulyanovsk', name: 'Ulyanovsk East' },
  ULZ: { city: 'Uliastai', name: 'Donoi' },
  UMD: { city: 'Uummannaq', name: 'Uummannaq Heliport' },
  UME: { city: 'Umea', name: 'Umeå' },
  UMR: { city: 'Woomera', name: 'Woomera' },
  UMS: { city: 'Ust-Maya', name: 'Ust-Maya' },
  UMU: { city: 'Umuarama', name: 'Umuarama' },
  UNA: { city: 'Una', name: 'Hotel Transamérica' },
  UND: { city: 'Kunduz', name: 'Konduz' },
  UNG: { city: 'Kiunga', name: 'Kiunga' },
  UNI: { city: 'Union Island', name: 'Union Island International' },
  UNK: { city: 'Unalakleet', name: 'Unalakleet' },
  UNN: { city: 'Ranong', name: 'Ranong' },
  UNT: { city: 'Unst', name: 'Unst' },
  UOL: { city: 'Buol', name: 'Buol' },
  UOS: { city: 'Sewanee', name: 'Franklin County' },
  UOX: { city: 'Oxford', name: 'University Oxford' },
  UPB: { city: 'Baracoa Playa', name: 'Playa Baracoa' },
  UPG: { city: 'Ujung Pandang', name: 'Hasanuddin International' },
  UPL: { city: 'Upala', name: 'Upala' },
  UPN: { city: 'Uruapan', name: 'Licenciado y General Ignacio Lopez Rayon' },
  UPP: { city: 'Opolu', name: 'Upolu' },
  URA: { city: 'Uralsk', name: 'Uralsk' },
  URC: { city: 'Urumqi', name: 'Ürümqi Diwopu International' },
  URD: { city: 'Burg Feuerstein', name: 'Burg Feuerstein' },
  URE: { city: 'Kuressaare', name: 'Kuressaare' },
  URG: { city: 'Uruguaiana', name: 'Rubem Berta' },
  URJ: { city: 'Uraj', name: 'Uray' },
  URO: { city: 'Rouen', name: 'Rouen' },
  URS: { city: 'Kursk', name: 'Kursk East' },
  URT: { city: 'Surat Thani', name: 'Surat Thani' },
  URY: { city: 'Guriat', name: 'Gurayat Domestic' },
  USA: { city: 'Concord', name: 'Concord-Padgett Regional' },
  USH: { city: 'Ushuaia', name: 'Malvinas Argentinas' },
  USI: { city: 'Mabaruma', name: 'Mabaruma' },
  USK: { city: 'Usinsk', name: 'Usinsk' },
  USM: { city: 'Ko Samui', name: 'Samui' },
  USN: { city: 'Ulsan', name: 'Ulsan' },
  USQ: { city: 'Usak', name: 'Uşak' },
  USR: { city: 'Ust-Nera', name: 'Ust-Nera' },
  USS: { city: 'Sancti Spiritus', name: 'Sancti Spiritus' },
  UST: { city: 'St. Augustine Airport', name: 'Northeast Florida Regional' },
  USU: { city: 'Busuanga', name: 'Francisco B. Reyes' },
  UTA: { city: 'Mutare', name: 'Mutare' },
  UTC: { city: 'Soesterberg', name: 'Soesterberg Air Base' },
  UTH: { city: 'Udon Thani', name: 'Udon Thani' },
  UTI: { city: 'Utti', name: 'Utti Air Base' },
  UTK: { city: 'Utirik Island', name: 'Utirik' },
  UTM: { city: 'Tunica', name: 'Tunica Municipal' },
  UTN: { city: 'Upington', name: 'Pierre Van Ryneveld' },
  UTO: { city: 'Indian Mountains', name: 'Indian Mountain LRRS' },
  UTP: { city: 'Pattaya', name: 'U-Tapao International' },
  UTS: { city: 'Ust-Tsylma', name: 'Ust-Tsylma' },
  UTT: { city: 'Umtata', name: 'K. D. Matanzima' },
  UTW: { city: 'Queenstown', name: 'Queenstown' },
  UUA: { city: 'Bugulma', name: 'Bugulma' },
  UUD: { city: 'Ulan-ude', name: 'Ulan-Ude Airport (Mukhino)' },
  UUK: { city: 'Kuparuk', name: 'Ugnu-Kuparuk' },
  UUS: { city: 'Yuzhno-sakhalinsk', name: 'Yuzhno-Sakhalinsk' },
  UVA: { city: 'Uvalde', name: 'Garner Field' },
  UVE: { city: 'Ouvea', name: 'Ouvéa' },
  UVF: { city: 'Hewandorra', name: 'Hewanorra International' },
  UYL: { city: 'Nyala', name: 'Nyala' },
  UYN: { city: 'Yulin', name: 'Yulin Yuyang' },
  UYU: { city: 'Uyuni', name: 'Uyuni' },
  UZR: { city: 'Urzhar', name: 'Urzhar' },
  UZU: { city: 'Curuzu Cuatia', name: 'Curuzu Cuatia' },
  VAA: { city: 'Vaasa', name: 'Vaasa' },
  VAD: { city: 'Valdosta', name: 'Moody Air Force Base' },
  VAF: { city: 'Valence', name: 'Valence-Chabeuil' },
  VAG: { city: 'Varginha', name: 'Major Brigadeiro Trompowsky' },
  VAI: { city: 'Vanimo', name: 'Vanimo' },
  VAK: { city: 'Chevak', name: 'Chevak' },
  VAL: { city: 'Valenca', name: 'Valença' },
  VAM: { city: 'Maamigili', name: 'Villa' },
  VAN: { city: 'Van', name: 'Van Ferit Melen' },
  VAO: { city: 'Suavanao', name: 'Suavanao' },
  VAR: { city: 'Varna', name: 'Varna' },
  VAS: { city: 'Sivas', name: 'Sivas Nuri Demirağ' },
  VAV: { city: 'Vavau', name: 'Vavau International' },
  VAW: { city: 'Vardø', name: 'Vardø Airport, Svartnes' },
  VBA: { city: 'Ann', name: 'Ann' },
  VBG: { city: 'Lompoc', name: 'Vandenberg Air Force Base' },
  VBP: { city: 'Bokepyin', name: 'Bokpyinn' },
  VBS: { city: 'Brescia', name: 'Brescia' },
  VBV: { city: 'Vanua Balavu', name: 'Vanua Balavu' },
  VBY: { city: 'Visby', name: 'Visby' },
  VCA: { city: 'Can Tho', name: 'Can Tho International' },
  VCD: { city: 'Victoria River Downs', name: 'Victoria River Downs' },
  VCE: { city: 'Venice', name: 'Venice Marco Polo' },
  VCL: { city: 'Chu Lai', name: 'Chu Lai International' },
  VCP: { city: 'Campinas', name: 'Viracopos International' },
  VCR: { city: 'Carora', name: 'Carora' },
  VCS: { city: 'Conson', name: 'Co Ong' },
  VCT: { city: 'Victoria', name: 'Victoria Regional' },
  VCV: { city: 'Victorville', name: 'Southern California Logistics' },
  VDA: { city: 'Ovda', name: 'Ovda International' },
  VDB: { city: 'Fagernes', name: 'Leirin' },
  VDC: { city: 'Vitória Da Conquista', name: 'Vitória da Conquista' },
  VDE: { city: 'Hierro', name: 'Hierro' },
  VDH: { city: 'Dong Hoi', name: 'Dong Hoi' },
  VDI: { city: 'Vidalia', name: 'Vidalia Regional' },
  VDM: { city: 'Viedma', name: 'Gobernador Castello' },
  VDP: { city: 'Valle De La Pascua', name: 'Valle de La Pascua' },
  VDR: { city: 'Villa Dolores', name: 'Villa Dolores' },
  VDS: { city: 'Vadsø', name: 'Vadsø' },
  VDY: { city: 'Toranagallu', name: 'Vijayanagar Aerodrome (JSW)' },
  VDZ: { city: 'Valdez', name: 'Valdez Pioneer Field' },
  VEE: { city: 'Venetie', name: 'Venetie' },
  VEL: { city: 'Vernal', name: 'Vernal Regional' },
  VER: { city: 'Vera Cruz', name: 'General Heriberto Jara International' },
  VEY: { city: 'Vestmannaeyjar', name: 'Vestmannaeyjar' },
  VFA: { city: 'Victoria Falls', name: 'Victoria Falls International' },
  VGA: { city: 'Vijayawada', name: 'Vijayawada' },
  VGD: { city: 'Vologda', name: 'Vologda' },
  VGO: { city: 'Vigo', name: 'Vigo' },
  VGT: { city: 'Las Vegas', name: 'North Las Vegas' },
  VGZ: { city: 'Villa Garzon', name: 'Villa Garzón' },
  VHC: { city: 'Saurimo', name: 'Saurimo' },
  VHM: { city: 'Vilhelmina', name: 'Vilhelmina' },
  VHV: { city: 'Verkhnevilyuysk', name: 'Verkhnevilyuisk' },
  VHY: { city: 'Vichy', name: 'Vichy-Charmeil' },
  VHZ: { city: 'Vahitahi', name: 'Vahitahi' },
  VIC: { city: 'Vicenza', name: 'Vicenza' },
  VIE: { city: 'Vienna', name: 'Vienna International' },
  VIG: { city: 'El Vigía', name: 'Juan Pablo Pérez Alfonso' },
  VII: { city: 'Vinh', name: 'Vinh' },
  VIJ: { city: 'Spanish Town', name: 'Virgin Gorda' },
  VIL: { city: 'Dakhla', name: 'Dakhla' },
  VIN: { city: 'Vinnitsa', name: 'Vinnytsia/Gavyryshivka' },
  VIR: { city: 'Durban', name: 'Virginia' },
  VIS: { city: 'Visalia', name: 'Visalia Municipal' },
  VIT: { city: 'Vitoria', name: 'Vitoria/Foronda' },
  VIX: { city: 'Vitoria', name: 'Eurico de Aguiar Salles' },
  VIY: { city: 'Villacoublay', name: 'Villacoublay-Vélizy (BA 107) Air Base' },
  VKG: { city: 'Rach Gia', name: 'Rach Gia' },
  VKO: { city: 'Moscow', name: 'Vnukovo International' },
  VKT: { city: 'Vorkuta', name: 'Vorkuta' },
  VLC: { city: 'Valencia', name: 'Valencia' },
  VLD: { city: 'Valdosta', name: 'Valdosta Regional' },
  VLG: { city: 'Villa Gesell', name: 'Villa Gesell' },
  VLI: { city: 'Port-vila', name: 'Bauerfield International' },
  VLL: { city: 'Valladolid', name: 'Valladolid' },
  VLM: { city: 'Villa Montes', name: 'Teniente Coronel Rafael Pabón' },
  VLN: { city: 'Valencia', name: 'Arturo Michelena International' },
  VLP: { city: 'Vila Rica', name: 'Vila Rica' },
  VLR: { city: 'Vallenar', name: 'Vallenar' },
  VLS: { city: 'Valesdir', name: 'Valesdir' },
  VLU: { city: 'Velikiye Luki', name: 'Velikiye Luki' },
  VLV: { city: 'Valera', name: 'Dr. Antonio Nicolás Briceño' },
  VLY: { city: 'Angelsey', name: 'Anglesey' },
  VME: { city: 'Villa Reynolds', name: 'Villa Reynolds' },
  VMU: { city: 'Baimuru', name: 'Baimuru' },
  VNA: { city: 'Saravane', name: 'Saravane' },
  VNC: { city: 'Venice', name: 'Venice Municipal' },
  VNE: { city: 'Vannes', name: 'Vannes-Meucon' },
  VNO: { city: 'Vilnius', name: 'Vilnius International' },
  VNS: { city: 'Varanasi', name: 'Lal Bahadur Shastri' },
  VNT: { city: 'Ventspils', name: 'Ventspils International' },
  VNX: { city: 'Vilankulu', name: 'Vilankulo' },
  VNY: { city: 'Van Nuys', name: 'Van Nuys' },
  VOD: { city: 'Vodochody', name: 'Vodochody' },
  VOG: { city: 'Volgograd', name: 'Volgograd International' },
  VOH: { city: 'Vohemar', name: 'Vohimarina' },
  VOK: { city: 'Camp Douglas', name: 'Volk Field' },
  VOL: { city: 'Nea Anghialos', name: 'Nea Anchialos' },
  VOZ: { city: 'Voronezh', name: 'Voronezh International' },
  VPE: { city: 'Ondjiva', name: 'Ngjiva Pereira' },
  VPN: { city: 'Vopnafjörður', name: 'Vopnafjörður' },
  VPS: { city: 'Valparaiso', name: 'Destin-Ft Walton Beach' },
  VPY: { city: 'Chimoio', name: 'Chimoio' },
  VPZ: { city: 'Valparaiso IN', name: 'Porter County Municipal' },
  VQQ: { city: 'Jacksonville', name: 'Cecil' },
  VQS: { city: 'Vieques Island', name: 'Vieques' },
  VRA: { city: 'Varadero', name: 'Juan Gualberto Gomez International' },
  VRB: { city: 'Vero Beach', name: 'Vero Beach Regional' },
  VRC: { city: 'Virac', name: 'Virac' },
  VRE: { city: 'Vredendal', name: 'Vredendal' },
  VRK: { city: 'Varkaus', name: 'Varkaus' },
  VRL: { city: 'Vila Real', name: 'Vila Real' },
  VRN: { city: 'Villafranca', name: 'Verona Villafranca' },
  VRO: { city: 'Kawama', name: 'Kawama' },
  VRU: { city: 'Vryburg', name: 'Vryburg' },
  VRY: { city: 'Værøy', name: 'Værøy Heliport' },
  VSA: { city: 'Villahermosa', name: 'Carlos Rovirosa Pérez International' },
  VSE: { city: 'Viseu', name: 'Aerodromo Goncalves Lobato (Viseu Airport)' },
  VSG: { city: 'Lugansk', name: 'Luhansk International' },
  VST: { city: 'Vasteras', name: 'Stockholm Västerås' },
  VTB: { city: 'Vitebsk', name: 'Vitebsk Vostochny' },
  VTE: { city: 'Vientiane', name: 'Wattay International' },
  VTM: { city: 'Nevatim', name: 'Nevatim Air Base' },
  VTN: { city: 'Valentine', name: 'Miller Field' },
  VTU: { city: 'Las Tunas', name: 'Hermanos Ameijeiras' },
  VTZ: { city: 'Vishakhapatnam', name: 'Vishakhapatnam' },
  VUP: { city: 'Valledupar', name: 'Alfonso López Pumarejo' },
  VUS: { city: 'Veliky Ustyug', name: 'Velikiy Ustyug' },
  VVC: { city: 'Villavicencio', name: 'Vanguardia' },
  VVI: { city: 'Santa Cruz', name: 'Viru Viru International' },
  VVO: { city: 'Vladivostok', name: 'Vladivostok International' },
  VVZ: { city: 'Illizi', name: 'Illizi Takhamalt' },
  VXC: { city: 'Lichinga', name: 'Lichinga' },
  VXE: { city: 'Sao Vicente Island', name: 'São Pedro' },
  VXO: { city: 'Vaxjo', name: 'Växjö Kronoberg' },
  VYI: { city: 'Vilyuisk', name: 'Vilyuisk' },
  VYS: { city: 'Peru', name: 'Illinois Valley Regional Airport-Walter A Duncan Field' },
  WAA: { city: 'Wales', name: 'Wales' },
  WAE: { city: 'Wadi-al-dawasir', name: 'Wadi Al Dawasir' },
  WAF: { city: 'Wana', name: 'Wana' },
  WAG: { city: 'Wanganui', name: 'Wanganui' },
  WAI: { city: 'Antsohihy', name: 'Ambalabe' },
  WAL: { city: 'Wallops Island', name: 'Wallops Flight Facility' },
  WAM: { city: 'Ambatondrazaka', name: 'Ambatondrazaka' },
  WAQ: { city: 'Antsalova', name: 'Antsalova' },
  WAR: { city: 'Waris-Papua Island', name: 'Waris' },
  WAT: { city: 'Waterford', name: 'Waterford' },
  WAW: { city: 'Warsaw', name: 'Warsaw Chopin' },
  WBG: { city: 'Schleswig', name: 'Schleswig Air Base' },
  WBM: { city: 'Wapenamanda', name: 'Wapenamanda' },
  WBQ: { city: 'Beaver', name: 'Beaver' },
  WBU: { city: 'Boulder', name: 'Boulder Municipal' },
  WBW: { city: 'Wilkes-Barre', name: 'Wilkes Barre Wyoming Valley' },
  WCH: { city: 'Chaiten', name: 'Chaitén' },
  WDH: { city: 'Windhoek', name: 'Hosea Kutako International' },
  WDR: { city: 'Winder', name: 'Barrow County' },
  WDS: { city: 'Shiyan', name: 'Shiyan Wudangshan' },
  WEF: { city: 'Weifang', name: 'Weifang' },
  WEH: { city: 'Weihai', name: 'Weihai' },
  WEI: { city: 'Weipa', name: 'Weipa' },
  WFI: { city: 'Fianarantsoa', name: 'Fianarantsoa' },
  WFK: { city: 'Frenchville', name: 'Northern Aroostook Regional' },
  WGA: { city: 'Wagga Wagga', name: 'Wagga Wagga City' },
  WGE: { city: 'Walgett', name: 'Walgett' },
  WGN: { city: 'Shaoyang', name: 'Shaoyang Wugang' },
  WGP: { city: 'Waingapu', name: 'Umbu Mehang Kunda' },
  WHF: { city: 'Wadi Halfa', name: 'Wadi Halfa' },
  WHK: { city: 'Whakatane', name: 'Whakatane' },
  WHP: { city: 'Los Angeles', name: 'Whiteman' },
  WHU: { city: 'Wuhu', name: 'Wuhu Air Base' },
  WIC: { city: 'Wick', name: 'Wick' },
  WIE: { city: 'Wiesbaden', name: 'Wiesbaden Army' },
  WIK: { city: 'Waiheke Island', name: 'Waiheke Reeve' },
  WIL: { city: 'Nairobi', name: 'Nairobi Wilson' },
  WIN: { city: 'Winton', name: 'Winton' },
  WIO: { city: 'Wilcannia', name: 'Wilcannia' },
  WIR: { city: 'Wairoa', name: 'Wairoa' },
  WJF: { city: 'Lancaster', name: 'General WM J Fox' },
  WJR: { city: 'Wajir', name: 'Wajir' },
  WJU: { city: 'Wonju', name: 'Wonju/Hoengseong Air Base (K-38/K-46)' },
  WKA: { city: 'Wanaka', name: 'Wanaka' },
  WKF: { city: 'Waterkloof', name: 'Waterkloof Air Force Base' },
  WKI: { city: 'Hwange', name: 'Hwange (Town)' },
  WKJ: { city: 'Wakkanai', name: 'Wakkanai' },
  WKK: { city: 'Aleknagik', name: 'Aleknagik / New' },
  WKL: { city: 'Waikoloa Village', name: 'Waikoloa Heliport' },
  WKR: { city: 'Walkers Cay', name: 'Abaco I Walker C' },
  WLD: { city: 'Winfield', name: 'Strother Field' },
  WLG: { city: 'Wellington', name: 'Wellington International' },
  WLH: { city: 'Walaha', name: 'Walaha' },
  WLK: { city: 'Selawik', name: 'Selawik' },
  WLS: { city: 'Wallis', name: 'Hihifo' },
  WMA: { city: 'Mandritsara', name: 'Mandritsara' },
  WMB: { city: 'Warrnambool', name: 'Warrnambool' },
  WMC: { city: 'Winnemucca', name: 'Winnemucca Municipal' },
  WME: { city: 'Mount Keith', name: 'Mount Keith' },
  WMH: { city: 'Mountain Home', name: 'Ozark Regional' },
  WMI: { city: 'Warsaw', name: 'Modlin' },
  WMN: { city: 'Maroantsetra', name: 'Maroantsetra' },
  WMO: { city: 'White Mountain', name: 'White Mountain' },
  WMP: { city: 'Mampikony', name: 'Mampikony' },
  WMR: { city: 'Mananara', name: 'Mananara Nord' },
  WMT: { city: 'Zunyi', name: 'Zunyi Maotai' },
  WMX: { city: 'Wamena', name: 'Wamena' },
  WNA: { city: 'Napakiak', name: 'Napakiak' },
  WNN: { city: 'Wunnumin Lake', name: 'Wunnumin Lake' },
  WNP: { city: 'Naga', name: 'Naga' },
  WNR: { city: 'Windorah', name: 'Windorah' },
  WNS: { city: 'Nawabshah', name: 'Shaheed Benazirabad' },
  WNZ: { city: 'Wenzhou', name: 'Wenzhou Longwan International' },
  WOE: { city: 'Woensdrecht', name: 'Woensdrecht Air Base' },
  WOL: { city: 'Wollongong', name: 'Wollongong' },
  WOS: { city: 'Wonsan', name: 'Wonsan Kalma International' },
  WOT: { city: 'Wang An', name: 'Wang-an' },
  WPB: { city: 'Port Bergé', name: 'Port Bergé' },
  WPC: { city: 'Pincher Creek', name: 'Pincher Creek' },
  WPR: { city: 'Porvenir', name: 'Capitan Fuentes Martinez Airport' },
  WPU: { city: 'Puerto Williams', name: 'Guardiamarina Zañartu' },
  WRB: { city: 'Macon', name: 'Robins Air Force Base' },
  WRE: { city: 'Whangarei', name: 'Whangarei' },
  WRG: { city: 'Wrangell', name: 'Wrangell' },
  WRI: { city: 'Wrightstown', name: 'Mc Guire Air Force Base' },
  WRL: { city: 'Worland', name: 'Worland Municipal' },
  WRO: { city: 'Wroclaw', name: 'Copernicus Wrocław' },
  WRT: { city: 'Warton', name: 'Warton' },
  WRY: { city: 'Westray', name: 'Westray' },
  WRZ: { city: 'Wirawila', name: 'Weerawila' },
  WSD: { city: 'White Sands', name: 'Condron Army Air Field' },
  WSN: { city: 'South Naknek', name: 'South Naknek Nr 2' },
  WSO: { city: 'Washabo', name: 'Washabo' },
  WSP: { city: 'Waspam', name: 'Waspam' },
  WSR: { city: 'Wasior', name: 'Wasior' },
  WST: { city: 'Washington County', name: 'Westerly State' },
  WSY: { city: 'Airlie Beach', name: 'Whitsunday Island' },
  WSZ: { city: 'Westport', name: 'Westport' },
  WTA: { city: 'Tambohorano', name: 'Tambohorano' },
  WTB: { city: 'Toowoomba', name: 'Toowoomba Wellcamp' },
  WTK: { city: 'Noatak', name: 'Noatak' },
  WTN: { city: 'Waddington', name: 'RAF Waddington' },
  WTS: { city: 'Tsiroanomandidy', name: 'Tsiroanomandidy' },
  WTZ: { city: 'Whitianga', name: 'Whitianga' },
  WUA: { city: 'Wuhai', name: 'Wuhai' },
  WUH: { city: 'Wuhan', name: 'Wuhan Tianhe International' },
  WUN: { city: 'Wiluna', name: 'Wiluna' },
  WUS: { city: 'Wuyishan', name: 'Nanping Wuyishan' },
  WUT: { city: 'Xinzhou', name: 'Xinzhou Wutaishan' },
  WUU: { city: 'Wau', name: 'Wau' },
  WUX: { city: 'Wuxi', name: 'Sunan Shuofang International' },
  WUZ: { city: 'Wuzhou', name: 'Wuzhou Changzhoudao' },
  WVB: { city: 'Walvis Bay', name: 'Walvis Bay' },
  WVI: { city: 'Watsonville', name: 'Watsonville Municipal' },
  WVK: { city: 'Manakara', name: 'Manakara' },
  WVN: { city: 'Wilhelmshaven', name: 'Wilhelmshaven-Mariensiel' },
  WWA: { city: 'Wasilla', name: 'Wasilla' },
  WWD: { city: 'Wildwood', name: 'Cape May County' },
  WWK: { city: 'Wewak', name: 'Wewak International' },
  WWR: { city: 'Woodward', name: 'West Woodward' },
  WWY: { city: 'West Wyalong', name: 'West Wyalong' },
  WXN: { city: 'Wanxian', name: 'Wanxian' },
  WYA: { city: 'Whyalla', name: 'Whyalla' },
  WYE: { city: 'Yengema', name: 'Yengema' },
  WYN: { city: 'Wyndham', name: 'Wyndham' },
  WYS: { city: 'West Yellowstone', name: 'Yellowstone' },
  XAB: { city: 'Abbeville', name: 'Abbeville' },
  XAP: { city: 'Chapeco', name: 'Serafin Enoss Bertaso' },
  XAU: { city: 'Saul', name: 'Saúl' },
  XBE: { city: 'Bearskin Lake', name: 'Bearskin Lake' },
  XBJ: { city: 'Birjand', name: 'Birjand' },
  XCH: { city: 'Christmas Island', name: 'Christmas Island' },
  XCR: { city: 'Chalons', name: 'Châlons-Vatry' },
  XCZ: { city: 'Charleville', name: 'Charleville-Mézières' },
  XFN: { city: 'Xiangfan', name: 'Xiangyang Liuji' },
  XFW: { city: 'Hamburg', name: 'Hamburg-Finkenwerder' },
  XGN: { city: 'Xangongo', name: 'Xangongo' },
  XGR: { city: 'Kangiqsualujjuaq', name: 'Kangiqsualujjuaq (Georges River)' },
  XIC: { city: 'Xichang', name: 'Xichang Qingshan' },
  XIJ: { city: 'Ahmed Al Jaber AB', name: 'Ahmed Al Jaber Air Base' },
  XIL: { city: 'Xilinhot', name: 'Xilinhot' },
  XIQ: { city: 'Ilimanaq', name: 'Ilimanaq Heliport' },
  XIY: { city: 'Xian', name: 'Xian Xianyang International' },
  XJD: { city: 'Doha', name: 'Al Udeid Air Base' },
  XJM: { city: 'Mangla', name: 'Mangla' },
  XKH: { city: 'Phon Savan', name: 'Xieng Khouang' },
  XKS: { city: 'Kasabonika', name: 'Kasabonika' },
  XLB: { city: 'Lac Brochet', name: 'Lac Brochet' },
  XLS: { city: 'St. Louis', name: 'Saint Louis' },
  XMC: { city: 'Mallacoota', name: 'Mallacoota' },
  XME: { city: 'Maubeuge', name: 'Maubeuge-Élesmes' },
  XMH: { city: 'Manihi', name: 'Manihi' },
  XMN: { city: 'Xiamen', name: 'Xiamen Gaoqi International' },
  XMS: { city: 'Macas', name: 'Coronel E Carvajal' },
  XMW: { city: 'Montauban', name: 'Montauban' },
  XMY: { city: 'Yam Island', name: 'Yam Island' },
  XNA: { city: 'Bentonville', name: 'Northwest Arkansas Regional' },
  XNN: { city: 'Xining', name: 'Xining Caojiabu' },
  XOG: { city: 'Orange', name: 'Orange-Caritat (BA 115) Air Base' },
  XPK: { city: 'Pukatawagan', name: 'Pukatawagan' },
  XPL: { city: 'Comayagua', name: 'Coronel Enrique Soto Cano Air Base' },
  XPP: { city: 'Poplar River', name: 'Poplar River' },
  XQC: { city: 'Al Bakr', name: 'Joint Base Balad' },
  XQP: { city: 'Quepos', name: 'Quepos Managua' },
  XRH: { city: 'Richmond', name: 'RAAF Base Richmond' },
  XRR: { city: 'Ross River', name: 'Ross River' },
  XRY: { city: 'Jerez', name: 'Jerez' },
  XSB: { city: 'Sir Bani Yas Island', name: 'Sir Bani Yas' },
  XSC: { city: 'South Caicos', name: 'South Caicos' },
  XSD: { city: 'Tonopah', name: 'Tonopah Test Range' },
  XSI: { city: 'South Indian Lake', name: 'South Indian Lake' },
  XSP: { city: 'Singapore', name: 'Seletar' },
  XTG: { city: 'Thargomindah', name: 'Thargomindah' },
  XTL: { city: 'Tadoule Lake', name: 'Tadoule Lake' },
  XTO: { city: 'Taroom', name: 'Taroom' },
  XUZ: { city: 'Xuzhou', name: 'Xuzhou Guanyin' },
  XVS: { city: 'Valenciennes', name: 'Valenciennes-Denain' },
  XXN: { city: 'Riyadh', name: 'Riyadh Air Base' },
  XYA: { city: 'Yandina', name: 'Yandina' },
  XYE: { city: 'Ye', name: 'Ye' },
  YAA: { city: 'Anahim Lake', name: 'Anahim Lake' },
  YAB: { city: 'Arctic Bay', name: 'Old Arctic Bay' },
  YAC: { city: 'Cat Lake', name: 'Cat Lake' },
  YAG: { city: 'Fort Frances', name: 'Fort Frances Municipal' },
  YAH: { city: 'La Grande-4', name: 'La Grande-4' },
  YAI: { city: 'Chillan', name: 'Gral. Bernardo O´Higgins' },
  YAK: { city: 'Yakutat', name: 'Yakutat' },
  YAL: { city: 'Alert Bay', name: 'Alert Bay' },
  YAM: { city: 'Sault Sainte Marie', name: 'Sault Ste Marie' },
  YAO: { city: 'Yaounde', name: 'Yaoundé' },
  YAP: { city: 'Yap', name: 'Yap International' },
  YAS: { city: 'Yasawa Island', name: 'Yasawa Island' },
  YAT: { city: 'Attawapiskat', name: 'Attawapiskat' },
  YAX: { city: 'Angling Lake', name: 'Wapekeka' },
  YAY: { city: 'St. Anthony', name: 'St. Anthony' },
  YAZ: { city: 'Tofino', name: 'Tofino / Long Beach' },
  YBA: { city: 'Banff', name: 'Banff' },
  YBB: { city: 'Pelly Bay', name: 'Kugaaruk' },
  YBC: { city: 'Baie Comeau', name: 'Baie Comeau' },
  YBE: { city: 'Uranium City', name: 'Uranium City' },
  YBG: { city: 'Bagotville', name: 'CFB Bagotville' },
  YBI: { city: 'Black Tickle', name: 'Black Tickle' },
  YBK: { city: 'Baker Lake', name: 'Baker Lake' },
  YBL: { city: 'Campbell River', name: 'Campbell River' },
  YBO: { city: 'Bob Quinn Lake', name: 'Bob Quinn Lake' },
  YBP: { city: 'Yibin', name: 'Yibin Caiba' },
  YBR: { city: 'Brandon', name: 'Brandon Municipal' },
  YBS: { city: 'Musselwhite Mine', name: 'Opapimiskan Lake' },
  YBT: { city: 'Brochet', name: 'Brochet' },
  YBV: { city: 'Berens River', name: 'Berens River' },
  YBW: { city: 'Bedwell Harbour', name: 'Bedwell Harbour Seaplane Base' },
  YBX: { city: 'Lourdes-De-Blanc-Sablon', name: 'Lourdes de Blanc Sablon' },
  YBY: { city: 'Bonnyville', name: 'Bonnyville' },
  YCB: { city: 'Cambridge Bay', name: 'Cambridge Bay' },
  YCC: { city: 'Cornwall', name: 'Cornwall Regional' },
  YCD: { city: 'Nanaimo', name: 'Nanaimo' },
  YCE: { city: 'Centralia', name: 'Centralia / James T. Field Memorial Aerodrome' },
  YCG: { city: 'Castlegar', name: 'Castlegar/West Kootenay Regional' },
  YCH: { city: 'Chatham', name: 'Miramichi' },
  YCK: { city: 'Colville Lake', name: 'Colville Lake' },
  YCL: { city: 'Charlo', name: 'Charlo' },
  YCM: { city: 'Saint Catherines', name: 'Niagara District' },
  YCN: { city: 'Cochrane', name: 'Cochrane' },
  YCO: { city: 'Coppermine', name: 'Kugluktuk' },
  YCQ: { city: 'Chetwynd', name: 'Chetwynd' },
  YCR: { city: 'Cross Lake', name: 'Cross Lake (Charlie Sinclair Memorial)' },
  YCS: { city: 'Chesterfield Inlet', name: 'Chesterfield Inlet' },
  YCT: { city: 'Coronation', name: 'Coronation' },
  YCU: { city: 'Yuncheng', name: 'Yuncheng Guangong' },
  YCW: { city: 'Chilliwack', name: 'Chilliwack' },
  YCY: { city: 'Clyde River', name: 'Clyde River' },
  YDA: { city: 'Dawson', name: 'Dawson City' },
  YDB: { city: 'Burwash', name: 'Burwash' },
  YDF: { city: 'Deer Lake', name: 'Deer Lake' },
  YDG: { city: 'Digby', name: 'Digby / Annapolis Regional' },
  YDL: { city: 'Dease Lake', name: 'Dease Lake' },
  YDN: { city: 'Dauphin', name: 'Dauphin Barker' },
  YDO: { city: 'Dolbeau-St-Félicien', name: 'Dolbeau St Felicien' },
  YDP: { city: 'Nain', name: 'Nain' },
  YDQ: { city: 'Dawson Creek', name: 'Dawson Creek' },
  YDT: { city: 'Boundary Bay', name: 'Boundary Bay' },
  YEC: { city: 'Yechon', name: 'Yecheon Airbase' },
  YEG: { city: 'Edmonton', name: 'Edmonton International' },
  YEI: { city: 'Yenisehir', name: 'Bursa Yenişehir' },
  YEK: { city: 'Eskimo Point', name: 'Arviat' },
  YEL: { city: 'ELLIOT LAKE', name: 'Elliot Lake Municipal' },
  YEM: { city: 'Manitowaning', name: 'Manitoulin East Municipal' },
  YEN: { city: 'Estevan', name: 'Estevan' },
  YEO: { city: 'Yeovilton', name: 'RNAS Yeovilton' },
  YER: { city: 'Fort Severn', name: 'Fort Severn' },
  YES: { city: 'Yasuj', name: 'Yasouj' },
  YET: { city: 'Edson', name: 'Edson' },
  YEU: { city: 'Eureka', name: 'Eureka' },
  YEV: { city: 'Inuvik', name: 'Inuvik Mike Zubko' },
  YEY: { city: 'Amos', name: 'Amos/Magny' },
  YFA: { city: 'Fort Albany', name: 'Fort Albany' },
  YFB: { city: 'Iqaluit', name: 'Iqaluit' },
  YFC: { city: 'Fredericton', name: 'Fredericton' },
  YFE: { city: 'Forestville', name: 'Forestville' },
  YFH: { city: 'Fort Hope', name: 'Fort Hope' },
  YFJ: { city: 'Wekweeti', name: 'Wekweètì' },
  YFO: { city: 'Flin Flon', name: 'Flin Flon' },
  YFR: { city: 'Fort Resolution', name: 'Fort Resolution' },
  YFS: { city: 'Fort Simpson', name: 'Fort Simpson' },
  YFX: { city: 'St. Lewis', name: 'St. Lewis (Fox Harbour)' },
  YGB: { city: 'Texada', name: 'Texada Gillies Bay' },
  YGG: { city: 'Ganges', name: 'Ganges Seaplane Base' },
  YGH: { city: 'Fort Good Hope', name: 'Fort Good Hope' },
  YGJ: { city: 'Miho', name: 'Miho Yonago' },
  YGK: { city: 'Kingston', name: 'Kingston Norman Rogers' },
  YGL: { city: 'La Grande Riviere', name: 'La Grande Rivière' },
  YGM: { city: 'Gimli', name: 'Gimli Industrial Park' },
  YGO: { city: 'Gods Lake Narrows', name: 'Gods Lake Narrows' },
  YGP: { city: 'Gaspe', name: 'Gaspé (Michel-Pouliot)' },
  YGQ: { city: 'Geraldton', name: 'Geraldton Greenstone Regional' },
  YGR: { city: 'Iles De La Madeleine', name: 'Îles-de-la-Madeleine' },
  YGT: { city: 'Igloolik', name: 'Igloolik' },
  YGV: { city: 'Havre-Saint-Pierre', name: 'Havre St Pierre' },
  YGW: { city: 'Kuujjuarapik', name: 'Kuujjuarapik' },
  YGX: { city: 'Gillam', name: 'Gillam' },
  YGZ: { city: 'Grise Fiord', name: 'Grise Fiord' },
  YHA: { city: 'Port Hope Simpson', name: 'Port Hope Simpson' },
  YHB: { city: 'Hudson Bay', name: 'Hudson Bay' },
  YHD: { city: 'Dryden', name: 'Dryden Regional' },
  YHE: { city: 'Hope', name: 'Hope' },
  YHF: { city: 'Hearst', name: 'Hearst René Fontaine Municipal' },
  YHI: { city: 'Holman Island', name: 'Ulukhaktok Holman' },
  YHK: { city: 'Gjoa Haven', name: 'Gjoa Haven' },
  YHM: { city: 'Hamilton', name: 'John C. Munro Hamilton International' },
  YHN: { city: 'Hornepayne', name: 'Hornepayne Municipal' },
  YHO: { city: 'Hopedale', name: 'Hopedale' },
  YHP: { city: 'Poplar Hill', name: 'Poplar Hill' },
  YHR: { city: 'Chevery', name: 'Chevery' },
  YHT: { city: 'Haines Junction', name: 'Haines Junction' },
  YHU: { city: 'Montreal', name: 'Montréal / Saint-Hubert' },
  YHY: { city: 'Hay River', name: 'Hay River / Merlyn Carter' },
  YHZ: { city: 'Halifax', name: 'Halifax / Stanfield International' },
  YIB: { city: 'Atikokan', name: 'Atikokan Municipal' },
  YIC: { city: 'Yichun', name: 'Yichun Mingyueshan' },
  YIE: { city: 'Arxan', name: 'Arxan Yiershi' },
  YIF: { city: 'St-Augustin', name: 'St Augustin' },
  YIH: { city: 'Yichang', name: 'Yichang Sanxia' },
  YIK: { city: 'Ivujivik', name: 'Ivujivik' },
  YIN: { city: 'Yining', name: 'Yining' },
  YIO: { city: 'Pond Inlet', name: 'Pond Inlet' },
  YIP: { city: 'Detroit', name: 'Willow Run' },
  YIV: { city: 'Island Lake', name: 'Island Lake' },
  YIW: { city: 'Yiwu', name: 'Yiwu' },
  YJF: { city: 'Fort Liard', name: 'Fort Liard' },
  YJN: { city: 'St. Jean', name: 'St Jean' },
  YJP: { city: 'Hinton', name: 'Hinton/Jasper-Hinton' },
  YJT: { city: 'Stephenville', name: 'Stephenville' },
  YKA: { city: 'Kamloops', name: 'Kamloops' },
  YKF: { city: 'Waterloo', name: 'Waterloo' },
  YKG: { city: 'Kangirsuk', name: 'Kangirsuk' },
  YKH: { city: 'Yingkou', name: 'Yingkou Lanqi' },
  YKJ: { city: 'Key Lake', name: 'Key Lake' },
  YKL: { city: 'Schefferville', name: 'Schefferville' },
  YKM: { city: 'Yakima', name: 'Yakima Air Terminal McAllister Field' },
  YKN: { city: 'Yankton', name: 'Chan Gurney Municipal' },
  YKO: { city: 'Hakkari', name: 'Hakkari Yüksekova' },
  YKQ: { city: 'Waskaganish', name: 'Waskaganish' },
  YKS: { city: 'Yakutsk', name: 'Yakutsk' },
  YKU: { city: 'Chisasibi', name: 'Chisasibi' },
  YKX: { city: 'Kirkland Lake', name: 'Kirkland Lake' },
  YKY: { city: 'Kindersley', name: 'Kindersley' },
  YKZ: { city: 'Toronto', name: 'Buttonville Municipal' },
  YLC: { city: 'Kimmirut', name: 'Kimmirut' },
  YLD: { city: 'Chapleau', name: 'Chapleau' },
  YLE: { city: 'Whatì', name: 'Whatì' },
  YLH: { city: 'Lansdowne House', name: 'Lansdowne House' },
  YLI: { city: 'Ylivieska-raudaskyla', name: 'Ylivieska' },
  YLJ: { city: 'Meadow Lake', name: 'Meadow Lake' },
  YLK: { city: 'Barrie-Orillia', name: 'Barrie-Orillia (Lake Simcoe Regional Airport)' },
  YLL: { city: 'Lloydminster', name: 'Lloydminster' },
  YLR: { city: 'Leaf Rapids', name: 'Leaf Rapids' },
  YLT: { city: 'Alert', name: 'Alert' },
  YLW: { city: 'Kelowna', name: 'Kelowna International' },
  YLY: { city: 'Langley Township', name: 'Langley' },
  YMA: { city: 'Mayo', name: 'Mayo' },
  YME: { city: 'Matane', name: 'Matane' },
  YMG: { city: 'Manitouwadge', name: 'Manitouwadge' },
  YMH: { city: 'Marys Harbour', name: 'Marys Harbour' },
  YMJ: { city: 'Moose Jaw', name: 'Moose Jaw Air Vice Marshal C. M. McEwen' },
  YML: { city: 'Charlevoix', name: 'Charlevoix' },
  YMM: { city: 'Fort Mcmurray', name: 'Fort McMurray' },
  YMN: { city: 'Makkovik', name: 'Makkovik' },
  YMO: { city: 'Moosonee', name: 'Moosonee' },
  YMS: { city: 'Yurimaguas', name: 'Moises Benzaquen Rengifo' },
  YMT: { city: 'Chibougamau', name: 'Chapais' },
  YMW: { city: 'Maniwaki', name: 'Maniwaki' },
  YMX: { city: 'Montreal', name: 'Montreal International (Mirabel)' },
  YNA: { city: 'Natashquan', name: 'Natashquan' },
  YNB: { city: 'Yenbo', name: 'Prince Abdulmohsin Bin Abdulaziz' },
  YNC: { city: 'Wemindji', name: 'Wemindji' },
  YND: { city: 'Gatineau', name: 'Ottawa / Gatineau' },
  YNE: { city: 'Norway House', name: 'Norway House' },
  YNG: { city: 'Youngstown', name: 'Youngstown Warren Regional' },
  YNJ: { city: 'Yanji', name: 'Yanji Chaoyangchuan' },
  YNL: { city: 'Points North Landing', name: 'Points North Landing' },
  YNM: { city: 'Matagami', name: 'Matagami' },
  YNO: { city: 'North Spirit Lake', name: 'North Spirit Lake' },
  YNP: { city: 'Natuashish', name: 'Natuashish' },
  YNS: { city: 'Nemiscau', name: 'Nemiscau' },
  YNT: { city: 'Yantai', name: 'Yantai Laishan' },
  YNY: { city: 'Sokcho / Gangneung', name: 'Yangyang International' },
  YNZ: { city: 'Yancheng', name: 'Yancheng' },
  YOA: { city: 'Ekati', name: 'Ekati' },
  YOC: { city: 'Old Crow', name: 'Old Crow' },
  YOD: { city: 'Cold Lake', name: 'CFB Cold Lake' },
  YOG: { city: 'Ogoki Post', name: 'Ogoki Post' },
  YOH: { city: 'Oxford House', name: 'Oxford House' },
  YOJ: { city: 'High Level', name: 'High Level' },
  YOL: { city: 'Yola', name: 'Yola' },
  YOO: { city: 'Oshawa', name: 'Toronto/Oshawa Executive' },
  YOP: { city: 'Rainbow Lake', name: 'Rainbow Lake' },
  YOS: { city: 'Owen Sound', name: 'Owen Sound / Billy Bishop Regional' },
  YOW: { city: 'Ottawa', name: 'Ottawa Macdonald-Cartier International' },
  YPA: { city: 'Prince Albert', name: 'Prince Albert Glass Field' },
  YPC: { city: 'Paulatuk', name: 'Paulatuk (Nora Aliqatchialuk Ruben)' },
  YPD: { city: 'Parry Sound', name: 'Parry Sound Area Municipal' },
  YPE: { city: 'Peace River', name: 'Peace River' },
  YPG: { city: 'Portage-la-prairie', name: 'Southport' },
  YPH: { city: 'Inukjuak', name: 'Inukjuak' },
  YPJ: { city: 'Aupaluk', name: 'Aupaluk' },
  YPL: { city: 'Pickle Lake', name: 'Pickle Lake' },
  YPM: { city: 'Pikangikum', name: 'Pikangikum' },
  YPN: { city: 'Port Menier', name: 'Port Menier' },
  YPO: { city: 'Peawanuck', name: 'Peawanuck' },
  YPQ: { city: 'Peterborough', name: 'Peterborough' },
  YPR: { city: 'Prince Pupert', name: 'Prince Rupert' },
  YPS: { city: 'Port Hawkesbury', name: 'Port Hawkesbury' },
  YPW: { city: 'Powell River', name: 'Powell River' },
  YPX: { city: 'Puvirnituq', name: 'Puvirnituq' },
  YPY: { city: 'Fort Chipewyan', name: 'Fort Chipewyan' },
  YQA: { city: 'Muskoka', name: 'Muskoka' },
  YQB: { city: 'Quebec', name: 'Quebec Jean Lesage International' },
  YQC: { city: 'Quaqtaq', name: 'Quaqtaq' },
  YQD: { city: 'The Pas', name: 'The Pas' },
  YQF: { city: 'Red Deer Industrial', name: 'Red Deer Regional' },
  YQG: { city: 'Windsor', name: 'Windsor' },
  YQH: { city: 'Watson Lake', name: 'Watson Lake' },
  YQI: { city: 'Yarmouth', name: 'Yarmouth' },
  YQK: { city: 'Kenora', name: 'Kenora' },
  YQL: { city: 'Lethbridge', name: 'Lethbridge County' },
  YQM: { city: 'Moncton', name: 'Greater Moncton International' },
  YQN: { city: 'Nakina', name: 'Nakina' },
  YQQ: { city: 'Comox', name: 'Comox' },
  YQR: { city: 'Regina', name: 'Regina International' },
  YQS: { city: 'St Thomas', name: 'St Thomas Municipal' },
  YQT: { city: 'Thunder Bay', name: 'Thunder Bay' },
  YQU: { city: 'Grande Prairie', name: 'Grande Prairie' },
  YQV: { city: 'Yorkton', name: 'Yorkton Municipal' },
  YQW: { city: 'North Battleford', name: 'North Battleford' },
  YQX: { city: 'Gander', name: 'Gander International' },
  YQY: { city: 'Sydney', name: 'Sydney / J.A. Douglas McCurdy' },
  YQZ: { city: 'Quesnel', name: 'Quesnel' },
  YRA: { city: 'Gamètì', name: 'Rae Lakes' },
  YRB: { city: 'Resolute', name: 'Resolute Bay' },
  YRF: { city: 'Cartwright', name: 'Cartwright' },
  YRG: { city: 'Rigolet', name: 'Rigolet' },
  YRI: { city: 'Riviere Du Loup', name: 'Rivière-du-Loup' },
  YRJ: { city: 'Roberval', name: 'Roberval' },
  YRL: { city: 'Red Lake', name: 'Red Lake' },
  YRM: { city: 'Rocky Mountain House', name: 'Rocky Mountain House' },
  YRO: { city: 'Ottawa', name: 'Ottawa / Rockcliffe' },
  YRQ: { city: 'Trois Rivieres', name: 'Trois-Rivières' },
  YRS: { city: 'Red Sucker Lake', name: 'Red Sucker Lake' },
  YRT: { city: 'Rankin Inlet', name: 'Rankin Inlet' },
  YRV: { city: 'Revelstoke', name: 'Revelstoke' },
  YSB: { city: 'Sudbury', name: 'Sudbury' },
  YSC: { city: 'Sherbrooke', name: 'Sherbrooke' },
  YSD: { city: 'Suffield', name: 'Suffield Heliport' },
  YSE: { city: 'Squamish', name: 'Squamish' },
  YSF: { city: 'Stony Rapids', name: 'Stony Rapids' },
  YSG: { city: 'Lutselke', name: 'Lutselke' },
  YSH: { city: 'Smiths Falls', name: 'Smiths Falls-Montague (Russ Beach)' },
  YSJ: { city: 'St. John', name: 'Saint John' },
  YSK: { city: 'Sanikiluaq', name: 'Sanikiluaq' },
  YSL: { city: 'St Leonard', name: 'St Leonard' },
  YSM: { city: 'Fort Smith', name: 'Fort Smith' },
  YSN: { city: 'Salmon Arm', name: 'Shuswap Regional' },
  YSO: { city: 'Postville', name: 'Postville' },
  YSP: { city: 'Marathon', name: 'Marathon' },
  YSQ: { city: 'Songyuan', name: 'Songyuan Chaganhu' },
  YSR: { city: 'Nanisivik', name: 'Nanisivik' },
  YST: { city: 'St. Theresa Point', name: 'St. Theresa Point' },
  YSU: { city: 'Summerside', name: 'Summerside' },
  YSY: { city: 'Sachs Harbour', name: 'Sachs Harbour (David Nasogaluak Jr. Saaryuaq)' },
  YTA: { city: 'Pembroke', name: 'Pembroke' },
  YTD: { city: 'Thicket Portage', name: 'Thicket Portage' },
  YTE: { city: 'Cape Dorset', name: 'Cape Dorset' },
  YTF: { city: 'Alma', name: 'Alma' },
  YTH: { city: 'Thompson', name: 'Thompson' },
  YTL: { city: 'Big Trout Lake', name: 'Big Trout Lake' },
  YTM: { city: 'Mont-Tremblant', name: 'La Macaza / Mont-Tremblant International Inc' },
  YTQ: { city: 'Tasiujaq', name: 'Tasiujaq' },
  YTR: { city: 'Trenton', name: 'CFB Trenton' },
  YTS: { city: 'Timmins', name: 'Timmins/Victor M. Power' },
  YTY: { city: 'Yangzhou', name: 'Yangzhou Taizhou' },
  YTZ: { city: 'Toronto', name: 'Billy Bishop Toronto City Centre' },
  YUA: { city: 'Yuanmou', name: 'Yuanmou Air Base' },
  YUB: { city: 'Tuktoyaktuk', name: 'Tuktoyaktuk' },
  YUD: { city: 'Umiujaq', name: 'Umiujaq' },
  YUE: { city: 'Yuendumu', name: 'Yuendumu' },
  YUL: { city: 'Montreal', name: 'Montreal / Pierre Elliott Trudeau International' },
  YUM: { city: 'Yuma', name: 'Yuma MCAS/Yuma International' },
  YUS: { city: 'Yushu', name: 'Yushu Batang' },
  YUT: { city: 'Repulse Bay', name: 'Repulse Bay' },
  YUX: { city: 'Hall Beach', name: 'Hall Beach' },
  YUY: { city: 'Rouyn', name: 'Rouyn Noranda' },
  YVA: { city: 'Moroni', name: 'Iconi' },
  YVB: { city: 'Bonaventure', name: 'Bonaventure' },
  YVC: { city: 'La Ronge', name: 'La Ronge' },
  YVE: { city: 'Vernon', name: 'Vernon' },
  YVG: { city: 'Vermillion', name: 'Vermilion' },
  YVM: { city: 'Broughton Island', name: 'Qikiqtarjuaq' },
  YVO: { city: 'Val Dor', name: 'Val-dOr' },
  YVP: { city: 'Quujjuaq', name: 'Kuujjuaq' },
  YVQ: { city: 'Norman Wells', name: 'Norman Wells' },
  YVR: { city: 'Vancouver', name: 'Vancouver International' },
  YVT: { city: 'Buffalo Narrows', name: 'Buffalo Narrows' },
  YVV: { city: 'Wiarton', name: 'Wiarton' },
  YVZ: { city: 'Deer Lake', name: 'Deer Lake' },
  YWA: { city: 'Petawawa', name: 'Petawawa' },
  YWB: { city: 'Kangiqsujuaq', name: 'Kangiqsujuaq (Wakeham Bay)' },
  YWG: { city: 'Winnipeg', name: 'Winnipeg / James Armstrong Richardson International' },
  YWH: { city: 'Victoria', name: 'Victoria Harbour Seaplane Base' },
  YWJ: { city: 'Deline', name: 'Déline' },
  YWK: { city: 'Wabush', name: 'Wabush' },
  YWL: { city: 'Williams Lake', name: 'Williams Lake' },
  YWM: { city: 'Williams Harbour', name: 'Williams Harbour' },
  YWP: { city: 'Webequie', name: 'Webequie' },
  YWS: { city: 'Whistler', name: 'Whistler/Green Lake Water Aerodrome' },
  YWY: { city: 'Wrigley', name: 'Wrigley' },
  YXC: { city: 'Cranbrook', name: 'Cranbrook/Canadian Rockies International' },
  YXD: { city: 'Edmonton', name: 'Edmonton City Centre (Blatchford Field)' },
  YXE: { city: 'Saskatoon', name: 'Saskatoon John G. Diefenbaker International' },
  YXH: { city: 'Medicine Hat', name: 'Medicine Hat' },
  YXJ: { city: 'Fort Saint John', name: 'Fort St John' },
  YXK: { city: 'Rimouski', name: 'Rimouski' },
  YXL: { city: 'Sioux Lookout', name: 'Sioux Lookout' },
  YXN: { city: 'Whale Cove', name: 'Whale Cove' },
  YXP: { city: 'Pangnirtung', name: 'Pangnirtung' },
  YXQ: { city: 'Beaver Creek', name: 'Beaver Creek' },
  YXR: { city: 'Earlton', name: 'Earlton (Timiskaming Regional)' },
  YXS: { city: 'Prince George', name: 'Prince George' },
  YXT: { city: 'Terrace', name: 'Northwest Regional Airport Terrace-Kitimat' },
  YXU: { city: 'London', name: 'London' },
  YXX: { city: 'Abbotsford', name: 'Abbotsford' },
  YXY: { city: 'Whitehorse', name: 'Whitehorse / Erik Nielsen International' },
  YXZ: { city: 'Wawa', name: 'Wawa' },
  YYB: { city: 'North Bay', name: 'North Bay Jack Garland' },
  YYC: { city: 'Calgary', name: 'Calgary International' },
  YYD: { city: 'Smithers', name: 'Smithers' },
  YYE: { city: 'Fort Nelson', name: 'Fort Nelson' },
  YYF: { city: 'Penticton', name: 'Penticton' },
  YYG: { city: 'Charlottetown', name: 'Charlottetown' },
  YYH: { city: 'Spence Bay', name: 'Taloyoak' },
  YYJ: { city: 'Victoria', name: 'Victoria International' },
  YYL: { city: 'Lynn Lake', name: 'Lynn Lake' },
  YYN: { city: 'Swift Current', name: 'Swift Current' },
  YYQ: { city: 'Churchill', name: 'Churchill' },
  YYR: { city: 'Goose Bay', name: 'Goose Bay' },
  YYT: { city: 'St. Johns', name: 'St. Johns International' },
  YYU: { city: 'Kapuskasing', name: 'Kapuskasing' },
  YYW: { city: 'Armstrong', name: 'Armstrong' },
  YYY: { city: 'Mont Joli', name: 'Mont Joli' },
  YYZ: { city: 'Toronto', name: 'Lester B. Pearson International' },
  YZD: { city: 'Toronto', name: 'Downsview' },
  YZE: { city: 'Gore Bay', name: 'Gore Bay Manitoulin' },
  YZF: { city: 'Yellowknife', name: 'Yellowknife' },
  YZG: { city: 'Salluit', name: 'Salluit' },
  YZH: { city: 'Slave Lake', name: 'Slave Lake' },
  YZP: { city: 'Sandspit', name: 'Sandspit' },
  YZR: { city: 'Sarnia', name: 'Chris Hadfield' },
  YZS: { city: 'Coral Harbour', name: 'Coral Harbour' },
  YZT: { city: 'Port Hardy', name: 'Port Hardy' },
  YZU: { city: 'Whitecourt', name: 'Whitecourt' },
  YZV: { city: 'Sept-iles', name: 'Sept-Îles' },
  YZW: { city: 'Teslin', name: 'Teslin' },
  YZX: { city: 'Greenwood', name: 'CFB Greenwood' },
  YZY: { city: 'Zhangye', name: 'Zhangye Ganzhou' },
  YZZ: { city: 'Trail', name: 'Trail' },
  ZAC: { city: 'York Landing', name: 'York Landing' },
  ZAD: { city: 'Zadar', name: 'Zadar' },
  ZAG: { city: 'Zagreb', name: 'Zagreb' },
  ZAH: { city: 'Zahedan', name: 'Zahedan International' },
  ZAJ: { city: 'Zaranj', name: 'Zaranj' },
  ZAL: { city: 'Valdivia', name: 'Pichoy' },
  ZAM: { city: 'Zamboanga', name: 'Zamboanga International' },
  ZAO: { city: 'Cahors', name: 'Cahors-Lalbenque' },
  ZAR: { city: 'Zaria', name: 'Zaria' },
  ZAT: { city: 'Zhaotong', name: 'Zhaotong' },
  ZAZ: { city: 'Zaragoza', name: 'Zaragoza Air Base' },
  ZBF: { city: 'Bathurst', name: 'Bathurst' },
  ZBM: { city: 'Bromont', name: 'Bromont (Roland Desourdy)' },
  ZBO: { city: 'Bowen', name: 'Bowen' },
  ZBR: { city: 'Chah Bahar', name: 'Konarak' },
  ZBY: { city: 'Sainyabuli', name: 'Sayaboury' },
  ZCL: { city: 'Zacatecas', name: 'General Leobardo C. Ruiz International' },
  ZCN: { city: 'Celle', name: 'Celle' },
  ZCO: { city: 'Temuco', name: 'La Araucanía' },
  ZEC: { city: 'Secunda', name: 'Secunda' },
  ZEM: { city: 'Eastmain River', name: 'Eastmain River' },
  ZER: { city: 'Zero', name: 'Ziro' },
  ZFA: { city: 'Faro', name: 'Faro' },
  ZFD: { city: 'Fond-Du-Lac', name: 'Fond-Du-Lac' },
  ZFM: { city: 'Fort Mcpherson', name: 'Fort Mcpherson' },
  ZFN: { city: 'Tulita', name: 'Tulita' },
  ZGF: { city: 'Grand Forks', name: 'Grand Forks' },
  ZGI: { city: 'Gods River', name: 'Gods River' },
  ZGR: { city: 'Little Grand Rapids', name: 'Little Grand Rapids' },
  ZGS: { city: 'La Romaine', name: 'La Romaine' },
  ZGU: { city: 'Gaua Island', name: 'Gaua Island' },
  ZHA: { city: 'Zhanjiang', name: 'Zhanjiang' },
  ZHI: { city: 'Grenchen', name: 'Grenchen' },
  ZHY: { city: 'Zhongwei', name: 'Zhongwei Shapotou' },
  ZIA: { city: 'Ramenskoe', name: 'Zhukovsky International' },
  ZIC: { city: 'Victoria', name: 'Victoria' },
  ZIG: { city: 'Ziguinchor', name: 'Ziguinchor' },
  ZIH: { city: 'Zihuatanejo', name: 'Ixtapa Zihuatanejo International' },
  ZIN: { city: 'Interlaken', name: 'Interlaken Air Base' },
  ZIS: { city: 'Zintan', name: 'Alzintan' },
  ZIX: { city: 'Zhigansk', name: 'Zhigansk' },
  ZJG: { city: 'Jenpeg', name: 'Jenpeg' },
  ZJI: { city: 'Locarno', name: 'Locarno' },
  ZJN: { city: 'Swan River', name: 'Swan River' },
  ZKB: { city: 'Kasaba Bay', name: 'Kasaba Bay' },
  ZKE: { city: 'Kashechewan', name: 'Kashechewan' },
  ZKG: { city: 'Kegaska', name: 'Kegaska' },
  ZKP: { city: 'Zyryanka', name: 'Zyryanka' },
  ZLO: { city: 'Manzanillo', name: 'Playa De Oro International' },
  ZLT: { city: 'La Tabatière', name: 'La Tabatière' },
  ZMG: { city: 'Magdeburg', name: 'Magdeburg City' },
  ZMH: { city: '108 Mile Ranch', name: 'South Cariboo Region / 108 Mile' },
  ZMM: { city: 'Zamora', name: 'Zamora' },
  ZMT: { city: 'Masset', name: 'Masset' },
  ZNA: { city: 'Nanaimo', name: 'Nanaimo Harbour Water' },
  ZND: { city: 'Zinder', name: 'Zinder' },
  ZNE: { city: 'Newman', name: 'Newman' },
  ZNF: { city: 'Hanau', name: 'Hanau Army Air Field' },
  ZNZ: { city: 'Zanzibar', name: 'Abeid Amani Karume International' },
  ZOS: { city: 'Osorno', name: 'Cañal Bajo Carlos - Hott Siebert' },
  ZPB: { city: 'Sachigo Lake', name: 'Sachigo Lake' },
  ZPC: { city: 'Pucon', name: 'Pucón' },
  ZPH: { city: 'Zephyrhills', name: 'Zephyrhills Municipal' },
  ZQL: { city: 'Donaueschingen', name: 'Donaueschingen-Villingen' },
  ZQN: { city: 'Queenstown International', name: 'Queenstown International' },
  ZQW: { city: 'Zweibruecken', name: 'Zweibrücken' },
  ZQZ: { city: 'Zhangjiakou', name: 'Zhangjiakou Ningyuan' },
  ZRH: { city: 'Zurich', name: 'Zürich' },
  ZRJ: { city: 'Round Lake', name: 'Round Lake (Weagamow Lake)' },
  ZSA: { city: 'Cockburn Town', name: 'San Salvador' },
  ZSE: { city: 'St.-pierre', name: 'Pierrefonds' },
  ZSJ: { city: 'Sandy Lake', name: 'Sandy Lake' },
  ZST: { city: 'Stewart', name: 'Stewart' },
  ZSW: { city: 'Prince Rupert', name: 'Prince Rupert/Seal Cove Seaplane Base' },
  ZTA: { city: 'Tureia', name: 'Tureia' },
  ZTB: { city: 'Tête-à-la-Baleine', name: 'Tête-à-la-Baleine' },
  ZTH: { city: 'Zakynthos', name: 'Zakynthos International Airport Dionysios Solomos' },
  ZTM: { city: 'Shamattawa', name: 'Shamattawa' },
  ZTR: { city: 'Zhytomyr', name: 'Zhytomyr' },
  ZTU: { city: 'Zaqatala', name: 'Zaqatala International' },
  ZUC: { city: 'Ignace', name: 'Ignace Municipal' },
  ZUH: { city: 'Zhuhai', name: 'Zhuhai Jinwan' },
  ZUM: { city: 'Churchill Falls', name: 'Churchill Falls' },
  ZVA: { city: 'Miandrivazo', name: 'Miandrivazo' },
  ZVK: { city: 'Savannakhet', name: 'Savannakhet' },
  ZWA: { city: 'Andapa', name: 'Andapa' },
  ZWL: { city: 'Wollaston Lake', name: 'Wollaston Lake' },
  ZXT: { city: 'Baku', name: 'Zabrat' },
  ZYI: { city: 'Zunyi', name: 'Zunyi Xinzhou' },
  ZYL: { city: 'Sylhet Osmani', name: 'Osmany International' },
  ZZU: { city: 'Mzuzu', name: 'Mzuzu' },
  ZZV: { city: 'Zanesville', name: 'Zanesville Municipal' },
};

export function getCityName(iata: string): string {
  return AIRPORTS[iata]?.city ?? iata;
}

export function getAirportName(iata: string): string {
  return AIRPORTS[iata]?.name ?? iata;
}

export function isValidAirport(iata: string): boolean {
  return iata.length === 3 && iata in AIRPORTS;
}
